// @generated by protobuf-ts 2.6.0
// @generated from protobuf file "Messages.proto" (package "ProtoMessages", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType as MessageType$ } from "@protobuf-ts/runtime";
import { CameraStatus } from "./Common";
import { AdapterStatus } from "./Common";
import { RtspLinkInfo } from "./Common";
import { LanScoreLinkDeviceList } from "./scoreconnect";
import { ScoreBoardDataMessage } from "./scoreconnect";
import { VendorConfigurationList } from "./scoreconnect";
import { VendorSportsList } from "./scoreconnect";
import { VendorList } from "./scoreconnect";
import { Configuration } from "./scoreconnect";
import { OcrDataMessage } from "./VPU";
import { Point2D } from "./Common";
import { DataChunkMessage } from "./Common";
import { VenueCalibrationData } from "./Common";
import { Empty } from "./Common";
/**
 * @generated from protobuf message ProtoMessages.CoordinatorMessage
 */
export interface CoordinatorMessage {
    /**
     * @generated from protobuf field: string userLevelToken = 1;
     */
    userLevelToken: string;
    /**
     * @generated from protobuf field: string messageTypeStr = 2;
     */
    messageTypeStr: string; // example: ProtoMessages.CameraFramesRequestMessage
    /**
     * uuid sessionId = 3;          later
     *
     * @generated from protobuf field: bytes messageContent = 5;
     */
    messageContent: Uint8Array;
}
// VPUM messages

/**
 * @generated from protobuf message ProtoMessages.MessageType
 */
export interface MessageType {
    /**
     * @generated from protobuf field: ProtoMessages.MessageType.Type value = 1;
     */
    value: MessageType_Type;
}
/**
 * @generated from protobuf enum ProtoMessages.MessageType.Type
 */
export enum MessageType_Type {
    /**
     * Use with StatusInformationMessage
     *
     * @generated from protobuf enum value: SYSTEM_INFO = 0;
     */
    SYSTEM_INFO = 0,
    /**
     * Use with RealtimeInformationMessage
     *
     * @generated from protobuf enum value: REALTIME_INFO = 1;
     */
    REALTIME_INFO = 1,
    /**
     * Use with StaticInformationMessage
     *
     * @generated from protobuf enum value: STATIC_INFO = 2;
     */
    STATIC_INFO = 2,
    /**
     * Use with CommandMessage
     *
     * @generated from protobuf enum value: COMMAND = 3;
     */
    COMMAND = 3,
    /**
     * @generated from protobuf enum value: SAVE_CONFIGURATION = 4;
     */
    SAVE_CONFIGURATION = 4,
    /**
     * @generated from protobuf enum value: COACHING_ADDITIONAL_ANGLE_INFO = 5;
     */
    COACHING_ADDITIONAL_ANGLE_INFO = 5,
    /**
     * @generated from protobuf enum value: FILE_IMPORT = 6;
     */
    FILE_IMPORT = 6,
    /**
     * @generated from protobuf enum value: VERSION = 7;
     */
    VERSION = 7,
    /**
     * @generated from protobuf enum value: SINGLE_PARAM_INFO = 8;
     */
    SINGLE_PARAM_INFO = 8,
    /**
     * @generated from protobuf enum value: CCU_UPDATE = 9;
     */
    CCU_UPDATE = 9,
    /**
     * @generated from protobuf enum value: LOG = 10;
     */
    LOG = 10,
    /**
     * @generated from protobuf enum value: CONFIGURATION = 11;
     */
    CONFIGURATION = 11,
    /**
     * CAMERA_PAIRING = 12;
     *
     * @generated from protobuf enum value: NETWORK_TESTS = 13;
     */
    NETWORK_TESTS = 13,
    /**
     * @generated from protobuf enum value: NETWORK_VALIDATION = 14;
     */
    NETWORK_VALIDATION = 14,
    /**
     * @generated from protobuf enum value: OPERATING_SYSTEM = 15;
     */
    OPERATING_SYSTEM = 15,
    /**
     * @generated from protobuf enum value: PING_PONG = 16;
     */
    PING_PONG = 16,
    /**
     * @generated from protobuf enum value: OTHER = 99;
     */
    OTHER = 99
}
/**
 * @generated from protobuf message ProtoMessages.GeneralStatus
 */
export interface GeneralStatus {
    /**
     * @generated from protobuf field: ProtoMessages.GeneralStatus.Status value = 1;
     */
    value: GeneralStatus_Status;
}
/**
 * @generated from protobuf enum ProtoMessages.GeneralStatus.Status
 */
export enum GeneralStatus_Status {
    /**
     * @generated from protobuf enum value: NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: GOOD = 1;
     */
    GOOD = 1,
    /**
     * @generated from protobuf enum value: BAD = 2;
     */
    BAD = 2
}
/**
 * @generated from protobuf message ProtoMessages.SwitchType
 */
export interface SwitchType {
    /**
     * @generated from protobuf field: ProtoMessages.SwitchType.Type value = 1;
     */
    value: SwitchType_Type;
}
/**
 * @generated from protobuf enum ProtoMessages.SwitchType.Type
 */
export enum SwitchType_Type {
    /**
     * @generated from protobuf enum value: NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: DLINK = 1;
     */
    DLINK = 1,
    /**
     * @generated from protobuf enum value: CISCO = 2;
     */
    CISCO = 2
}
/**
 * @generated from protobuf message ProtoMessages.SystemMode
 */
export interface SystemMode {
    /**
     * @generated from protobuf field: ProtoMessages.SystemMode.Mode value = 1;
     */
    value: SystemMode_Mode;
}
/**
 * @generated from protobuf enum ProtoMessages.SystemMode.Mode
 */
export enum SystemMode_Mode {
    /**
     * @generated from protobuf enum value: WORKING_HOURS = 0;
     */
    WORKING_HOURS = 0,
    /**
     * @generated from protobuf enum value: APPLICATION = 1;
     */
    APPLICATION = 1,
    /**
     * @generated from protobuf enum value: MAINTENANCE = 2;
     */
    MAINTENANCE = 2
}
/**
 * @generated from protobuf message ProtoMessages.SystemType
 */
export interface SystemType {
    /**
     * @generated from protobuf field: ProtoMessages.SystemType.Type value = 1;
     */
    value: SystemType_Type;
}
/**
 * @generated from protobuf enum ProtoMessages.SystemType.Type
 */
export enum SystemType_Type {
    /**
     * @generated from protobuf enum value: S_TYPE = 0;
     */
    S_TYPE = 0,
    /**
     * @generated from protobuf enum value: C_TYPE = 1;
     */
    C_TYPE = 1,
    /**
     * @generated from protobuf enum value: S2_TYPE = 2;
     */
    S2_TYPE = 2,
    /**
     * @generated from protobuf enum value: S3_TYPE = 3;
     */
    S3_TYPE = 3,
    /**
     * @generated from protobuf enum value: PRIME_TYPE = 4;
     */
    PRIME_TYPE = 4,
    /**
     * @generated from protobuf enum value: S2_MOBILITY_TYPE = 5;
     */
    S2_MOBILITY_TYPE = 5,
    /**
     * @generated from protobuf enum value: S2S_TYPE = 6;
     */
    S2S_TYPE = 6,
    /**
     * @generated from protobuf enum value: S2C_TYPE = 7;
     */
    S2C_TYPE = 7,
    /**
     * @generated from protobuf enum value: S_PLUS_TYPE = 8;
     */
    S_PLUS_TYPE = 8,
    /**
     * @generated from protobuf enum value: S2_PLUS_TYPE = 9;
     */
    S2_PLUS_TYPE = 9,
    /**
     * @generated from protobuf enum value: S3_PLUS_TYPE = 10;
     */
    S3_PLUS_TYPE = 10,
    /**
     * @generated from protobuf enum value: DOUBLE_PLAY_TYPE = 11;
     */
    DOUBLE_PLAY_TYPE = 11,
    /**
     * @generated from protobuf enum value: SOLO_TYPE = 12;
     */
    SOLO_TYPE = 12,
    /**
     * @generated from protobuf enum value: SINGLE_PLAY_TYPE = 13;
     */
    SINGLE_PLAY_TYPE = 13,
    /**
     * @generated from protobuf enum value: SP2_TYPE = 14;
     */
    SP2_TYPE = 14
}
/**
 * @generated from protobuf message ProtoMessages.VpuStatus
 */
export interface VpuStatus {
    /**
     * @generated from protobuf field: ProtoMessages.VpuStatus.Status value = 1;
     */
    value: VpuStatus_Status;
}
/**
 * @generated from protobuf enum ProtoMessages.VpuStatus.Status
 */
export enum VpuStatus_Status {
    /**
     * @generated from protobuf enum value: OFF = 0;
     */
    OFF = 0,
    /**
     * @generated from protobuf enum value: SLEEP = 1;
     */
    SLEEP = 1,
    /**
     * @generated from protobuf enum value: INIT = 2;
     */
    INIT = 2,
    /**
     * @generated from protobuf enum value: ON = 3;
     */
    ON = 3,
    /**
     * @generated from protobuf enum value: PROCESSING = 4;
     */
    PROCESSING = 4
}
/**
 * @generated from protobuf message ProtoMessages.ChuStatus
 */
export interface ChuStatus {
    /**
     * @generated from protobuf field: ProtoMessages.ChuStatus.Status value = 1;
     */
    value: ChuStatus_Status;
}
/**
 * @generated from protobuf enum ProtoMessages.ChuStatus.Status
 */
export enum ChuStatus_Status {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: UPDATING = 1;
     */
    UPDATING = 1,
    /**
     * @generated from protobuf enum value: COMPLETE = 2;
     */
    COMPLETE = 2,
    /**
     * @generated from protobuf enum value: FAILED = 3;
     */
    FAILED = 3
}
/**
 * @generated from protobuf message ProtoMessages.SportsType
 */
export interface SportsType {
    /**
     * @generated from protobuf field: ProtoMessages.SportsType.Type value = 1;
     */
    value: SportsType_Type;
}
/**
 * DO NOT Change the order of this ENUM without changing the list
 * in VPU Manegment UI (store.js)
 *
 * @generated from protobuf enum ProtoMessages.SportsType.Type
 */
export enum SportsType_Type {
    /**
     * @generated from protobuf enum value: OTHER = 0;
     */
    OTHER = 0,
    /**
     * @generated from protobuf enum value: SOCCER = 1;
     */
    SOCCER = 1,
    /**
     * @generated from protobuf enum value: BASKETBALL = 2;
     */
    BASKETBALL = 2,
    /**
     * @generated from protobuf enum value: HANDBALL = 3;
     */
    HANDBALL = 3,
    /**
     * @generated from protobuf enum value: AMERICAN_FOOTBALL = 4;
     */
    AMERICAN_FOOTBALL = 4,
    /**
     * @generated from protobuf enum value: RUGBY = 5;
     */
    RUGBY = 5,
    /**
     * @generated from protobuf enum value: FIELD_HOCKEY = 6;
     */
    FIELD_HOCKEY = 6,
    /**
     * @generated from protobuf enum value: ICE_HOCKEY = 7;
     */
    ICE_HOCKEY = 7,
    /**
     * @generated from protobuf enum value: ROLLER_HOCKEY = 8;
     */
    ROLLER_HOCKEY = 8,
    /**
     * @generated from protobuf enum value: FUTSAL = 9;
     */
    FUTSAL = 9,
    /**
     * @generated from protobuf enum value: SOCCER_TACTICAL = 10;
     */
    SOCCER_TACTICAL = 10,
    /**
     * @generated from protobuf enum value: FUTSAL_TACTICAL = 11;
     */
    FUTSAL_TACTICAL = 11,
    /**
     * @generated from protobuf enum value: WRESTLING = 12;
     */
    WRESTLING = 12,
    /**
     * @generated from protobuf enum value: VOLLEYBALL = 13;
     */
    VOLLEYBALL = 13,
    /**
     * @generated from protobuf enum value: GYMNASTICS = 14;
     */
    GYMNASTICS = 14,
    /**
     * @generated from protobuf enum value: LEFT_SIDE = 15;
     */
    LEFT_SIDE = 15,
    /**
     * @generated from protobuf enum value: CENTER = 16;
     */
    CENTER = 16,
    /**
     * @generated from protobuf enum value: RIGHT_SIDE = 17;
     */
    RIGHT_SIDE = 17,
    /**
     * @generated from protobuf enum value: BASEBALL = 18;
     */
    BASEBALL = 18,
    /**
     * @generated from protobuf enum value: BASKETBALL_TACTICAL = 19;
     */
    BASKETBALL_TACTICAL = 19,
    /**
     * @generated from protobuf enum value: ROLLER_HOCKEY_TACTICAL = 20;
     */
    ROLLER_HOCKEY_TACTICAL = 20,
    /**
     * @generated from protobuf enum value: HANDBALL_TACTICAL = 21;
     */
    HANDBALL_TACTICAL = 21,
    /**
     * @generated from protobuf enum value: CRICKET = 22;
     */
    CRICKET = 22,
    /**
     * @generated from protobuf enum value: WATER_POLO = 23;
     */
    WATER_POLO = 23,
    /**
     * @generated from protobuf enum value: NETBALL = 24;
     */
    NETBALL = 24
}
/**
 * @generated from protobuf message ProtoMessages.CameraFPSChangeStatus
 */
export interface CameraFPSChangeStatus {
    /**
     * @generated from protobuf field: ProtoMessages.CameraFPSChangeStatus.Status value = 1;
     */
    value: CameraFPSChangeStatus_Status;
}
/**
 * @generated from protobuf enum ProtoMessages.CameraFPSChangeStatus.Status
 */
export enum CameraFPSChangeStatus_Status {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: ALLOW = 1;
     */
    ALLOW = 1,
    /**
     * @generated from protobuf enum value: DONOT_ALLOW = 2;
     */
    DONOT_ALLOW = 2
}
/**
 * @generated from protobuf message ProtoMessages.String
 */
export interface String$ {
    /**
     * @generated from protobuf field: string value = 1;
     */
    value: string;
}
/**
 * @generated from protobuf message ProtoMessages.Bool
 */
export interface Bool {
    /**
     * @generated from protobuf field: bool value = 1;
     */
    value: boolean;
}
/**
 * @generated from protobuf message ProtoMessages.Float
 */
export interface Float {
    /**
     * @generated from protobuf field: float value = 1;
     */
    value: number;
}
/**
 * @generated from protobuf message ProtoMessages.Double
 */
export interface Double {
    /**
     * @generated from protobuf field: double value = 1;
     */
    value: number;
}
/**
 * @generated from protobuf message ProtoMessages.Uint64
 */
export interface Uint64 {
    /**
     * @generated from protobuf field: uint64 value = 1;
     */
    value: bigint;
}
/**
 * @generated from protobuf message ProtoMessages.Int64
 */
export interface Int64 {
    /**
     * @generated from protobuf field: int64 value = 1;
     */
    value: bigint;
}
/**
 * @generated from protobuf message ProtoMessages.Int32
 */
export interface Int32 {
    /**
     * @generated from protobuf field: int32 value = 1;
     */
    value: number;
}
/**
 * @generated from protobuf message ProtoMessages.CoachingAdditionalAngleInfo
 */
export interface CoachingAdditionalAngleInfo {
    /**
     * @generated from protobuf field: ProtoMessages.String name = 1;
     */
    name?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String url = 2;
     */
    url?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Bool enabled = 3;
     */
    enabled?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.CoachingAdditionalAngleList
 */
export interface CoachingAdditionalAngleList {
    /**
     * @generated from protobuf field: repeated ProtoMessages.CoachingAdditionalAngleInfo aaDetails = 1;
     */
    aaDetails: CoachingAdditionalAngleInfo[];
}
/**
 * @generated from protobuf message ProtoMessages.NasInfo
 */
export interface NasInfo {
    /**
     * @generated from protobuf field: ProtoMessages.String path = 1;
     */
    path?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Bool copyPano = 2;
     */
    copyPano?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool copyHd = 3;
     */
    copyHd?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool copyJpeg = 4;
     */
    copyJpeg?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool NasEnabled = 5 [json_name = "NasEnabled"];
     */
    nasEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.String username = 6;
     */
    username?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String password = 7;
     */
    password?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.NasInfo.Protocol protocol = 8;
     */
    protocol: NasInfo_Protocol;
}
/**
 * @generated from protobuf enum ProtoMessages.NasInfo.Protocol
 */
export enum NasInfo_Protocol {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: SMB1 = 1;
     */
    SMB1 = 1,
    /**
     * @generated from protobuf enum value: SMB2 = 2;
     */
    SMB2 = 2,
    /**
     * @generated from protobuf enum value: DEFAULT = 3;
     */
    DEFAULT = 3
}
/**
 * @generated from protobuf message ProtoMessages.NetworkConfigType
 */
export interface NetworkConfigType {
    /**
     * @generated from protobuf field: ProtoMessages.NetworkConfigType.Type value = 1;
     */
    value: NetworkConfigType_Type;
}
/**
 * @generated from protobuf enum ProtoMessages.NetworkConfigType.Type
 */
export enum NetworkConfigType_Type {
    /**
     * @generated from protobuf enum value: DHCP = 0;
     */
    DHCP = 0,
    /**
     * @generated from protobuf enum value: STATIC = 1;
     */
    STATIC = 1
}
/**
 * @generated from protobuf message ProtoMessages.NetworkInfo
 */
export interface NetworkInfo {
    /**
     * @generated from protobuf field: ProtoMessages.NetworkConfigType networkType = 1;
     */
    networkType?: NetworkConfigType;
    /**
     * @generated from protobuf field: ProtoMessages.String ipAddress = 2;
     */
    ipAddress?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String subnetMask = 3;
     */
    subnetMask?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String deafultGateway = 4;
     */
    deafultGateway?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String dns1 = 5;
     */
    dns1?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String dns2 = 6;
     */
    dns2?: String$;
}
/**
 * @generated from protobuf message ProtoMessages.OcrCameraParamChange
 */
export interface OcrCameraParamChange {
    /**
     * @generated from protobuf field: ProtoMessages.OcrCameraParamChange.CameraParamType cameraParam = 1;
     */
    cameraParam: OcrCameraParamChange_CameraParamType;
    /**
     * @generated from protobuf field: int32 value = 2;
     */
    value: number;
}
/**
 * @generated from protobuf enum ProtoMessages.OcrCameraParamChange.CameraParamType
 */
export enum OcrCameraParamChange_CameraParamType {
    /**
     * @generated from protobuf enum value: IRIS = 0;
     */
    IRIS = 0,
    /**
     * @generated from protobuf enum value: GAIN = 1;
     */
    GAIN = 1,
    /**
     * @generated from protobuf enum value: BRIGHTNESS = 2;
     */
    BRIGHTNESS = 2,
    /**
     * @generated from protobuf enum value: SATURATION = 3;
     */
    SATURATION = 3,
    /**
     * @generated from protobuf enum value: CONTRAST = 4;
     */
    CONTRAST = 4,
    /**
     * @generated from protobuf enum value: SHARPNESS = 5;
     */
    SHARPNESS = 5
}
/**
 * @generated from protobuf message ProtoMessages.CommandMessage
 */
export interface CommandMessage {
    /**
     * @generated from protobuf field: bool formatJpegRecordings = 1;
     */
    formatJpegRecordings: boolean;
    /**
     * @generated from protobuf field: bool formatLocalRecordings = 2;
     */
    formatLocalRecordings: boolean;
    /**
     * @generated from protobuf field: bool resetPoe = 3;
     */
    resetPoe: boolean;
    /**
     * @generated from protobuf field: bool restartVpu = 4;
     */
    restartVpu: boolean;
    /**
     * @generated from protobuf field: bool startVpu = 5;
     */
    startVpu: boolean;
    /**
     * @generated from protobuf field: bool stopVpu = 6;
     */
    stopVpu: boolean;
    /**
     * @generated from protobuf field: bool restartComputer = 7;
     */
    restartComputer: boolean;
    /**
     * @generated from protobuf field: bool sendPanoramaRequest = 8;
     */
    sendPanoramaRequest: boolean;
    /**
     * @generated from protobuf field: bool sendCcuPresetsRequest = 9;
     */
    sendCcuPresetsRequest: boolean;
    /**
     * @generated from protobuf field: ProtoMessages.String deletePreset = 10;
     */
    deletePreset?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.CCUPreset savePreset = 11;
     */
    savePreset?: CCUPreset;
    /**
     * @generated from protobuf field: repeated ProtoMessages.TestPorts requestPortTesting = 12;
     */
    requestPortTesting: TestPorts[];
    /**
     * @generated from protobuf field: bool getCameras = 13;
     */
    getCameras: boolean;
    /**
     * @generated from protobuf field: ProtoMessages.String restoreCameraParams = 14;
     */
    restoreCameraParams?: String$;
    /**
     * @generated from protobuf field: bool sendHeadSetupFramesRequest = 15;
     */
    sendHeadSetupFramesRequest: boolean;
    /**
     * @generated from protobuf field: bool requestOsType = 16;
     */
    requestOsType: boolean;
    /**
     * @generated from protobuf field: bool restartPip = 17;
     */
    restartPip: boolean;
    /**
     * @generated from protobuf field: bool restartCoordinator = 18;
     */
    restartCoordinator: boolean;
    /**
     * @generated from protobuf field: bool restartCg = 19;
     */
    restartCg: boolean;
    /**
     * @generated from protobuf field: bool restartAgent = 20;
     */
    restartAgent: boolean;
    /**
     * @generated from protobuf field: bool updateLastCalibrationTime = 21;
     */
    updateLastCalibrationTime: boolean;
    /**
     * @generated from protobuf field: bool requestStaticInfo = 22;
     */
    requestStaticInfo: boolean;
    /**
     * @generated from protobuf field: ProtoMessages.PingPolicyStatus changePingPolicy = 23;
     */
    changePingPolicy?: PingPolicyStatus;
    /**
     * @generated from protobuf field: bool startVpuInSetupMode = 24;
     */
    startVpuInSetupMode: boolean;
    /**
     * @generated from protobuf field: bool restoreCalibration = 25;
     */
    restoreCalibration: boolean;
    /**
     * @generated from protobuf field: bool startVpuInSetupModeRemoteCalibration = 26;
     */
    startVpuInSetupModeRemoteCalibration: boolean;
    /**
     * @generated from protobuf field: bool stopVpuRemoteCalibration = 27;
     */
    stopVpuRemoteCalibration: boolean;
    /**
     * @generated from protobuf field: bool swReset = 28;
     */
    swReset: boolean;
    /**
     * @generated from protobuf field: ProtoMessages.PoeCardStatus switchPoeCardStatus = 29;
     */
    switchPoeCardStatus?: PoeCardStatus;
    /**
     * @generated from protobuf field: bool chuReset = 30;
     */
    chuReset: boolean;
    /**
     * @generated from protobuf field: bool pingCamera = 31;
     */
    pingCamera: boolean;
    /**
     * @generated from protobuf field: bool chuPartialRestore = 32;
     */
    chuPartialRestore: boolean;
    /**
     * @generated from protobuf field: ProtoMessages.ChuTvSystemMode setChuTvSystemMode = 33;
     */
    setChuTvSystemMode?: ChuTvSystemMode;
    /**
     * @generated from protobuf field: ProtoMessages.ApplyColorCalibrationMatrix setApplyColorCalibrationMatrix = 34;
     */
    setApplyColorCalibrationMatrix?: ApplyColorCalibrationMatrix;
    /**
     * @generated from protobuf field: bool enableAlcForOcr = 35;
     */
    enableAlcForOcr: boolean;
    /**
     * @generated from protobuf field: bool disableAlcForOcr = 36;
     */
    disableAlcForOcr: boolean;
    /**
     * @generated from protobuf field: ProtoMessages.OcrCameraParamChange ocrCameraParamChange = 37;
     */
    ocrCameraParamChange?: OcrCameraParamChange;
    /**
     * @generated from protobuf field: bool refreshVirtualAds = 38;
     */
    refreshVirtualAds: boolean;
    /**
     * @generated from protobuf field: bool send_cue_out = 39;
     */
    sendCueOut: boolean;
    /**
     * @generated from protobuf field: bool send_cue_in = 40;
     */
    sendCueIn: boolean;
    /**
     * @generated from protobuf field: ProtoMessages.Bool manualMidrollEnabled = 41;
     */
    manualMidrollEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool useSmartMidroll = 42;
     */
    useSmartMidroll?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool smartMidrollSimulator = 43;
     */
    smartMidrollSimulator?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool scoreboardManualFromVideo = 44;
     */
    scoreboardManualFromVideo?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.RestoreCalibrationCommandResponse
 */
export interface RestoreCalibrationCommandResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
}
/**
 * @generated from protobuf message ProtoMessages.RefreshVirtualAdsResponse
 */
export interface RefreshVirtualAdsResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
}
/**
 * @generated from protobuf message ProtoMessages.PingPolicyStatus
 */
export interface PingPolicyStatus {
    /**
     * @generated from protobuf field: bool allowed = 1;
     */
    allowed: boolean;
}
/**
 * @generated from protobuf message ProtoMessages.PoeCardStatus
 */
export interface PoeCardStatus {
    /**
     * @generated from protobuf field: bool status = 1;
     */
    status: boolean;
}
/**
 * @generated from protobuf message ProtoMessages.ApplyColorCalibrationMatrix
 */
export interface ApplyColorCalibrationMatrix {
    /**
     * @generated from protobuf field: bool value = 1;
     */
    value: boolean;
}
/**
 * @generated from protobuf message ProtoMessages.ChuTvSystemMode
 */
export interface ChuTvSystemMode {
    /**
     * @generated from protobuf field: ProtoMessages.ChuTvSystemMode.TvMode mode = 1;
     */
    mode: ChuTvSystemMode_TvMode;
    /**
     * @generated from protobuf field: repeated string cameraIps = 2;
     */
    cameraIps: string[];
}
/**
 * @generated from protobuf enum ProtoMessages.ChuTvSystemMode.TvMode
 */
export enum ChuTvSystemMode_TvMode {
    /**
     * @generated from protobuf enum value: PAL = 0;
     */
    PAL = 0,
    /**
     * @generated from protobuf enum value: NTSC = 1;
     */
    NTSC = 1
}
/**
 * @generated from protobuf message ProtoMessages.CameraInformation
 */
export interface CameraInformation {
    /**
     * @generated from protobuf field: string type = 1;
     */
    type: string;
    /**
     * @generated from protobuf field: string uid = 2;
     */
    uid: string;
    /**
     * @generated from protobuf field: string firmware = 3;
     */
    firmware: string;
    /**
     * @generated from protobuf field: string version = 4;
     */
    version: string;
    /**
     * @generated from protobuf field: string tvSystemMode = 5;
     */
    tvSystemMode: string;
    /**
     * @generated from protobuf field: string macAddress = 6;
     */
    macAddress: string;
    /**
     * @generated from protobuf field: string revision = 7;
     */
    revision: string;
    /**
     * @generated from protobuf field: string ip = 8;
     */
    ip: string;
    /**
     * @generated from protobuf field: string cameraModel = 9;
     */
    cameraModel: string;
    /**
     * @generated from protobuf field: string serialNumber = 10;
     */
    serialNumber: string;
    /**
     * @generated from protobuf field: string partNumber = 11;
     */
    partNumber: string;
}
/**
 * @generated from protobuf message ProtoMessages.ConfigurationParameter
 */
export interface ConfigurationParameter {
    /**
     * @generated from protobuf field: string key = 1;
     */
    key: string;
    /**
     * @generated from protobuf field: string value = 2;
     */
    value: string;
    /**
     * @generated from protobuf field: string type = 3;
     */
    type: string;
    /**
     * @generated from protobuf field: string defaultValue = 4;
     */
    defaultValue: string;
    /**
     * @generated from protobuf field: bool enabled = 5;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string description = 6;
     */
    description: string;
}
/**
 * @generated from protobuf message ProtoMessages.ConfigurationMessage
 */
export interface ConfigurationMessage {
    /**
     * @generated from protobuf field: ProtoMessages.ConfigurationAction action = 1;
     */
    action: ConfigurationAction;
    /**
     * @generated from protobuf field: repeated ProtoMessages.ConfigurationParameter configParam = 2;
     */
    configParam: ConfigurationParameter[];
}
/**
 * @generated from protobuf message ProtoMessages.GeneralMessage
 */
export interface GeneralMessage {
    /**
     * @generated from protobuf field: ProtoMessages.MessageType messageType = 1;
     */
    messageType?: MessageType;
    /**
     * @generated from protobuf field: ProtoMessages.StatusInformationMessage statusInformationMessage = 2;
     */
    statusInformationMessage?: StatusInformationMessage;
    /**
     * @generated from protobuf field: ProtoMessages.RealtimeInformationMessage realtimeInformationMessage = 3;
     */
    realtimeInformationMessage?: RealtimeInformationMessage;
    /**
     * @generated from protobuf field: ProtoMessages.StaticInformationMessage staticInformationMessage = 4;
     */
    staticInformationMessage?: StaticInformationMessage;
    /**
     * @generated from protobuf field: ProtoMessages.CommandMessage commandMessage = 5;
     */
    commandMessage?: CommandMessage;
    /**
     * @generated from protobuf field: ProtoMessages.CoachingAdditionalAngleList coachingAdditionalAngleMessage = 6;
     */
    coachingAdditionalAngleMessage?: CoachingAdditionalAngleList;
    /**
     * @generated from protobuf field: ProtoMessages.FileTransferMessage fileImportExportFile = 7;
     */
    fileImportExportFile?: FileTransferMessage;
    /**
     * @generated from protobuf field: ProtoMessages.VersionMessage versionMessage = 8;
     */
    versionMessage?: VersionMessage;
    /**
     * @generated from protobuf field: ProtoMessages.SingleParamInformationMessage singleParamInformationMessage = 9;
     */
    singleParamInformationMessage?: SingleParamInformationMessage;
    /**
     * @generated from protobuf field: ProtoMessages.CcuUpdateMessage ccuUpdateMessage = 10;
     */
    ccuUpdateMessage?: CcuUpdateMessage;
    /**
     * LogsGrpc.LogMessage logMessage = 11;
     *
     * @generated from protobuf field: ProtoMessages.ConfigurationMessage configurationAction = 12;
     */
    configurationAction?: ConfigurationMessage;
    /**
     * @generated from protobuf field: ProtoMessages.NetworkTestRequest networkTestRequest = 14;
     */
    networkTestRequest?: NetworkTestRequest;
    /**
     * NetworkTestResult networkTestResult = 15;
     *
     * @generated from protobuf field: ProtoMessages.NetworkValidation networkValidation = 16;
     */
    networkValidation?: NetworkValidation;
    /**
     * @generated from protobuf field: ProtoMessages.OperatingSystemMessage operatingSystemMessage = 17;
     */
    operatingSystemMessage?: OperatingSystemMessage;
    /**
     * @generated from protobuf field: ProtoMessages.PingPongMessage pingPongMessage = 19;
     */
    pingPongMessage?: PingPongMessage;
    /**
     * @generated from protobuf field: ProtoMessages.VenueSelfTestProgressMessage venueSelfTestProgressMessage = 20;
     */
    venueSelfTestProgressMessage?: VenueSelfTestProgressMessage;
}
/**
 * @generated from protobuf message ProtoMessages.VenueCalibrationDataRequest
 */
export interface VenueCalibrationDataRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.VenueCalibrationDataResponse
 */
export interface VenueCalibrationDataResponse {
    /**
     * @generated from protobuf field: repeated CommonUsedMessages.VenueCalibrationData venueCalibrationData = 1;
     */
    venueCalibrationData: VenueCalibrationData[];
}
/**
 * @generated from protobuf message ProtoMessages.DetectUnpairedCamerasRequest
 */
export interface DetectUnpairedCamerasRequest {
    /**
     * @generated from protobuf field: repeated string pairedCamerasIp = 1;
     */
    pairedCamerasIp: string[];
}
/**
 * @generated from protobuf message ProtoMessages.DetectUnpairedCamerasResponse
 */
export interface DetectUnpairedCamerasResponse {
    /**
     * @generated from protobuf field: repeated ProtoMessages.DynaColorCameraInfo unpairedCameras = 1;
     */
    unpairedCameras: DynaColorCameraInfo[];
}
/**
 * @generated from protobuf message ProtoMessages.DynaColorCameraInfo
 */
export interface DynaColorCameraInfo {
    /**
     * @generated from protobuf field: string ip = 1;
     */
    ip: string;
    /**
     * @generated from protobuf field: string model = 2;
     */
    model: string;
    /**
     * @generated from protobuf field: string gateway = 3;
     */
    gateway: string;
    /**
     * @generated from protobuf field: string subnetMask = 4;
     */
    subnetMask: string;
    /**
     * @generated from protobuf field: string macAddress = 5;
     */
    macAddress: string;
}
/**
 * @generated from protobuf message ProtoMessages.ResetCHURequest
 */
export interface ResetCHURequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.ResetCHUResponse
 */
export interface ResetCHUResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.PingCameraRequest
 */
export interface PingCameraRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.PingCameraResponse
 */
export interface PingCameraResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.GetLocalRecordingStreamsRequest
 */
export interface GetLocalRecordingStreamsRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.GetLocalRecordingStreamsResponse
 */
export interface GetLocalRecordingStreamsResponse {
    /**
     * @generated from protobuf field: repeated ProtoMessages.StreamConfig streams = 1;
     */
    streams: StreamConfig[];
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 2;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.StreamConfig
 */
export interface StreamConfig {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string url = 2;
     */
    url: string;
    /**
     * @generated from protobuf field: uint32 index = 3;
     */
    index: number;
    /**
     * @generated from protobuf field: uint32 bandwidth = 4;
     */
    bandwidth: number;
    /**
     * @generated from protobuf field: uint32 fps = 5;
     */
    fps: number;
    /**
     * @generated from protobuf field: string status = 6;
     */
    status: string;
}
/**
 * For detect button, sets new info
 *
 * @generated from protobuf message ProtoMessages.DetectAudioSourceRequest
 */
export interface DetectAudioSourceRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.DetectAudioSourceResponse
 */
export interface DetectAudioSourceResponse {
    /**
     * @generated from protobuf field: repeated ProtoMessages.AudioSourceData detectAudioSources = 1;
     */
    detectAudioSources: AudioSourceData[];
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 2;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
}
/**
 * For the Peripherals page
 *
 * @generated from protobuf message ProtoMessages.CurrentAudioSourceDataRequest
 */
export interface CurrentAudioSourceDataRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.CurrentAudioSourceDataResponse
 */
export interface CurrentAudioSourceDataResponse {
    /**
     * @generated from protobuf field: ProtoMessages.AudioSourceData audioSourceData = 1;
     */
    audioSourceData?: AudioSourceData;
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 2;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
}
/**
 * To update to the current source, gets the last info
 *
 * @generated from protobuf message ProtoMessages.UpdateCurrentAudioSourceRequest
 */
export interface UpdateCurrentAudioSourceRequest {
    /**
     * @generated from protobuf field: ProtoMessages.CommentatorType selectedType = 1;
     */
    selectedType?: CommentatorType;
}
/**
 * @generated from protobuf message ProtoMessages.UpdateCurrentAudioSourceResponse
 */
export interface UpdateCurrentAudioSourceResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.AudioSourceData
 */
export interface AudioSourceData {
    /**
     * @generated from protobuf field: ProtoMessages.CommentatorType commentatorType = 1;
     */
    commentatorType?: CommentatorType;
    /**
     * @generated from protobuf field: ProtoMessages.Bool displayAudioLevel = 2;
     */
    displayAudioLevel?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Int32 currentAudioVolume = 3;
     */
    currentAudioVolume?: Int32;
    /**
     * @generated from protobuf field: ProtoMessages.Bool selected = 4;
     */
    selected?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.String compatibilityStatus = 5;
     */
    compatibilityStatus?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String fpsSupport = 6;
     */
    fpsSupport?: String$;
}
/**
 * @generated from protobuf message ProtoMessages.CommentatorType
 */
export interface CommentatorType {
    /**
     * @generated from protobuf field: ProtoMessages.CommentatorType.Type value = 1;
     */
    value: CommentatorType_Type;
}
/**
 * @generated from protobuf enum ProtoMessages.CommentatorType.Type
 */
export enum CommentatorType_Type {
    /**
     * @generated from protobuf enum value: UNKNOWN_AUDIO_TYPE = 0;
     */
    UNKNOWN_AUDIO_TYPE = 0,
    /**
     * @generated from protobuf enum value: BEHRINGER = 1;
     */
    BEHRINGER = 1,
    /**
     * @generated from protobuf enum value: OFF = 2;
     */
    OFF = 2,
    /**
     * @generated from protobuf enum value: MIC = 3;
     */
    MIC = 3,
    /**
     * @generated from protobuf enum value: AUX = 4;
     */
    AUX = 4
}
/**
 * @generated from protobuf message ProtoMessages.UpdateCommentatorAudioVolumeRequest
 */
export interface UpdateCommentatorAudioVolumeRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Int32 volume = 1;
     */
    volume?: Int32;
}
/**
 * @generated from protobuf message ProtoMessages.UpdateCommentatorAudioVolumeResponse
 */
export interface UpdateCommentatorAudioVolumeResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: ProtoMessages.Int32 volume = 3;
     */
    volume?: Int32;
}
/**
 * @generated from protobuf message ProtoMessages.AudioSourceInputLevelStartRequest
 */
export interface AudioSourceInputLevelStartRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.AudioSourceInputLevelResponse
 */
export interface AudioSourceInputLevelResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Int32 level = 1;
     */
    level?: Int32;
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 2;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.AudioSourceInputLevelStopRequest
 */
export interface AudioSourceInputLevelStopRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.PingPongMessage
 */
export interface PingPongMessage {
    /**
     * @generated from protobuf field: ProtoMessages.Int64 msg = 1;
     */
    msg?: Int64;
}
/**
 * @generated from protobuf message ProtoMessages.StatusInformationMessage
 */
export interface StatusInformationMessage {
    /**
     * @generated from protobuf field: ProtoMessages.GeneralStatus systemStatus = 1;
     */
    systemStatus?: GeneralStatus;
    /**
     * @generated from protobuf field: ProtoMessages.VpuStatus vpuStatus = 2;
     */
    vpuStatus?: VpuStatus;
    /**
     * GeneralStatus audioStatus = 3;
     *
     * @generated from protobuf field: ProtoMessages.SystemMode systemMode = 4;
     */
    systemMode?: SystemMode;
    /**
     * @generated from protobuf field: ProtoMessages.WorkingHours workingHours = 5;
     */
    workingHours?: WorkingHours;
    /**
     * @generated from protobuf field: ProtoMessages.StreamsInfo streamsInfo = 6;
     */
    streamsInfo?: StreamsInfo;
    /**
     * @generated from protobuf field: ProtoMessages.EventInfo currentEvent = 7;
     */
    currentEvent?: EventInfo;
    /**
     * @generated from protobuf field: ProtoMessages.EventInfo upcomingEvent = 8;
     */
    upcomingEvent?: EventInfo;
    /**
     * @generated from protobuf field: ProtoMessages.SportsType sportsType = 9;
     */
    sportsType?: SportsType;
    /**
     * @generated from protobuf field: ProtoMessages.Bool highlightsEnabled = 10;
     */
    highlightsEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.GraphicEngineInfo graphicsInfo = 11;
     */
    graphicsInfo?: GraphicEngineInfo;
    /**
     * @generated from protobuf field: ProtoMessages.Bool manualCameraEnabled = 12;
     */
    manualCameraEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool clipperLiveEnabled = 13;
     */
    clipperLiveEnabled?: Bool;
    /**
     * @generated from protobuf field: repeated ProtoMessages.CameraInformation headCameras = 14;
     */
    headCameras: CameraInformation[];
    /**
     * @generated from protobuf field: ProtoMessages.Int64 lastModifiedCalibration = 15;
     */
    lastModifiedCalibration?: Int64;
    /**
     * @generated from protobuf field: ProtoMessages.Int64 lastModifiedColorBalance = 16;
     */
    lastModifiedColorBalance?: Int64;
    /**
     * @generated from protobuf field: ProtoMessages.Int64 lastModifiedCCU = 17;
     */
    lastModifiedCCU?: Int64;
    /**
     * @generated from protobuf field: ProtoMessages.Bool audioEnabled = 18;
     */
    audioEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.String poeLastReset = 19;
     */
    poeLastReset?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String nicInfo = 20;
     */
    nicInfo?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Bool autoProductionEnabled = 21;
     */
    autoProductionEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool autoLightControlEnabled = 22;
     */
    autoLightControlEnabled?: Bool;
    /**
     * Bool tryLeaveMaintenanceMode = 23;
     *
     * @generated from protobuf field: ProtoMessages.Bool stayInMaintenanceMode = 24;
     */
    stayInMaintenanceMode?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.ToggleSetupMode toggleSetupMode = 25;
     */
    toggleSetupMode?: ToggleSetupMode;
    /**
     * @generated from protobuf field: ProtoMessages.Bool setupModeOn = 26;
     */
    setupModeOn?: Bool; // Int32 autoLightControlValue = 27;
    /**
     * Bool licenseUpdateSucceeded = 28;
     * Bool forceLeaveSetupMode = 29;
     *
     * @generated from protobuf field: ProtoMessages.Bool cgEngineState = 30;
     */
    cgEngineState?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool pipState = 31;
     */
    pipState?: Bool;
    /**
     * CameraFramesData cameraFramesData = 32;
     * repeated TestPorts requestedTestPorts = 33;
     *
     * @generated from protobuf field: repeated ProtoMessages.TestPortsResult testPortsResult = 34;
     */
    testPortsResult: TestPortsResult[];
    /**
     * @generated from protobuf field: ProtoMessages.Bool sdiEnabled = 35;
     */
    sdiEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool graphicsUpdateRequired = 37;
     */
    graphicsUpdateRequired?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool varSupportEnabled = 38;
     */
    varSupportEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool allowPing = 39;
     */
    allowPing?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Int64 audioVolumeUpdated = 40;
     */
    audioVolumeUpdated?: Int64;
    /**
     * @generated from protobuf field: ProtoMessages.Int64 audioGainUpdated = 41;
     */
    audioGainUpdated?: Int64;
    /**
     * @generated from protobuf field: ProtoMessages.LigrStatus ligrStatus = 42;
     */
    ligrStatus?: LigrStatus;
    /**
     * @generated from protobuf field: ProtoMessages.Bool debugPrintoutsEnabled = 43;
     */
    debugPrintoutsEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool systemHasCalibration = 44;
     */
    systemHasCalibration?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.String reason = 45;
     */
    reason?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.SdiFormat sdiFormat = 46;
     */
    sdiFormat?: SdiFormat;
    /**
     * @generated from protobuf field: ProtoMessages.Bool sdiGraphicsEnabled = 47;
     */
    sdiGraphicsEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool dualRenderingInProgress = 48;
     */
    dualRenderingInProgress?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.ChuStatus chuStatus = 49;
     */
    chuStatus?: ChuStatus;
    /**
     * @generated from protobuf field: ProtoMessages.Bool applyColorCalibrationMatrix = 50;
     */
    applyColorCalibrationMatrix?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool manualMidrollEnabled = 51;
     */
    manualMidrollEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool useSmartMidroll = 52;
     */
    useSmartMidroll?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool smartMidrollSimulator = 53;
     */
    smartMidrollSimulator?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool scoreboardManualFromVideo = 54;
     */
    scoreboardManualFromVideo?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.SdiFormat
 */
export interface SdiFormat {
    /**
     * @generated from protobuf field: ProtoMessages.SdiFormat.Format value = 1;
     */
    value: SdiFormat_Format;
}
/**
 * @generated from protobuf enum ProtoMessages.SdiFormat.Format
 */
export enum SdiFormat_Format {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: SMPTE_LEVEL_A = 1;
     */
    SMPTE_LEVEL_A = 1,
    /**
     * @generated from protobuf enum value: SMPTE_LEVEL_B = 2;
     */
    SMPTE_LEVEL_B = 2
}
/**
 * @generated from protobuf message ProtoMessages.RealtimeInformationMessage
 */
export interface RealtimeInformationMessage {
    /**
     * @generated from protobuf field: ProtoMessages.Double cpuUsage = 1;
     */
    cpuUsage?: Double;
    /**
     * @generated from protobuf field: ProtoMessages.Double cpuTemperature = 2;
     */
    cpuTemperature?: Double;
    /**
     * @generated from protobuf field: ProtoMessages.Double gpuUsage = 3;
     */
    gpuUsage?: Double;
    /**
     * @generated from protobuf field: ProtoMessages.Bool health = 4;
     */
    health?: Bool;
    /**
     * @generated from protobuf field: repeated ProtoMessages.DriveInformation drives = 5;
     */
    drives: DriveInformation[];
    /**
     * @generated from protobuf field: ProtoMessages.Bool backendConnection = 6;
     */
    backendConnection?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool autoProductionState = 7;
     */
    autoProductionState?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool autoLightControlState = 8;
     */
    autoLightControlState?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.GeneralStatus panoStreamStatus = 9;
     */
    panoStreamStatus?: GeneralStatus;
    /**
     * @generated from protobuf field: ProtoMessages.GeneralStatus hdStreamStatus = 10;
     */
    hdStreamStatus?: GeneralStatus;
    /**
     * @generated from protobuf field: ProtoMessages.Bool audioStatus = 11;
     */
    audioStatus?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Double memoryUsage = 12;
     */
    memoryUsage?: Double;
    /**
     * @generated from protobuf field: ProtoMessages.AutoLightControlValues autoLightControlValues = 13;
     */
    autoLightControlValues?: AutoLightControlValues;
}
/**
 * @generated from protobuf message ProtoMessages.SingleParamInformationMessage
 */
export interface SingleParamInformationMessage {
    /**
     * @generated from protobuf field: ProtoMessages.CameraFramesData cameraFramesData = 1;
     */
    cameraFramesData?: CameraFramesData;
    /**
     * @generated from protobuf field: ProtoMessages.Bool licenseUpdateSucceeded = 2;
     */
    licenseUpdateSucceeded?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool forceLeaveSetupMode = 3;
     */
    forceLeaveSetupMode?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool tryLeaveMaintenanceMode = 4;
     */
    tryLeaveMaintenanceMode?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.PanoramaInfo panoramaInfo = 7;
     */
    panoramaInfo?: PanoramaInfo;
    /**
     * @generated from protobuf field: repeated ProtoMessages.CCUPreset ccuPresets = 8;
     */
    ccuPresets: CCUPreset[];
    /**
     * @generated from protobuf field: repeated ProtoMessages.String detectedCameras = 9;
     */
    detectedCameras: String$[];
    /**
     * @generated from protobuf field: ProtoMessages.Bool cameraRestoreSucceeded = 10;
     */
    cameraRestoreSucceeded?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool enterSetupModeFailed = 11;
     */
    enterSetupModeFailed?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.CameraFramesData headSetupFramesData = 12;
     */
    headSetupFramesData?: CameraFramesData; // temporarily use the same data for head setup frames
    /**
     * @generated from protobuf field: ProtoMessages.Int32 currentVpuPhaseIndex = 13;
     */
    currentVpuPhaseIndex?: Int32;
}
/**
 * @generated from protobuf message ProtoMessages.CameraDetailsFromPNRequest
 */
export interface CameraDetailsFromPNRequest {
    /**
     * @generated from protobuf field: ProtoMessages.String partNumber = 1;
     */
    partNumber?: String$;
}
/**
 * @generated from protobuf message ProtoMessages.CameraDetailsFromPNResponse
 */
export interface CameraDetailsFromPNResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool validPN = 1;
     */
    validPN?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.CameraData data = 2;
     */
    data?: CameraData;
}
/**
 * @generated from protobuf message ProtoMessages.StartPairingVpum
 */
export interface StartPairingVpum {
    /**
     * @generated from protobuf field: ProtoMessages.RunPairingWithData pairingdata = 1;
     */
    pairingdata?: RunPairingWithData;
}
/**
 * @generated from protobuf message ProtoMessages.CameraData
 */
export interface CameraData {
    /**
     * @generated from protobuf field: ProtoMessages.String numOfCameras = 1;
     */
    numOfCameras?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String cameraType = 2;
     */
    cameraType?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String lensType = 3;
     */
    lensType?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String calibration = 4;
     */
    calibration?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.CameraData.Type systemType = 5;
     */
    systemType: CameraData_Type;
    /**
     * @generated from protobuf field: ProtoMessages.Bool isFirstPairing = 6;
     */
    isFirstPairing?: Bool;
}
/**
 * @generated from protobuf enum ProtoMessages.CameraData.Type
 */
export enum CameraData_Type {
    /**
     * @generated from protobuf enum value: S1 = 0;
     */
    S1 = 0,
    /**
     * @generated from protobuf enum value: S2 = 1;
     */
    S2 = 1,
    /**
     * @generated from protobuf enum value: S3 = 2;
     */
    S3 = 2,
    /**
     * @generated from protobuf enum value: PRIME = 3;
     */
    PRIME = 3,
    /**
     * @generated from protobuf enum value: S2S = 4;
     */
    S2S = 4,
    /**
     * @generated from protobuf enum value: S2C = 5;
     */
    S2C = 5,
    /**
     * @generated from protobuf enum value: SOLO = 6;
     */
    SOLO = 6,
    /**
     * @generated from protobuf enum value: SINGLEPLAY = 7;
     */
    SINGLEPLAY = 7
}
/**
 * @generated from protobuf message ProtoMessages.RunPairingWithData
 */
export interface RunPairingWithData {
    /**
     * @generated from protobuf field: ProtoMessages.RunPairingWithData.Type systemType = 1;
     */
    systemType: RunPairingWithData_Type;
    /**
     * @generated from protobuf field: ProtoMessages.String partNumber = 2;
     */
    partNumber?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String s2CalibrationFolder = 3;
     */
    s2CalibrationFolder?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.RunPairingWithData.VideoStandard videoStandard = 4;
     */
    videoStandard: RunPairingWithData_VideoStandard;
    /**
     * @generated from protobuf field: ProtoMessages.RunPairingWithData.FrameStandard primeFrameStandard = 5;
     */
    primeFrameStandard: RunPairingWithData_FrameStandard;
    /**
     * @generated from protobuf field: ProtoMessages.RunPairingWithData.Units units = 6;
     */
    units: RunPairingWithData_Units;
    /**
     * @generated from protobuf field: ProtoMessages.RunPairingWithData.FieldType fieldType = 7;
     */
    fieldType: RunPairingWithData_FieldType;
    /**
     * @generated from protobuf field: int32 standoff = 8;
     */
    standoff: number;
    /**
     * @generated from protobuf field: int32 height = 9;
     */
    height: number;
    /**
     * @generated from protobuf field: ProtoMessages.String firmwareModel = 10;
     */
    firmwareModel?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String soloCameraManufacturer = 11;
     */
    soloCameraManufacturer?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String soloCameraModel = 12;
     */
    soloCameraModel?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String soloCameraUsername = 13;
     */
    soloCameraUsername?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String soloCameraPassword = 14;
     */
    soloCameraPassword?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String serialNumber = 15;
     */
    serialNumber?: String$;
}
/**
 * @generated from protobuf enum ProtoMessages.RunPairingWithData.VideoStandard
 */
export enum RunPairingWithData_VideoStandard {
    /**
     * @generated from protobuf enum value: UNKNOWN_VIDEO_STANDARD = 0;
     */
    UNKNOWN_VIDEO_STANDARD = 0,
    /**
     * @generated from protobuf enum value: PAL = 1;
     */
    PAL = 1,
    /**
     * @generated from protobuf enum value: NTSC = 2;
     */
    NTSC = 2
}
/**
 * @generated from protobuf enum ProtoMessages.RunPairingWithData.FrameStandard
 */
export enum RunPairingWithData_FrameStandard {
    /**
     * @generated from protobuf enum value: UNKNOWN_FRAME_STANDARD = 0;
     */
    UNKNOWN_FRAME_STANDARD = 0,
    /**
     * @generated from protobuf enum value: SMALL = 1;
     */
    SMALL = 1,
    /**
     * @generated from protobuf enum value: BIG = 2;
     */
    BIG = 2
}
/**
 * @generated from protobuf enum ProtoMessages.RunPairingWithData.Type
 */
export enum RunPairingWithData_Type {
    /**
     * @generated from protobuf enum value: S1 = 0;
     */
    S1 = 0,
    /**
     * @generated from protobuf enum value: S2 = 1;
     */
    S2 = 1,
    /**
     * @generated from protobuf enum value: S3 = 2;
     */
    S3 = 2,
    /**
     * @generated from protobuf enum value: PRIME = 3;
     */
    PRIME = 3,
    /**
     * @generated from protobuf enum value: S2S = 4;
     */
    S2S = 4,
    /**
     * @generated from protobuf enum value: S2C = 5;
     */
    S2C = 5,
    /**
     * @generated from protobuf enum value: SOLO = 6;
     */
    SOLO = 6,
    /**
     * @generated from protobuf enum value: SINGLEPLAY = 7;
     */
    SINGLEPLAY = 7
}
/**
 * @generated from protobuf enum ProtoMessages.RunPairingWithData.FieldType
 */
export enum RunPairingWithData_FieldType {
    /**
     * @generated from protobuf enum value: UNKNOWN_FIELD_TYPE = 0;
     */
    UNKNOWN_FIELD_TYPE = 0,
    /**
     * @generated from protobuf enum value: BASKETBALL = 1;
     */
    BASKETBALL = 1,
    /**
     * Soccer / Football full size
     *
     * @generated from protobuf enum value: SOCCER = 2;
     */
    SOCCER = 2,
    /**
     * @generated from protobuf enum value: BASEBALL = 3;
     */
    BASEBALL = 3,
    /**
     * @generated from protobuf enum value: ICE_HOCKEY = 4;
     */
    ICE_HOCKEY = 4,
    /**
     * Handball / Futsal
     *
     * @generated from protobuf enum value: HANDBALL = 5;
     */
    HANDBALL = 5,
    /**
     * @generated from protobuf enum value: CRICKET = 6;
     */
    CRICKET = 6,
    /**
     * @generated from protobuf enum value: BASEBALL_OR_SOFTBALL = 7;
     */
    BASEBALL_OR_SOFTBALL = 7,
    /**
     * @generated from protobuf enum value: GENERAL = 8;
     */
    GENERAL = 8
}
/**
 * @generated from protobuf enum ProtoMessages.RunPairingWithData.Units
 */
export enum RunPairingWithData_Units {
    /**
     * @generated from protobuf enum value: UNKNOWN_UNITS = 0;
     */
    UNKNOWN_UNITS = 0,
    /**
     * @generated from protobuf enum value: METERS = 1;
     */
    METERS = 1,
    /**
     * @generated from protobuf enum value: FEET = 2;
     */
    FEET = 2
}
/**
 * @generated from protobuf message ProtoMessages.ChuFirmwareModelsRequest
 */
export interface ChuFirmwareModelsRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.firmwareModel
 */
export interface firmwareModel {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: ProtoMessages.Bool default = 2;
     */
    default?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.ChuFirmwareModelsResponse
 */
export interface ChuFirmwareModelsResponse {
    /**
     * @generated from protobuf field: repeated ProtoMessages.firmwareModel firmwareModels = 1;
     */
    firmwareModels: firmwareModel[];
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 2;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.ChuSoloCameraModelsRequest
 */
export interface ChuSoloCameraModelsRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.SoloManufacturer
 */
export interface SoloManufacturer {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: repeated string models = 2;
     */
    models: string[];
}
/**
 * @generated from protobuf message ProtoMessages.ChuSoloCameraModelsResponse
 */
export interface ChuSoloCameraModelsResponse {
    /**
     * @generated from protobuf field: repeated ProtoMessages.SoloManufacturer manufacturers = 1;
     */
    manufacturers: SoloManufacturer[];
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 2;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.CcuUpdateMessage
 */
export interface CcuUpdateMessage {
    /**
     * @generated from protobuf field: ProtoMessages.CCUData newVPUCCUData = 1;
     */
    newVPUCCUData?: CCUData;
}
/**
 * @generated from protobuf message ProtoMessages.PanoramaInfo
 */
export interface PanoramaInfo {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.String panoramaErrorMessage = 2;
     */
    panoramaErrorMessage?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String panoramaFile = 3;
     */
    panoramaFile?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.CCUData ccuData = 4;
     */
    ccuData?: CCUData;
}
/**
 * @generated from protobuf message ProtoMessages.CCUData
 */
export interface CCUData {
    /**
     * @generated from protobuf field: float saturation = 1;
     */
    saturation: number;
    /**
     * float intensity = 2;
     *
     * @generated from protobuf field: float hue = 3;
     */
    hue: number;
    /**
     * @generated from protobuf field: float gamma = 4;
     */
    gamma: number;
    /**
     * @generated from protobuf field: float contrast = 5;
     */
    contrast: number;
    /**
     * @generated from protobuf field: float intensity = 6;
     */
    intensity: number;
    /**
     * @generated from protobuf field: float rx1 = 7;
     */
    rx1: number;
    /**
     * @generated from protobuf field: float rx2 = 8;
     */
    rx2: number;
    /**
     * @generated from protobuf field: float gx1 = 9;
     */
    gx1: number;
    /**
     * @generated from protobuf field: float gx2 = 10;
     */
    gx2: number;
    /**
     * @generated from protobuf field: float bx1 = 11;
     */
    bx1: number;
    /**
     * @generated from protobuf field: float bx2 = 12;
     */
    bx2: number;
}
/**
 * @generated from protobuf message ProtoMessages.AutoLightControlValues
 */
export interface AutoLightControlValues {
    /**
     * @generated from protobuf field: ProtoMessages.Int32 autoLightControlLiveValue = 1;
     */
    autoLightControlLiveValue?: Int32;
    /**
     * @generated from protobuf field: ProtoMessages.Int32 autoLightControlHealth = 2;
     */
    autoLightControlHealth?: Int32;
    /**
     * @generated from protobuf field: ProtoMessages.Int32 autoLightControlDesiredBrightness = 3;
     */
    autoLightControlDesiredBrightness?: Int32;
}
/**
 * @generated from protobuf message ProtoMessages.FileTransferMessage
 */
export interface FileTransferMessage {
    /**
     * @generated from protobuf field: string fileName = 1;
     */
    fileName: string;
    /**
     * @generated from protobuf field: uint64 fileSize = 2;
     */
    fileSize: bigint;
    /**
     * @generated from protobuf field: bytes content = 3;
     */
    content: Uint8Array;
    /**
     * @generated from protobuf field: int32 offset = 4;
     */
    offset: number;
    /**
     * @generated from protobuf field: int32 count = 5;
     */
    count: number;
    /**
     * @generated from protobuf field: ProtoMessages.FileTransferMessage.FileType fileType = 6;
     */
    fileType: FileTransferMessage_FileType;
    /**
     * @generated from protobuf field: ProtoMessages.FileTransferMessage.TransferType transferType = 7;
     */
    transferType: FileTransferMessage_TransferType;
    /**
     * @generated from protobuf field: string data = 8;
     */
    data: string;
}
/**
 * @generated from protobuf enum ProtoMessages.FileTransferMessage.FileType
 */
export enum FileTransferMessage_FileType {
    /**
     * @generated from protobuf enum value: CONFIGURATION_FILE = 0;
     */
    CONFIGURATION_FILE = 0,
    /**
     * @generated from protobuf enum value: CALIBRATION_FILE = 1;
     */
    CALIBRATION_FILE = 1,
    /**
     * @generated from protobuf enum value: PIP_FILE = 2;
     */
    PIP_FILE = 2
}
/**
 * @generated from protobuf enum ProtoMessages.FileTransferMessage.TransferType
 */
export enum FileTransferMessage_TransferType {
    /**
     * @generated from protobuf enum value: IMPORT = 0;
     */
    IMPORT = 0,
    /**
     * @generated from protobuf enum value: EXPORT = 1;
     */
    EXPORT = 1
}
/**
 * @generated from protobuf message ProtoMessages.DriveInformation
 */
export interface DriveInformation {
    /**
     * @generated from protobuf field: ProtoMessages.String letter = 1;
     */
    letter?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Int64 totalSpace = 2;
     */
    totalSpace?: Int64; // In MB
    /**
     * @generated from protobuf field: ProtoMessages.Int64 freeSpace = 3;
     */
    freeSpace?: Int64; // In MB
    /**
     * @generated from protobuf field: ProtoMessages.String toolTip = 4;
     */
    toolTip?: String$;
}
/**
 * @generated from protobuf message ProtoMessages.StaticInformationMessage
 */
export interface StaticInformationMessage {
    /**
     * @generated from protobuf field: ProtoMessages.String venueId = 1;
     */
    venueId?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String venueName = 2;
     */
    venueName?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String venueDescription = 3;
     */
    venueDescription?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.SystemType systemType = 4;
     */
    systemType?: SystemType;
    /**
     * @generated from protobuf field: ProtoMessages.String totalMemory = 5;
     */
    totalMemory?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.SwitchInfo switchInfo = 6;
     */
    switchInfo?: SwitchInfo;
    /**
     * @generated from protobuf field: ProtoMessages.String licenseInfo = 7;
     */
    licenseInfo?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String softwareVersion = 8;
     */
    softwareVersion?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.NasInfo nasInfo = 9;
     */
    nasInfo?: NasInfo;
    /**
     * @generated from protobuf field: ProtoMessages.String gpuName = 10;
     */
    gpuName?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String gpuDriverVersion = 11;
     */
    gpuDriverVersion?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Float cameraFPS = 12;
     */
    cameraFPS?: Float;
    /**
     * @generated from protobuf field: ProtoMessages.String cameraPartNumber = 13;
     */
    cameraPartNumber?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.CameraFPSChangeStatus allowFpsChange = 14;
     */
    allowFpsChange?: CameraFPSChangeStatus;
    /**
     * @generated from protobuf field: ProtoMessages.String dongleId = 15;
     */
    dongleId?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String headType = 16;
     */
    headType?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Bool licenseInfoValid = 17;
     */
    licenseInfoValid?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Int64 audioVolumeUpdated = 18;
     */
    audioVolumeUpdated?: Int64;
    /**
     * @generated from protobuf field: ProtoMessages.Int64 audioGainUpdated = 19;
     */
    audioGainUpdated?: Int64;
    /**
     * @generated from protobuf field: ProtoMessages.NetworkInfo networkInfo = 20;
     */
    networkInfo?: NetworkInfo;
    /**
     * @generated from protobuf field: ProtoMessages.String cpuName = 21;
     */
    cpuName?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String vpuMac = 22;
     */
    vpuMac?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Environment venueEnv = 23;
     */
    venueEnv?: Environment;
    /**
     * @generated from protobuf field: ProtoMessages.String OemSerialNumber = 24 [json_name = "OemSerialNumber"];
     */
    oemSerialNumber?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.HeaterMode cameraHeaterMode = 25;
     */
    cameraHeaterMode?: HeaterMode;
    /**
     * @generated from protobuf field: ProtoMessages.String cameraRevision = 26;
     */
    cameraRevision?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.AudioEqualizerMode audioEqualizerMode = 27;
     */
    audioEqualizerMode?: AudioEqualizerMode;
}
/**
 * @generated from protobuf message ProtoMessages.Environment
 */
export interface Environment {
    /**
     * @generated from protobuf field: ProtoMessages.Environment.Env value = 1;
     */
    value: Environment_Env;
}
/**
 * @generated from protobuf enum ProtoMessages.Environment.Env
 */
export enum Environment_Env {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: DEV = 1;
     */
    DEV = 1,
    /**
     * @generated from protobuf enum value: STAGE = 2;
     */
    STAGE = 2,
    /**
     * @generated from protobuf enum value: PROD = 3;
     */
    PROD = 3
}
/**
 * @generated from protobuf message ProtoMessages.EventInfo
 */
export interface EventInfo {
    /**
     * @generated from protobuf field: ProtoMessages.String name = 1;
     */
    name?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Uint64 startTime = 2;
     */
    startTime?: Uint64;
    /**
     * @generated from protobuf field: ProtoMessages.Uint64 endTime = 3;
     */
    endTime?: Uint64;
    /**
     * @generated from protobuf field: ProtoMessages.SportsType sportType = 4;
     */
    sportType?: SportsType;
}
/**
 * @generated from protobuf message ProtoMessages.WorkingHours
 */
export interface WorkingHours {
    /**
     * @generated from protobuf field: ProtoMessages.String from = 1;
     */
    from?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String to = 2;
     */
    to?: String$;
}
/**
 * @generated from protobuf message ProtoMessages.StreamsInfo
 */
export interface StreamsInfo {
    /**
     * @generated from protobuf field: ProtoMessages.Bool hdEnabled = 1;
     */
    hdEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Float hdBandwidth = 2;
     */
    hdBandwidth?: Float;
    /**
     * @generated from protobuf field: ProtoMessages.String hdUrl = 3;
     */
    hdUrl?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Bool panoEnabled = 4;
     */
    panoEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Float panoBandwidth = 5;
     */
    panoBandwidth?: Float;
    /**
     * @generated from protobuf field: ProtoMessages.String panoUrl = 6;
     */
    panoUrl?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Bool adaptiveBitrateEnabled = 7;
     */
    adaptiveBitrateEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.String hdVideoFormat = 8;
     */
    hdVideoFormat?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Bool cameraEnabled = 10;
     */
    cameraEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Float cameraBandwidth = 11;
     */
    cameraBandwidth?: Float;
    /**
     * @generated from protobuf field: ProtoMessages.String cameraUrl = 12;
     */
    cameraUrl?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String cameraVideoFormat = 13;
     */
    cameraVideoFormat?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Bool panoGraphicsEnabled = 15;
     */
    panoGraphicsEnabled?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.SwitchInfo
 */
export interface SwitchInfo {
    /**
     * @generated from protobuf field: ProtoMessages.String ip = 1;
     */
    ip?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.SwitchType type = 2;
     */
    type?: SwitchType;
}
/**
 * @generated from protobuf message ProtoMessages.GraphicEngineInfo
 */
export interface GraphicEngineInfo {
    /**
     * @generated from protobuf field: ProtoMessages.GraphicEngineInfo.ScoreboardType sbType = 1;
     */
    sbType: GraphicEngineInfo_ScoreboardType;
    /**
     * @generated from protobuf field: ProtoMessages.GraphicEngineInfo.GraphicsDataProvider provider = 2;
     */
    provider: GraphicEngineInfo_GraphicsDataProvider;
    /**
     * @generated from protobuf field: ProtoMessages.GraphicEngineInfo.GraphicsUiType uiType = 3;
     */
    uiType: GraphicEngineInfo_GraphicsUiType;
    /**
     * @generated from protobuf field: ProtoMessages.String ip = 4;
     */
    ip?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.String pipUrl = 5;
     */
    pipUrl?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Bool useOcr = 6;
     */
    useOcr?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.String authentication = 7;
     */
    authentication?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Bool useEnhancedPip = 8;
     */
    useEnhancedPip?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool isOutdoorSports = 9;
     */
    isOutdoorSports?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool multiSportEnabledInVpum = 10;
     */
    multiSportEnabledInVpum?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool AlcOcrIsEnabled = 11 [json_name = "AlcOcrIsEnabled"];
     */
    alcOcrIsEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool ocrAiEnabledInVpum = 12;
     */
    ocrAiEnabledInVpum?: Bool;
}
/**
 * @generated from protobuf enum ProtoMessages.GraphicEngineInfo.GraphicsUiType
 */
export enum GraphicEngineInfo_GraphicsUiType {
    /**
     * @generated from protobuf enum value: OFF = 0;
     */
    OFF = 0,
    /**
     * @generated from protobuf enum value: MANUAL = 1;
     */
    MANUAL = 1,
    /**
     * @generated from protobuf enum value: WIRED = 2;
     */
    WIRED = 2,
    /**
     * @generated from protobuf enum value: CAMERA = 3;
     */
    CAMERA = 3,
    /**
     * @generated from protobuf enum value: OCR_AI = 4;
     */
    OCR_AI = 4
}
/**
 * @generated from protobuf enum ProtoMessages.GraphicEngineInfo.ScoreboardType
 */
export enum GraphicEngineInfo_ScoreboardType {
    /**
     * @generated from protobuf enum value: NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: CGENGINE = 1;
     */
    CGENGINE = 1
}
/**
 * @generated from protobuf enum ProtoMessages.GraphicEngineInfo.GraphicsDataProvider
 */
export enum GraphicEngineInfo_GraphicsDataProvider {
    /**
     * @generated from protobuf enum value: WEB = 0;
     */
    WEB = 0,
    /**
     * @generated from protobuf enum value: SPORTZCAST = 1;
     */
    SPORTZCAST = 1,
    /**
     * @generated from protobuf enum value: DAKTRONICS = 2;
     */
    DAKTRONICS = 2,
    /**
     * @generated from protobuf enum value: HOCKEYTECH = 3;
     */
    HOCKEYTECH = 3,
    /**
     * @generated from protobuf enum value: OCR = 4;
     */
    OCR = 4,
    /**
     * @generated from protobuf enum value: ENHANCED_PIP = 5;
     */
    ENHANCED_PIP = 5,
    /**
     * @generated from protobuf enum value: FULLPIP = 6;
     */
    FULLPIP = 6
}
/**
 * @generated from protobuf message ProtoMessages.NetworkSpeedTestRequest
 */
export interface NetworkSpeedTestRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.NetworkSpeedTestResponse
 */
export interface NetworkSpeedTestResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: ProtoMessages.NetworkSpeedTestResult speedTest = 3;
     */
    speedTest?: NetworkSpeedTestResult;
}
/**
 * @generated from protobuf message ProtoMessages.NetworkSpeedTestResult
 */
export interface NetworkSpeedTestResult {
    /**
     * @generated from protobuf field: ProtoMessages.Double downloadMbps = 1;
     */
    downloadMbps?: Double;
    /**
     * @generated from protobuf field: ProtoMessages.Double uploadMbps = 2;
     */
    uploadMbps?: Double;
    /**
     * @generated from protobuf field: ProtoMessages.Double pingMs = 3;
     */
    pingMs?: Double;
}
/**
 * @generated from protobuf message ProtoMessages.VpuDataResponse
 */
export interface VpuDataResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: string vpuSerialNumber = 3;
     */
    vpuSerialNumber: string;
    /**
     * @generated from protobuf field: string vpuPartNumber = 4;
     */
    vpuPartNumber: string;
}
/**
 * @generated from protobuf message ProtoMessages.VpuDataRequest
 */
export interface VpuDataRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.VersionMessage
 */
export interface VersionMessage {
    /**
     * @generated from protobuf field: string version = 1;
     */
    version: string;
}
/**
 * @generated from protobuf message ProtoMessages.OperatingSystemMessage
 */
export interface OperatingSystemMessage {
    /**
     * @generated from protobuf field: ProtoMessages.OperatingSystemMessage.Type OsType = 1 [json_name = "OsType"];
     */
    osType: OperatingSystemMessage_Type;
}
/**
 * @generated from protobuf enum ProtoMessages.OperatingSystemMessage.Type
 */
export enum OperatingSystemMessage_Type {
    /**
     * @generated from protobuf enum value: WINDOWS = 0;
     */
    WINDOWS = 0,
    /**
     * @generated from protobuf enum value: LINUX = 1;
     */
    LINUX = 1,
    /**
     * @generated from protobuf enum value: UNKNOWN = 2;
     */
    UNKNOWN = 2
}
/**
 * @generated from protobuf message ProtoMessages.Token
 */
export interface Token {
    /**
     * @generated from protobuf field: string token = 1;
     */
    token: string;
}
/**
 * @generated from protobuf message ProtoMessages.ToggleSetupMode
 */
export interface ToggleSetupMode {
    /**
     * @generated from protobuf field: ProtoMessages.Bool activate = 1;
     */
    activate?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.String vpuStatus = 2;
     */
    vpuStatus?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.Bool isPairing = 3;
     */
    isPairing?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.CameraFramesData
 */
export interface CameraFramesData {
    /**
     * @generated from protobuf field: ProtoMessages.Int32 numOfFrames = 1;
     */
    numOfFrames?: Int32;
    /**
     * @generated from protobuf field: ProtoMessages.String Result = 2 [json_name = "Result"];
     */
    result?: String$;
    /**
     * @generated from protobuf field: repeated ProtoMessages.String frames = 3;
     */
    frames: String$[];
}
/**
 * @generated from protobuf message ProtoMessages.TestPorts
 */
export interface TestPorts {
    /**
     * @generated from protobuf field: int32 portNumber = 1;
     */
    portNumber: number;
    /**
     * @generated from protobuf field: string index = 2;
     */
    index: string;
    /**
     * @generated from protobuf field: bool testTCP = 3;
     */
    testTCP: boolean;
    /**
     * @generated from protobuf field: bool testUDP = 4;
     */
    testUDP: boolean;
}
/**
 * @generated from protobuf message ProtoMessages.TestPortsResult
 */
export interface TestPortsResult {
    /**
     * @generated from protobuf field: int32 portNumber = 1;
     */
    portNumber: number;
    /**
     * @generated from protobuf field: string index = 2;
     */
    index: string;
    /**
     * @generated from protobuf field: ProtoMessages.TestPortsResult.Result testTCPResult = 3;
     */
    testTCPResult: TestPortsResult_Result;
    /**
     * @generated from protobuf field: ProtoMessages.TestPortsResult.Result testUDPResult = 4;
     */
    testUDPResult: TestPortsResult_Result;
}
/**
 * @generated from protobuf enum ProtoMessages.TestPortsResult.Result
 */
export enum TestPortsResult_Result {
    /**
     * @generated from protobuf enum value: NA = 0;
     */
    NA = 0,
    /**
     * @generated from protobuf enum value: CONNECTED = 1;
     */
    CONNECTED = 1,
    /**
     * @generated from protobuf enum value: BLOCKED = 2;
     */
    BLOCKED = 2
}
/**
 * @generated from protobuf message ProtoMessages.LigrStatus
 */
export interface LigrStatus {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string url = 2;
     */
    url: string;
}
/**
 * @generated from protobuf message ProtoMessages.TestStatus
 */
export interface TestStatus {
    /**
     * @generated from protobuf field: ProtoMessages.TestStatus.StatusType type = 1;
     */
    type: TestStatus_StatusType;
    /**
     * @generated from protobuf field: string index = 2;
     */
    index: string;
}
/**
 * @generated from protobuf enum ProtoMessages.TestStatus.StatusType
 */
export enum TestStatus_StatusType {
    /**
     * @generated from protobuf enum value: NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: MainBE = 1;
     */
    MainBE = 1,
    /**
     * @generated from protobuf enum value: RabbitMQ = 2;
     */
    RabbitMQ = 2
}
/**
 * @generated from protobuf message ProtoMessages.TestStatusResult
 */
export interface TestStatusResult {
    /**
     * @generated from protobuf field: ProtoMessages.TestStatusResult.StatusType type = 1;
     */
    type: TestStatusResult_StatusType;
    /**
     * @generated from protobuf field: string index = 2;
     */
    index: string;
    /**
     * @generated from protobuf field: ProtoMessages.TestStatusResult.Result testResult = 3;
     */
    testResult: TestStatusResult_Result;
}
/**
 * @generated from protobuf enum ProtoMessages.TestStatusResult.Result
 */
export enum TestStatusResult_Result {
    /**
     * @generated from protobuf enum value: NA = 0;
     */
    NA = 0,
    /**
     * @generated from protobuf enum value: CONNECTED = 1;
     */
    CONNECTED = 1,
    /**
     * @generated from protobuf enum value: BLOCKED = 2;
     */
    BLOCKED = 2
}
/**
 * @generated from protobuf enum ProtoMessages.TestStatusResult.StatusType
 */
export enum TestStatusResult_StatusType {
    /**
     * @generated from protobuf enum value: NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: MainBE = 1;
     */
    MainBE = 1
}
/**
 * @generated from protobuf message ProtoMessages.NetworkTestRequest
 */
export interface NetworkTestRequest {
    /**
     * @generated from protobuf field: repeated ProtoMessages.TestPorts requestPortTesting = 1;
     */
    requestPortTesting: TestPorts[];
    /**
     * @generated from protobuf field: repeated ProtoMessages.TestStatus requestStatusTesting = 2;
     */
    requestStatusTesting: TestStatus[];
}
/**
 * @generated from protobuf message ProtoMessages.NetworkTestResult
 */
export interface NetworkTestResult {
    /**
     * @generated from protobuf field: repeated ProtoMessages.TestPortsResult testPortsResult = 1;
     */
    testPortsResult: TestPortsResult[];
    /**
     * @generated from protobuf field: repeated ProtoMessages.TestStatusResult testStatusResult = 2;
     */
    testStatusResult: TestStatusResult[];
    /**
     * @generated from protobuf field: bool testPassed = 3;
     */
    testPassed: boolean;
    /**
     * @generated from protobuf field: bool success = 4;
     */
    success: boolean;
}
/**
 * @generated from protobuf message ProtoMessages.NetworkValidation
 */
export interface NetworkValidation {
    /**
     * @generated from protobuf field: bool validated = 1;
     */
    validated: boolean;
}
/**
 * @generated from protobuf message ProtoMessages.CCUPreset
 */
export interface CCUPreset {
    /**
     * @generated from protobuf field: ProtoMessages.String name = 1;
     */
    name?: String$;
    /**
     * @generated from protobuf field: ProtoMessages.CCUPreset.PresetType presetType = 2;
     */
    presetType: CCUPreset_PresetType;
    /**
     * @generated from protobuf field: ProtoMessages.CCUData ccuValues = 3;
     */
    ccuValues?: CCUData;
}
/**
 * @generated from protobuf enum ProtoMessages.CCUPreset.PresetType
 */
export enum CCUPreset_PresetType {
    /**
     * @generated from protobuf enum value: PREDEFINED = 0;
     */
    PREDEFINED = 0,
    /**
     * @generated from protobuf enum value: USER = 1;
     */
    USER = 1
}
/**
 * @generated from protobuf message ProtoMessages.BigDataMessage
 */
export interface BigDataMessage {
    /**
     * @generated from protobuf field: string messageTypeStr = 1;
     */
    messageTypeStr: string; // name of the internal message whose binary content presents in 'messageContent'
    /**
     * @generated from protobuf field: string uuid = 2;
     */
    uuid: string; // message unique id
    /**
     * @generated from protobuf field: uint32 chunkIndex = 3;
     */
    chunkIndex: number;
    /**
     * @generated from protobuf field: uint32 totalChunks = 4;
     */
    totalChunks: number;
    /**
     * @generated from protobuf field: uint64 totalBytes = 5;
     */
    totalBytes: bigint;
    /**
     * @generated from protobuf field: uint64 offset = 6;
     */
    offset: bigint;
    /**
     * @generated from protobuf field: bytes messageContent = 7;
     */
    messageContent: Uint8Array;
}
/**
 * use this message when a filename is relevant
 *
 * @generated from protobuf message ProtoMessages.FileChunkMessage
 */
export interface FileChunkMessage {
    /**
     * @generated from protobuf field: CommonUsedMessages.DataChunkMessage dataChunk = 1;
     */
    dataChunk?: DataChunkMessage; // as a base class
    /**
     * @generated from protobuf field: string filename = 2;
     */
    filename: string;
}
/**
 * @generated from protobuf message ProtoMessages.CameraFramesRequestMessage
 */
export interface CameraFramesRequestMessage {
    /**
     * @generated from protobuf field: string requestId = 1;
     */
    requestId: string;
    /**
     * @generated from protobuf field: ProtoMessages.FrameType frameType = 2;
     */
    frameType: FrameType;
    /**
     * @generated from protobuf field: ProtoMessages.CaptureFramesReplyType replyType = 3;
     */
    replyType: CaptureFramesReplyType;
    /**
     * @generated from protobuf field: bool rotateFrames = 4;
     */
    rotateFrames: boolean;
    /**
     * @generated from protobuf field: ProtoMessages.CameraFramesRequestMessage.RequestSource requestSource = 5;
     */
    requestSource: CameraFramesRequestMessage_RequestSource;
    /**
     * @generated from protobuf field: int32 cameraIndex = 6;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf enum ProtoMessages.CameraFramesRequestMessage.RequestSource
 */
export enum CameraFramesRequestMessage_RequestSource {
    /**
     * @generated from protobuf enum value: CALIBRATION = 0;
     */
    CALIBRATION = 0,
    /**
     * @generated from protobuf enum value: VENUE_TOOLS = 1;
     */
    VENUE_TOOLS = 1,
    /**
     * @generated from protobuf enum value: SCOREBOARED = 2;
     */
    SCOREBOARED = 2,
    /**
     * @generated from protobuf enum value: HEAD_SETUP = 3;
     */
    HEAD_SETUP = 3,
    /**
     * @generated from protobuf enum value: AA = 4;
     */
    AA = 4,
    /**
     * @generated from protobuf enum value: CONNECT_APP = 5;
     */
    CONNECT_APP = 5
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraFramesDirectRequest
 */
export interface AdditionalCameraFramesDirectRequest {
    /**
     * @generated from protobuf field: string requestId = 1;
     */
    requestId: string;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraFramesLanRequest
 */
export interface AdditionalCameraFramesLanRequest {
    /**
     * @generated from protobuf field: string requestId = 1;
     */
    requestId: string;
    /**
     * @generated from protobuf field: repeated string ipAdresses = 2;
     */
    ipAdresses: string[];
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraFramesDirectResponse
 */
export interface AdditionalCameraFramesDirectResponse {
    /**
     * @generated from protobuf field: string requestId = 1;
     */
    requestId: string;
    /**
     * @generated from protobuf field: bool success = 2;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMsg = 3;
     */
    errorMsg: string;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraPairingRequest
 */
export interface AdditionalCameraPairingRequest {
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraType cameraType = 1;
     */
    cameraType: AdditionalCameraType;
    /**
     * @generated from protobuf field: int32 cameraIndex = 2;
     */
    cameraIndex: number;
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraConnectionType connectionType = 3;
     */
    connectionType: AdditionalCameraConnectionType;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraUnpairingRequest
 */
export interface AdditionalCameraUnpairingRequest {
    /**
     * @generated from protobuf field: int32 cameraIndex = 1;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraUnpairingResponse
 */
export interface AdditionalCameraUnpairingResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.CameraFramesReplyMessage
 */
export interface CameraFramesReplyMessage {
    /**
     * @generated from protobuf field: string requestId = 1;
     */
    requestId: string;
    /**
     * @generated from protobuf field: ProtoMessages.FrameType frameType = 2;
     */
    frameType: FrameType;
    /**
     * @generated from protobuf field: uint32 framesCount = 3;
     */
    framesCount: number;
    /**
     * @generated from protobuf field: uint32 frameIndex = 4;
     */
    frameIndex: number;
    /**
     * @generated from protobuf field: CommonUsedMessages.DataChunkMessage dataMsg = 5;
     */
    dataMsg?: DataChunkMessage;
    /**
     * @generated from protobuf field: int32 frameRotation = 6;
     */
    frameRotation: number;
    /**
     * @generated from protobuf field: string cameraIp = 7;
     */
    cameraIp: string;
    /**
     * @generated from protobuf field: string cameraModel = 8;
     */
    cameraModel: string;
}
/**
 * @generated from protobuf message ProtoMessages.CameraFramesFailureReplyMessage
 */
export interface CameraFramesFailureReplyMessage {
    /**
     * @generated from protobuf field: string requestId = 1;
     */
    requestId: string;
    /**
     * @generated from protobuf field: ProtoMessages.FrameType frameType = 2;
     */
    frameType: FrameType;
    /**
     * @generated from protobuf field: string failureReason = 3;
     */
    failureReason: string;
}
// /////////////////////////////////////////////////////////////////////////////////
// Simplified Calibration Messages

/**
 * @generated from protobuf message ProtoMessages.GroundPoint
 */
export interface GroundPoint {
    /**
     * @generated from protobuf field: CommonUsedMessages.Point2D framePoint = 1;
     */
    framePoint?: Point2D;
    /**
     * @generated from protobuf field: CommonUsedMessages.Point2D fieldPoint = 2;
     */
    fieldPoint?: Point2D;
    /**
     * @generated from protobuf field: int32 cameraIndex = 3;
     */
    cameraIndex: number;
    /**
     * @generated from protobuf field: bool skipped = 4;
     */
    skipped: boolean;
}
/**
 * @generated from protobuf message ProtoMessages.SportTypeInfo
 */
export interface SportTypeInfo {
    /**
     * @generated from protobuf field: string displayName = 1;
     */
    displayName: string; // consider to add also a field's width and height
}
/**
 * @generated from protobuf message ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage
 */
export interface SimplifiedCalibrationGetSportTypesRequestMessage {
}
/**
 * @generated from protobuf message ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage
 */
export interface SimplifiedCalibrationSportTypesReplyMessage {
    /**
     * @generated from protobuf field: repeated ProtoMessages.SportTypeInfo autoProductionTypes = 1;
     */
    autoProductionTypes: SportTypeInfo[];
    /**
     * @generated from protobuf field: repeated ProtoMessages.SportTypeInfo fixedFrameTypes = 2;
     */
    fixedFrameTypes: SportTypeInfo[];
    /**
     * @generated from protobuf field: string result = 3;
     */
    result: string;
}
/**
 * @generated from protobuf message ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage
 */
export interface SimplifiedCalibrationSetGroundPointsRequestMessage {
    /**
     * @generated from protobuf field: repeated ProtoMessages.GroundPoint groundPoints = 1;
     */
    groundPoints: GroundPoint[];
    /**
     * @generated from protobuf field: string sportType = 2;
     */
    sportType: string;
    /**
     * @generated from protobuf field: int32 fieldWidth = 3;
     */
    fieldWidth: number;
    /**
     * @generated from protobuf field: int32 fieldHeight = 4;
     */
    fieldHeight: number;
}
/**
 * @generated from protobuf message ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage
 */
export interface SimplifiedCalibrationSetGroundPointsReplyMessage {
    /**
     * @generated from protobuf field: string result = 1;
     */
    result: string;
}
// ////////////////// PIP/OCR in VPUM//////////////////

/**
 * @generated from protobuf message ProtoMessages.PipCameraFocusRequest
 */
export interface PipCameraFocusRequest {
    /**
     * @generated from protobuf field: int32 focus = 1;
     */
    focus: number; // 1 for focus in, -1 for focus out
    /**
     * @generated from protobuf field: string requestId = 2;
     */
    requestId: string; // for the return frame
}
/**
 * @generated from protobuf message ProtoMessages.PipCameraZoomRequest
 */
export interface PipCameraZoomRequest {
    /**
     * @generated from protobuf field: int32 zoom = 1;
     */
    zoom: number; // 1 for zoom in, -1 for zoom out
    /**
     * @generated from protobuf field: ProtoMessages.Bool fine = 2;
     */
    fine?: Bool;
    /**
     * @generated from protobuf field: string requestId = 3;
     */
    requestId: string; // for the return frame
}
/**
 * @generated from protobuf message ProtoMessages.PipCameraChangeExposureModeChange
 */
export interface PipCameraChangeExposureModeChange {
    /**
     * @generated from protobuf field: string newMode = 1;
     */
    newMode: string; // for manual: "manualpreset"
    /**
     * @generated from protobuf field: string requestId = 2;
     */
    requestId: string; // for the return frame
}
/**
 * @generated from protobuf message ProtoMessages.PipCameraFlipRequest
 */
export interface PipCameraFlipRequest {
    /**
     * @generated from protobuf field: string requestId = 1;
     */
    requestId: string; // for the return frame
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraParams
 */
export interface AdditionalCameraParams {
    /**
     * @generated from protobuf field: int32 gain = 1;
     */
    gain: number;
    /**
     * @generated from protobuf field: int32 iris = 2;
     */
    iris: number;
    /**
     * @generated from protobuf field: int32 sharpness = 3;
     */
    sharpness: number;
    /**
     * @generated from protobuf field: int32 contrast = 4;
     */
    contrast: number;
    /**
     * @generated from protobuf field: int32 brightness = 5;
     */
    brightness: number;
    /**
     * @generated from protobuf field: int32 saturation = 6;
     */
    saturation: number;
}
/**
 * @generated from protobuf message ProtoMessages.InactivatedScoreboardQuery
 */
export interface InactivatedScoreboardQuery {
}
/**
 * @generated from protobuf message ProtoMessages.InactivatedScoreboardResponse
 */
export interface InactivatedScoreboardResponse {
    /**
     * @generated from protobuf field: ProtoMessages.InactivatedScoreboardResponse.Type inactiveScoreboard = 1;
     */
    inactiveScoreboard: InactivatedScoreboardResponse_Type;
}
/**
 * @generated from protobuf enum ProtoMessages.InactivatedScoreboardResponse.Type
 */
export enum InactivatedScoreboardResponse_Type {
    /**
     * @generated from protobuf enum value: NA = 0;
     */
    NA = 0,
    /**
     * @generated from protobuf enum value: CAMERA = 1;
     */
    CAMERA = 1,
    /**
     * @generated from protobuf enum value: WIRED = 2;
     */
    WIRED = 2
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraChangeAfMode
 */
export interface AdditionalCameraChangeAfMode {
    /**
     * @generated from protobuf field: ProtoMessages.AFMode switchTo = 1;
     */
    switchTo: AFMode;
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraType cameraType = 2;
     */
    cameraType: AdditionalCameraType;
    /**
     * @generated from protobuf field: int32 cameraIndex = 3;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraChangeAFModeReplyMessage
 */
export interface AdditionalCameraChangeAFModeReplyMessage {
    /**
     * @generated from protobuf field: ProtoMessages.AFMode mode = 1;
     */
    mode: AFMode;
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 2;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraType cameraType = 4;
     */
    cameraType: AdditionalCameraType;
}
/**
 * @generated from protobuf message ProtoMessages.PairingStageUpdate
 */
export interface PairingStageUpdate {
    /**
     * @generated from protobuf field: ProtoMessages.PairingStage stage = 1;
     */
    stage: PairingStage;
    /**
     * @generated from protobuf field: ProtoMessages.Bool stageSuccess = 2;
     */
    stageSuccess?: Bool;
    /**
     * @generated from protobuf field: string errorMessege = 3;
     */
    errorMessege: string;
    /**
     * @generated from protobuf field: ProtoMessages.PairingStageUpdate.PairingErrorCode errorCode = 4;
     */
    errorCode: PairingStageUpdate_PairingErrorCode;
    /**
     * @generated from protobuf field: ProtoMessages.PairingStageUpdate.CameraType type = 5;
     */
    type: PairingStageUpdate_CameraType;
    /**
     * @generated from protobuf field: int32 cameraIndex = 6;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf enum ProtoMessages.PairingStageUpdate.PairingErrorCode
 */
export enum PairingStageUpdate_PairingErrorCode {
    /**
     * @generated from protobuf enum value: NA = 0;
     */
    NA = 0,
    /**
     * @generated from protobuf enum value: NO_CAMERA_FOUND = 1;
     */
    NO_CAMERA_FOUND = 1,
    /**
     * @generated from protobuf enum value: MULTIPLE_CAMERAS_FOUND = 2;
     */
    MULTIPLE_CAMERAS_FOUND = 2
}
/**
 * @generated from protobuf enum ProtoMessages.PairingStageUpdate.CameraType
 */
export enum PairingStageUpdate_CameraType {
    /**
     * @generated from protobuf enum value: UNKNOWN_TYPE = 0;
     */
    UNKNOWN_TYPE = 0,
    /**
     * @generated from protobuf enum value: CHU = 1;
     */
    CHU = 1,
    /**
     * @generated from protobuf enum value: AA = 2;
     */
    AA = 2,
    /**
     * @generated from protobuf enum value: PIP = 3;
     */
    PIP = 3
}
/**
 * @generated from protobuf message ProtoMessages.AACameraZoomRequest
 */
export interface AACameraZoomRequest {
    /**
     * @generated from protobuf field: int32 zoom = 1;
     */
    zoom: number; // 1 for zoom in, -1 for zoom out
    /**
     * @generated from protobuf field: int32 zoomStep = 2;
     */
    zoomStep: number;
    /**
     * @generated from protobuf field: string requestId = 3;
     */
    requestId: string; // for the return frame
    /**
     * @generated from protobuf field: int32 cameraIndex = 4;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.AACameraFocusRequest
 */
export interface AACameraFocusRequest {
    /**
     * @generated from protobuf field: int32 focus = 1;
     */
    focus: number; // 1 for focus in, -1 for focus out
    /**
     * @generated from protobuf field: string requestId = 2;
     */
    requestId: string; // for the return frame
    /**
     * @generated from protobuf field: int32 cameraIndex = 3;
     */
    cameraIndex: number;
}
// General additional camera - OCR or AA (R2SDG / S5SDG / E8NCG)

/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraIrisChangeRequest
 */
export interface AdditionalCameraIrisChangeRequest {
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraType cameraType = 1;
     */
    cameraType: AdditionalCameraType;
    /**
     * @generated from protobuf field: int32 newIrisValue = 2;
     */
    newIrisValue: number; // valid values 0-10
    /**
     * @generated from protobuf field: string requestId = 3;
     */
    requestId: string; // for the return frame
    /**
     * @generated from protobuf field: int32 cameraIndex = 4;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraGainChangeRequest
 */
export interface AdditionalCameraGainChangeRequest {
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraType cameraType = 1;
     */
    cameraType: AdditionalCameraType;
    /**
     * @generated from protobuf field: int32 newGainValue = 2;
     */
    newGainValue: number; // valid values 0-9
    /**
     * @generated from protobuf field: string requestId = 3;
     */
    requestId: string; // for the return frame
    /**
     * @generated from protobuf field: int32 cameraIndex = 4;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraSharpnessChangeRequest
 */
export interface AdditionalCameraSharpnessChangeRequest {
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraType cameraType = 1;
     */
    cameraType: AdditionalCameraType;
    /**
     * @generated from protobuf field: int32 newSharpnessValue = 2;
     */
    newSharpnessValue: number; // valid values 0-15
    /**
     * @generated from protobuf field: string requestId = 3;
     */
    requestId: string; // for the return frame
    /**
     * @generated from protobuf field: int32 cameraIndex = 4;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraContrastChangeRequest
 */
export interface AdditionalCameraContrastChangeRequest {
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraType cameraType = 1;
     */
    cameraType: AdditionalCameraType;
    /**
     * @generated from protobuf field: int32 newContrastValue = 2;
     */
    newContrastValue: number; // valid values -6 - 10
    /**
     * @generated from protobuf field: string requestId = 3;
     */
    requestId: string; // for the return frame
    /**
     * @generated from protobuf field: int32 cameraIndex = 4;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraBrightnessChangeRequest
 */
export interface AdditionalCameraBrightnessChangeRequest {
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraType cameraType = 1;
     */
    cameraType: AdditionalCameraType;
    /**
     * @generated from protobuf field: int32 newBrightnessValue = 2;
     */
    newBrightnessValue: number; // valid values ?
    /**
     * @generated from protobuf field: string requestId = 3;
     */
    requestId: string; // for the return frame
    /**
     * @generated from protobuf field: int32 cameraIndex = 4;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraSaturationChangeRequest
 */
export interface AdditionalCameraSaturationChangeRequest {
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraType cameraType = 1;
     */
    cameraType: AdditionalCameraType;
    /**
     * @generated from protobuf field: int32 newSaturationValue = 2;
     */
    newSaturationValue: number; // valid values ?
    /**
     * @generated from protobuf field: string requestId = 3;
     */
    requestId: string; // for the return frame
    /**
     * @generated from protobuf field: int32 cameraIndex = 4;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraRotateRequest
 */
export interface AdditionalCameraRotateRequest {
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraType cameraType = 1;
     */
    cameraType: AdditionalCameraType;
    /**
     * @generated from protobuf field: string requestId = 3;
     */
    requestId: string; // for the return frame
    /**
     * @generated from protobuf field: int32 cameraIndex = 4;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraParametersRequest
 */
export interface AdditionalCameraParametersRequest {
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraType cameraType = 1;
     */
    cameraType: AdditionalCameraType;
    /**
     * @generated from protobuf field: int32 cameraIndex = 2;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.AdditionalCameraParametersResponse
 */
export interface AdditionalCameraParametersResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraType cameraType = 3;
     */
    cameraType: AdditionalCameraType;
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraParams params = 4;
     */
    params?: AdditionalCameraParams;
    /**
     * @generated from protobuf field: int32 cameraIndex = 5;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.AACameraAutoFocusRequest
 */
export interface AACameraAutoFocusRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool request = 1;
     */
    request?: Bool;
    /**
     * @generated from protobuf field: string requestId = 2;
     */
    requestId: string;
    /**
     * @generated from protobuf field: int32 cameraIndex = 3;
     */
    cameraIndex: number;
}
/**
 * @generated from protobuf message ProtoMessages.RequestStatusEnabledAACameras
 */
export interface RequestStatusEnabledAACameras {
    /**
     * @generated from protobuf field: ProtoMessages.Bool request = 1;
     */
    request?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.CameraStatusPair
 */
export interface CameraStatusPair {
    /**
     * @generated from protobuf field: int32 index = 1;
     */
    index: number;
    /**
     * @generated from protobuf field: ProtoMessages.AACameraStatus status = 2;
     */
    status: AACameraStatus;
    /**
     * @generated from protobuf field: ProtoMessages.AACameraType type = 3;
     */
    type: AACameraType;
}
/**
 * @generated from protobuf message ProtoMessages.StatusEnabledAACameras
 */
export interface StatusEnabledAACameras {
    /**
     * @generated from protobuf field: repeated ProtoMessages.CameraStatusPair status = 1;
     */
    status: CameraStatusPair[];
}
/**
 * @generated from protobuf message ProtoMessages.ChangeStatusAACameras
 */
export interface ChangeStatusAACameras {
    /**
     * @generated from protobuf field: repeated ProtoMessages.CameraStatusPair changes = 1;
     */
    changes: CameraStatusPair[];
}
/**
 * @generated from protobuf message ProtoMessages.ExistingCalibrationRequest
 */
export interface ExistingCalibrationRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool request = 1;
     */
    request?: Bool;
}
/**
 * ── CHU scoreboard calibration ───────────────────────────────────────────────
 * Corners are normalized [0,1] within the source frame, ordered top-left,
 * top-right, bottom-right, bottom-left. The Coordinator scales them to the
 * camera's native resolution when writing scoreboard.xml (and normalizes back
 * when reading), so the contract is resolution-independent.
 *
 * @generated from protobuf message ProtoMessages.ScoreboardCalibrationPoint
 */
export interface ScoreboardCalibrationPoint {
    /**
     * @generated from protobuf field: double x = 1;
     */
    x: number;
    /**
     * @generated from protobuf field: double y = 2;
     */
    y: number;
}
/**
 * VPUM -> Coordinator: load the existing CHU scoreboard.xml calibration, if any.
 *
 * @generated from protobuf message ProtoMessages.RequestScoreboardCalibrationMessage
 */
export interface RequestScoreboardCalibrationMessage {
}
/**
 * @generated from protobuf message ProtoMessages.ScoreboardCalibrationDataMessage
 */
export interface ScoreboardCalibrationDataMessage {
    /**
     * @generated from protobuf field: bool exists = 1;
     */
    exists: boolean;
    /**
     * @generated from protobuf field: int32 cameraIndex = 2;
     */
    cameraIndex: number;
    /**
     * @generated from protobuf field: repeated ProtoMessages.ScoreboardCalibrationPoint corners = 3;
     */
    corners: ScoreboardCalibrationPoint[];
    /**
     * @generated from protobuf field: ProtoMessages.ChuUsage usage = 4;
     */
    usage: ChuUsage;
}
/**
 * VPUM -> Coordinator: persist the marked corners as scoreboard.xml and set how the
 * CHU camera is used by PiP.
 *
 * @generated from protobuf message ProtoMessages.ApplyScoreboardCalibrationMessage
 */
export interface ApplyScoreboardCalibrationMessage {
    /**
     * @generated from protobuf field: int32 cameraIndex = 1;
     */
    cameraIndex: number;
    /**
     * @generated from protobuf field: repeated ProtoMessages.ScoreboardCalibrationPoint corners = 2;
     */
    corners: ScoreboardCalibrationPoint[];
    /**
     * @generated from protobuf field: ProtoMessages.ChuUsage usage = 3;
     */
    usage: ChuUsage;
}
/**
 * Coordinator -> VPUM: result of persisting the calibration.
 *
 * @generated from protobuf message ProtoMessages.ApplyScoreboardCalibrationResponseMessage
 */
export interface ApplyScoreboardCalibrationResponseMessage {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * VPUM -> Coordinator: set how PiP uses the CHU camera without touching the calibration
 * file (used to force CHU during OCR validation and restore the chosen usage on exit).
 *
 * @generated from protobuf message ProtoMessages.SetChuFeedModeMessage
 */
export interface SetChuFeedModeMessage {
    /**
     * @generated from protobuf field: ProtoMessages.ChuUsage usage = 1;
     */
    usage: ChuUsage;
}
/**
 * VPUM -> Coordinator: poll for the latest CHU OCR-validation frame + data.
 *
 * @generated from protobuf message ProtoMessages.RequestChuOcrFrameMessage
 */
export interface RequestChuOcrFrameMessage {
}
/**
 * Coordinator -> VPUM: the warped scoreboard crop + its OCR data (paired at the source).
 *
 * @generated from protobuf message ProtoMessages.ChuOcrFrameMessage
 */
export interface ChuOcrFrameMessage {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string frame = 2;
     */
    frame: string; // base64-encoded JPEG warped scoreboard crop
    /**
     * @generated from protobuf field: VpuGrpc.OcrDataMessage scoreboardData = 3;
     */
    scoreboardData?: OcrDataMessage;
}
/**
 * VPUM -> Coordinator: start PiP in OCR AI mode with CHU as the active feed.
 * Blocks until PiP is up and OCR AI is active (mirrors the standard EnableOcrAiForPip flow).
 *
 * @generated from protobuf message ProtoMessages.StartChuOcrValidationMessage
 */
export interface StartChuOcrValidationMessage {
}
/**
 * Coordinator -> VPUM: result of the StartChuOcrValidationMessage request.
 *
 * @generated from protobuf message ProtoMessages.StartChuOcrValidationResponseMessage
 */
export interface StartChuOcrValidationResponseMessage {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.RefreshOcrImageAndPreview
 */
export interface RefreshOcrImageAndPreview {
    /**
     * @generated from protobuf field: string reqId = 1;
     */
    reqId: string;
}
// /////////////////onboarding messages//////////////

/**
 * @generated from protobuf message ProtoMessages.OnboardingIsBalenaSystemRequest
 */
export interface OnboardingIsBalenaSystemRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingIsBalenaSystemResponse
 */
export interface OnboardingIsBalenaSystemResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool isBalena = 1;
     */
    isBalena?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingGetDiagnosticsResults
 */
export interface OnboardingGetDiagnosticsResults {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingDiagnosticsResultsResponse
 */
export interface OnboardingDiagnosticsResultsResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool hwTestPass = 2;
     */
    hwTestPass?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.ConnectivityTestResult connectivityTestResult = 3;
     */
    connectivityTestResult?: ConnectivityTestResult;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingGetFullDiagnosticsResults
 */
export interface OnboardingGetFullDiagnosticsResults {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingGetFullDiagnosticsResultsResponse
 */
export interface OnboardingGetFullDiagnosticsResultsResponse {
    /**
     * @generated from protobuf field: ProtoMessages.HwTestResults hwTestResults = 1;
     */
    hwTestResults?: HwTestResults;
    /**
     * @generated from protobuf field: ProtoMessages.ConnectivityTestResult connectivityTestResult = 2;
     */
    connectivityTestResult?: ConnectivityTestResult;
    /**
     * @generated from protobuf field: repeated ProtoMessages.SingleCameraConnectionResults cameraConnectionResultList = 3;
     */
    cameraConnectionResultList: SingleCameraConnectionResults[];
    /**
     * @generated from protobuf field: repeated ProtoMessages.SinglePoeStatusResults poeStatusResultList = 4;
     */
    poeStatusResultList: SinglePoeStatusResults[];
}
/**
 * @generated from protobuf message ProtoMessages.SingleCameraConnectionResults
 */
export interface SingleCameraConnectionResults {
    /**
     * @generated from protobuf field: string ip = 1;
     */
    ip: string;
    /**
     * @generated from protobuf field: ProtoMessages.Bool connected = 2;
     */
    connected?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.SinglePoeStatusResults
 */
export interface SinglePoeStatusResults {
    /**
     * @generated from protobuf field: ProtoMessages.Bool connected = 1;
     */
    connected?: Bool;
    /**
     * @generated from protobuf field: int32 speed = 2;
     */
    speed: number;
}
/**
 * @generated from protobuf message ProtoMessages.HwTestResults
 */
export interface HwTestResults {
    /**
     * @generated from protobuf field: ProtoMessages.Bool gpuPass = 1;
     */
    gpuPass?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool wifiPass = 2;
     */
    wifiPass?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool poePass = 3;
     */
    poePass?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool memoryPass = 4;
     */
    memoryPass?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.ConnectivityTestResult
 */
export interface ConnectivityTestResult {
    /**
     * @generated from protobuf field: ProtoMessages.Bool networkConnectionPass = 1;
     */
    networkConnectionPass?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool ipTestPass = 2;
     */
    ipTestPass?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool pixellotCloudConnectionPass = 3;
     */
    pixellotCloudConnectionPass?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool firewallTestPass = 4;
     */
    firewallTestPass?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingGetCurrentNetworkRequest
 */
export interface OnboardingGetCurrentNetworkRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool request = 1;
     */
    request?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool fromConnectApp = 2;
     */
    fromConnectApp?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingGetCurrentCHUUpdateRequest
 */
export interface OnboardingGetCurrentCHUUpdateRequest {
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingGetCurrentCHUUpdateResponse
 */
export interface OnboardingGetCurrentCHUUpdateResponse {
    /**
     * @generated from protobuf field: string step = 1;
     */
    step: string;
    /**
     * @generated from protobuf field: int32 percentage = 2;
     */
    percentage: number;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingCurrentNetworkDataResponse
 */
export interface OnboardingCurrentNetworkDataResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.OnboardingNetworkSetupRequest networkData = 2;
     */
    networkData?: OnboardingNetworkSetupRequest;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingNetworkSetupRequest
 */
export interface OnboardingNetworkSetupRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool manual = 1;
     */
    manual?: Bool;
    /**
     * @generated from protobuf field: string ip = 2;
     */
    ip: string;
    /**
     * @generated from protobuf field: string mask = 3;
     */
    mask: string;
    /**
     * @generated from protobuf field: string gateway = 4;
     */
    gateway: string;
    /**
     * @generated from protobuf field: string dns1 = 5;
     */
    dns1: string;
    /**
     * @generated from protobuf field: string dns2 = 6;
     */
    dns2: string;
    /**
     * @generated from protobuf field: ProtoMessages.Bool fromConnectApp = 7;
     */
    fromConnectApp?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingNetworkSetupResponseNew
 */
export interface OnboardingNetworkSetupResponseNew {
    /**
     * @generated from protobuf field: ProtoMessages.OnboardingNetworkSetupResponseNew.NetworkSetupResponseStatus status = 1;
     */
    status: OnboardingNetworkSetupResponseNew_NetworkSetupResponseStatus;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
}
/**
 * @generated from protobuf enum ProtoMessages.OnboardingNetworkSetupResponseNew.NetworkSetupResponseStatus
 */
export enum OnboardingNetworkSetupResponseNew_NetworkSetupResponseStatus {
    /**
     * @generated from protobuf enum value: VALIDATION_FAILED = 0;
     */
    VALIDATION_FAILED = 0,
    /**
     * @generated from protobuf enum value: APPROVAL_REQUIRED = 1;
     */
    APPROVAL_REQUIRED = 1,
    /**
     * @generated from protobuf enum value: SETUP_FAILED = 2;
     */
    SETUP_FAILED = 2,
    /**
     * @generated from protobuf enum value: SETTINGS_RESTORED = 3;
     */
    SETTINGS_RESTORED = 3,
    /**
     * @generated from protobuf enum value: NO_CHANGE_REQUIRED = 4;
     */
    NO_CHANGE_REQUIRED = 4
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingNetworkSetupUserFeedback
 */
export interface OnboardingNetworkSetupUserFeedback {
    /**
     * @generated from protobuf field: ProtoMessages.Bool approved = 1;
     */
    approved?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool fromConnectApp = 2;
     */
    fromConnectApp?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingFullNetworkTestRequest
 */
export interface OnboardingFullNetworkTestRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool test = 1;
     */
    test?: Bool;
}
/**
 * from app to coordinator
 *
 * @generated from protobuf message ProtoMessages.PairingInProgressQuery
 */
export interface PairingInProgressQuery {
    /**
     * @generated from protobuf field: ProtoMessages.Bool checkForRunningPairing = 1;
     */
    checkForRunningPairing?: Bool;
}
/**
 * from coordinator to app
 *
 * @generated from protobuf message ProtoMessages.PairingInProgressResponse
 */
export interface PairingInProgressResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool pairingAlreadyRunning = 1;
     */
    pairingAlreadyRunning?: Bool;
}
/**
 * from app to coordinator
 *
 * @generated from protobuf message ProtoMessages.TokenRequest
 */
export interface TokenRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool requestToken = 1;
     */
    requestToken?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.TokenResponse
 */
export interface TokenResponse {
    /**
     * @generated from protobuf field: string wsproxyAddress = 1;
     */
    wsproxyAddress: string;
    /**
     * @generated from protobuf field: string token = 2;
     */
    token: string;
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 3;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 4;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.VenueSelfTestRequest
 */
export interface VenueSelfTestRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool runTest = 1;
     */
    runTest?: Bool;
    /**
     * @generated from protobuf field: string vpumSessionId = 2;
     */
    vpumSessionId: string;
}
/**
 * @generated from protobuf message ProtoMessages.CameraTestRequest
 */
export interface CameraTestRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool runTest = 1;
     */
    runTest?: Bool;
    /**
     * @generated from protobuf field: string vpumSessionId = 2;
     */
    vpumSessionId: string;
}
/**
 * @generated from protobuf message ProtoMessages.AdvancedCameraTestRequest
 */
export interface AdvancedCameraTestRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool runTest = 1;
     */
    runTest?: Bool;
    /**
     * @generated from protobuf field: string vpumSessionId = 2;
     */
    vpumSessionId: string;
}
/**
 * @generated from protobuf message ProtoMessages.POETestRequest
 */
export interface POETestRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool runTest = 1;
     */
    runTest?: Bool;
    /**
     * @generated from protobuf field: string vpumSessionId = 2;
     */
    vpumSessionId: string;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingCameraTestResponse
 */
export interface OnboardingCameraTestResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: repeated ProtoMessages.IndividualCameraTestResult advancedTestResults = 3;
     */
    advancedTestResults: IndividualCameraTestResult[];
    /**
     * @generated from protobuf field: ProtoMessages.Bool mainCameraSuccess = 4;
     */
    mainCameraSuccess?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingGPUTestResponse
 */
export interface OnboardingGPUTestResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.POETestResponse
 */
export interface POETestResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: repeated ProtoMessages.POEError poeErrors = 3;
     */
    poeErrors: POEError[];
}
/**
 * @generated from protobuf message ProtoMessages.POEError
 */
export interface POEError {
    /**
     * @generated from protobuf field: ProtoMessages.POEErrorType errorType = 1;
     */
    errorType: POEErrorType;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: double temperature = 3;
     */
    temperature: number; // For temperature errors (in Celsius)
    /**
     * @generated from protobuf field: double powerDetected = 4;
     */
    powerDetected: number; // For Molex errors (in Watts)
    /**
     * @generated from protobuf field: double powerBudget = 5;
     */
    powerBudget: number; // For power budget errors (in Watts)
}
/**
 * @generated from protobuf message ProtoMessages.VenueSelfTestResult
 */
export interface VenueSelfTestResult {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: bool manual = 3;
     */
    manual: boolean;
}
/**
 * @generated from protobuf message ProtoMessages.AdvancedCameraTestResult
 */
export interface AdvancedCameraTestResult {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: repeated ProtoMessages.IndividualCameraTestResult testResults = 2;
     */
    testResults: IndividualCameraTestResult[];
}
/**
 * @generated from protobuf message ProtoMessages.CameraTestProcessResult
 */
export interface CameraTestProcessResult {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string error_message = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: ProtoMessages.CameraErrorType error_type = 3;
     */
    errorType: CameraErrorType;
    /**
     * @generated from protobuf field: repeated ProtoMessages.IndividualCameraTestResult test_results = 4;
     */
    testResults: IndividualCameraTestResult[];
}
/**
 * @generated from protobuf message ProtoMessages.VenueSelfTestResponse
 */
export interface VenueSelfTestResponse {
    /**
     * @generated from protobuf field: ProtoMessages.NetworkTestResult networkTestResponse = 1;
     */
    networkTestResponse?: NetworkTestResult;
    /**
     * @generated from protobuf field: ProtoMessages.OnboardingCameraTestResponse cameraTestResponse = 2;
     */
    cameraTestResponse?: OnboardingCameraTestResponse;
    /**
     * @generated from protobuf field: ProtoMessages.OnboardingGPUTestResponse gpuTestResponse = 3;
     */
    gpuTestResponse?: OnboardingGPUTestResponse;
    /**
     * @generated from protobuf field: ProtoMessages.VenueSelfTestResult venueSelfTestResult = 4;
     */
    venueSelfTestResult?: VenueSelfTestResult;
    /**
     * @generated from protobuf field: ProtoMessages.SelfTestHwTestResults HwTestsResults = 5 [json_name = "HwTestsResults"];
     */
    hwTestsResults?: SelfTestHwTestResults;
}
/**
 * @generated from protobuf message ProtoMessages.SelfTestHwTestResults
 */
export interface SelfTestHwTestResults {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool ramMemoryCapacityOk = 2;
     */
    ramMemoryCapacityOk?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool poeDetected = 3;
     */
    poeDetected?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool wifiDetected = 4;
     */
    wifiDetected?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingHandshakeRequest
 */
export interface OnboardingHandshakeRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool request = 1;
     */
    request?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingHandshakeReply
 */
export interface OnboardingHandshakeReply {
    /**
     * @generated from protobuf field: string version = 1;
     */
    version: string;
    /**
     * @generated from protobuf field: string venueId = 2;
     */
    venueId: string;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingOcrZoomRequest
 */
export interface OnboardingOcrZoomRequest {
    /**
     * @generated from protobuf field: int32 zoom = 1;
     */
    zoom: number; // 1 for zoom in, -1 for zoom out
    /**
     * @generated from protobuf field: string requestId = 2;
     */
    requestId: string;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingOcrAutoFocusRequest
 */
export interface OnboardingOcrAutoFocusRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool request = 1;
     */
    request?: Bool;
    /**
     * @generated from protobuf field: string requestId = 2;
     */
    requestId: string;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingPipCameraPairingRequest
 */
export interface OnboardingPipCameraPairingRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool request = 1;
     */
    request?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingPipCameraPairingResponse
 */
export interface OnboardingPipCameraPairingResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingRunPipInSetupModeRequest
 */
export interface OnboardingRunPipInSetupModeRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool run = 1;
     */
    run?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingStopPipInSetupModeRequest
 */
export interface OnboardingStopPipInSetupModeRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool stop = 1;
     */
    stop?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.RequestLastPairingDetails
 */
export interface RequestLastPairingDetails {
    /**
     * @generated from protobuf field: ProtoMessages.Bool request = 1;
     */
    request?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.LastPairingDetails
 */
export interface LastPairingDetails {
    /**
     * @generated from protobuf field: ProtoMessages.LastPairingDetails.PairingType LastPaired = 1 [json_name = "LastPaired"];
     */
    lastPaired: LastPairingDetails_PairingType;
    /**
     * @generated from protobuf field: string TimeDateStart = 2 [json_name = "TimeDateStart"];
     */
    timeDateStart: string; // last pairing started at, local time ISO-8601 [yyyy-MM-ddThh:mm:ss.xxZ]
    /**
     * @generated from protobuf field: string TimeDateEnd = 3 [json_name = "TimeDateEnd"];
     */
    timeDateEnd: string; // last pairing was completed at, local time ISO-8601 [yyyy-MM-ddThh:mm:ss.xxZ]
    /**
     * @generated from protobuf field: ProtoMessages.Bool DataAvailable = 4 [json_name = "DataAvailable"];
     */
    dataAvailable?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool Successful = 5 [json_name = "Successful"];
     */
    successful?: Bool;
    /**
     * @generated from protobuf field: string ErrorMessage = 6 [json_name = "ErrorMessage"];
     */
    errorMessage: string;
}
/**
 * @generated from protobuf enum ProtoMessages.LastPairingDetails.PairingType
 */
export enum LastPairingDetails_PairingType {
    /**
     * @generated from protobuf enum value: HEAD = 0;
     */
    HEAD = 0,
    /**
     * @generated from protobuf enum value: OCR = 1;
     */
    OCR = 1,
    /**
     * @generated from protobuf enum value: AA = 2;
     */
    AA = 2,
    /**
     * @generated from protobuf enum value: UNKNOWN = 3;
     */
    UNKNOWN = 3
}
// ///// New LastPairing AA/OCR details VPUM<->Coordinator ////

/**
 * VPUM-->Coordinator
 *
 * @generated from protobuf message ProtoMessages.LastPairingDetailsRequest
 */
export interface LastPairingDetailsRequest {
    /**
     * @generated from protobuf field: bool request = 1;
     */
    request: boolean;
}
/**
 * Coordinator-->VPUM
 *
 * @generated from protobuf message ProtoMessages.LastPairingDetailsResponse
 */
export interface LastPairingDetailsResponse {
    /**
     * @generated from protobuf field: repeated ProtoMessages.LastPairingDetailsResponse.pairingDetails details = 1;
     */
    details: LastPairingDetailsResponse_pairingDetails[];
}
/**
 * @generated from protobuf message ProtoMessages.LastPairingDetailsResponse.pairingDetails
 */
export interface LastPairingDetailsResponse_pairingDetails {
    /**
     * @generated from protobuf field: ProtoMessages.LastPairingDetailsResponse.pairingDetails.AditionalCameraType cameraType = 1;
     */
    cameraType: LastPairingDetailsResponse_pairingDetails_AditionalCameraType;
    /**
     * @generated from protobuf field: ProtoMessages.AdditionalCameraConnectionType connectionType = 2;
     */
    connectionType: AdditionalCameraConnectionType;
    /**
     * @generated from protobuf field: string ip = 3;
     */
    ip: string;
    /**
     * @generated from protobuf field: string mac = 4;
     */
    mac: string;
    /**
     * @generated from protobuf field: ProtoMessages.Uint64 lastTimePairingTimeStampUTC = 5;
     */
    lastTimePairingTimeStampUTC?: Uint64; // epoch UTC timestamp
    /**
     * @generated from protobuf field: ProtoMessages.Bool status = 6;
     */
    status?: Bool;
    /**
     * @generated from protobuf field: bool success = 7;
     */
    success: boolean;
    /**
     * @generated from protobuf field: int32 cameraIndex = 8;
     */
    cameraIndex: number;
    /**
     * @generated from protobuf field: string model = 9;
     */
    model: string;
}
/**
 * @generated from protobuf enum ProtoMessages.LastPairingDetailsResponse.pairingDetails.AditionalCameraType
 */
export enum LastPairingDetailsResponse_pairingDetails_AditionalCameraType {
    /**
     * @generated from protobuf enum value: UNKNOWN_TYPE = 0;
     */
    UNKNOWN_TYPE = 0,
    /**
     * @generated from protobuf enum value: PIP = 1;
     */
    PIP = 1,
    /**
     * @generated from protobuf enum value: AA = 2;
     */
    AA = 2
}
// ///// CHU last pairing details VPUM<->Coordinator ////

/**
 * VPUM-->Coordinator
 *
 * @generated from protobuf message ProtoMessages.ChuLastPairingDetailsRequest
 */
export interface ChuLastPairingDetailsRequest {
    /**
     * @generated from protobuf field: bool request = 1;
     */
    request: boolean;
}
/**
 * Coordinator-->VPUM
 *
 * @generated from protobuf message ProtoMessages.ChuLastPairingDetailsResponse
 */
export interface ChuLastPairingDetailsResponse {
    /**
     * @generated from protobuf field: ProtoMessages.RunPairingWithData pairingdata = 1;
     */
    pairingdata?: RunPairingWithData;
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 2;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.RequestLatestVenueSelfTest
 */
export interface RequestLatestVenueSelfTest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool request = 1;
     */
    request?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.LatestVenueSelfTestResponse
 */
export interface LatestVenueSelfTestResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool DataAvailable = 1 [json_name = "DataAvailable"];
     */
    dataAvailable?: Bool;
    /**
     * @generated from protobuf field: string TimeDateStart = 2 [json_name = "TimeDateStart"];
     */
    timeDateStart: string; // ISO-8601 [yyyy-MM-ddThh:mm:ss.xxZ]
    /**
     * @generated from protobuf field: string TimeDateEnd = 3 [json_name = "TimeDateEnd"];
     */
    timeDateEnd: string; // ISO-8601 [yyyy-MM-ddThh:mm:ss.xxZ]
    /**
     * @generated from protobuf field: ProtoMessages.NetworkTestResult NetworkTestResponse = 4 [json_name = "NetworkTestResponse"];
     */
    networkTestResponse?: NetworkTestResult;
    /**
     * @generated from protobuf field: ProtoMessages.OnboardingCameraTestResponse CameraTestResponse = 5 [json_name = "CameraTestResponse"];
     */
    cameraTestResponse?: OnboardingCameraTestResponse;
    /**
     * @generated from protobuf field: ProtoMessages.OnboardingGPUTestResponse GpuTestResponse = 6 [json_name = "GpuTestResponse"];
     */
    gpuTestResponse?: OnboardingGPUTestResponse;
    /**
     * @generated from protobuf field: ProtoMessages.SelfTestHwTestResults HwTestsResults = 7 [json_name = "HwTestsResults"];
     */
    hwTestsResults?: SelfTestHwTestResults;
}
/**
 * @generated from protobuf message ProtoMessages.MarkPipCalibrationAndStopPipRequest
 */
export interface MarkPipCalibrationAndStopPipRequest {
    /**
     * @generated from protobuf field: ProtoMessages.Bool set = 1;
     */
    set?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingWiredScoreboardAdded
 */
export interface OnboardingWiredScoreboardAdded {
    /**
     * @generated from protobuf field: ProtoMessages.Bool set = 1;
     */
    set?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingSystemRenameRequest
 */
export interface OnboardingSystemRenameRequest {
    /**
     * @generated from protobuf field: string venueName = 1;
     */
    venueName: string;
    /**
     * @generated from protobuf field: string pairingType = 2;
     */
    pairingType: string;
    /**
     * @generated from protobuf field: string sn = 3;
     */
    sn: string;
    /**
     * @generated from protobuf field: string venueType = 4;
     */
    venueType: string;
    /**
     * @generated from protobuf field: string tenant = 5;
     */
    tenant: string;
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingSystemRenameRequestRecieved
 */
export interface OnboardingSystemRenameRequestRecieved {
}
/**
 * @generated from protobuf message ProtoMessages.OnboardingSystemRenameDone
 */
export interface OnboardingSystemRenameDone {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
}
/**
 * Device available for web tunneling (cameras, repeaters, etc.)
 *
 * @generated from protobuf message ProtoMessages.TunnelDevice
 */
export interface TunnelDevice {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string; // Unique identifier (typically IP address)
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string; // Display name
    /**
     * @generated from protobuf field: string model = 3;
     */
    model: string; // Device model
    /**
     * @generated from protobuf field: ProtoMessages.TunnelDevice.DeviceType deviceType = 4;
     */
    deviceType: TunnelDevice_DeviceType;
}
/**
 * @generated from protobuf enum ProtoMessages.TunnelDevice.DeviceType
 */
export enum TunnelDevice_DeviceType {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: HEAD_CAMERA = 1;
     */
    HEAD_CAMERA = 1,
    /**
     * @generated from protobuf enum value: ADDITIONAL_ANGLE = 2;
     */
    ADDITIONAL_ANGLE = 2,
    /**
     * @generated from protobuf enum value: PIP_CAMERA = 3;
     */
    PIP_CAMERA = 3,
    /**
     * @generated from protobuf enum value: REPEATER = 4;
     */
    REPEATER = 4
}
/**
 * Request to get list of devices available for tunneling
 *
 * @generated from protobuf message ProtoMessages.TunnelDeviceListRequest
 */
export interface TunnelDeviceListRequest {
}
/**
 * Response with list of available devices
 *
 * @generated from protobuf message ProtoMessages.TunnelDeviceListResponse
 */
export interface TunnelDeviceListResponse {
    /**
     * @generated from protobuf field: repeated ProtoMessages.TunnelDevice devices = 1;
     */
    devices: TunnelDevice[];
    /**
     * @generated from protobuf field: bool success = 2;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
}
/**
 * Web tunnel control messages for tunneling device web UIs
 *
 * @generated from protobuf message ProtoMessages.TunnelControlMessage
 */
export interface TunnelControlMessage {
    /**
     * @generated from protobuf field: ProtoMessages.TunnelControlMessage.ControlMessageType type = 1;
     */
    type: TunnelControlMessage_ControlMessageType;
    /**
     * @generated from protobuf field: string tunnelId = 2;
     */
    tunnelId: string;
    /**
     * @generated from protobuf field: string deviceId = 3;
     */
    deviceId: string; // Device ID to create tunnel for
    /**
     * @generated from protobuf field: string errorMessage = 4;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf enum ProtoMessages.TunnelControlMessage.ControlMessageType
 */
export enum TunnelControlMessage_ControlMessageType {
    /**
     * @generated from protobuf enum value: TUNNEL_CREATE = 0;
     */
    TUNNEL_CREATE = 0,
    /**
     * @generated from protobuf enum value: TUNNEL_CLOSE = 1;
     */
    TUNNEL_CLOSE = 1,
    /**
     * @generated from protobuf enum value: TUNNEL_ERROR = 2;
     */
    TUNNEL_ERROR = 2,
    /**
     * @generated from protobuf enum value: TUNNEL_STATUS = 3;
     */
    TUNNEL_STATUS = 3
}
/**
 * @generated from protobuf message ProtoMessages.TunnelTcpFrame
 */
export interface TunnelTcpFrame {
    /**
     * @generated from protobuf field: ProtoMessages.TunnelTcpFrame.FrameType frameType = 1;
     */
    frameType: TunnelTcpFrame_FrameType;
    /**
     * @generated from protobuf field: uint32 connectionId = 2;
     */
    connectionId: number;
    /**
     * @generated from protobuf field: string tunnelId = 3;
     */
    tunnelId: string;
    /**
     * @generated from protobuf field: bytes data = 4;
     */
    data: Uint8Array; // Raw TCP data bytes
    /**
     * @generated from protobuf field: string errorMsg = 5;
     */
    errorMsg: string; // Only used for ERROR frames
}
/**
 * @generated from protobuf enum ProtoMessages.TunnelTcpFrame.FrameType
 */
export enum TunnelTcpFrame_FrameType {
    /**
     * @generated from protobuf enum value: DATA = 0;
     */
    DATA = 0,
    /**
     * @generated from protobuf enum value: OPEN = 1;
     */
    OPEN = 1,
    /**
     * @generated from protobuf enum value: CLOSE = 2;
     */
    CLOSE = 2,
    /**
     * @generated from protobuf enum value: ERROR = 3;
     */
    ERROR = 3
}
/**
 * Legacy Remote Web Control messages (browser automation for camera UIs)
 *
 * @generated from protobuf message ProtoMessages.CameraInfo
 */
export interface CameraInfo {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string ip = 2;
     */
    ip: string;
    /**
     * @generated from protobuf field: string model = 3;
     */
    model: string;
    /**
     * @generated from protobuf field: string url = 4;
     */
    url: string;
}
/**
 * @generated from protobuf message ProtoMessages.CameraControlMessage
 */
export interface CameraControlMessage {
    /**
     * @generated from protobuf field: ProtoMessages.CameraControlMessage.CameraControlMessageType type = 1;
     */
    type: CameraControlMessage_CameraControlMessageType;
    /**
     * @generated from protobuf field: repeated ProtoMessages.CameraInfo headCameras = 2;
     */
    headCameras: CameraInfo[];
    /**
     * @generated from protobuf field: repeated ProtoMessages.CameraInfo aditionalAnglesCameras = 3;
     */
    aditionalAnglesCameras: CameraInfo[];
    /**
     * @generated from protobuf field: string cameraToConnect = 4;
     */
    cameraToConnect: string;
    /**
     * @generated from protobuf field: string input = 5;
     */
    input: string;
    /**
     * @generated from protobuf field: string data = 6;
     */
    data: string;
    /**
     * @generated from protobuf field: string msg = 7;
     */
    msg: string;
}
/**
 * @generated from protobuf enum ProtoMessages.CameraControlMessage.CameraControlMessageType
 */
export enum CameraControlMessage_CameraControlMessageType {
    /**
     * @generated from protobuf enum value: GET_CAMERAS = 0;
     */
    GET_CAMERAS = 0,
    /**
     * @generated from protobuf enum value: CONNECT_TO_CAMERA = 1;
     */
    CONNECT_TO_CAMERA = 1,
    /**
     * @generated from protobuf enum value: CAMERA_CONTROL_FRAME = 2;
     */
    CAMERA_CONTROL_FRAME = 2,
    /**
     * @generated from protobuf enum value: CAMERA_CONTROL_INPUT = 3;
     */
    CAMERA_CONTROL_INPUT = 3,
    /**
     * @generated from protobuf enum value: CLOSE_CONNECTION = 4;
     */
    CLOSE_CONNECTION = 4,
    /**
     * @generated from protobuf enum value: FRAME_ACK = 5;
     */
    FRAME_ACK = 5
}
// /////////////////Color Balance messages//////////////

/**
 * @generated from protobuf message ProtoMessages.ColorBalanceDataRequest
 */
export interface ColorBalanceDataRequest {
}
/**
 * @generated from protobuf message ProtoMessages.CalibrationPoints
 */
export interface CalibrationPoints {
    /**
     * @generated from protobuf field: repeated CommonUsedMessages.Point2D point2d = 1 [json_name = "point2d"];
     */
    point2D: Point2D[];
}
/**
 * @generated from protobuf message ProtoMessages.CalibrationPointsReply
 */
export interface CalibrationPointsReply {
    /**
     * @generated from protobuf field: ProtoMessages.CalibrationPointsType pointsType = 1;
     */
    pointsType: CalibrationPointsType;
    /**
     * @generated from protobuf field: repeated ProtoMessages.CalibrationPoints calibrationPoints = 2;
     */
    calibrationPoints: CalibrationPoints[];
}
/**
 * @generated from protobuf message ProtoMessages.CalibrationPointsRequest
 */
export interface CalibrationPointsRequest {
    /**
     * @generated from protobuf field: ProtoMessages.CalibrationPointsType pointsType = 1;
     */
    pointsType: CalibrationPointsType;
    /**
     * @generated from protobuf field: repeated ProtoMessages.CalibrationPoints calibrationPoints = 2;
     */
    calibrationPoints: CalibrationPoints[];
}
/**
 * @generated from protobuf message ProtoMessages.ColorBalanceDataReply
 */
export interface ColorBalanceDataReply {
    /**
     * @generated from protobuf field: repeated ProtoMessages.CalibrationPointsReply data = 1;
     */
    data: CalibrationPointsReply[];
}
/**
 * @generated from protobuf message ProtoMessages.UpdatePIPStatus
 */
export interface UpdatePIPStatus {
    /**
     * @generated from protobuf field: bool status = 1;
     */
    status: boolean;
}
/**
 * /heartbeat
 *
 * @generated from protobuf message ProtoMessages.VpumToCoordinatorHeartbeatMessage
 */
export interface VpumToCoordinatorHeartbeatMessage {
    /**
     * @generated from protobuf field: string sessionId = 1;
     */
    sessionId: string;
}
/**
 * @generated from protobuf message ProtoMessages.CoordinatorToVpumHeartbeatAck
 */
export interface CoordinatorToVpumHeartbeatAck {
    /**
     * @generated from protobuf field: string sessionId = 1;
     */
    sessionId: string;
}
// System Tests

/**
 * VPUM --> Coordinator
 *
 * @generated from protobuf message ProtoMessages.SystemTestResultsRequest
 */
export interface SystemTestResultsRequest {
    /**
     * @generated from protobuf field: int64 offset = 1;
     */
    offset: bigint;
    /**
     * @generated from protobuf field: int64 limit = 2;
     */
    limit: bigint;
}
/**
 * @generated from protobuf message ProtoMessages.IndividualCameraTestResult
 */
export interface IndividualCameraTestResult {
    /**
     * @generated from protobuf field: string testName = 1;
     */
    testName: string;
    /**
     * @generated from protobuf field: ProtoMessages.SystemTestResult.TestResult result = 2;
     */
    result: SystemTestResult_TestResult;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.SystemTestResult
 */
export interface SystemTestResult {
    /**
     * @generated from protobuf field: int64 timeStamp = 1;
     */
    timeStamp: bigint;
    /**
     * @generated from protobuf field: ProtoMessages.SystemTestResult.TestResult result = 2;
     */
    result: SystemTestResult_TestResult;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: ProtoMessages.SystemTestResult.TestRunningMode runningMode = 4;
     */
    runningMode: SystemTestResult_TestRunningMode;
    /**
     * @generated from protobuf field: ProtoMessages.SystemTestResult.TestName testName = 5;
     */
    testName: SystemTestResult_TestName;
    /**
     * @generated from protobuf field: repeated ProtoMessages.IndividualCameraTestResult advancedTestResults = 6;
     */
    advancedTestResults: IndividualCameraTestResult[];
}
/**
 * @generated from protobuf enum ProtoMessages.SystemTestResult.TestRunningMode
 */
export enum SystemTestResult_TestRunningMode {
    /**
     * @generated from protobuf enum value: AUTO = 0;
     */
    AUTO = 0,
    /**
     * @generated from protobuf enum value: MANUAL = 1;
     */
    MANUAL = 1
}
/**
 * @generated from protobuf enum ProtoMessages.SystemTestResult.TestResult
 */
export enum SystemTestResult_TestResult {
    /**
     * @generated from protobuf enum value: SUCCESS = 0;
     */
    SUCCESS = 0,
    /**
     * @generated from protobuf enum value: FAILED = 1;
     */
    FAILED = 1,
    /**
     * @generated from protobuf enum value: NOT_COMPLETED = 2;
     */
    NOT_COMPLETED = 2
}
/**
 * @generated from protobuf enum ProtoMessages.SystemTestResult.TestName
 */
export enum SystemTestResult_TestName {
    /**
     * @generated from protobuf enum value: SYSTEM_TEST = 0;
     */
    SYSTEM_TEST = 0,
    /**
     * @generated from protobuf enum value: CAMERA_TEST = 1;
     */
    CAMERA_TEST = 1,
    /**
     * @generated from protobuf enum value: ADV_CAMERA_TEST = 2;
     */
    ADV_CAMERA_TEST = 2,
    /**
     * @generated from protobuf enum value: POE_TEST = 3;
     */
    POE_TEST = 3
}
/**
 * Coordinator --> VPUM
 *
 * @generated from protobuf message ProtoMessages.SystemTestResultsResponse
 */
export interface SystemTestResultsResponse {
    /**
     * @generated from protobuf field: int64 offset = 1;
     */
    offset: bigint;
    /**
     * @generated from protobuf field: int64 total = 2;
     */
    total: bigint;
    /**
     * @generated from protobuf field: repeated ProtoMessages.SystemTestResult data = 3;
     */
    data: SystemTestResult[];
}
/**
 * System Audit
 * VPUM --> Coordinator
 *
 * @generated from protobuf message ProtoMessages.AuditInfoRequest
 */
export interface AuditInfoRequest {
    /**
     * @generated from protobuf field: int64 offset = 1;
     */
    offset: bigint;
    /**
     * @generated from protobuf field: int64 limit = 2;
     */
    limit: bigint;
    /**
     * @generated from protobuf field: string searchKeyword = 3;
     */
    searchKeyword: string;
}
/**
 * Coordinator --> VPUM
 *
 * @generated from protobuf message ProtoMessages.AuditInfoResponse
 */
export interface AuditInfoResponse {
    /**
     * @generated from protobuf field: int64 offset = 1;
     */
    offset: bigint;
    /**
     * @generated from protobuf field: int64 total = 2;
     */
    total: bigint;
    /**
     * @generated from protobuf field: repeated ProtoMessages.AuditInfo data = 3;
     */
    data: AuditInfo[];
    /**
     * @generated from protobuf field: bool success = 4;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 5;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.AuditUserData
 */
export interface AuditUserData {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string role = 2;
     */
    role: string;
}
/**
 * @generated from protobuf message ProtoMessages.AuditInfo
 */
export interface AuditInfo {
    /**
     * @generated from protobuf field: uint64 dateTimeStampUTC = 1;
     */
    dateTimeStampUTC: bigint;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: ProtoMessages.AuditUserData userData = 3;
     */
    userData?: AuditUserData;
}
// Balena - sportzcast scoreboard

// VPUM --> Coordinator

/**
 * @generated from protobuf message ProtoMessages.SportzcastGetVendorListRequest
 */
export interface SportzcastGetVendorListRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastGetVendorSportsListRequest
 */
export interface SportzcastGetVendorSportsListRequest {
    /**
     * @generated from protobuf field: int32 vendorId = 1;
     */
    vendorId: number;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastGetVendorConfigurationListRequest
 */
export interface SportzcastGetVendorConfigurationListRequest {
    /**
     * @generated from protobuf field: int32 vendorId = 1;
     */
    vendorId: number;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastGetCurrentConfigurationRequest
 */
export interface SportzcastGetCurrentConfigurationRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastSetConfigurationRequest
 */
export interface SportzcastSetConfigurationRequest {
    /**
     * @generated from protobuf field: VpuScoreconnectGrpc.Configuration input = 1;
     */
    input?: Configuration;
    /**
     * @generated from protobuf field: string vendorName = 2;
     */
    vendorName: string;
    /**
     * @generated from protobuf field: string vendorSportName = 3;
     */
    vendorSportName: string;
    /**
     * @generated from protobuf field: string vendorConfigurationName = 4;
     */
    vendorConfigurationName: string;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastGetLiveDataRequest
 */
export interface SportzcastGetLiveDataRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastDiscoverLanScorelinkRequest
 */
export interface SportzcastDiscoverLanScorelinkRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * System INIT
 *
 * @generated from protobuf message ProtoMessages.CurrentSessionListStartRequest
 */
export interface CurrentSessionListStartRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.CurrentSessionListResponse
 */
export interface CurrentSessionListResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: string key = 3;
     */
    key: string;
    /**
     * @generated from protobuf field: repeated ProtoMessages.VpuPhase phases = 4;
     */
    phases: VpuPhase[];
}
/**
 * @generated from protobuf message ProtoMessages.VpuPhase
 */
export interface VpuPhase {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: ProtoMessages.Uint64 startTime = 2;
     */
    startTime?: Uint64;
    /**
     * @generated from protobuf field: ProtoMessages.Uint64 endTime = 3;
     */
    endTime?: Uint64;
}
/**
 * @generated from protobuf message ProtoMessages.CurrentSessionListStopRequest
 */
export interface CurrentSessionListStopRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.SessionsEventsAndDatesListRequest
 */
export interface SessionsEventsAndDatesListRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.SessionsEventsAndDatesListResponse
 */
export interface SessionsEventsAndDatesListResponse {
    /**
     * @generated from protobuf field: repeated string eventsAndDates = 1;
     */
    eventsAndDates: string[];
}
/**
 * @generated from protobuf message ProtoMessages.SessionsHistoryTableByKeyAndCurrentRequest
 */
export interface SessionsHistoryTableByKeyAndCurrentRequest {
    /**
     * @generated from protobuf field: string key = 1;
     */
    key: string;
}
/**
 * @generated from protobuf message ProtoMessages.SessionsHistoryTableByKeyAndCurrentResponse
 */
export interface SessionsHistoryTableByKeyAndCurrentResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: repeated ProtoMessages.VpuSession sessions = 3;
     */
    sessions: VpuSession[];
}
/**
 * @generated from protobuf message ProtoMessages.VpuSession
 */
export interface VpuSession {
    /**
     * @generated from protobuf field: ProtoMessages.Int32 sessionId = 1;
     */
    sessionId?: Int32;
    /**
     * @generated from protobuf field: string lastPhaseName = 2;
     */
    lastPhaseName: string;
    /**
     * @generated from protobuf field: ProtoMessages.Uint64 createdAt = 3;
     */
    createdAt?: Uint64;
}
/**
 * @generated from protobuf message ProtoMessages.UpdateVpuSnAndPnRequest
 */
export interface UpdateVpuSnAndPnRequest {
    /**
     * @generated from protobuf field: string serialNumber = 1;
     */
    serialNumber: string;
    /**
     * @generated from protobuf field: string partNumber = 2;
     */
    partNumber: string;
    /**
     * @generated from protobuf field: string source = 3;
     */
    source: string;
}
/**
 * @generated from protobuf message ProtoMessages.UpdateVpuSnAndPnResponse
 */
export interface UpdateVpuSnAndPnResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastGetVendorListResponse
 */
export interface SportzcastGetVendorListResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: VpuScoreconnectGrpc.VendorList vendorList = 2;
     */
    vendorList?: VendorList;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastGetVendorSportsListResponse
 */
export interface SportzcastGetVendorSportsListResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: VpuScoreconnectGrpc.VendorSportsList vendorSportsList = 2;
     */
    vendorSportsList?: VendorSportsList;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastGetVendorConfigurationListResponse
 */
export interface SportzcastGetVendorConfigurationListResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: VpuScoreconnectGrpc.VendorConfigurationList vendorConfigurationList = 2;
     */
    vendorConfigurationList?: VendorConfigurationList;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastGetCurrentConfigurationResponse
 */
export interface SportzcastGetCurrentConfigurationResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool isConfigured = 2;
     */
    isConfigured?: Bool;
    /**
     * @generated from protobuf field: VpuScoreconnectGrpc.Configuration configuration = 3;
     */
    configuration?: Configuration;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastSetConfigurationResponse
 */
export interface SportzcastSetConfigurationResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastGetLiveDataResponse
 */
export interface SportzcastGetLiveDataResponse {
    /**
     * @generated from protobuf field: int32 botNumber = 1;
     */
    botNumber: number; // return -1 if not configured
    /**
     * @generated from protobuf field: VpuScoreconnectGrpc.ScoreBoardDataMessage scoreBoardData = 2;
     */
    scoreBoardData?: ScoreBoardDataMessage;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastDiscoverLanScorelinkResponse
 */
export interface SportzcastDiscoverLanScorelinkResponse {
    /**
     * @generated from protobuf field: VpuScoreconnectGrpc.LanScoreLinkDeviceList discoverdScoreLinksList = 1;
     */
    discoverdScoreLinksList?: LanScoreLinkDeviceList;
}
// RTSP links for VPUM

/**
 * VPUM -> Coordinator
 *
 * @generated from protobuf message ProtoMessages.LiveRtspLinksRequest
 */
export interface LiveRtspLinksRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * Coordiantor -> VPUM
 *
 * @generated from protobuf message ProtoMessages.LiveRtspLinksResponse
 */
export interface LiveRtspLinksResponse {
    /**
     * @generated from protobuf field: repeated CommonUsedMessages.RtspLinkInfo rtspLinks = 1;
     */
    rtspLinks: RtspLinkInfo[];
}
/**
 * Coordiantor -> VPUM
 *
 * @generated from protobuf message ProtoMessages.VpumTabsStatusesMessage
 */
export interface VpumTabsStatusesMessage {
    /**
     * @generated from protobuf field: ProtoMessages.GeneralStatus networkCheck = 1;
     */
    networkCheck?: GeneralStatus;
    /**
     * @generated from protobuf field: ProtoMessages.GeneralStatus systemTest = 2;
     */
    systemTest?: GeneralStatus;
    /**
     * @generated from protobuf field: ProtoMessages.GeneralStatus chuPairing = 3;
     */
    chuPairing?: GeneralStatus;
    /**
     * @generated from protobuf field: ProtoMessages.GeneralStatus chuAdjustment = 4;
     */
    chuAdjustment?: GeneralStatus;
    /**
     * @generated from protobuf field: ProtoMessages.GeneralStatus venueCalibration = 5;
     */
    venueCalibration?: GeneralStatus;
    /**
     * @generated from protobuf field: ProtoMessages.GeneralStatus additionalPairing = 6;
     */
    additionalPairing?: GeneralStatus;
    /**
     * @generated from protobuf field: ProtoMessages.GeneralStatus additionalAngle = 7;
     */
    additionalAngle?: GeneralStatus;
}
// VPUM -> Coordiantor - tab statuses:

/**
 * ************************************
 *
 * @generated from protobuf message ProtoMessages.VpumTabStatusUpdate
 */
export interface VpumTabStatusUpdate {
    /**
     * @generated from protobuf field: ProtoMessages.VpumTabStatusUpdate.TabName tabName = 1;
     */
    tabName: VpumTabStatusUpdate_TabName;
    /**
     * @generated from protobuf field: ProtoMessages.GeneralStatus status = 2;
     */
    status?: GeneralStatus;
}
/**
 * @generated from protobuf enum ProtoMessages.VpumTabStatusUpdate.TabName
 */
export enum VpumTabStatusUpdate_TabName {
    /**
     * @generated from protobuf enum value: UNKNOWN_TAB = 0;
     */
    UNKNOWN_TAB = 0,
    /**
     * @generated from protobuf enum value: NETWORK_CHECK = 1;
     */
    NETWORK_CHECK = 1,
    /**
     * @generated from protobuf enum value: SYSTEM_TEST = 2;
     */
    SYSTEM_TEST = 2,
    /**
     * @generated from protobuf enum value: CHU_PAIRING = 3;
     */
    CHU_PAIRING = 3,
    /**
     * @generated from protobuf enum value: CHU_ADJUSTMENT = 4;
     */
    CHU_ADJUSTMENT = 4,
    /**
     * @generated from protobuf enum value: VENUE_CALIBRATION = 5;
     */
    VENUE_CALIBRATION = 5,
    /**
     * @generated from protobuf enum value: ADDITIONAL_PAIRING = 6;
     */
    ADDITIONAL_PAIRING = 6,
    /**
     * @generated from protobuf enum value: ADDITIONAL_ANGLE = 7;
     */
    ADDITIONAL_ANGLE = 7
}
/**
 * @generated from protobuf message ProtoMessages.GetChosenAPDoublePlayCameraRequest
 */
export interface GetChosenAPDoublePlayCameraRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.GetChosenAPDoublePlayCameraResponse
 */
export interface GetChosenAPDoublePlayCameraResponse {
    /**
     * @generated from protobuf field: ProtoMessages.GetChosenAPDoublePlayCameraResponse.CameraType cameraType = 1;
     */
    cameraType: GetChosenAPDoublePlayCameraResponse_CameraType;
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 2;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf enum ProtoMessages.GetChosenAPDoublePlayCameraResponse.CameraType
 */
export enum GetChosenAPDoublePlayCameraResponse_CameraType {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: MAIN_CAMERA = 1;
     */
    MAIN_CAMERA = 1,
    /**
     * @generated from protobuf enum value: AA_CAMERA = 2;
     */
    AA_CAMERA = 2
}
/**
 * @generated from protobuf message ProtoMessages.SwitchAPDoublePlayCameraRequest
 */
export interface SwitchAPDoublePlayCameraRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.SwitchAPDoublePlayCameraResponse
 */
export interface SwitchAPDoublePlayCameraResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.CamerasConnectionStatusesRequest
 */
export interface CamerasConnectionStatusesRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.CamerasConnectionStatusesResponse
 */
export interface CamerasConnectionStatusesResponse {
    /**
     * @generated from protobuf field: repeated CommonUsedMessages.AdapterStatus adapterStatus = 1;
     */
    adapterStatus: AdapterStatus[];
    /**
     * @generated from protobuf field: repeated CommonUsedMessages.CameraStatus cameraStatus = 2;
     */
    cameraStatus: CameraStatus[];
}
/**
 * @generated from protobuf message ProtoMessages.HeaterMode
 */
export interface HeaterMode {
    /**
     * @generated from protobuf field: ProtoMessages.HeaterMode.Mode value = 1;
     */
    value: HeaterMode_Mode;
}
/**
 * @generated from protobuf enum ProtoMessages.HeaterMode.Mode
 */
export enum HeaterMode_Mode {
    /**
     * @generated from protobuf enum value: OFF = 0;
     */
    OFF = 0,
    /**
     * @generated from protobuf enum value: ON = 1;
     */
    ON = 1,
    /**
     * @generated from protobuf enum value: AUTO = 2;
     */
    AUTO = 2
}
/**
 * @generated from protobuf message ProtoMessages.AudioEqualizerMode
 */
export interface AudioEqualizerMode {
    /**
     * @generated from protobuf field: ProtoMessages.AudioEqualizerMode.Mode value = 1;
     */
    value: AudioEqualizerMode_Mode;
}
/**
 * @generated from protobuf enum ProtoMessages.AudioEqualizerMode.Mode
 */
export enum AudioEqualizerMode_Mode {
    /**
     * @generated from protobuf enum value: ENHANCED_AUDIO = 0;
     */
    ENHANCED_AUDIO = 0,
    /**
     * @generated from protobuf enum value: FLAT = 1;
     */
    FLAT = 1,
    /**
     * @generated from protobuf enum value: WIND_REDUCTION = 2;
     */
    WIND_REDUCTION = 2
}
/**
 * @generated from protobuf message ProtoMessages.VenueSelfTestProgressMessage
 */
export interface VenueSelfTestProgressMessage {
    /**
     * @generated from protobuf field: ProtoMessages.Bool running = 1;
     */
    running?: Bool;
    /**
     * @generated from protobuf field: string initiator = 2;
     */
    initiator: string;
}
/**
 * @generated from protobuf message ProtoMessages.ProductionManagementParams
 */
export interface ProductionManagementParams {
    /**
     * @generated from protobuf field: ProtoMessages.Bool yellowLineEnabled = 1;
     */
    yellowLineEnabled?: Bool;
    /**
     * @generated from protobuf field: ProtoMessages.Bool replayEnabled = 2;
     */
    replayEnabled?: Bool;
    /**
     * @generated from protobuf field: double replayMinimumPlayTime = 3;
     */
    replayMinimumPlayTime: number;
    /**
     * @generated from protobuf field: int32 replayZoom = 4;
     */
    replayZoom: number;
    /**
     * @generated from protobuf field: int32 replaySpeed = 5;
     */
    replaySpeed: number;
}
/**
 * @generated from protobuf message ProtoMessages.ProductionManagementParametersRequest
 */
export interface ProductionManagementParametersRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.ProductionManagementParametersResponse
 */
export interface ProductionManagementParametersResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: ProtoMessages.ProductionManagementParams params = 4;
     */
    params?: ProductionManagementParams;
}
/**
 * @generated from protobuf message ProtoMessages.UpdateProductionManagementParametersRequest
 */
export interface UpdateProductionManagementParametersRequest {
    /**
     * @generated from protobuf field: ProtoMessages.ProductionManagementParams params = 1;
     */
    params?: ProductionManagementParams;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastSwapTeamDataRequest
 */
export interface SportzcastSwapTeamDataRequest {
    /**
     * @generated from protobuf field: CommonUsedMessages.Empty empty = 1;
     */
    empty?: Empty;
}
/**
 * @generated from protobuf message ProtoMessages.SportzcastSwapTeamDataResponse
 */
export interface SportzcastSwapTeamDataResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
}
/**
 * @generated from protobuf message ProtoMessages.StartPipFramesStreamRequest
 */
export interface StartPipFramesStreamRequest {
    /**
     * @generated from protobuf field: string sessionId = 1;
     */
    sessionId: string; // VPUM session ID
}
/**
 * @generated from protobuf message ProtoMessages.StartPipFramesStreamResponse
 */
export interface StartPipFramesStreamResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: string sessionId = 3;
     */
    sessionId: string;
}
/**
 * @generated from protobuf message ProtoMessages.StopPipFramesStreamRequest
 */
export interface StopPipFramesStreamRequest {
    /**
     * @generated from protobuf field: string sessionId = 1;
     */
    sessionId: string;
}
/**
 * @generated from protobuf message ProtoMessages.StopPipFramesStreamResponse
 */
export interface StopPipFramesStreamResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: string sessionId = 3;
     */
    sessionId: string;
}
/**
 * @generated from protobuf message ProtoMessages.PipFrameStreamMessage
 */
export interface PipFrameStreamMessage {
    /**
     * @generated from protobuf field: CommonUsedMessages.DataChunkMessage frame = 1;
     */
    frame?: DataChunkMessage;
    /**
     * @generated from protobuf field: uint32 frameNumber = 2;
     */
    frameNumber: number;
    /**
     * @generated from protobuf field: VpuGrpc.OcrDataMessage scoreBoardData = 3;
     */
    scoreBoardData?: OcrDataMessage;
}
/**
 * @generated from protobuf message ProtoMessages.PipFrameStreamErrorMessage
 */
export interface PipFrameStreamErrorMessage {
    /**
     * @generated from protobuf field: string sessionId = 1;
     */
    sessionId: string;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: uint32 lastFrameNumber = 3;
     */
    lastFrameNumber: number;
}
/**
 * @generated from protobuf message ProtoMessages.StartSendScoreboardDataWithPipFrameStreamRequest
 */
export interface StartSendScoreboardDataWithPipFrameStreamRequest {
    /**
     * @generated from protobuf field: string sessionId = 1;
     */
    sessionId: string;
    /**
     * @generated from protobuf field: int32 stopSendAfterMinutes = 2;
     */
    stopSendAfterMinutes: number;
}
/**
 * @generated from protobuf message ProtoMessages.StartSendScoreboardDataWithPipFrameStreamResponse
 */
export interface StartSendScoreboardDataWithPipFrameStreamResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string sessionId = 2;
     */
    sessionId: string;
}
/**
 * @generated from protobuf message ProtoMessages.StopSendScoreboardDataWithPipFrameStreamRequest
 */
export interface StopSendScoreboardDataWithPipFrameStreamRequest {
    /**
     * @generated from protobuf field: string sessionId = 1;
     */
    sessionId: string;
}
/**
 * @generated from protobuf message ProtoMessages.StopSendScoreboardDataWithPipFrameStreamResponse
 */
export interface StopSendScoreboardDataWithPipFrameStreamResponse {
    /**
     * @generated from protobuf field: ProtoMessages.Bool success = 1;
     */
    success?: Bool;
    /**
     * @generated from protobuf field: string sessionId = 2;
     */
    sessionId: string;
}
/**
 * @generated from protobuf message ProtoMessages.FullScoreboardSaveHistoryEntry
 */
export interface FullScoreboardSaveHistoryEntry {
    /**
     * @generated from protobuf field: string user = 1;
     */
    user: string;
    /**
     * @generated from protobuf field: uint64 timestamp = 2;
     */
    timestamp: bigint;
}
/**
 * @generated from protobuf message ProtoMessages.FullScoreboardSaveHistoryRequest
 */
export interface FullScoreboardSaveHistoryRequest {
    /**
     * @generated from protobuf field: int32 numOfRecords = 1;
     */
    numOfRecords: number;
}
/**
 * @generated from protobuf message ProtoMessages.FullScoreboardSaveHistoryResponse
 */
export interface FullScoreboardSaveHistoryResponse {
    /**
     * @generated from protobuf field: repeated ProtoMessages.FullScoreboardSaveHistoryEntry entries = 1;
     */
    entries: FullScoreboardSaveHistoryEntry[];
}
/**
 * @generated from protobuf message ProtoMessages.OcrAiCalibrateRequest
 */
export interface OcrAiCalibrateRequest {
    /**
     * @generated from protobuf field: string sportType = 1;
     */
    sportType: string;
}
/**
 * @generated from protobuf message ProtoMessages.OcrAiCalibrateResponse
 */
export interface OcrAiCalibrateResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.OcrAiSetSportTypeRequest
 */
export interface OcrAiSetSportTypeRequest {
    /**
     * @generated from protobuf field: string sportType = 1;
     */
    sportType: string;
}
/**
 * @generated from protobuf message ProtoMessages.OcrAiSetSportTypeResponse
 */
export interface OcrAiSetSportTypeResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.OcrAiSetSwapHomeAwayRequest
 */
export interface OcrAiSetSwapHomeAwayRequest {
    /**
     * @generated from protobuf field: bool swap = 1;
     */
    swap: boolean;
}
/**
 * @generated from protobuf message ProtoMessages.OcrAiSetSwapHomeAwayResponse
 */
export interface OcrAiSetSwapHomeAwayResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message ProtoMessages.OcrAiValidationHistoryRequest
 */
export interface OcrAiValidationHistoryRequest {
}
/**
 * @generated from protobuf message ProtoMessages.OcrAiValidationHistoryEntry
 */
export interface OcrAiValidationHistoryEntry {
    /**
     * @generated from protobuf field: string sportType = 1;
     */
    sportType: string;
    /**
     * @generated from protobuf field: uint64 lastValidatedTimestamp = 2;
     */
    lastValidatedTimestamp: bigint;
    /**
     * @generated from protobuf field: bool lastValidationSuccess = 3;
     */
    lastValidationSuccess: boolean;
    /**
     * @generated from protobuf field: string validatedBy = 4;
     */
    validatedBy: string;
}
/**
 * @generated from protobuf message ProtoMessages.OcrAiValidationHistoryResponse
 */
export interface OcrAiValidationHistoryResponse {
    /**
     * @generated from protobuf field: repeated ProtoMessages.OcrAiValidationHistoryEntry entries = 1;
     */
    entries: OcrAiValidationHistoryEntry[];
}
/**
 * @generated from protobuf enum ProtoMessages.MessageSender
 */
export enum MessageSender {
    /**
     * @generated from protobuf enum value: UNKNOWN_SENDER = 0;
     */
    UNKNOWN_SENDER = 0,
    /**
     * @generated from protobuf enum value: VPUM = 1;
     */
    VPUM = 1,
    /**
     * @generated from protobuf enum value: CONNECT_APP = 2;
     */
    CONNECT_APP = 2
}
/**
 * @generated from protobuf enum ProtoMessages.ConfigurationAction
 */
export enum ConfigurationAction {
    /**
     * @generated from protobuf enum value: CONFIGURATION_ACTION_GET = 0;
     */
    GET = 0,
    /**
     * @generated from protobuf enum value: CONFIGURATION_ACTION_SET = 1;
     */
    SET = 1,
    /**
     * @generated from protobuf enum value: CONFIGURATION_ACTION_RESULT = 2;
     */
    RESULT = 2
}
// /////////////////////////////////////////////////////////////////////////////////
// Frames Capturing Messages

/**
 * @generated from protobuf enum ProtoMessages.FrameType
 */
export enum FrameType {
    /**
     * @generated from protobuf enum value: FRAME_TYPE_UNDEFINED = 0;
     */
    FRAME_TYPE_UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: SMALL_FRAMES = 1;
     */
    SMALL_FRAMES = 1,
    /**
     * @generated from protobuf enum value: LARGE_FRAMES = 2;
     */
    LARGE_FRAMES = 2,
    /**
     * @generated from protobuf enum value: PANO_IMAGE = 3;
     */
    PANO_IMAGE = 3,
    /**
     * @generated from protobuf enum value: PIP_IMAGE = 4;
     */
    PIP_IMAGE = 4,
    /**
     * @generated from protobuf enum value: AA_IMAGE = 5;
     */
    AA_IMAGE = 5
}
/**
 * @generated from protobuf enum ProtoMessages.CaptureFramesReplyType
 */
export enum CaptureFramesReplyType {
    /**
     * @generated from protobuf enum value: REPLY_TYPE_UNDEFINED = 0;
     */
    REPLY_TYPE_UNDEFINED = 0,
    /**
     * reply with BigDataMessage (for C++ clients)
     *
     * @generated from protobuf enum value: REPLY_WITH_BIG_DATA_MESSAGE = 1;
     */
    REPLY_WITH_BIG_DATA_MESSAGE = 1,
    /**
     * reply with   (for web clients)
     *
     * @generated from protobuf enum value: REPLY_WITH_DATA_CHUNK_MESSAGE = 2;
     */
    REPLY_WITH_DATA_CHUNK_MESSAGE = 2
}
/**
 * @generated from protobuf enum ProtoMessages.AdditionalCameraConnectionType
 */
export enum AdditionalCameraConnectionType {
    /**
     * @generated from protobuf enum value: UNKNOWN_CONNECTION_TYPE = 0;
     */
    UNKNOWN_CONNECTION_TYPE = 0,
    /**
     * @generated from protobuf enum value: DIRECT = 1;
     */
    DIRECT = 1,
    /**
     * @generated from protobuf enum value: LAN = 2;
     */
    LAN = 2,
    /**
     * @generated from protobuf enum value: USB = 3;
     */
    USB = 3
}
/**
 * @generated from protobuf enum ProtoMessages.AFMode
 */
export enum AFMode {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: MANUAL = 1;
     */
    MANUAL = 1,
    /**
     * @generated from protobuf enum value: ZOOM_TRIGGERED = 2;
     */
    ZOOM_TRIGGERED = 2,
    /**
     * @generated from protobuf enum value: AUTO = 3;
     */
    AUTO = 3
}
/**
 * @generated from protobuf enum ProtoMessages.AdditionalCameraType
 */
export enum AdditionalCameraType {
    /**
     * @generated from protobuf enum value: UNKNOWN_TYPE = 0;
     */
    UNKNOWN_TYPE = 0,
    /**
     * @generated from protobuf enum value: PIP = 1;
     */
    PIP = 1,
    /**
     * @generated from protobuf enum value: AA = 2;
     */
    AA = 2
}
// ///////////////// AA messages//////////////

/**
 * @generated from protobuf enum ProtoMessages.PairingStage
 */
export enum PairingStage {
    /**
     * @generated from protobuf enum value: CALIBRATION_COPY = 0;
     */
    CALIBRATION_COPY = 0,
    /**
     * @generated from protobuf enum value: FIND_CAMERAS = 1;
     */
    FIND_CAMERAS = 1,
    /**
     * @generated from protobuf enum value: IP_SETUP = 2;
     */
    IP_SETUP = 2,
    /**
     * @generated from protobuf enum value: FW_FLASH = 3;
     */
    FW_FLASH = 3,
    /**
     * @generated from protobuf enum value: CONFIG_FLASH = 4;
     */
    CONFIG_FLASH = 4,
    /**
     * @generated from protobuf enum value: ALL = 5;
     */
    ALL = 5
}
/**
 * @generated from protobuf enum ProtoMessages.AACameraStatus
 */
export enum AACameraStatus {
    /**
     * @generated from protobuf enum value: ENABLED = 0;
     */
    ENABLED = 0,
    /**
     * @generated from protobuf enum value: DISABLED = 1;
     */
    DISABLED = 1
}
/**
 * @generated from protobuf enum ProtoMessages.AACameraType
 */
export enum AACameraType {
    /**
     * @generated from protobuf enum value: AP = 0;
     */
    AP = 0,
    /**
     * @generated from protobuf enum value: LOCAL_RECORDING = 1;
     */
    LOCAL_RECORDING = 1
}
/**
 * @generated from protobuf enum ProtoMessages.ChuUsage
 */
export enum ChuUsage {
    /**
     * @generated from protobuf enum value: CHU_USAGE_FALLBACK = 0;
     */
    FALLBACK = 0,
    /**
     * @generated from protobuf enum value: CHU_USAGE_PRIMARY = 1;
     */
    PRIMARY = 1
}
/**
 * @generated from protobuf enum ProtoMessages.CameraErrorType
 */
export enum CameraErrorType {
    /**
     * @generated from protobuf enum value: ERROR_NONE = 0;
     */
    ERROR_NONE = 0,
    /**
     * @generated from protobuf enum value: ERROR_FIRMWARE = 1;
     */
    ERROR_FIRMWARE = 1,
    /**
     * @generated from protobuf enum value: ERROR_FPS = 2;
     */
    ERROR_FPS = 2,
    /**
     * @generated from protobuf enum value: ERROR_CHU_HW = 3;
     */
    ERROR_CHU_HW = 3,
    /**
     * @generated from protobuf enum value: ERROR_RESET_CHU = 4;
     */
    ERROR_RESET_CHU = 4,
    /**
     * @generated from protobuf enum value: ERROR_CAMERA_DIRECT_COMMUNICATION = 5;
     */
    ERROR_CAMERA_DIRECT_COMMUNICATION = 5,
    /**
     * @generated from protobuf enum value: ERROR_SENDER_BITRATE = 6;
     */
    ERROR_SENDER_BITRATE = 6,
    /**
     * @generated from protobuf enum value: ERROR_RECEIVER_BITRATE = 7;
     */
    ERROR_RECEIVER_BITRATE = 7,
    /**
     * @generated from protobuf enum value: ERROR_CAMERA_HEAD_HW = 8;
     */
    ERROR_CAMERA_HEAD_HW = 8,
    /**
     * @generated from protobuf enum value: ERROR_POE_POWER_VALIDATION = 9;
     */
    ERROR_POE_POWER_VALIDATION = 9,
    /**
     * @generated from protobuf enum value: ERROR_OTHER = 10;
     */
    ERROR_OTHER = 10
}
/**
 * @generated from protobuf enum ProtoMessages.POEErrorType
 */
export enum POEErrorType {
    /**
     * @generated from protobuf enum value: POE_ERROR_NONE = 0;
     */
    POE_ERROR_NONE = 0,
    /**
     * @generated from protobuf enum value: POE_ERROR_NO_CARD_DETECTED = 1;
     */
    POE_ERROR_NO_CARD_DETECTED = 1,
    /**
     * @generated from protobuf enum value: POE_ERROR_MOLEX_DISCONNECTED = 2;
     */
    POE_ERROR_MOLEX_DISCONNECTED = 2,
    /**
     * @generated from protobuf enum value: POE_ERROR_INSUFFICIENT_POWER = 3;
     */
    POE_ERROR_INSUFFICIENT_POWER = 3,
    /**
     * @generated from protobuf enum value: POE_ERROR_OVER_TEMPERATURE = 4;
     */
    POE_ERROR_OVER_TEMPERATURE = 4,
    /**
     * @generated from protobuf enum value: POE_ERROR_POWER_BUDGET_EXCEEDED = 5;
     */
    POE_ERROR_POWER_BUDGET_EXCEEDED = 5,
    /**
     * @generated from protobuf enum value: POE_ERROR_PORT_FAILURE = 6;
     */
    POE_ERROR_PORT_FAILURE = 6,
    /**
     * @generated from protobuf enum value: POE_ERROR_DIAGNOSTIC_FAILURE = 7;
     */
    POE_ERROR_DIAGNOSTIC_FAILURE = 7,
    /**
     * @generated from protobuf enum value: POE_ERROR_OTHER = 8;
     */
    POE_ERROR_OTHER = 8
}
/**
 * @generated from protobuf enum ProtoMessages.CalibrationPointsType
 */
export enum CalibrationPointsType {
    /**
     * @generated from protobuf enum value: MASK = 0;
     */
    MASK = 0,
    /**
     * @generated from protobuf enum value: STITCHING = 1;
     */
    STITCHING = 1
}
// @generated message type with reflection information, may provide speed optimized methods
class CoordinatorMessage$Type extends MessageType$<CoordinatorMessage> {
    constructor() {
        super("ProtoMessages.CoordinatorMessage", [
            { no: 1, name: "userLevelToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "messageTypeStr", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "messageContent", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<CoordinatorMessage>): CoordinatorMessage {
        const message = { userLevelToken: "", messageTypeStr: "", messageContent: new Uint8Array(0) };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CoordinatorMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CoordinatorMessage): CoordinatorMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string userLevelToken */ 1:
                    message.userLevelToken = reader.string();
                    break;
                case /* string messageTypeStr */ 2:
                    message.messageTypeStr = reader.string();
                    break;
                case /* bytes messageContent */ 5:
                    message.messageContent = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CoordinatorMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string userLevelToken = 1; */
        if (message.userLevelToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userLevelToken);
        /* string messageTypeStr = 2; */
        if (message.messageTypeStr !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.messageTypeStr);
        /* bytes messageContent = 5; */
        if (message.messageContent.length)
            writer.tag(5, WireType.LengthDelimited).bytes(message.messageContent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CoordinatorMessage
 */
export const CoordinatorMessage = new CoordinatorMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageType$Type extends MessageType$<MessageType> {
    constructor() {
        super("ProtoMessages.MessageType", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.MessageType.Type", MessageType_Type] }
        ]);
    }
    create(value?: PartialMessage<MessageType>): MessageType {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<MessageType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MessageType): MessageType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.MessageType.Type value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MessageType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.MessageType.Type value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.MessageType
 */
export const MessageType = new MessageType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneralStatus$Type extends MessageType$<GeneralStatus> {
    constructor() {
        super("ProtoMessages.GeneralStatus", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.GeneralStatus.Status", GeneralStatus_Status] }
        ]);
    }
    create(value?: PartialMessage<GeneralStatus>): GeneralStatus {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GeneralStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GeneralStatus): GeneralStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.GeneralStatus.Status value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GeneralStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.GeneralStatus.Status value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.GeneralStatus
 */
export const GeneralStatus = new GeneralStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SwitchType$Type extends MessageType$<SwitchType> {
    constructor() {
        super("ProtoMessages.SwitchType", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.SwitchType.Type", SwitchType_Type] }
        ]);
    }
    create(value?: PartialMessage<SwitchType>): SwitchType {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SwitchType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SwitchType): SwitchType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.SwitchType.Type value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SwitchType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.SwitchType.Type value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SwitchType
 */
export const SwitchType = new SwitchType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SystemMode$Type extends MessageType$<SystemMode> {
    constructor() {
        super("ProtoMessages.SystemMode", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.SystemMode.Mode", SystemMode_Mode] }
        ]);
    }
    create(value?: PartialMessage<SystemMode>): SystemMode {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SystemMode>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SystemMode): SystemMode {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.SystemMode.Mode value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SystemMode, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.SystemMode.Mode value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SystemMode
 */
export const SystemMode = new SystemMode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SystemType$Type extends MessageType$<SystemType> {
    constructor() {
        super("ProtoMessages.SystemType", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.SystemType.Type", SystemType_Type] }
        ]);
    }
    create(value?: PartialMessage<SystemType>): SystemType {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SystemType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SystemType): SystemType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.SystemType.Type value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SystemType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.SystemType.Type value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SystemType
 */
export const SystemType = new SystemType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VpuStatus$Type extends MessageType$<VpuStatus> {
    constructor() {
        super("ProtoMessages.VpuStatus", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.VpuStatus.Status", VpuStatus_Status] }
        ]);
    }
    create(value?: PartialMessage<VpuStatus>): VpuStatus {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VpuStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VpuStatus): VpuStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.VpuStatus.Status value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VpuStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.VpuStatus.Status value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VpuStatus
 */
export const VpuStatus = new VpuStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChuStatus$Type extends MessageType$<ChuStatus> {
    constructor() {
        super("ProtoMessages.ChuStatus", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.ChuStatus.Status", ChuStatus_Status] }
        ]);
    }
    create(value?: PartialMessage<ChuStatus>): ChuStatus {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChuStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChuStatus): ChuStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.ChuStatus.Status value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChuStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.ChuStatus.Status value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ChuStatus
 */
export const ChuStatus = new ChuStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportsType$Type extends MessageType$<SportsType> {
    constructor() {
        super("ProtoMessages.SportsType", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.SportsType.Type", SportsType_Type] }
        ]);
    }
    create(value?: PartialMessage<SportsType>): SportsType {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportsType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportsType): SportsType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.SportsType.Type value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportsType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.SportsType.Type value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportsType
 */
export const SportsType = new SportsType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraFPSChangeStatus$Type extends MessageType$<CameraFPSChangeStatus> {
    constructor() {
        super("ProtoMessages.CameraFPSChangeStatus", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.CameraFPSChangeStatus.Status", CameraFPSChangeStatus_Status] }
        ]);
    }
    create(value?: PartialMessage<CameraFPSChangeStatus>): CameraFPSChangeStatus {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraFPSChangeStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraFPSChangeStatus): CameraFPSChangeStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.CameraFPSChangeStatus.Status value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraFPSChangeStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.CameraFPSChangeStatus.Status value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraFPSChangeStatus
 */
export const CameraFPSChangeStatus = new CameraFPSChangeStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class String$$Type extends MessageType$<String$> {
    constructor() {
        super("ProtoMessages.String", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<String$>): String$ {
        const message = { value: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<String$>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: String$): String$ {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: String$, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.String
 */
export const String$ = new String$$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Bool$Type extends MessageType$<Bool> {
    constructor() {
        super("ProtoMessages.Bool", [
            { no: 1, name: "value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Bool>): Bool {
        const message = { value: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Bool>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Bool): Bool {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool value */ 1:
                    message.value = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Bool, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool value = 1; */
        if (message.value !== false)
            writer.tag(1, WireType.Varint).bool(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.Bool
 */
export const Bool = new Bool$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Float$Type extends MessageType$<Float> {
    constructor() {
        super("ProtoMessages.Float", [
            { no: 1, name: "value", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<Float>): Float {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Float>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Float): Float {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* float value */ 1:
                    message.value = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Float, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* float value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Bit32).float(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.Float
 */
export const Float = new Float$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Double$Type extends MessageType$<Double> {
    constructor() {
        super("ProtoMessages.Double", [
            { no: 1, name: "value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<Double>): Double {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Double>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Double): Double {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double value */ 1:
                    message.value = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Double, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Bit64).double(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.Double
 */
export const Double = new Double$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Uint64$Type extends MessageType$<Uint64> {
    constructor() {
        super("ProtoMessages.Uint64", [
            { no: 1, name: "value", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<Uint64>): Uint64 {
        const message = { value: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Uint64>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Uint64): Uint64 {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 value */ 1:
                    message.value = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Uint64, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint64 value = 1; */
        if (message.value !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.Uint64
 */
export const Uint64 = new Uint64$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Int64$Type extends MessageType$<Int64> {
    constructor() {
        super("ProtoMessages.Int64", [
            { no: 1, name: "value", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<Int64>): Int64 {
        const message = { value: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Int64>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Int64): Int64 {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 value */ 1:
                    message.value = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Int64, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 value = 1; */
        if (message.value !== 0n)
            writer.tag(1, WireType.Varint).int64(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.Int64
 */
export const Int64 = new Int64$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Int32$Type extends MessageType$<Int32> {
    constructor() {
        super("ProtoMessages.Int32", [
            { no: 1, name: "value", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<Int32>): Int32 {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Int32>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Int32): Int32 {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Int32, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.Int32
 */
export const Int32 = new Int32$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CoachingAdditionalAngleInfo$Type extends MessageType$<CoachingAdditionalAngleInfo> {
    constructor() {
        super("ProtoMessages.CoachingAdditionalAngleInfo", [
            { no: 1, name: "name", kind: "message", T: () => String$ },
            { no: 2, name: "url", kind: "message", T: () => String$ },
            { no: 3, name: "enabled", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<CoachingAdditionalAngleInfo>): CoachingAdditionalAngleInfo {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CoachingAdditionalAngleInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CoachingAdditionalAngleInfo): CoachingAdditionalAngleInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.String name */ 1:
                    message.name = String$.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* ProtoMessages.String url */ 2:
                    message.url = String$.internalBinaryRead(reader, reader.uint32(), options, message.url);
                    break;
                case /* ProtoMessages.Bool enabled */ 3:
                    message.enabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.enabled);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CoachingAdditionalAngleInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.String name = 1; */
        if (message.name)
            String$.internalBinaryWrite(message.name, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String url = 2; */
        if (message.url)
            String$.internalBinaryWrite(message.url, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool enabled = 3; */
        if (message.enabled)
            Bool.internalBinaryWrite(message.enabled, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CoachingAdditionalAngleInfo
 */
export const CoachingAdditionalAngleInfo = new CoachingAdditionalAngleInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CoachingAdditionalAngleList$Type extends MessageType$<CoachingAdditionalAngleList> {
    constructor() {
        super("ProtoMessages.CoachingAdditionalAngleList", [
            { no: 1, name: "aaDetails", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CoachingAdditionalAngleInfo }
        ]);
    }
    create(value?: PartialMessage<CoachingAdditionalAngleList>): CoachingAdditionalAngleList {
        const message = { aaDetails: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CoachingAdditionalAngleList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CoachingAdditionalAngleList): CoachingAdditionalAngleList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.CoachingAdditionalAngleInfo aaDetails */ 1:
                    message.aaDetails.push(CoachingAdditionalAngleInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CoachingAdditionalAngleList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.CoachingAdditionalAngleInfo aaDetails = 1; */
        for (let i = 0; i < message.aaDetails.length; i++)
            CoachingAdditionalAngleInfo.internalBinaryWrite(message.aaDetails[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CoachingAdditionalAngleList
 */
export const CoachingAdditionalAngleList = new CoachingAdditionalAngleList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NasInfo$Type extends MessageType$<NasInfo> {
    constructor() {
        super("ProtoMessages.NasInfo", [
            { no: 1, name: "path", kind: "message", T: () => String$ },
            { no: 2, name: "copyPano", kind: "message", T: () => Bool },
            { no: 3, name: "copyHd", kind: "message", T: () => Bool },
            { no: 4, name: "copyJpeg", kind: "message", T: () => Bool },
            { no: 5, name: "NasEnabled", kind: "message", jsonName: "NasEnabled", T: () => Bool },
            { no: 6, name: "username", kind: "message", T: () => String$ },
            { no: 7, name: "password", kind: "message", T: () => String$ },
            { no: 8, name: "protocol", kind: "enum", T: () => ["ProtoMessages.NasInfo.Protocol", NasInfo_Protocol] }
        ]);
    }
    create(value?: PartialMessage<NasInfo>): NasInfo {
        const message = { protocol: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<NasInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NasInfo): NasInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.String path */ 1:
                    message.path = String$.internalBinaryRead(reader, reader.uint32(), options, message.path);
                    break;
                case /* ProtoMessages.Bool copyPano */ 2:
                    message.copyPano = Bool.internalBinaryRead(reader, reader.uint32(), options, message.copyPano);
                    break;
                case /* ProtoMessages.Bool copyHd */ 3:
                    message.copyHd = Bool.internalBinaryRead(reader, reader.uint32(), options, message.copyHd);
                    break;
                case /* ProtoMessages.Bool copyJpeg */ 4:
                    message.copyJpeg = Bool.internalBinaryRead(reader, reader.uint32(), options, message.copyJpeg);
                    break;
                case /* ProtoMessages.Bool NasEnabled = 5 [json_name = "NasEnabled"];*/ 5:
                    message.nasEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.nasEnabled);
                    break;
                case /* ProtoMessages.String username */ 6:
                    message.username = String$.internalBinaryRead(reader, reader.uint32(), options, message.username);
                    break;
                case /* ProtoMessages.String password */ 7:
                    message.password = String$.internalBinaryRead(reader, reader.uint32(), options, message.password);
                    break;
                case /* ProtoMessages.NasInfo.Protocol protocol */ 8:
                    message.protocol = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NasInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.String path = 1; */
        if (message.path)
            String$.internalBinaryWrite(message.path, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool copyPano = 2; */
        if (message.copyPano)
            Bool.internalBinaryWrite(message.copyPano, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool copyHd = 3; */
        if (message.copyHd)
            Bool.internalBinaryWrite(message.copyHd, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool copyJpeg = 4; */
        if (message.copyJpeg)
            Bool.internalBinaryWrite(message.copyJpeg, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool NasEnabled = 5 [json_name = "NasEnabled"]; */
        if (message.nasEnabled)
            Bool.internalBinaryWrite(message.nasEnabled, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String username = 6; */
        if (message.username)
            String$.internalBinaryWrite(message.username, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String password = 7; */
        if (message.password)
            String$.internalBinaryWrite(message.password, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.NasInfo.Protocol protocol = 8; */
        if (message.protocol !== 0)
            writer.tag(8, WireType.Varint).int32(message.protocol);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.NasInfo
 */
export const NasInfo = new NasInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NetworkConfigType$Type extends MessageType$<NetworkConfigType> {
    constructor() {
        super("ProtoMessages.NetworkConfigType", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.NetworkConfigType.Type", NetworkConfigType_Type] }
        ]);
    }
    create(value?: PartialMessage<NetworkConfigType>): NetworkConfigType {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<NetworkConfigType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NetworkConfigType): NetworkConfigType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.NetworkConfigType.Type value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NetworkConfigType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.NetworkConfigType.Type value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.NetworkConfigType
 */
export const NetworkConfigType = new NetworkConfigType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NetworkInfo$Type extends MessageType$<NetworkInfo> {
    constructor() {
        super("ProtoMessages.NetworkInfo", [
            { no: 1, name: "networkType", kind: "message", T: () => NetworkConfigType },
            { no: 2, name: "ipAddress", kind: "message", T: () => String$ },
            { no: 3, name: "subnetMask", kind: "message", T: () => String$ },
            { no: 4, name: "deafultGateway", kind: "message", T: () => String$ },
            { no: 5, name: "dns1", kind: "message", T: () => String$ },
            { no: 6, name: "dns2", kind: "message", T: () => String$ }
        ]);
    }
    create(value?: PartialMessage<NetworkInfo>): NetworkInfo {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<NetworkInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NetworkInfo): NetworkInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.NetworkConfigType networkType */ 1:
                    message.networkType = NetworkConfigType.internalBinaryRead(reader, reader.uint32(), options, message.networkType);
                    break;
                case /* ProtoMessages.String ipAddress */ 2:
                    message.ipAddress = String$.internalBinaryRead(reader, reader.uint32(), options, message.ipAddress);
                    break;
                case /* ProtoMessages.String subnetMask */ 3:
                    message.subnetMask = String$.internalBinaryRead(reader, reader.uint32(), options, message.subnetMask);
                    break;
                case /* ProtoMessages.String deafultGateway */ 4:
                    message.deafultGateway = String$.internalBinaryRead(reader, reader.uint32(), options, message.deafultGateway);
                    break;
                case /* ProtoMessages.String dns1 */ 5:
                    message.dns1 = String$.internalBinaryRead(reader, reader.uint32(), options, message.dns1);
                    break;
                case /* ProtoMessages.String dns2 */ 6:
                    message.dns2 = String$.internalBinaryRead(reader, reader.uint32(), options, message.dns2);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NetworkInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.NetworkConfigType networkType = 1; */
        if (message.networkType)
            NetworkConfigType.internalBinaryWrite(message.networkType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String ipAddress = 2; */
        if (message.ipAddress)
            String$.internalBinaryWrite(message.ipAddress, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String subnetMask = 3; */
        if (message.subnetMask)
            String$.internalBinaryWrite(message.subnetMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String deafultGateway = 4; */
        if (message.deafultGateway)
            String$.internalBinaryWrite(message.deafultGateway, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String dns1 = 5; */
        if (message.dns1)
            String$.internalBinaryWrite(message.dns1, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String dns2 = 6; */
        if (message.dns2)
            String$.internalBinaryWrite(message.dns2, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.NetworkInfo
 */
export const NetworkInfo = new NetworkInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrCameraParamChange$Type extends MessageType$<OcrCameraParamChange> {
    constructor() {
        super("ProtoMessages.OcrCameraParamChange", [
            { no: 1, name: "cameraParam", kind: "enum", T: () => ["ProtoMessages.OcrCameraParamChange.CameraParamType", OcrCameraParamChange_CameraParamType] },
            { no: 2, name: "value", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<OcrCameraParamChange>): OcrCameraParamChange {
        const message = { cameraParam: 0, value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrCameraParamChange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrCameraParamChange): OcrCameraParamChange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.OcrCameraParamChange.CameraParamType cameraParam */ 1:
                    message.cameraParam = reader.int32();
                    break;
                case /* int32 value */ 2:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrCameraParamChange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.OcrCameraParamChange.CameraParamType cameraParam = 1; */
        if (message.cameraParam !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraParam);
        /* int32 value = 2; */
        if (message.value !== 0)
            writer.tag(2, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OcrCameraParamChange
 */
export const OcrCameraParamChange = new OcrCameraParamChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommandMessage$Type extends MessageType$<CommandMessage> {
    constructor() {
        super("ProtoMessages.CommandMessage", [
            { no: 1, name: "formatJpegRecordings", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "formatLocalRecordings", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "resetPoe", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "restartVpu", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "startVpu", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "stopVpu", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "restartComputer", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "sendPanoramaRequest", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "sendCcuPresetsRequest", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "deletePreset", kind: "message", T: () => String$ },
            { no: 11, name: "savePreset", kind: "message", T: () => CCUPreset },
            { no: 12, name: "requestPortTesting", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TestPorts },
            { no: 13, name: "getCameras", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "restoreCameraParams", kind: "message", T: () => String$ },
            { no: 15, name: "sendHeadSetupFramesRequest", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "requestOsType", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "restartPip", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "restartCoordinator", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "restartCg", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "restartAgent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "updateLastCalibrationTime", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "requestStaticInfo", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "changePingPolicy", kind: "message", T: () => PingPolicyStatus },
            { no: 24, name: "startVpuInSetupMode", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "restoreCalibration", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "startVpuInSetupModeRemoteCalibration", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 27, name: "stopVpuRemoteCalibration", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 28, name: "swReset", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "switchPoeCardStatus", kind: "message", T: () => PoeCardStatus },
            { no: 30, name: "chuReset", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "pingCamera", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 32, name: "chuPartialRestore", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 33, name: "setChuTvSystemMode", kind: "message", T: () => ChuTvSystemMode },
            { no: 34, name: "setApplyColorCalibrationMatrix", kind: "message", T: () => ApplyColorCalibrationMatrix },
            { no: 35, name: "enableAlcForOcr", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 36, name: "disableAlcForOcr", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 37, name: "ocrCameraParamChange", kind: "message", T: () => OcrCameraParamChange },
            { no: 38, name: "refreshVirtualAds", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 39, name: "send_cue_out", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 40, name: "send_cue_in", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 41, name: "manualMidrollEnabled", kind: "message", T: () => Bool },
            { no: 42, name: "useSmartMidroll", kind: "message", T: () => Bool },
            { no: 43, name: "smartMidrollSimulator", kind: "message", T: () => Bool },
            { no: 44, name: "scoreboardManualFromVideo", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<CommandMessage>): CommandMessage {
        const message = { formatJpegRecordings: false, formatLocalRecordings: false, resetPoe: false, restartVpu: false, startVpu: false, stopVpu: false, restartComputer: false, sendPanoramaRequest: false, sendCcuPresetsRequest: false, requestPortTesting: [], getCameras: false, sendHeadSetupFramesRequest: false, requestOsType: false, restartPip: false, restartCoordinator: false, restartCg: false, restartAgent: false, updateLastCalibrationTime: false, requestStaticInfo: false, startVpuInSetupMode: false, restoreCalibration: false, startVpuInSetupModeRemoteCalibration: false, stopVpuRemoteCalibration: false, swReset: false, chuReset: false, pingCamera: false, chuPartialRestore: false, enableAlcForOcr: false, disableAlcForOcr: false, refreshVirtualAds: false, sendCueOut: false, sendCueIn: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CommandMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CommandMessage): CommandMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool formatJpegRecordings */ 1:
                    message.formatJpegRecordings = reader.bool();
                    break;
                case /* bool formatLocalRecordings */ 2:
                    message.formatLocalRecordings = reader.bool();
                    break;
                case /* bool resetPoe */ 3:
                    message.resetPoe = reader.bool();
                    break;
                case /* bool restartVpu */ 4:
                    message.restartVpu = reader.bool();
                    break;
                case /* bool startVpu */ 5:
                    message.startVpu = reader.bool();
                    break;
                case /* bool stopVpu */ 6:
                    message.stopVpu = reader.bool();
                    break;
                case /* bool restartComputer */ 7:
                    message.restartComputer = reader.bool();
                    break;
                case /* bool sendPanoramaRequest */ 8:
                    message.sendPanoramaRequest = reader.bool();
                    break;
                case /* bool sendCcuPresetsRequest */ 9:
                    message.sendCcuPresetsRequest = reader.bool();
                    break;
                case /* ProtoMessages.String deletePreset */ 10:
                    message.deletePreset = String$.internalBinaryRead(reader, reader.uint32(), options, message.deletePreset);
                    break;
                case /* ProtoMessages.CCUPreset savePreset */ 11:
                    message.savePreset = CCUPreset.internalBinaryRead(reader, reader.uint32(), options, message.savePreset);
                    break;
                case /* repeated ProtoMessages.TestPorts requestPortTesting */ 12:
                    message.requestPortTesting.push(TestPorts.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool getCameras */ 13:
                    message.getCameras = reader.bool();
                    break;
                case /* ProtoMessages.String restoreCameraParams */ 14:
                    message.restoreCameraParams = String$.internalBinaryRead(reader, reader.uint32(), options, message.restoreCameraParams);
                    break;
                case /* bool sendHeadSetupFramesRequest */ 15:
                    message.sendHeadSetupFramesRequest = reader.bool();
                    break;
                case /* bool requestOsType */ 16:
                    message.requestOsType = reader.bool();
                    break;
                case /* bool restartPip */ 17:
                    message.restartPip = reader.bool();
                    break;
                case /* bool restartCoordinator */ 18:
                    message.restartCoordinator = reader.bool();
                    break;
                case /* bool restartCg */ 19:
                    message.restartCg = reader.bool();
                    break;
                case /* bool restartAgent */ 20:
                    message.restartAgent = reader.bool();
                    break;
                case /* bool updateLastCalibrationTime */ 21:
                    message.updateLastCalibrationTime = reader.bool();
                    break;
                case /* bool requestStaticInfo */ 22:
                    message.requestStaticInfo = reader.bool();
                    break;
                case /* ProtoMessages.PingPolicyStatus changePingPolicy */ 23:
                    message.changePingPolicy = PingPolicyStatus.internalBinaryRead(reader, reader.uint32(), options, message.changePingPolicy);
                    break;
                case /* bool startVpuInSetupMode */ 24:
                    message.startVpuInSetupMode = reader.bool();
                    break;
                case /* bool restoreCalibration */ 25:
                    message.restoreCalibration = reader.bool();
                    break;
                case /* bool startVpuInSetupModeRemoteCalibration */ 26:
                    message.startVpuInSetupModeRemoteCalibration = reader.bool();
                    break;
                case /* bool stopVpuRemoteCalibration */ 27:
                    message.stopVpuRemoteCalibration = reader.bool();
                    break;
                case /* bool swReset */ 28:
                    message.swReset = reader.bool();
                    break;
                case /* ProtoMessages.PoeCardStatus switchPoeCardStatus */ 29:
                    message.switchPoeCardStatus = PoeCardStatus.internalBinaryRead(reader, reader.uint32(), options, message.switchPoeCardStatus);
                    break;
                case /* bool chuReset */ 30:
                    message.chuReset = reader.bool();
                    break;
                case /* bool pingCamera */ 31:
                    message.pingCamera = reader.bool();
                    break;
                case /* bool chuPartialRestore */ 32:
                    message.chuPartialRestore = reader.bool();
                    break;
                case /* ProtoMessages.ChuTvSystemMode setChuTvSystemMode */ 33:
                    message.setChuTvSystemMode = ChuTvSystemMode.internalBinaryRead(reader, reader.uint32(), options, message.setChuTvSystemMode);
                    break;
                case /* ProtoMessages.ApplyColorCalibrationMatrix setApplyColorCalibrationMatrix */ 34:
                    message.setApplyColorCalibrationMatrix = ApplyColorCalibrationMatrix.internalBinaryRead(reader, reader.uint32(), options, message.setApplyColorCalibrationMatrix);
                    break;
                case /* bool enableAlcForOcr */ 35:
                    message.enableAlcForOcr = reader.bool();
                    break;
                case /* bool disableAlcForOcr */ 36:
                    message.disableAlcForOcr = reader.bool();
                    break;
                case /* ProtoMessages.OcrCameraParamChange ocrCameraParamChange */ 37:
                    message.ocrCameraParamChange = OcrCameraParamChange.internalBinaryRead(reader, reader.uint32(), options, message.ocrCameraParamChange);
                    break;
                case /* bool refreshVirtualAds */ 38:
                    message.refreshVirtualAds = reader.bool();
                    break;
                case /* bool send_cue_out */ 39:
                    message.sendCueOut = reader.bool();
                    break;
                case /* bool send_cue_in */ 40:
                    message.sendCueIn = reader.bool();
                    break;
                case /* ProtoMessages.Bool manualMidrollEnabled */ 41:
                    message.manualMidrollEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.manualMidrollEnabled);
                    break;
                case /* ProtoMessages.Bool useSmartMidroll */ 42:
                    message.useSmartMidroll = Bool.internalBinaryRead(reader, reader.uint32(), options, message.useSmartMidroll);
                    break;
                case /* ProtoMessages.Bool smartMidrollSimulator */ 43:
                    message.smartMidrollSimulator = Bool.internalBinaryRead(reader, reader.uint32(), options, message.smartMidrollSimulator);
                    break;
                case /* ProtoMessages.Bool scoreboardManualFromVideo */ 44:
                    message.scoreboardManualFromVideo = Bool.internalBinaryRead(reader, reader.uint32(), options, message.scoreboardManualFromVideo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CommandMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool formatJpegRecordings = 1; */
        if (message.formatJpegRecordings !== false)
            writer.tag(1, WireType.Varint).bool(message.formatJpegRecordings);
        /* bool formatLocalRecordings = 2; */
        if (message.formatLocalRecordings !== false)
            writer.tag(2, WireType.Varint).bool(message.formatLocalRecordings);
        /* bool resetPoe = 3; */
        if (message.resetPoe !== false)
            writer.tag(3, WireType.Varint).bool(message.resetPoe);
        /* bool restartVpu = 4; */
        if (message.restartVpu !== false)
            writer.tag(4, WireType.Varint).bool(message.restartVpu);
        /* bool startVpu = 5; */
        if (message.startVpu !== false)
            writer.tag(5, WireType.Varint).bool(message.startVpu);
        /* bool stopVpu = 6; */
        if (message.stopVpu !== false)
            writer.tag(6, WireType.Varint).bool(message.stopVpu);
        /* bool restartComputer = 7; */
        if (message.restartComputer !== false)
            writer.tag(7, WireType.Varint).bool(message.restartComputer);
        /* bool sendPanoramaRequest = 8; */
        if (message.sendPanoramaRequest !== false)
            writer.tag(8, WireType.Varint).bool(message.sendPanoramaRequest);
        /* bool sendCcuPresetsRequest = 9; */
        if (message.sendCcuPresetsRequest !== false)
            writer.tag(9, WireType.Varint).bool(message.sendCcuPresetsRequest);
        /* ProtoMessages.String deletePreset = 10; */
        if (message.deletePreset)
            String$.internalBinaryWrite(message.deletePreset, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.CCUPreset savePreset = 11; */
        if (message.savePreset)
            CCUPreset.internalBinaryWrite(message.savePreset, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.TestPorts requestPortTesting = 12; */
        for (let i = 0; i < message.requestPortTesting.length; i++)
            TestPorts.internalBinaryWrite(message.requestPortTesting[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* bool getCameras = 13; */
        if (message.getCameras !== false)
            writer.tag(13, WireType.Varint).bool(message.getCameras);
        /* ProtoMessages.String restoreCameraParams = 14; */
        if (message.restoreCameraParams)
            String$.internalBinaryWrite(message.restoreCameraParams, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* bool sendHeadSetupFramesRequest = 15; */
        if (message.sendHeadSetupFramesRequest !== false)
            writer.tag(15, WireType.Varint).bool(message.sendHeadSetupFramesRequest);
        /* bool requestOsType = 16; */
        if (message.requestOsType !== false)
            writer.tag(16, WireType.Varint).bool(message.requestOsType);
        /* bool restartPip = 17; */
        if (message.restartPip !== false)
            writer.tag(17, WireType.Varint).bool(message.restartPip);
        /* bool restartCoordinator = 18; */
        if (message.restartCoordinator !== false)
            writer.tag(18, WireType.Varint).bool(message.restartCoordinator);
        /* bool restartCg = 19; */
        if (message.restartCg !== false)
            writer.tag(19, WireType.Varint).bool(message.restartCg);
        /* bool restartAgent = 20; */
        if (message.restartAgent !== false)
            writer.tag(20, WireType.Varint).bool(message.restartAgent);
        /* bool updateLastCalibrationTime = 21; */
        if (message.updateLastCalibrationTime !== false)
            writer.tag(21, WireType.Varint).bool(message.updateLastCalibrationTime);
        /* bool requestStaticInfo = 22; */
        if (message.requestStaticInfo !== false)
            writer.tag(22, WireType.Varint).bool(message.requestStaticInfo);
        /* ProtoMessages.PingPolicyStatus changePingPolicy = 23; */
        if (message.changePingPolicy)
            PingPolicyStatus.internalBinaryWrite(message.changePingPolicy, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* bool startVpuInSetupMode = 24; */
        if (message.startVpuInSetupMode !== false)
            writer.tag(24, WireType.Varint).bool(message.startVpuInSetupMode);
        /* bool restoreCalibration = 25; */
        if (message.restoreCalibration !== false)
            writer.tag(25, WireType.Varint).bool(message.restoreCalibration);
        /* bool startVpuInSetupModeRemoteCalibration = 26; */
        if (message.startVpuInSetupModeRemoteCalibration !== false)
            writer.tag(26, WireType.Varint).bool(message.startVpuInSetupModeRemoteCalibration);
        /* bool stopVpuRemoteCalibration = 27; */
        if (message.stopVpuRemoteCalibration !== false)
            writer.tag(27, WireType.Varint).bool(message.stopVpuRemoteCalibration);
        /* bool swReset = 28; */
        if (message.swReset !== false)
            writer.tag(28, WireType.Varint).bool(message.swReset);
        /* ProtoMessages.PoeCardStatus switchPoeCardStatus = 29; */
        if (message.switchPoeCardStatus)
            PoeCardStatus.internalBinaryWrite(message.switchPoeCardStatus, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* bool chuReset = 30; */
        if (message.chuReset !== false)
            writer.tag(30, WireType.Varint).bool(message.chuReset);
        /* bool pingCamera = 31; */
        if (message.pingCamera !== false)
            writer.tag(31, WireType.Varint).bool(message.pingCamera);
        /* bool chuPartialRestore = 32; */
        if (message.chuPartialRestore !== false)
            writer.tag(32, WireType.Varint).bool(message.chuPartialRestore);
        /* ProtoMessages.ChuTvSystemMode setChuTvSystemMode = 33; */
        if (message.setChuTvSystemMode)
            ChuTvSystemMode.internalBinaryWrite(message.setChuTvSystemMode, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.ApplyColorCalibrationMatrix setApplyColorCalibrationMatrix = 34; */
        if (message.setApplyColorCalibrationMatrix)
            ApplyColorCalibrationMatrix.internalBinaryWrite(message.setApplyColorCalibrationMatrix, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* bool enableAlcForOcr = 35; */
        if (message.enableAlcForOcr !== false)
            writer.tag(35, WireType.Varint).bool(message.enableAlcForOcr);
        /* bool disableAlcForOcr = 36; */
        if (message.disableAlcForOcr !== false)
            writer.tag(36, WireType.Varint).bool(message.disableAlcForOcr);
        /* ProtoMessages.OcrCameraParamChange ocrCameraParamChange = 37; */
        if (message.ocrCameraParamChange)
            OcrCameraParamChange.internalBinaryWrite(message.ocrCameraParamChange, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* bool refreshVirtualAds = 38; */
        if (message.refreshVirtualAds !== false)
            writer.tag(38, WireType.Varint).bool(message.refreshVirtualAds);
        /* bool send_cue_out = 39; */
        if (message.sendCueOut !== false)
            writer.tag(39, WireType.Varint).bool(message.sendCueOut);
        /* bool send_cue_in = 40; */
        if (message.sendCueIn !== false)
            writer.tag(40, WireType.Varint).bool(message.sendCueIn);
        /* ProtoMessages.Bool manualMidrollEnabled = 41; */
        if (message.manualMidrollEnabled)
            Bool.internalBinaryWrite(message.manualMidrollEnabled, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool useSmartMidroll = 42; */
        if (message.useSmartMidroll)
            Bool.internalBinaryWrite(message.useSmartMidroll, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool smartMidrollSimulator = 43; */
        if (message.smartMidrollSimulator)
            Bool.internalBinaryWrite(message.smartMidrollSimulator, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool scoreboardManualFromVideo = 44; */
        if (message.scoreboardManualFromVideo)
            Bool.internalBinaryWrite(message.scoreboardManualFromVideo, writer.tag(44, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CommandMessage
 */
export const CommandMessage = new CommandMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestoreCalibrationCommandResponse$Type extends MessageType$<RestoreCalibrationCommandResponse> {
    constructor() {
        super("ProtoMessages.RestoreCalibrationCommandResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RestoreCalibrationCommandResponse>): RestoreCalibrationCommandResponse {
        const message = { success: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RestoreCalibrationCommandResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RestoreCalibrationCommandResponse): RestoreCalibrationCommandResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RestoreCalibrationCommandResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.RestoreCalibrationCommandResponse
 */
export const RestoreCalibrationCommandResponse = new RestoreCalibrationCommandResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefreshVirtualAdsResponse$Type extends MessageType$<RefreshVirtualAdsResponse> {
    constructor() {
        super("ProtoMessages.RefreshVirtualAdsResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RefreshVirtualAdsResponse>): RefreshVirtualAdsResponse {
        const message = { success: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RefreshVirtualAdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefreshVirtualAdsResponse): RefreshVirtualAdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefreshVirtualAdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.RefreshVirtualAdsResponse
 */
export const RefreshVirtualAdsResponse = new RefreshVirtualAdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PingPolicyStatus$Type extends MessageType$<PingPolicyStatus> {
    constructor() {
        super("ProtoMessages.PingPolicyStatus", [
            { no: 1, name: "allowed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PingPolicyStatus>): PingPolicyStatus {
        const message = { allowed: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PingPolicyStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PingPolicyStatus): PingPolicyStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool allowed */ 1:
                    message.allowed = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PingPolicyStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool allowed = 1; */
        if (message.allowed !== false)
            writer.tag(1, WireType.Varint).bool(message.allowed);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PingPolicyStatus
 */
export const PingPolicyStatus = new PingPolicyStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PoeCardStatus$Type extends MessageType$<PoeCardStatus> {
    constructor() {
        super("ProtoMessages.PoeCardStatus", [
            { no: 1, name: "status", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PoeCardStatus>): PoeCardStatus {
        const message = { status: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PoeCardStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PoeCardStatus): PoeCardStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool status */ 1:
                    message.status = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PoeCardStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool status = 1; */
        if (message.status !== false)
            writer.tag(1, WireType.Varint).bool(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PoeCardStatus
 */
export const PoeCardStatus = new PoeCardStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApplyColorCalibrationMatrix$Type extends MessageType$<ApplyColorCalibrationMatrix> {
    constructor() {
        super("ProtoMessages.ApplyColorCalibrationMatrix", [
            { no: 1, name: "value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ApplyColorCalibrationMatrix>): ApplyColorCalibrationMatrix {
        const message = { value: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ApplyColorCalibrationMatrix>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ApplyColorCalibrationMatrix): ApplyColorCalibrationMatrix {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool value */ 1:
                    message.value = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ApplyColorCalibrationMatrix, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool value = 1; */
        if (message.value !== false)
            writer.tag(1, WireType.Varint).bool(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ApplyColorCalibrationMatrix
 */
export const ApplyColorCalibrationMatrix = new ApplyColorCalibrationMatrix$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChuTvSystemMode$Type extends MessageType$<ChuTvSystemMode> {
    constructor() {
        super("ProtoMessages.ChuTvSystemMode", [
            { no: 1, name: "mode", kind: "enum", T: () => ["ProtoMessages.ChuTvSystemMode.TvMode", ChuTvSystemMode_TvMode] },
            { no: 2, name: "cameraIps", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ChuTvSystemMode>): ChuTvSystemMode {
        const message = { mode: 0, cameraIps: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChuTvSystemMode>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChuTvSystemMode): ChuTvSystemMode {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.ChuTvSystemMode.TvMode mode */ 1:
                    message.mode = reader.int32();
                    break;
                case /* repeated string cameraIps */ 2:
                    message.cameraIps.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChuTvSystemMode, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.ChuTvSystemMode.TvMode mode = 1; */
        if (message.mode !== 0)
            writer.tag(1, WireType.Varint).int32(message.mode);
        /* repeated string cameraIps = 2; */
        for (let i = 0; i < message.cameraIps.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.cameraIps[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ChuTvSystemMode
 */
export const ChuTvSystemMode = new ChuTvSystemMode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraInformation$Type extends MessageType$<CameraInformation> {
    constructor() {
        super("ProtoMessages.CameraInformation", [
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "firmware", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "tvSystemMode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "macAddress", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "revision", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "ip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "cameraModel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "serialNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "partNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CameraInformation>): CameraInformation {
        const message = { type: "", uid: "", firmware: "", version: "", tvSystemMode: "", macAddress: "", revision: "", ip: "", cameraModel: "", serialNumber: "", partNumber: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraInformation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraInformation): CameraInformation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string type */ 1:
                    message.type = reader.string();
                    break;
                case /* string uid */ 2:
                    message.uid = reader.string();
                    break;
                case /* string firmware */ 3:
                    message.firmware = reader.string();
                    break;
                case /* string version */ 4:
                    message.version = reader.string();
                    break;
                case /* string tvSystemMode */ 5:
                    message.tvSystemMode = reader.string();
                    break;
                case /* string macAddress */ 6:
                    message.macAddress = reader.string();
                    break;
                case /* string revision */ 7:
                    message.revision = reader.string();
                    break;
                case /* string ip */ 8:
                    message.ip = reader.string();
                    break;
                case /* string cameraModel */ 9:
                    message.cameraModel = reader.string();
                    break;
                case /* string serialNumber */ 10:
                    message.serialNumber = reader.string();
                    break;
                case /* string partNumber */ 11:
                    message.partNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraInformation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string type = 1; */
        if (message.type !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.type);
        /* string uid = 2; */
        if (message.uid !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.uid);
        /* string firmware = 3; */
        if (message.firmware !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.firmware);
        /* string version = 4; */
        if (message.version !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.version);
        /* string tvSystemMode = 5; */
        if (message.tvSystemMode !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.tvSystemMode);
        /* string macAddress = 6; */
        if (message.macAddress !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.macAddress);
        /* string revision = 7; */
        if (message.revision !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.revision);
        /* string ip = 8; */
        if (message.ip !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.ip);
        /* string cameraModel = 9; */
        if (message.cameraModel !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.cameraModel);
        /* string serialNumber = 10; */
        if (message.serialNumber !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.serialNumber);
        /* string partNumber = 11; */
        if (message.partNumber !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.partNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraInformation
 */
export const CameraInformation = new CameraInformation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigurationParameter$Type extends MessageType$<ConfigurationParameter> {
    constructor() {
        super("ProtoMessages.ConfigurationParameter", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "defaultValue", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConfigurationParameter>): ConfigurationParameter {
        const message = { key: "", value: "", type: "", defaultValue: "", enabled: false, description: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ConfigurationParameter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfigurationParameter): ConfigurationParameter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                case /* string defaultValue */ 4:
                    message.defaultValue = reader.string();
                    break;
                case /* bool enabled */ 5:
                    message.enabled = reader.bool();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfigurationParameter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        /* string defaultValue = 4; */
        if (message.defaultValue !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.defaultValue);
        /* bool enabled = 5; */
        if (message.enabled !== false)
            writer.tag(5, WireType.Varint).bool(message.enabled);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ConfigurationParameter
 */
export const ConfigurationParameter = new ConfigurationParameter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigurationMessage$Type extends MessageType$<ConfigurationMessage> {
    constructor() {
        super("ProtoMessages.ConfigurationMessage", [
            { no: 1, name: "action", kind: "enum", T: () => ["ProtoMessages.ConfigurationAction", ConfigurationAction, "CONFIGURATION_ACTION_"] },
            { no: 2, name: "configParam", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ConfigurationParameter }
        ]);
    }
    create(value?: PartialMessage<ConfigurationMessage>): ConfigurationMessage {
        const message = { action: 0, configParam: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ConfigurationMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfigurationMessage): ConfigurationMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.ConfigurationAction action */ 1:
                    message.action = reader.int32();
                    break;
                case /* repeated ProtoMessages.ConfigurationParameter configParam */ 2:
                    message.configParam.push(ConfigurationParameter.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfigurationMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.ConfigurationAction action = 1; */
        if (message.action !== 0)
            writer.tag(1, WireType.Varint).int32(message.action);
        /* repeated ProtoMessages.ConfigurationParameter configParam = 2; */
        for (let i = 0; i < message.configParam.length; i++)
            ConfigurationParameter.internalBinaryWrite(message.configParam[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ConfigurationMessage
 */
export const ConfigurationMessage = new ConfigurationMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneralMessage$Type extends MessageType$<GeneralMessage> {
    constructor() {
        super("ProtoMessages.GeneralMessage", [
            { no: 1, name: "messageType", kind: "message", T: () => MessageType },
            { no: 2, name: "statusInformationMessage", kind: "message", T: () => StatusInformationMessage },
            { no: 3, name: "realtimeInformationMessage", kind: "message", T: () => RealtimeInformationMessage },
            { no: 4, name: "staticInformationMessage", kind: "message", T: () => StaticInformationMessage },
            { no: 5, name: "commandMessage", kind: "message", T: () => CommandMessage },
            { no: 6, name: "coachingAdditionalAngleMessage", kind: "message", T: () => CoachingAdditionalAngleList },
            { no: 7, name: "fileImportExportFile", kind: "message", T: () => FileTransferMessage },
            { no: 8, name: "versionMessage", kind: "message", T: () => VersionMessage },
            { no: 9, name: "singleParamInformationMessage", kind: "message", T: () => SingleParamInformationMessage },
            { no: 10, name: "ccuUpdateMessage", kind: "message", T: () => CcuUpdateMessage },
            { no: 12, name: "configurationAction", kind: "message", T: () => ConfigurationMessage },
            { no: 14, name: "networkTestRequest", kind: "message", T: () => NetworkTestRequest },
            { no: 16, name: "networkValidation", kind: "message", T: () => NetworkValidation },
            { no: 17, name: "operatingSystemMessage", kind: "message", T: () => OperatingSystemMessage },
            { no: 19, name: "pingPongMessage", kind: "message", T: () => PingPongMessage },
            { no: 20, name: "venueSelfTestProgressMessage", kind: "message", T: () => VenueSelfTestProgressMessage }
        ]);
    }
    create(value?: PartialMessage<GeneralMessage>): GeneralMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GeneralMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GeneralMessage): GeneralMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.MessageType messageType */ 1:
                    message.messageType = MessageType.internalBinaryRead(reader, reader.uint32(), options, message.messageType);
                    break;
                case /* ProtoMessages.StatusInformationMessage statusInformationMessage */ 2:
                    message.statusInformationMessage = StatusInformationMessage.internalBinaryRead(reader, reader.uint32(), options, message.statusInformationMessage);
                    break;
                case /* ProtoMessages.RealtimeInformationMessage realtimeInformationMessage */ 3:
                    message.realtimeInformationMessage = RealtimeInformationMessage.internalBinaryRead(reader, reader.uint32(), options, message.realtimeInformationMessage);
                    break;
                case /* ProtoMessages.StaticInformationMessage staticInformationMessage */ 4:
                    message.staticInformationMessage = StaticInformationMessage.internalBinaryRead(reader, reader.uint32(), options, message.staticInformationMessage);
                    break;
                case /* ProtoMessages.CommandMessage commandMessage */ 5:
                    message.commandMessage = CommandMessage.internalBinaryRead(reader, reader.uint32(), options, message.commandMessage);
                    break;
                case /* ProtoMessages.CoachingAdditionalAngleList coachingAdditionalAngleMessage */ 6:
                    message.coachingAdditionalAngleMessage = CoachingAdditionalAngleList.internalBinaryRead(reader, reader.uint32(), options, message.coachingAdditionalAngleMessage);
                    break;
                case /* ProtoMessages.FileTransferMessage fileImportExportFile */ 7:
                    message.fileImportExportFile = FileTransferMessage.internalBinaryRead(reader, reader.uint32(), options, message.fileImportExportFile);
                    break;
                case /* ProtoMessages.VersionMessage versionMessage */ 8:
                    message.versionMessage = VersionMessage.internalBinaryRead(reader, reader.uint32(), options, message.versionMessage);
                    break;
                case /* ProtoMessages.SingleParamInformationMessage singleParamInformationMessage */ 9:
                    message.singleParamInformationMessage = SingleParamInformationMessage.internalBinaryRead(reader, reader.uint32(), options, message.singleParamInformationMessage);
                    break;
                case /* ProtoMessages.CcuUpdateMessage ccuUpdateMessage */ 10:
                    message.ccuUpdateMessage = CcuUpdateMessage.internalBinaryRead(reader, reader.uint32(), options, message.ccuUpdateMessage);
                    break;
                case /* ProtoMessages.ConfigurationMessage configurationAction */ 12:
                    message.configurationAction = ConfigurationMessage.internalBinaryRead(reader, reader.uint32(), options, message.configurationAction);
                    break;
                case /* ProtoMessages.NetworkTestRequest networkTestRequest */ 14:
                    message.networkTestRequest = NetworkTestRequest.internalBinaryRead(reader, reader.uint32(), options, message.networkTestRequest);
                    break;
                case /* ProtoMessages.NetworkValidation networkValidation */ 16:
                    message.networkValidation = NetworkValidation.internalBinaryRead(reader, reader.uint32(), options, message.networkValidation);
                    break;
                case /* ProtoMessages.OperatingSystemMessage operatingSystemMessage */ 17:
                    message.operatingSystemMessage = OperatingSystemMessage.internalBinaryRead(reader, reader.uint32(), options, message.operatingSystemMessage);
                    break;
                case /* ProtoMessages.PingPongMessage pingPongMessage */ 19:
                    message.pingPongMessage = PingPongMessage.internalBinaryRead(reader, reader.uint32(), options, message.pingPongMessage);
                    break;
                case /* ProtoMessages.VenueSelfTestProgressMessage venueSelfTestProgressMessage */ 20:
                    message.venueSelfTestProgressMessage = VenueSelfTestProgressMessage.internalBinaryRead(reader, reader.uint32(), options, message.venueSelfTestProgressMessage);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GeneralMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.MessageType messageType = 1; */
        if (message.messageType)
            MessageType.internalBinaryWrite(message.messageType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.StatusInformationMessage statusInformationMessage = 2; */
        if (message.statusInformationMessage)
            StatusInformationMessage.internalBinaryWrite(message.statusInformationMessage, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.RealtimeInformationMessage realtimeInformationMessage = 3; */
        if (message.realtimeInformationMessage)
            RealtimeInformationMessage.internalBinaryWrite(message.realtimeInformationMessage, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.StaticInformationMessage staticInformationMessage = 4; */
        if (message.staticInformationMessage)
            StaticInformationMessage.internalBinaryWrite(message.staticInformationMessage, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.CommandMessage commandMessage = 5; */
        if (message.commandMessage)
            CommandMessage.internalBinaryWrite(message.commandMessage, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.CoachingAdditionalAngleList coachingAdditionalAngleMessage = 6; */
        if (message.coachingAdditionalAngleMessage)
            CoachingAdditionalAngleList.internalBinaryWrite(message.coachingAdditionalAngleMessage, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.FileTransferMessage fileImportExportFile = 7; */
        if (message.fileImportExportFile)
            FileTransferMessage.internalBinaryWrite(message.fileImportExportFile, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.VersionMessage versionMessage = 8; */
        if (message.versionMessage)
            VersionMessage.internalBinaryWrite(message.versionMessage, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.SingleParamInformationMessage singleParamInformationMessage = 9; */
        if (message.singleParamInformationMessage)
            SingleParamInformationMessage.internalBinaryWrite(message.singleParamInformationMessage, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.CcuUpdateMessage ccuUpdateMessage = 10; */
        if (message.ccuUpdateMessage)
            CcuUpdateMessage.internalBinaryWrite(message.ccuUpdateMessage, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.ConfigurationMessage configurationAction = 12; */
        if (message.configurationAction)
            ConfigurationMessage.internalBinaryWrite(message.configurationAction, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.NetworkTestRequest networkTestRequest = 14; */
        if (message.networkTestRequest)
            NetworkTestRequest.internalBinaryWrite(message.networkTestRequest, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.NetworkValidation networkValidation = 16; */
        if (message.networkValidation)
            NetworkValidation.internalBinaryWrite(message.networkValidation, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.OperatingSystemMessage operatingSystemMessage = 17; */
        if (message.operatingSystemMessage)
            OperatingSystemMessage.internalBinaryWrite(message.operatingSystemMessage, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.PingPongMessage pingPongMessage = 19; */
        if (message.pingPongMessage)
            PingPongMessage.internalBinaryWrite(message.pingPongMessage, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.VenueSelfTestProgressMessage venueSelfTestProgressMessage = 20; */
        if (message.venueSelfTestProgressMessage)
            VenueSelfTestProgressMessage.internalBinaryWrite(message.venueSelfTestProgressMessage, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.GeneralMessage
 */
export const GeneralMessage = new GeneralMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VenueCalibrationDataRequest$Type extends MessageType$<VenueCalibrationDataRequest> {
    constructor() {
        super("ProtoMessages.VenueCalibrationDataRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<VenueCalibrationDataRequest>): VenueCalibrationDataRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VenueCalibrationDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VenueCalibrationDataRequest): VenueCalibrationDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VenueCalibrationDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VenueCalibrationDataRequest
 */
export const VenueCalibrationDataRequest = new VenueCalibrationDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VenueCalibrationDataResponse$Type extends MessageType$<VenueCalibrationDataResponse> {
    constructor() {
        super("ProtoMessages.VenueCalibrationDataResponse", [
            { no: 1, name: "venueCalibrationData", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VenueCalibrationData }
        ]);
    }
    create(value?: PartialMessage<VenueCalibrationDataResponse>): VenueCalibrationDataResponse {
        const message = { venueCalibrationData: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VenueCalibrationDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VenueCalibrationDataResponse): VenueCalibrationDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CommonUsedMessages.VenueCalibrationData venueCalibrationData */ 1:
                    message.venueCalibrationData.push(VenueCalibrationData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VenueCalibrationDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated CommonUsedMessages.VenueCalibrationData venueCalibrationData = 1; */
        for (let i = 0; i < message.venueCalibrationData.length; i++)
            VenueCalibrationData.internalBinaryWrite(message.venueCalibrationData[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VenueCalibrationDataResponse
 */
export const VenueCalibrationDataResponse = new VenueCalibrationDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DetectUnpairedCamerasRequest$Type extends MessageType$<DetectUnpairedCamerasRequest> {
    constructor() {
        super("ProtoMessages.DetectUnpairedCamerasRequest", [
            { no: 1, name: "pairedCamerasIp", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DetectUnpairedCamerasRequest>): DetectUnpairedCamerasRequest {
        const message = { pairedCamerasIp: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DetectUnpairedCamerasRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DetectUnpairedCamerasRequest): DetectUnpairedCamerasRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string pairedCamerasIp */ 1:
                    message.pairedCamerasIp.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DetectUnpairedCamerasRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string pairedCamerasIp = 1; */
        for (let i = 0; i < message.pairedCamerasIp.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.pairedCamerasIp[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.DetectUnpairedCamerasRequest
 */
export const DetectUnpairedCamerasRequest = new DetectUnpairedCamerasRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DetectUnpairedCamerasResponse$Type extends MessageType$<DetectUnpairedCamerasResponse> {
    constructor() {
        super("ProtoMessages.DetectUnpairedCamerasResponse", [
            { no: 1, name: "unpairedCameras", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DynaColorCameraInfo }
        ]);
    }
    create(value?: PartialMessage<DetectUnpairedCamerasResponse>): DetectUnpairedCamerasResponse {
        const message = { unpairedCameras: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DetectUnpairedCamerasResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DetectUnpairedCamerasResponse): DetectUnpairedCamerasResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.DynaColorCameraInfo unpairedCameras */ 1:
                    message.unpairedCameras.push(DynaColorCameraInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DetectUnpairedCamerasResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.DynaColorCameraInfo unpairedCameras = 1; */
        for (let i = 0; i < message.unpairedCameras.length; i++)
            DynaColorCameraInfo.internalBinaryWrite(message.unpairedCameras[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.DetectUnpairedCamerasResponse
 */
export const DetectUnpairedCamerasResponse = new DetectUnpairedCamerasResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DynaColorCameraInfo$Type extends MessageType$<DynaColorCameraInfo> {
    constructor() {
        super("ProtoMessages.DynaColorCameraInfo", [
            { no: 1, name: "ip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "gateway", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "subnetMask", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "macAddress", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DynaColorCameraInfo>): DynaColorCameraInfo {
        const message = { ip: "", model: "", gateway: "", subnetMask: "", macAddress: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DynaColorCameraInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DynaColorCameraInfo): DynaColorCameraInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string ip */ 1:
                    message.ip = reader.string();
                    break;
                case /* string model */ 2:
                    message.model = reader.string();
                    break;
                case /* string gateway */ 3:
                    message.gateway = reader.string();
                    break;
                case /* string subnetMask */ 4:
                    message.subnetMask = reader.string();
                    break;
                case /* string macAddress */ 5:
                    message.macAddress = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DynaColorCameraInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string ip = 1; */
        if (message.ip !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.ip);
        /* string model = 2; */
        if (message.model !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.model);
        /* string gateway = 3; */
        if (message.gateway !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.gateway);
        /* string subnetMask = 4; */
        if (message.subnetMask !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.subnetMask);
        /* string macAddress = 5; */
        if (message.macAddress !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.macAddress);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.DynaColorCameraInfo
 */
export const DynaColorCameraInfo = new DynaColorCameraInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetCHURequest$Type extends MessageType$<ResetCHURequest> {
    constructor() {
        super("ProtoMessages.ResetCHURequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<ResetCHURequest>): ResetCHURequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ResetCHURequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResetCHURequest): ResetCHURequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResetCHURequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ResetCHURequest
 */
export const ResetCHURequest = new ResetCHURequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetCHUResponse$Type extends MessageType$<ResetCHUResponse> {
    constructor() {
        super("ProtoMessages.ResetCHUResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ResetCHUResponse>): ResetCHUResponse {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ResetCHUResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResetCHUResponse): ResetCHUResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResetCHUResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ResetCHUResponse
 */
export const ResetCHUResponse = new ResetCHUResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PingCameraRequest$Type extends MessageType$<PingCameraRequest> {
    constructor() {
        super("ProtoMessages.PingCameraRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<PingCameraRequest>): PingCameraRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PingCameraRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PingCameraRequest): PingCameraRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PingCameraRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PingCameraRequest
 */
export const PingCameraRequest = new PingCameraRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PingCameraResponse$Type extends MessageType$<PingCameraResponse> {
    constructor() {
        super("ProtoMessages.PingCameraResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PingCameraResponse>): PingCameraResponse {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PingCameraResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PingCameraResponse): PingCameraResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PingCameraResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PingCameraResponse
 */
export const PingCameraResponse = new PingCameraResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLocalRecordingStreamsRequest$Type extends MessageType$<GetLocalRecordingStreamsRequest> {
    constructor() {
        super("ProtoMessages.GetLocalRecordingStreamsRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<GetLocalRecordingStreamsRequest>): GetLocalRecordingStreamsRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetLocalRecordingStreamsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLocalRecordingStreamsRequest): GetLocalRecordingStreamsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLocalRecordingStreamsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.GetLocalRecordingStreamsRequest
 */
export const GetLocalRecordingStreamsRequest = new GetLocalRecordingStreamsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLocalRecordingStreamsResponse$Type extends MessageType$<GetLocalRecordingStreamsResponse> {
    constructor() {
        super("ProtoMessages.GetLocalRecordingStreamsResponse", [
            { no: 1, name: "streams", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => StreamConfig },
            { no: 2, name: "success", kind: "message", T: () => Bool },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetLocalRecordingStreamsResponse>): GetLocalRecordingStreamsResponse {
        const message = { streams: [], errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetLocalRecordingStreamsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLocalRecordingStreamsResponse): GetLocalRecordingStreamsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.StreamConfig streams */ 1:
                    message.streams.push(StreamConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ProtoMessages.Bool success */ 2:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLocalRecordingStreamsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.StreamConfig streams = 1; */
        for (let i = 0; i < message.streams.length; i++)
            StreamConfig.internalBinaryWrite(message.streams[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool success = 2; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.GetLocalRecordingStreamsResponse
 */
export const GetLocalRecordingStreamsResponse = new GetLocalRecordingStreamsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamConfig$Type extends MessageType$<StreamConfig> {
    constructor() {
        super("ProtoMessages.StreamConfig", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "index", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "bandwidth", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "fps", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StreamConfig>): StreamConfig {
        const message = { name: "", url: "", index: 0, bandwidth: 0, fps: 0, status: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StreamConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamConfig): StreamConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                case /* uint32 index */ 3:
                    message.index = reader.uint32();
                    break;
                case /* uint32 bandwidth */ 4:
                    message.bandwidth = reader.uint32();
                    break;
                case /* uint32 fps */ 5:
                    message.fps = reader.uint32();
                    break;
                case /* string status */ 6:
                    message.status = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        /* uint32 index = 3; */
        if (message.index !== 0)
            writer.tag(3, WireType.Varint).uint32(message.index);
        /* uint32 bandwidth = 4; */
        if (message.bandwidth !== 0)
            writer.tag(4, WireType.Varint).uint32(message.bandwidth);
        /* uint32 fps = 5; */
        if (message.fps !== 0)
            writer.tag(5, WireType.Varint).uint32(message.fps);
        /* string status = 6; */
        if (message.status !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StreamConfig
 */
export const StreamConfig = new StreamConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DetectAudioSourceRequest$Type extends MessageType$<DetectAudioSourceRequest> {
    constructor() {
        super("ProtoMessages.DetectAudioSourceRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<DetectAudioSourceRequest>): DetectAudioSourceRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DetectAudioSourceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DetectAudioSourceRequest): DetectAudioSourceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DetectAudioSourceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.DetectAudioSourceRequest
 */
export const DetectAudioSourceRequest = new DetectAudioSourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DetectAudioSourceResponse$Type extends MessageType$<DetectAudioSourceResponse> {
    constructor() {
        super("ProtoMessages.DetectAudioSourceResponse", [
            { no: 1, name: "detectAudioSources", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AudioSourceData },
            { no: 2, name: "success", kind: "message", T: () => Bool },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DetectAudioSourceResponse>): DetectAudioSourceResponse {
        const message = { detectAudioSources: [], errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DetectAudioSourceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DetectAudioSourceResponse): DetectAudioSourceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.AudioSourceData detectAudioSources */ 1:
                    message.detectAudioSources.push(AudioSourceData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ProtoMessages.Bool success */ 2:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DetectAudioSourceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.AudioSourceData detectAudioSources = 1; */
        for (let i = 0; i < message.detectAudioSources.length; i++)
            AudioSourceData.internalBinaryWrite(message.detectAudioSources[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool success = 2; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.DetectAudioSourceResponse
 */
export const DetectAudioSourceResponse = new DetectAudioSourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CurrentAudioSourceDataRequest$Type extends MessageType$<CurrentAudioSourceDataRequest> {
    constructor() {
        super("ProtoMessages.CurrentAudioSourceDataRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<CurrentAudioSourceDataRequest>): CurrentAudioSourceDataRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CurrentAudioSourceDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CurrentAudioSourceDataRequest): CurrentAudioSourceDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CurrentAudioSourceDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CurrentAudioSourceDataRequest
 */
export const CurrentAudioSourceDataRequest = new CurrentAudioSourceDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CurrentAudioSourceDataResponse$Type extends MessageType$<CurrentAudioSourceDataResponse> {
    constructor() {
        super("ProtoMessages.CurrentAudioSourceDataResponse", [
            { no: 1, name: "audioSourceData", kind: "message", T: () => AudioSourceData },
            { no: 2, name: "success", kind: "message", T: () => Bool },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CurrentAudioSourceDataResponse>): CurrentAudioSourceDataResponse {
        const message = { errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CurrentAudioSourceDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CurrentAudioSourceDataResponse): CurrentAudioSourceDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AudioSourceData audioSourceData */ 1:
                    message.audioSourceData = AudioSourceData.internalBinaryRead(reader, reader.uint32(), options, message.audioSourceData);
                    break;
                case /* ProtoMessages.Bool success */ 2:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CurrentAudioSourceDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AudioSourceData audioSourceData = 1; */
        if (message.audioSourceData)
            AudioSourceData.internalBinaryWrite(message.audioSourceData, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool success = 2; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CurrentAudioSourceDataResponse
 */
export const CurrentAudioSourceDataResponse = new CurrentAudioSourceDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCurrentAudioSourceRequest$Type extends MessageType$<UpdateCurrentAudioSourceRequest> {
    constructor() {
        super("ProtoMessages.UpdateCurrentAudioSourceRequest", [
            { no: 1, name: "selectedType", kind: "message", T: () => CommentatorType }
        ]);
    }
    create(value?: PartialMessage<UpdateCurrentAudioSourceRequest>): UpdateCurrentAudioSourceRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdateCurrentAudioSourceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCurrentAudioSourceRequest): UpdateCurrentAudioSourceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.CommentatorType selectedType */ 1:
                    message.selectedType = CommentatorType.internalBinaryRead(reader, reader.uint32(), options, message.selectedType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCurrentAudioSourceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.CommentatorType selectedType = 1; */
        if (message.selectedType)
            CommentatorType.internalBinaryWrite(message.selectedType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.UpdateCurrentAudioSourceRequest
 */
export const UpdateCurrentAudioSourceRequest = new UpdateCurrentAudioSourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCurrentAudioSourceResponse$Type extends MessageType$<UpdateCurrentAudioSourceResponse> {
    constructor() {
        super("ProtoMessages.UpdateCurrentAudioSourceResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCurrentAudioSourceResponse>): UpdateCurrentAudioSourceResponse {
        const message = { errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdateCurrentAudioSourceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCurrentAudioSourceResponse): UpdateCurrentAudioSourceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCurrentAudioSourceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.UpdateCurrentAudioSourceResponse
 */
export const UpdateCurrentAudioSourceResponse = new UpdateCurrentAudioSourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioSourceData$Type extends MessageType$<AudioSourceData> {
    constructor() {
        super("ProtoMessages.AudioSourceData", [
            { no: 1, name: "commentatorType", kind: "message", T: () => CommentatorType },
            { no: 2, name: "displayAudioLevel", kind: "message", T: () => Bool },
            { no: 3, name: "currentAudioVolume", kind: "message", T: () => Int32 },
            { no: 4, name: "selected", kind: "message", T: () => Bool },
            { no: 5, name: "compatibilityStatus", kind: "message", T: () => String$ },
            { no: 6, name: "fpsSupport", kind: "message", T: () => String$ }
        ]);
    }
    create(value?: PartialMessage<AudioSourceData>): AudioSourceData {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AudioSourceData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioSourceData): AudioSourceData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.CommentatorType commentatorType */ 1:
                    message.commentatorType = CommentatorType.internalBinaryRead(reader, reader.uint32(), options, message.commentatorType);
                    break;
                case /* ProtoMessages.Bool displayAudioLevel */ 2:
                    message.displayAudioLevel = Bool.internalBinaryRead(reader, reader.uint32(), options, message.displayAudioLevel);
                    break;
                case /* ProtoMessages.Int32 currentAudioVolume */ 3:
                    message.currentAudioVolume = Int32.internalBinaryRead(reader, reader.uint32(), options, message.currentAudioVolume);
                    break;
                case /* ProtoMessages.Bool selected */ 4:
                    message.selected = Bool.internalBinaryRead(reader, reader.uint32(), options, message.selected);
                    break;
                case /* ProtoMessages.String compatibilityStatus */ 5:
                    message.compatibilityStatus = String$.internalBinaryRead(reader, reader.uint32(), options, message.compatibilityStatus);
                    break;
                case /* ProtoMessages.String fpsSupport */ 6:
                    message.fpsSupport = String$.internalBinaryRead(reader, reader.uint32(), options, message.fpsSupport);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioSourceData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.CommentatorType commentatorType = 1; */
        if (message.commentatorType)
            CommentatorType.internalBinaryWrite(message.commentatorType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool displayAudioLevel = 2; */
        if (message.displayAudioLevel)
            Bool.internalBinaryWrite(message.displayAudioLevel, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int32 currentAudioVolume = 3; */
        if (message.currentAudioVolume)
            Int32.internalBinaryWrite(message.currentAudioVolume, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool selected = 4; */
        if (message.selected)
            Bool.internalBinaryWrite(message.selected, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String compatibilityStatus = 5; */
        if (message.compatibilityStatus)
            String$.internalBinaryWrite(message.compatibilityStatus, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String fpsSupport = 6; */
        if (message.fpsSupport)
            String$.internalBinaryWrite(message.fpsSupport, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AudioSourceData
 */
export const AudioSourceData = new AudioSourceData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommentatorType$Type extends MessageType$<CommentatorType> {
    constructor() {
        super("ProtoMessages.CommentatorType", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.CommentatorType.Type", CommentatorType_Type] }
        ]);
    }
    create(value?: PartialMessage<CommentatorType>): CommentatorType {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CommentatorType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CommentatorType): CommentatorType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.CommentatorType.Type value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CommentatorType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.CommentatorType.Type value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CommentatorType
 */
export const CommentatorType = new CommentatorType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCommentatorAudioVolumeRequest$Type extends MessageType$<UpdateCommentatorAudioVolumeRequest> {
    constructor() {
        super("ProtoMessages.UpdateCommentatorAudioVolumeRequest", [
            { no: 1, name: "volume", kind: "message", T: () => Int32 }
        ]);
    }
    create(value?: PartialMessage<UpdateCommentatorAudioVolumeRequest>): UpdateCommentatorAudioVolumeRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdateCommentatorAudioVolumeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCommentatorAudioVolumeRequest): UpdateCommentatorAudioVolumeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Int32 volume */ 1:
                    message.volume = Int32.internalBinaryRead(reader, reader.uint32(), options, message.volume);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCommentatorAudioVolumeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Int32 volume = 1; */
        if (message.volume)
            Int32.internalBinaryWrite(message.volume, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.UpdateCommentatorAudioVolumeRequest
 */
export const UpdateCommentatorAudioVolumeRequest = new UpdateCommentatorAudioVolumeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCommentatorAudioVolumeResponse$Type extends MessageType$<UpdateCommentatorAudioVolumeResponse> {
    constructor() {
        super("ProtoMessages.UpdateCommentatorAudioVolumeResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "volume", kind: "message", T: () => Int32 }
        ]);
    }
    create(value?: PartialMessage<UpdateCommentatorAudioVolumeResponse>): UpdateCommentatorAudioVolumeResponse {
        const message = { errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdateCommentatorAudioVolumeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCommentatorAudioVolumeResponse): UpdateCommentatorAudioVolumeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* ProtoMessages.Int32 volume */ 3:
                    message.volume = Int32.internalBinaryRead(reader, reader.uint32(), options, message.volume);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCommentatorAudioVolumeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* ProtoMessages.Int32 volume = 3; */
        if (message.volume)
            Int32.internalBinaryWrite(message.volume, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.UpdateCommentatorAudioVolumeResponse
 */
export const UpdateCommentatorAudioVolumeResponse = new UpdateCommentatorAudioVolumeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioSourceInputLevelStartRequest$Type extends MessageType$<AudioSourceInputLevelStartRequest> {
    constructor() {
        super("ProtoMessages.AudioSourceInputLevelStartRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<AudioSourceInputLevelStartRequest>): AudioSourceInputLevelStartRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AudioSourceInputLevelStartRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioSourceInputLevelStartRequest): AudioSourceInputLevelStartRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioSourceInputLevelStartRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AudioSourceInputLevelStartRequest
 */
export const AudioSourceInputLevelStartRequest = new AudioSourceInputLevelStartRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioSourceInputLevelResponse$Type extends MessageType$<AudioSourceInputLevelResponse> {
    constructor() {
        super("ProtoMessages.AudioSourceInputLevelResponse", [
            { no: 1, name: "level", kind: "message", T: () => Int32 },
            { no: 2, name: "success", kind: "message", T: () => Bool },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AudioSourceInputLevelResponse>): AudioSourceInputLevelResponse {
        const message = { errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AudioSourceInputLevelResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioSourceInputLevelResponse): AudioSourceInputLevelResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Int32 level */ 1:
                    message.level = Int32.internalBinaryRead(reader, reader.uint32(), options, message.level);
                    break;
                case /* ProtoMessages.Bool success */ 2:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioSourceInputLevelResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Int32 level = 1; */
        if (message.level)
            Int32.internalBinaryWrite(message.level, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool success = 2; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AudioSourceInputLevelResponse
 */
export const AudioSourceInputLevelResponse = new AudioSourceInputLevelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioSourceInputLevelStopRequest$Type extends MessageType$<AudioSourceInputLevelStopRequest> {
    constructor() {
        super("ProtoMessages.AudioSourceInputLevelStopRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<AudioSourceInputLevelStopRequest>): AudioSourceInputLevelStopRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AudioSourceInputLevelStopRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioSourceInputLevelStopRequest): AudioSourceInputLevelStopRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioSourceInputLevelStopRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AudioSourceInputLevelStopRequest
 */
export const AudioSourceInputLevelStopRequest = new AudioSourceInputLevelStopRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PingPongMessage$Type extends MessageType$<PingPongMessage> {
    constructor() {
        super("ProtoMessages.PingPongMessage", [
            { no: 1, name: "msg", kind: "message", T: () => Int64 }
        ]);
    }
    create(value?: PartialMessage<PingPongMessage>): PingPongMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PingPongMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PingPongMessage): PingPongMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Int64 msg */ 1:
                    message.msg = Int64.internalBinaryRead(reader, reader.uint32(), options, message.msg);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PingPongMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Int64 msg = 1; */
        if (message.msg)
            Int64.internalBinaryWrite(message.msg, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PingPongMessage
 */
export const PingPongMessage = new PingPongMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StatusInformationMessage$Type extends MessageType$<StatusInformationMessage> {
    constructor() {
        super("ProtoMessages.StatusInformationMessage", [
            { no: 1, name: "systemStatus", kind: "message", T: () => GeneralStatus },
            { no: 2, name: "vpuStatus", kind: "message", T: () => VpuStatus },
            { no: 4, name: "systemMode", kind: "message", T: () => SystemMode },
            { no: 5, name: "workingHours", kind: "message", T: () => WorkingHours },
            { no: 6, name: "streamsInfo", kind: "message", T: () => StreamsInfo },
            { no: 7, name: "currentEvent", kind: "message", T: () => EventInfo },
            { no: 8, name: "upcomingEvent", kind: "message", T: () => EventInfo },
            { no: 9, name: "sportsType", kind: "message", T: () => SportsType },
            { no: 10, name: "highlightsEnabled", kind: "message", T: () => Bool },
            { no: 11, name: "graphicsInfo", kind: "message", T: () => GraphicEngineInfo },
            { no: 12, name: "manualCameraEnabled", kind: "message", T: () => Bool },
            { no: 13, name: "clipperLiveEnabled", kind: "message", T: () => Bool },
            { no: 14, name: "headCameras", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CameraInformation },
            { no: 15, name: "lastModifiedCalibration", kind: "message", T: () => Int64 },
            { no: 16, name: "lastModifiedColorBalance", kind: "message", T: () => Int64 },
            { no: 17, name: "lastModifiedCCU", kind: "message", T: () => Int64 },
            { no: 18, name: "audioEnabled", kind: "message", T: () => Bool },
            { no: 19, name: "poeLastReset", kind: "message", T: () => String$ },
            { no: 20, name: "nicInfo", kind: "message", T: () => String$ },
            { no: 21, name: "autoProductionEnabled", kind: "message", T: () => Bool },
            { no: 22, name: "autoLightControlEnabled", kind: "message", T: () => Bool },
            { no: 24, name: "stayInMaintenanceMode", kind: "message", T: () => Bool },
            { no: 25, name: "toggleSetupMode", kind: "message", T: () => ToggleSetupMode },
            { no: 26, name: "setupModeOn", kind: "message", T: () => Bool },
            { no: 30, name: "cgEngineState", kind: "message", T: () => Bool },
            { no: 31, name: "pipState", kind: "message", T: () => Bool },
            { no: 34, name: "testPortsResult", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TestPortsResult },
            { no: 35, name: "sdiEnabled", kind: "message", T: () => Bool },
            { no: 37, name: "graphicsUpdateRequired", kind: "message", T: () => Bool },
            { no: 38, name: "varSupportEnabled", kind: "message", T: () => Bool },
            { no: 39, name: "allowPing", kind: "message", T: () => Bool },
            { no: 40, name: "audioVolumeUpdated", kind: "message", T: () => Int64 },
            { no: 41, name: "audioGainUpdated", kind: "message", T: () => Int64 },
            { no: 42, name: "ligrStatus", kind: "message", T: () => LigrStatus },
            { no: 43, name: "debugPrintoutsEnabled", kind: "message", T: () => Bool },
            { no: 44, name: "systemHasCalibration", kind: "message", T: () => Bool },
            { no: 45, name: "reason", kind: "message", T: () => String$ },
            { no: 46, name: "sdiFormat", kind: "message", T: () => SdiFormat },
            { no: 47, name: "sdiGraphicsEnabled", kind: "message", T: () => Bool },
            { no: 48, name: "dualRenderingInProgress", kind: "message", T: () => Bool },
            { no: 49, name: "chuStatus", kind: "message", T: () => ChuStatus },
            { no: 50, name: "applyColorCalibrationMatrix", kind: "message", T: () => Bool },
            { no: 51, name: "manualMidrollEnabled", kind: "message", T: () => Bool },
            { no: 52, name: "useSmartMidroll", kind: "message", T: () => Bool },
            { no: 53, name: "smartMidrollSimulator", kind: "message", T: () => Bool },
            { no: 54, name: "scoreboardManualFromVideo", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<StatusInformationMessage>): StatusInformationMessage {
        const message = { headCameras: [], testPortsResult: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StatusInformationMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StatusInformationMessage): StatusInformationMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.GeneralStatus systemStatus */ 1:
                    message.systemStatus = GeneralStatus.internalBinaryRead(reader, reader.uint32(), options, message.systemStatus);
                    break;
                case /* ProtoMessages.VpuStatus vpuStatus */ 2:
                    message.vpuStatus = VpuStatus.internalBinaryRead(reader, reader.uint32(), options, message.vpuStatus);
                    break;
                case /* ProtoMessages.SystemMode systemMode */ 4:
                    message.systemMode = SystemMode.internalBinaryRead(reader, reader.uint32(), options, message.systemMode);
                    break;
                case /* ProtoMessages.WorkingHours workingHours */ 5:
                    message.workingHours = WorkingHours.internalBinaryRead(reader, reader.uint32(), options, message.workingHours);
                    break;
                case /* ProtoMessages.StreamsInfo streamsInfo */ 6:
                    message.streamsInfo = StreamsInfo.internalBinaryRead(reader, reader.uint32(), options, message.streamsInfo);
                    break;
                case /* ProtoMessages.EventInfo currentEvent */ 7:
                    message.currentEvent = EventInfo.internalBinaryRead(reader, reader.uint32(), options, message.currentEvent);
                    break;
                case /* ProtoMessages.EventInfo upcomingEvent */ 8:
                    message.upcomingEvent = EventInfo.internalBinaryRead(reader, reader.uint32(), options, message.upcomingEvent);
                    break;
                case /* ProtoMessages.SportsType sportsType */ 9:
                    message.sportsType = SportsType.internalBinaryRead(reader, reader.uint32(), options, message.sportsType);
                    break;
                case /* ProtoMessages.Bool highlightsEnabled */ 10:
                    message.highlightsEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.highlightsEnabled);
                    break;
                case /* ProtoMessages.GraphicEngineInfo graphicsInfo */ 11:
                    message.graphicsInfo = GraphicEngineInfo.internalBinaryRead(reader, reader.uint32(), options, message.graphicsInfo);
                    break;
                case /* ProtoMessages.Bool manualCameraEnabled */ 12:
                    message.manualCameraEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.manualCameraEnabled);
                    break;
                case /* ProtoMessages.Bool clipperLiveEnabled */ 13:
                    message.clipperLiveEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.clipperLiveEnabled);
                    break;
                case /* repeated ProtoMessages.CameraInformation headCameras */ 14:
                    message.headCameras.push(CameraInformation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ProtoMessages.Int64 lastModifiedCalibration */ 15:
                    message.lastModifiedCalibration = Int64.internalBinaryRead(reader, reader.uint32(), options, message.lastModifiedCalibration);
                    break;
                case /* ProtoMessages.Int64 lastModifiedColorBalance */ 16:
                    message.lastModifiedColorBalance = Int64.internalBinaryRead(reader, reader.uint32(), options, message.lastModifiedColorBalance);
                    break;
                case /* ProtoMessages.Int64 lastModifiedCCU */ 17:
                    message.lastModifiedCCU = Int64.internalBinaryRead(reader, reader.uint32(), options, message.lastModifiedCCU);
                    break;
                case /* ProtoMessages.Bool audioEnabled */ 18:
                    message.audioEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.audioEnabled);
                    break;
                case /* ProtoMessages.String poeLastReset */ 19:
                    message.poeLastReset = String$.internalBinaryRead(reader, reader.uint32(), options, message.poeLastReset);
                    break;
                case /* ProtoMessages.String nicInfo */ 20:
                    message.nicInfo = String$.internalBinaryRead(reader, reader.uint32(), options, message.nicInfo);
                    break;
                case /* ProtoMessages.Bool autoProductionEnabled */ 21:
                    message.autoProductionEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.autoProductionEnabled);
                    break;
                case /* ProtoMessages.Bool autoLightControlEnabled */ 22:
                    message.autoLightControlEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.autoLightControlEnabled);
                    break;
                case /* ProtoMessages.Bool stayInMaintenanceMode */ 24:
                    message.stayInMaintenanceMode = Bool.internalBinaryRead(reader, reader.uint32(), options, message.stayInMaintenanceMode);
                    break;
                case /* ProtoMessages.ToggleSetupMode toggleSetupMode */ 25:
                    message.toggleSetupMode = ToggleSetupMode.internalBinaryRead(reader, reader.uint32(), options, message.toggleSetupMode);
                    break;
                case /* ProtoMessages.Bool setupModeOn */ 26:
                    message.setupModeOn = Bool.internalBinaryRead(reader, reader.uint32(), options, message.setupModeOn);
                    break;
                case /* ProtoMessages.Bool cgEngineState */ 30:
                    message.cgEngineState = Bool.internalBinaryRead(reader, reader.uint32(), options, message.cgEngineState);
                    break;
                case /* ProtoMessages.Bool pipState */ 31:
                    message.pipState = Bool.internalBinaryRead(reader, reader.uint32(), options, message.pipState);
                    break;
                case /* repeated ProtoMessages.TestPortsResult testPortsResult */ 34:
                    message.testPortsResult.push(TestPortsResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ProtoMessages.Bool sdiEnabled */ 35:
                    message.sdiEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.sdiEnabled);
                    break;
                case /* ProtoMessages.Bool graphicsUpdateRequired */ 37:
                    message.graphicsUpdateRequired = Bool.internalBinaryRead(reader, reader.uint32(), options, message.graphicsUpdateRequired);
                    break;
                case /* ProtoMessages.Bool varSupportEnabled */ 38:
                    message.varSupportEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.varSupportEnabled);
                    break;
                case /* ProtoMessages.Bool allowPing */ 39:
                    message.allowPing = Bool.internalBinaryRead(reader, reader.uint32(), options, message.allowPing);
                    break;
                case /* ProtoMessages.Int64 audioVolumeUpdated */ 40:
                    message.audioVolumeUpdated = Int64.internalBinaryRead(reader, reader.uint32(), options, message.audioVolumeUpdated);
                    break;
                case /* ProtoMessages.Int64 audioGainUpdated */ 41:
                    message.audioGainUpdated = Int64.internalBinaryRead(reader, reader.uint32(), options, message.audioGainUpdated);
                    break;
                case /* ProtoMessages.LigrStatus ligrStatus */ 42:
                    message.ligrStatus = LigrStatus.internalBinaryRead(reader, reader.uint32(), options, message.ligrStatus);
                    break;
                case /* ProtoMessages.Bool debugPrintoutsEnabled */ 43:
                    message.debugPrintoutsEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.debugPrintoutsEnabled);
                    break;
                case /* ProtoMessages.Bool systemHasCalibration */ 44:
                    message.systemHasCalibration = Bool.internalBinaryRead(reader, reader.uint32(), options, message.systemHasCalibration);
                    break;
                case /* ProtoMessages.String reason */ 45:
                    message.reason = String$.internalBinaryRead(reader, reader.uint32(), options, message.reason);
                    break;
                case /* ProtoMessages.SdiFormat sdiFormat */ 46:
                    message.sdiFormat = SdiFormat.internalBinaryRead(reader, reader.uint32(), options, message.sdiFormat);
                    break;
                case /* ProtoMessages.Bool sdiGraphicsEnabled */ 47:
                    message.sdiGraphicsEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.sdiGraphicsEnabled);
                    break;
                case /* ProtoMessages.Bool dualRenderingInProgress */ 48:
                    message.dualRenderingInProgress = Bool.internalBinaryRead(reader, reader.uint32(), options, message.dualRenderingInProgress);
                    break;
                case /* ProtoMessages.ChuStatus chuStatus */ 49:
                    message.chuStatus = ChuStatus.internalBinaryRead(reader, reader.uint32(), options, message.chuStatus);
                    break;
                case /* ProtoMessages.Bool applyColorCalibrationMatrix */ 50:
                    message.applyColorCalibrationMatrix = Bool.internalBinaryRead(reader, reader.uint32(), options, message.applyColorCalibrationMatrix);
                    break;
                case /* ProtoMessages.Bool manualMidrollEnabled */ 51:
                    message.manualMidrollEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.manualMidrollEnabled);
                    break;
                case /* ProtoMessages.Bool useSmartMidroll */ 52:
                    message.useSmartMidroll = Bool.internalBinaryRead(reader, reader.uint32(), options, message.useSmartMidroll);
                    break;
                case /* ProtoMessages.Bool smartMidrollSimulator */ 53:
                    message.smartMidrollSimulator = Bool.internalBinaryRead(reader, reader.uint32(), options, message.smartMidrollSimulator);
                    break;
                case /* ProtoMessages.Bool scoreboardManualFromVideo */ 54:
                    message.scoreboardManualFromVideo = Bool.internalBinaryRead(reader, reader.uint32(), options, message.scoreboardManualFromVideo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StatusInformationMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.GeneralStatus systemStatus = 1; */
        if (message.systemStatus)
            GeneralStatus.internalBinaryWrite(message.systemStatus, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.VpuStatus vpuStatus = 2; */
        if (message.vpuStatus)
            VpuStatus.internalBinaryWrite(message.vpuStatus, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.SystemMode systemMode = 4; */
        if (message.systemMode)
            SystemMode.internalBinaryWrite(message.systemMode, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.WorkingHours workingHours = 5; */
        if (message.workingHours)
            WorkingHours.internalBinaryWrite(message.workingHours, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.StreamsInfo streamsInfo = 6; */
        if (message.streamsInfo)
            StreamsInfo.internalBinaryWrite(message.streamsInfo, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.EventInfo currentEvent = 7; */
        if (message.currentEvent)
            EventInfo.internalBinaryWrite(message.currentEvent, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.EventInfo upcomingEvent = 8; */
        if (message.upcomingEvent)
            EventInfo.internalBinaryWrite(message.upcomingEvent, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.SportsType sportsType = 9; */
        if (message.sportsType)
            SportsType.internalBinaryWrite(message.sportsType, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool highlightsEnabled = 10; */
        if (message.highlightsEnabled)
            Bool.internalBinaryWrite(message.highlightsEnabled, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.GraphicEngineInfo graphicsInfo = 11; */
        if (message.graphicsInfo)
            GraphicEngineInfo.internalBinaryWrite(message.graphicsInfo, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool manualCameraEnabled = 12; */
        if (message.manualCameraEnabled)
            Bool.internalBinaryWrite(message.manualCameraEnabled, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool clipperLiveEnabled = 13; */
        if (message.clipperLiveEnabled)
            Bool.internalBinaryWrite(message.clipperLiveEnabled, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.CameraInformation headCameras = 14; */
        for (let i = 0; i < message.headCameras.length; i++)
            CameraInformation.internalBinaryWrite(message.headCameras[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int64 lastModifiedCalibration = 15; */
        if (message.lastModifiedCalibration)
            Int64.internalBinaryWrite(message.lastModifiedCalibration, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int64 lastModifiedColorBalance = 16; */
        if (message.lastModifiedColorBalance)
            Int64.internalBinaryWrite(message.lastModifiedColorBalance, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int64 lastModifiedCCU = 17; */
        if (message.lastModifiedCCU)
            Int64.internalBinaryWrite(message.lastModifiedCCU, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool audioEnabled = 18; */
        if (message.audioEnabled)
            Bool.internalBinaryWrite(message.audioEnabled, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String poeLastReset = 19; */
        if (message.poeLastReset)
            String$.internalBinaryWrite(message.poeLastReset, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String nicInfo = 20; */
        if (message.nicInfo)
            String$.internalBinaryWrite(message.nicInfo, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool autoProductionEnabled = 21; */
        if (message.autoProductionEnabled)
            Bool.internalBinaryWrite(message.autoProductionEnabled, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool autoLightControlEnabled = 22; */
        if (message.autoLightControlEnabled)
            Bool.internalBinaryWrite(message.autoLightControlEnabled, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool stayInMaintenanceMode = 24; */
        if (message.stayInMaintenanceMode)
            Bool.internalBinaryWrite(message.stayInMaintenanceMode, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.ToggleSetupMode toggleSetupMode = 25; */
        if (message.toggleSetupMode)
            ToggleSetupMode.internalBinaryWrite(message.toggleSetupMode, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool setupModeOn = 26; */
        if (message.setupModeOn)
            Bool.internalBinaryWrite(message.setupModeOn, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool cgEngineState = 30; */
        if (message.cgEngineState)
            Bool.internalBinaryWrite(message.cgEngineState, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool pipState = 31; */
        if (message.pipState)
            Bool.internalBinaryWrite(message.pipState, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.TestPortsResult testPortsResult = 34; */
        for (let i = 0; i < message.testPortsResult.length; i++)
            TestPortsResult.internalBinaryWrite(message.testPortsResult[i], writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool sdiEnabled = 35; */
        if (message.sdiEnabled)
            Bool.internalBinaryWrite(message.sdiEnabled, writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool graphicsUpdateRequired = 37; */
        if (message.graphicsUpdateRequired)
            Bool.internalBinaryWrite(message.graphicsUpdateRequired, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool varSupportEnabled = 38; */
        if (message.varSupportEnabled)
            Bool.internalBinaryWrite(message.varSupportEnabled, writer.tag(38, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool allowPing = 39; */
        if (message.allowPing)
            Bool.internalBinaryWrite(message.allowPing, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int64 audioVolumeUpdated = 40; */
        if (message.audioVolumeUpdated)
            Int64.internalBinaryWrite(message.audioVolumeUpdated, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int64 audioGainUpdated = 41; */
        if (message.audioGainUpdated)
            Int64.internalBinaryWrite(message.audioGainUpdated, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.LigrStatus ligrStatus = 42; */
        if (message.ligrStatus)
            LigrStatus.internalBinaryWrite(message.ligrStatus, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool debugPrintoutsEnabled = 43; */
        if (message.debugPrintoutsEnabled)
            Bool.internalBinaryWrite(message.debugPrintoutsEnabled, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool systemHasCalibration = 44; */
        if (message.systemHasCalibration)
            Bool.internalBinaryWrite(message.systemHasCalibration, writer.tag(44, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String reason = 45; */
        if (message.reason)
            String$.internalBinaryWrite(message.reason, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.SdiFormat sdiFormat = 46; */
        if (message.sdiFormat)
            SdiFormat.internalBinaryWrite(message.sdiFormat, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool sdiGraphicsEnabled = 47; */
        if (message.sdiGraphicsEnabled)
            Bool.internalBinaryWrite(message.sdiGraphicsEnabled, writer.tag(47, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool dualRenderingInProgress = 48; */
        if (message.dualRenderingInProgress)
            Bool.internalBinaryWrite(message.dualRenderingInProgress, writer.tag(48, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.ChuStatus chuStatus = 49; */
        if (message.chuStatus)
            ChuStatus.internalBinaryWrite(message.chuStatus, writer.tag(49, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool applyColorCalibrationMatrix = 50; */
        if (message.applyColorCalibrationMatrix)
            Bool.internalBinaryWrite(message.applyColorCalibrationMatrix, writer.tag(50, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool manualMidrollEnabled = 51; */
        if (message.manualMidrollEnabled)
            Bool.internalBinaryWrite(message.manualMidrollEnabled, writer.tag(51, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool useSmartMidroll = 52; */
        if (message.useSmartMidroll)
            Bool.internalBinaryWrite(message.useSmartMidroll, writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool smartMidrollSimulator = 53; */
        if (message.smartMidrollSimulator)
            Bool.internalBinaryWrite(message.smartMidrollSimulator, writer.tag(53, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool scoreboardManualFromVideo = 54; */
        if (message.scoreboardManualFromVideo)
            Bool.internalBinaryWrite(message.scoreboardManualFromVideo, writer.tag(54, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StatusInformationMessage
 */
export const StatusInformationMessage = new StatusInformationMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SdiFormat$Type extends MessageType$<SdiFormat> {
    constructor() {
        super("ProtoMessages.SdiFormat", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.SdiFormat.Format", SdiFormat_Format] }
        ]);
    }
    create(value?: PartialMessage<SdiFormat>): SdiFormat {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SdiFormat>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SdiFormat): SdiFormat {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.SdiFormat.Format value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SdiFormat, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.SdiFormat.Format value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SdiFormat
 */
export const SdiFormat = new SdiFormat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RealtimeInformationMessage$Type extends MessageType$<RealtimeInformationMessage> {
    constructor() {
        super("ProtoMessages.RealtimeInformationMessage", [
            { no: 1, name: "cpuUsage", kind: "message", T: () => Double },
            { no: 2, name: "cpuTemperature", kind: "message", T: () => Double },
            { no: 3, name: "gpuUsage", kind: "message", T: () => Double },
            { no: 4, name: "health", kind: "message", T: () => Bool },
            { no: 5, name: "drives", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DriveInformation },
            { no: 6, name: "backendConnection", kind: "message", T: () => Bool },
            { no: 7, name: "autoProductionState", kind: "message", T: () => Bool },
            { no: 8, name: "autoLightControlState", kind: "message", T: () => Bool },
            { no: 9, name: "panoStreamStatus", kind: "message", T: () => GeneralStatus },
            { no: 10, name: "hdStreamStatus", kind: "message", T: () => GeneralStatus },
            { no: 11, name: "audioStatus", kind: "message", T: () => Bool },
            { no: 12, name: "memoryUsage", kind: "message", T: () => Double },
            { no: 13, name: "autoLightControlValues", kind: "message", T: () => AutoLightControlValues }
        ]);
    }
    create(value?: PartialMessage<RealtimeInformationMessage>): RealtimeInformationMessage {
        const message = { drives: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RealtimeInformationMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RealtimeInformationMessage): RealtimeInformationMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Double cpuUsage */ 1:
                    message.cpuUsage = Double.internalBinaryRead(reader, reader.uint32(), options, message.cpuUsage);
                    break;
                case /* ProtoMessages.Double cpuTemperature */ 2:
                    message.cpuTemperature = Double.internalBinaryRead(reader, reader.uint32(), options, message.cpuTemperature);
                    break;
                case /* ProtoMessages.Double gpuUsage */ 3:
                    message.gpuUsage = Double.internalBinaryRead(reader, reader.uint32(), options, message.gpuUsage);
                    break;
                case /* ProtoMessages.Bool health */ 4:
                    message.health = Bool.internalBinaryRead(reader, reader.uint32(), options, message.health);
                    break;
                case /* repeated ProtoMessages.DriveInformation drives */ 5:
                    message.drives.push(DriveInformation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ProtoMessages.Bool backendConnection */ 6:
                    message.backendConnection = Bool.internalBinaryRead(reader, reader.uint32(), options, message.backendConnection);
                    break;
                case /* ProtoMessages.Bool autoProductionState */ 7:
                    message.autoProductionState = Bool.internalBinaryRead(reader, reader.uint32(), options, message.autoProductionState);
                    break;
                case /* ProtoMessages.Bool autoLightControlState */ 8:
                    message.autoLightControlState = Bool.internalBinaryRead(reader, reader.uint32(), options, message.autoLightControlState);
                    break;
                case /* ProtoMessages.GeneralStatus panoStreamStatus */ 9:
                    message.panoStreamStatus = GeneralStatus.internalBinaryRead(reader, reader.uint32(), options, message.panoStreamStatus);
                    break;
                case /* ProtoMessages.GeneralStatus hdStreamStatus */ 10:
                    message.hdStreamStatus = GeneralStatus.internalBinaryRead(reader, reader.uint32(), options, message.hdStreamStatus);
                    break;
                case /* ProtoMessages.Bool audioStatus */ 11:
                    message.audioStatus = Bool.internalBinaryRead(reader, reader.uint32(), options, message.audioStatus);
                    break;
                case /* ProtoMessages.Double memoryUsage */ 12:
                    message.memoryUsage = Double.internalBinaryRead(reader, reader.uint32(), options, message.memoryUsage);
                    break;
                case /* ProtoMessages.AutoLightControlValues autoLightControlValues */ 13:
                    message.autoLightControlValues = AutoLightControlValues.internalBinaryRead(reader, reader.uint32(), options, message.autoLightControlValues);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RealtimeInformationMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Double cpuUsage = 1; */
        if (message.cpuUsage)
            Double.internalBinaryWrite(message.cpuUsage, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Double cpuTemperature = 2; */
        if (message.cpuTemperature)
            Double.internalBinaryWrite(message.cpuTemperature, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Double gpuUsage = 3; */
        if (message.gpuUsage)
            Double.internalBinaryWrite(message.gpuUsage, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool health = 4; */
        if (message.health)
            Bool.internalBinaryWrite(message.health, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.DriveInformation drives = 5; */
        for (let i = 0; i < message.drives.length; i++)
            DriveInformation.internalBinaryWrite(message.drives[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool backendConnection = 6; */
        if (message.backendConnection)
            Bool.internalBinaryWrite(message.backendConnection, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool autoProductionState = 7; */
        if (message.autoProductionState)
            Bool.internalBinaryWrite(message.autoProductionState, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool autoLightControlState = 8; */
        if (message.autoLightControlState)
            Bool.internalBinaryWrite(message.autoLightControlState, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.GeneralStatus panoStreamStatus = 9; */
        if (message.panoStreamStatus)
            GeneralStatus.internalBinaryWrite(message.panoStreamStatus, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.GeneralStatus hdStreamStatus = 10; */
        if (message.hdStreamStatus)
            GeneralStatus.internalBinaryWrite(message.hdStreamStatus, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool audioStatus = 11; */
        if (message.audioStatus)
            Bool.internalBinaryWrite(message.audioStatus, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Double memoryUsage = 12; */
        if (message.memoryUsage)
            Double.internalBinaryWrite(message.memoryUsage, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.AutoLightControlValues autoLightControlValues = 13; */
        if (message.autoLightControlValues)
            AutoLightControlValues.internalBinaryWrite(message.autoLightControlValues, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.RealtimeInformationMessage
 */
export const RealtimeInformationMessage = new RealtimeInformationMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SingleParamInformationMessage$Type extends MessageType$<SingleParamInformationMessage> {
    constructor() {
        super("ProtoMessages.SingleParamInformationMessage", [
            { no: 1, name: "cameraFramesData", kind: "message", T: () => CameraFramesData },
            { no: 2, name: "licenseUpdateSucceeded", kind: "message", T: () => Bool },
            { no: 3, name: "forceLeaveSetupMode", kind: "message", T: () => Bool },
            { no: 4, name: "tryLeaveMaintenanceMode", kind: "message", T: () => Bool },
            { no: 7, name: "panoramaInfo", kind: "message", T: () => PanoramaInfo },
            { no: 8, name: "ccuPresets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CCUPreset },
            { no: 9, name: "detectedCameras", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => String$ },
            { no: 10, name: "cameraRestoreSucceeded", kind: "message", T: () => Bool },
            { no: 11, name: "enterSetupModeFailed", kind: "message", T: () => Bool },
            { no: 12, name: "headSetupFramesData", kind: "message", T: () => CameraFramesData },
            { no: 13, name: "currentVpuPhaseIndex", kind: "message", T: () => Int32 }
        ]);
    }
    create(value?: PartialMessage<SingleParamInformationMessage>): SingleParamInformationMessage {
        const message = { ccuPresets: [], detectedCameras: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SingleParamInformationMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SingleParamInformationMessage): SingleParamInformationMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.CameraFramesData cameraFramesData */ 1:
                    message.cameraFramesData = CameraFramesData.internalBinaryRead(reader, reader.uint32(), options, message.cameraFramesData);
                    break;
                case /* ProtoMessages.Bool licenseUpdateSucceeded */ 2:
                    message.licenseUpdateSucceeded = Bool.internalBinaryRead(reader, reader.uint32(), options, message.licenseUpdateSucceeded);
                    break;
                case /* ProtoMessages.Bool forceLeaveSetupMode */ 3:
                    message.forceLeaveSetupMode = Bool.internalBinaryRead(reader, reader.uint32(), options, message.forceLeaveSetupMode);
                    break;
                case /* ProtoMessages.Bool tryLeaveMaintenanceMode */ 4:
                    message.tryLeaveMaintenanceMode = Bool.internalBinaryRead(reader, reader.uint32(), options, message.tryLeaveMaintenanceMode);
                    break;
                case /* ProtoMessages.PanoramaInfo panoramaInfo */ 7:
                    message.panoramaInfo = PanoramaInfo.internalBinaryRead(reader, reader.uint32(), options, message.panoramaInfo);
                    break;
                case /* repeated ProtoMessages.CCUPreset ccuPresets */ 8:
                    message.ccuPresets.push(CCUPreset.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ProtoMessages.String detectedCameras */ 9:
                    message.detectedCameras.push(String$.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ProtoMessages.Bool cameraRestoreSucceeded */ 10:
                    message.cameraRestoreSucceeded = Bool.internalBinaryRead(reader, reader.uint32(), options, message.cameraRestoreSucceeded);
                    break;
                case /* ProtoMessages.Bool enterSetupModeFailed */ 11:
                    message.enterSetupModeFailed = Bool.internalBinaryRead(reader, reader.uint32(), options, message.enterSetupModeFailed);
                    break;
                case /* ProtoMessages.CameraFramesData headSetupFramesData */ 12:
                    message.headSetupFramesData = CameraFramesData.internalBinaryRead(reader, reader.uint32(), options, message.headSetupFramesData);
                    break;
                case /* ProtoMessages.Int32 currentVpuPhaseIndex */ 13:
                    message.currentVpuPhaseIndex = Int32.internalBinaryRead(reader, reader.uint32(), options, message.currentVpuPhaseIndex);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SingleParamInformationMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.CameraFramesData cameraFramesData = 1; */
        if (message.cameraFramesData)
            CameraFramesData.internalBinaryWrite(message.cameraFramesData, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool licenseUpdateSucceeded = 2; */
        if (message.licenseUpdateSucceeded)
            Bool.internalBinaryWrite(message.licenseUpdateSucceeded, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool forceLeaveSetupMode = 3; */
        if (message.forceLeaveSetupMode)
            Bool.internalBinaryWrite(message.forceLeaveSetupMode, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool tryLeaveMaintenanceMode = 4; */
        if (message.tryLeaveMaintenanceMode)
            Bool.internalBinaryWrite(message.tryLeaveMaintenanceMode, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.PanoramaInfo panoramaInfo = 7; */
        if (message.panoramaInfo)
            PanoramaInfo.internalBinaryWrite(message.panoramaInfo, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.CCUPreset ccuPresets = 8; */
        for (let i = 0; i < message.ccuPresets.length; i++)
            CCUPreset.internalBinaryWrite(message.ccuPresets[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.String detectedCameras = 9; */
        for (let i = 0; i < message.detectedCameras.length; i++)
            String$.internalBinaryWrite(message.detectedCameras[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool cameraRestoreSucceeded = 10; */
        if (message.cameraRestoreSucceeded)
            Bool.internalBinaryWrite(message.cameraRestoreSucceeded, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool enterSetupModeFailed = 11; */
        if (message.enterSetupModeFailed)
            Bool.internalBinaryWrite(message.enterSetupModeFailed, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.CameraFramesData headSetupFramesData = 12; */
        if (message.headSetupFramesData)
            CameraFramesData.internalBinaryWrite(message.headSetupFramesData, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int32 currentVpuPhaseIndex = 13; */
        if (message.currentVpuPhaseIndex)
            Int32.internalBinaryWrite(message.currentVpuPhaseIndex, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SingleParamInformationMessage
 */
export const SingleParamInformationMessage = new SingleParamInformationMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraDetailsFromPNRequest$Type extends MessageType$<CameraDetailsFromPNRequest> {
    constructor() {
        super("ProtoMessages.CameraDetailsFromPNRequest", [
            { no: 1, name: "partNumber", kind: "message", T: () => String$ }
        ]);
    }
    create(value?: PartialMessage<CameraDetailsFromPNRequest>): CameraDetailsFromPNRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraDetailsFromPNRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraDetailsFromPNRequest): CameraDetailsFromPNRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.String partNumber */ 1:
                    message.partNumber = String$.internalBinaryRead(reader, reader.uint32(), options, message.partNumber);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraDetailsFromPNRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.String partNumber = 1; */
        if (message.partNumber)
            String$.internalBinaryWrite(message.partNumber, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraDetailsFromPNRequest
 */
export const CameraDetailsFromPNRequest = new CameraDetailsFromPNRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraDetailsFromPNResponse$Type extends MessageType$<CameraDetailsFromPNResponse> {
    constructor() {
        super("ProtoMessages.CameraDetailsFromPNResponse", [
            { no: 1, name: "validPN", kind: "message", T: () => Bool },
            { no: 2, name: "data", kind: "message", T: () => CameraData }
        ]);
    }
    create(value?: PartialMessage<CameraDetailsFromPNResponse>): CameraDetailsFromPNResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraDetailsFromPNResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraDetailsFromPNResponse): CameraDetailsFromPNResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool validPN */ 1:
                    message.validPN = Bool.internalBinaryRead(reader, reader.uint32(), options, message.validPN);
                    break;
                case /* ProtoMessages.CameraData data */ 2:
                    message.data = CameraData.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraDetailsFromPNResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool validPN = 1; */
        if (message.validPN)
            Bool.internalBinaryWrite(message.validPN, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.CameraData data = 2; */
        if (message.data)
            CameraData.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraDetailsFromPNResponse
 */
export const CameraDetailsFromPNResponse = new CameraDetailsFromPNResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartPairingVpum$Type extends MessageType$<StartPairingVpum> {
    constructor() {
        super("ProtoMessages.StartPairingVpum", [
            { no: 1, name: "pairingdata", kind: "message", T: () => RunPairingWithData }
        ]);
    }
    create(value?: PartialMessage<StartPairingVpum>): StartPairingVpum {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StartPairingVpum>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StartPairingVpum): StartPairingVpum {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.RunPairingWithData pairingdata */ 1:
                    message.pairingdata = RunPairingWithData.internalBinaryRead(reader, reader.uint32(), options, message.pairingdata);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StartPairingVpum, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.RunPairingWithData pairingdata = 1; */
        if (message.pairingdata)
            RunPairingWithData.internalBinaryWrite(message.pairingdata, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StartPairingVpum
 */
export const StartPairingVpum = new StartPairingVpum$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraData$Type extends MessageType$<CameraData> {
    constructor() {
        super("ProtoMessages.CameraData", [
            { no: 1, name: "numOfCameras", kind: "message", T: () => String$ },
            { no: 2, name: "cameraType", kind: "message", T: () => String$ },
            { no: 3, name: "lensType", kind: "message", T: () => String$ },
            { no: 4, name: "calibration", kind: "message", T: () => String$ },
            { no: 5, name: "systemType", kind: "enum", T: () => ["ProtoMessages.CameraData.Type", CameraData_Type] },
            { no: 6, name: "isFirstPairing", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<CameraData>): CameraData {
        const message = { systemType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraData): CameraData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.String numOfCameras */ 1:
                    message.numOfCameras = String$.internalBinaryRead(reader, reader.uint32(), options, message.numOfCameras);
                    break;
                case /* ProtoMessages.String cameraType */ 2:
                    message.cameraType = String$.internalBinaryRead(reader, reader.uint32(), options, message.cameraType);
                    break;
                case /* ProtoMessages.String lensType */ 3:
                    message.lensType = String$.internalBinaryRead(reader, reader.uint32(), options, message.lensType);
                    break;
                case /* ProtoMessages.String calibration */ 4:
                    message.calibration = String$.internalBinaryRead(reader, reader.uint32(), options, message.calibration);
                    break;
                case /* ProtoMessages.CameraData.Type systemType */ 5:
                    message.systemType = reader.int32();
                    break;
                case /* ProtoMessages.Bool isFirstPairing */ 6:
                    message.isFirstPairing = Bool.internalBinaryRead(reader, reader.uint32(), options, message.isFirstPairing);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.String numOfCameras = 1; */
        if (message.numOfCameras)
            String$.internalBinaryWrite(message.numOfCameras, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String cameraType = 2; */
        if (message.cameraType)
            String$.internalBinaryWrite(message.cameraType, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String lensType = 3; */
        if (message.lensType)
            String$.internalBinaryWrite(message.lensType, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String calibration = 4; */
        if (message.calibration)
            String$.internalBinaryWrite(message.calibration, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.CameraData.Type systemType = 5; */
        if (message.systemType !== 0)
            writer.tag(5, WireType.Varint).int32(message.systemType);
        /* ProtoMessages.Bool isFirstPairing = 6; */
        if (message.isFirstPairing)
            Bool.internalBinaryWrite(message.isFirstPairing, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraData
 */
export const CameraData = new CameraData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RunPairingWithData$Type extends MessageType$<RunPairingWithData> {
    constructor() {
        super("ProtoMessages.RunPairingWithData", [
            { no: 1, name: "systemType", kind: "enum", T: () => ["ProtoMessages.RunPairingWithData.Type", RunPairingWithData_Type] },
            { no: 2, name: "partNumber", kind: "message", T: () => String$ },
            { no: 3, name: "s2CalibrationFolder", kind: "message", T: () => String$ },
            { no: 4, name: "videoStandard", kind: "enum", T: () => ["ProtoMessages.RunPairingWithData.VideoStandard", RunPairingWithData_VideoStandard] },
            { no: 5, name: "primeFrameStandard", kind: "enum", T: () => ["ProtoMessages.RunPairingWithData.FrameStandard", RunPairingWithData_FrameStandard] },
            { no: 6, name: "units", kind: "enum", T: () => ["ProtoMessages.RunPairingWithData.Units", RunPairingWithData_Units] },
            { no: 7, name: "fieldType", kind: "enum", T: () => ["ProtoMessages.RunPairingWithData.FieldType", RunPairingWithData_FieldType] },
            { no: 8, name: "standoff", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "height", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "firmwareModel", kind: "message", T: () => String$ },
            { no: 11, name: "soloCameraManufacturer", kind: "message", T: () => String$ },
            { no: 12, name: "soloCameraModel", kind: "message", T: () => String$ },
            { no: 13, name: "soloCameraUsername", kind: "message", T: () => String$ },
            { no: 14, name: "soloCameraPassword", kind: "message", T: () => String$ },
            { no: 15, name: "serialNumber", kind: "message", T: () => String$ }
        ]);
    }
    create(value?: PartialMessage<RunPairingWithData>): RunPairingWithData {
        const message = { systemType: 0, videoStandard: 0, primeFrameStandard: 0, units: 0, fieldType: 0, standoff: 0, height: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RunPairingWithData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RunPairingWithData): RunPairingWithData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.RunPairingWithData.Type systemType */ 1:
                    message.systemType = reader.int32();
                    break;
                case /* ProtoMessages.String partNumber */ 2:
                    message.partNumber = String$.internalBinaryRead(reader, reader.uint32(), options, message.partNumber);
                    break;
                case /* ProtoMessages.String s2CalibrationFolder */ 3:
                    message.s2CalibrationFolder = String$.internalBinaryRead(reader, reader.uint32(), options, message.s2CalibrationFolder);
                    break;
                case /* ProtoMessages.RunPairingWithData.VideoStandard videoStandard */ 4:
                    message.videoStandard = reader.int32();
                    break;
                case /* ProtoMessages.RunPairingWithData.FrameStandard primeFrameStandard */ 5:
                    message.primeFrameStandard = reader.int32();
                    break;
                case /* ProtoMessages.RunPairingWithData.Units units */ 6:
                    message.units = reader.int32();
                    break;
                case /* ProtoMessages.RunPairingWithData.FieldType fieldType */ 7:
                    message.fieldType = reader.int32();
                    break;
                case /* int32 standoff */ 8:
                    message.standoff = reader.int32();
                    break;
                case /* int32 height */ 9:
                    message.height = reader.int32();
                    break;
                case /* ProtoMessages.String firmwareModel */ 10:
                    message.firmwareModel = String$.internalBinaryRead(reader, reader.uint32(), options, message.firmwareModel);
                    break;
                case /* ProtoMessages.String soloCameraManufacturer */ 11:
                    message.soloCameraManufacturer = String$.internalBinaryRead(reader, reader.uint32(), options, message.soloCameraManufacturer);
                    break;
                case /* ProtoMessages.String soloCameraModel */ 12:
                    message.soloCameraModel = String$.internalBinaryRead(reader, reader.uint32(), options, message.soloCameraModel);
                    break;
                case /* ProtoMessages.String soloCameraUsername */ 13:
                    message.soloCameraUsername = String$.internalBinaryRead(reader, reader.uint32(), options, message.soloCameraUsername);
                    break;
                case /* ProtoMessages.String soloCameraPassword */ 14:
                    message.soloCameraPassword = String$.internalBinaryRead(reader, reader.uint32(), options, message.soloCameraPassword);
                    break;
                case /* ProtoMessages.String serialNumber */ 15:
                    message.serialNumber = String$.internalBinaryRead(reader, reader.uint32(), options, message.serialNumber);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RunPairingWithData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.RunPairingWithData.Type systemType = 1; */
        if (message.systemType !== 0)
            writer.tag(1, WireType.Varint).int32(message.systemType);
        /* ProtoMessages.String partNumber = 2; */
        if (message.partNumber)
            String$.internalBinaryWrite(message.partNumber, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String s2CalibrationFolder = 3; */
        if (message.s2CalibrationFolder)
            String$.internalBinaryWrite(message.s2CalibrationFolder, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.RunPairingWithData.VideoStandard videoStandard = 4; */
        if (message.videoStandard !== 0)
            writer.tag(4, WireType.Varint).int32(message.videoStandard);
        /* ProtoMessages.RunPairingWithData.FrameStandard primeFrameStandard = 5; */
        if (message.primeFrameStandard !== 0)
            writer.tag(5, WireType.Varint).int32(message.primeFrameStandard);
        /* ProtoMessages.RunPairingWithData.Units units = 6; */
        if (message.units !== 0)
            writer.tag(6, WireType.Varint).int32(message.units);
        /* ProtoMessages.RunPairingWithData.FieldType fieldType = 7; */
        if (message.fieldType !== 0)
            writer.tag(7, WireType.Varint).int32(message.fieldType);
        /* int32 standoff = 8; */
        if (message.standoff !== 0)
            writer.tag(8, WireType.Varint).int32(message.standoff);
        /* int32 height = 9; */
        if (message.height !== 0)
            writer.tag(9, WireType.Varint).int32(message.height);
        /* ProtoMessages.String firmwareModel = 10; */
        if (message.firmwareModel)
            String$.internalBinaryWrite(message.firmwareModel, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String soloCameraManufacturer = 11; */
        if (message.soloCameraManufacturer)
            String$.internalBinaryWrite(message.soloCameraManufacturer, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String soloCameraModel = 12; */
        if (message.soloCameraModel)
            String$.internalBinaryWrite(message.soloCameraModel, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String soloCameraUsername = 13; */
        if (message.soloCameraUsername)
            String$.internalBinaryWrite(message.soloCameraUsername, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String soloCameraPassword = 14; */
        if (message.soloCameraPassword)
            String$.internalBinaryWrite(message.soloCameraPassword, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String serialNumber = 15; */
        if (message.serialNumber)
            String$.internalBinaryWrite(message.serialNumber, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.RunPairingWithData
 */
export const RunPairingWithData = new RunPairingWithData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChuFirmwareModelsRequest$Type extends MessageType$<ChuFirmwareModelsRequest> {
    constructor() {
        super("ProtoMessages.ChuFirmwareModelsRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<ChuFirmwareModelsRequest>): ChuFirmwareModelsRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChuFirmwareModelsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChuFirmwareModelsRequest): ChuFirmwareModelsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChuFirmwareModelsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ChuFirmwareModelsRequest
 */
export const ChuFirmwareModelsRequest = new ChuFirmwareModelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class firmwareModel$Type extends MessageType$<firmwareModel> {
    constructor() {
        super("ProtoMessages.firmwareModel", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "default", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<firmwareModel>): firmwareModel {
        const message = { name: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<firmwareModel>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: firmwareModel): firmwareModel {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* ProtoMessages.Bool default */ 2:
                    message.default = Bool.internalBinaryRead(reader, reader.uint32(), options, message.default);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: firmwareModel, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* ProtoMessages.Bool default = 2; */
        if (message.default)
            Bool.internalBinaryWrite(message.default, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.firmwareModel
 */
export const firmwareModel = new firmwareModel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChuFirmwareModelsResponse$Type extends MessageType$<ChuFirmwareModelsResponse> {
    constructor() {
        super("ProtoMessages.ChuFirmwareModelsResponse", [
            { no: 1, name: "firmwareModels", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => firmwareModel },
            { no: 2, name: "success", kind: "message", T: () => Bool },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ChuFirmwareModelsResponse>): ChuFirmwareModelsResponse {
        const message = { firmwareModels: [], errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChuFirmwareModelsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChuFirmwareModelsResponse): ChuFirmwareModelsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.firmwareModel firmwareModels */ 1:
                    message.firmwareModels.push(firmwareModel.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ProtoMessages.Bool success */ 2:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChuFirmwareModelsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.firmwareModel firmwareModels = 1; */
        for (let i = 0; i < message.firmwareModels.length; i++)
            firmwareModel.internalBinaryWrite(message.firmwareModels[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool success = 2; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ChuFirmwareModelsResponse
 */
export const ChuFirmwareModelsResponse = new ChuFirmwareModelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChuSoloCameraModelsRequest$Type extends MessageType$<ChuSoloCameraModelsRequest> {
    constructor() {
        super("ProtoMessages.ChuSoloCameraModelsRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<ChuSoloCameraModelsRequest>): ChuSoloCameraModelsRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChuSoloCameraModelsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChuSoloCameraModelsRequest): ChuSoloCameraModelsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChuSoloCameraModelsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ChuSoloCameraModelsRequest
 */
export const ChuSoloCameraModelsRequest = new ChuSoloCameraModelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SoloManufacturer$Type extends MessageType$<SoloManufacturer> {
    constructor() {
        super("ProtoMessages.SoloManufacturer", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "models", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SoloManufacturer>): SoloManufacturer {
        const message = { name: "", models: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SoloManufacturer>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SoloManufacturer): SoloManufacturer {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* repeated string models */ 2:
                    message.models.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SoloManufacturer, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* repeated string models = 2; */
        for (let i = 0; i < message.models.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.models[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SoloManufacturer
 */
export const SoloManufacturer = new SoloManufacturer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChuSoloCameraModelsResponse$Type extends MessageType$<ChuSoloCameraModelsResponse> {
    constructor() {
        super("ProtoMessages.ChuSoloCameraModelsResponse", [
            { no: 1, name: "manufacturers", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SoloManufacturer },
            { no: 2, name: "success", kind: "message", T: () => Bool },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ChuSoloCameraModelsResponse>): ChuSoloCameraModelsResponse {
        const message = { manufacturers: [], errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChuSoloCameraModelsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChuSoloCameraModelsResponse): ChuSoloCameraModelsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.SoloManufacturer manufacturers */ 1:
                    message.manufacturers.push(SoloManufacturer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ProtoMessages.Bool success */ 2:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChuSoloCameraModelsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.SoloManufacturer manufacturers = 1; */
        for (let i = 0; i < message.manufacturers.length; i++)
            SoloManufacturer.internalBinaryWrite(message.manufacturers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool success = 2; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ChuSoloCameraModelsResponse
 */
export const ChuSoloCameraModelsResponse = new ChuSoloCameraModelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CcuUpdateMessage$Type extends MessageType$<CcuUpdateMessage> {
    constructor() {
        super("ProtoMessages.CcuUpdateMessage", [
            { no: 1, name: "newVPUCCUData", kind: "message", T: () => CCUData }
        ]);
    }
    create(value?: PartialMessage<CcuUpdateMessage>): CcuUpdateMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CcuUpdateMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CcuUpdateMessage): CcuUpdateMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.CCUData newVPUCCUData */ 1:
                    message.newVPUCCUData = CCUData.internalBinaryRead(reader, reader.uint32(), options, message.newVPUCCUData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CcuUpdateMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.CCUData newVPUCCUData = 1; */
        if (message.newVPUCCUData)
            CCUData.internalBinaryWrite(message.newVPUCCUData, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CcuUpdateMessage
 */
export const CcuUpdateMessage = new CcuUpdateMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PanoramaInfo$Type extends MessageType$<PanoramaInfo> {
    constructor() {
        super("ProtoMessages.PanoramaInfo", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "panoramaErrorMessage", kind: "message", T: () => String$ },
            { no: 3, name: "panoramaFile", kind: "message", T: () => String$ },
            { no: 4, name: "ccuData", kind: "message", T: () => CCUData }
        ]);
    }
    create(value?: PartialMessage<PanoramaInfo>): PanoramaInfo {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PanoramaInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PanoramaInfo): PanoramaInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* ProtoMessages.String panoramaErrorMessage */ 2:
                    message.panoramaErrorMessage = String$.internalBinaryRead(reader, reader.uint32(), options, message.panoramaErrorMessage);
                    break;
                case /* ProtoMessages.String panoramaFile */ 3:
                    message.panoramaFile = String$.internalBinaryRead(reader, reader.uint32(), options, message.panoramaFile);
                    break;
                case /* ProtoMessages.CCUData ccuData */ 4:
                    message.ccuData = CCUData.internalBinaryRead(reader, reader.uint32(), options, message.ccuData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PanoramaInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String panoramaErrorMessage = 2; */
        if (message.panoramaErrorMessage)
            String$.internalBinaryWrite(message.panoramaErrorMessage, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String panoramaFile = 3; */
        if (message.panoramaFile)
            String$.internalBinaryWrite(message.panoramaFile, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.CCUData ccuData = 4; */
        if (message.ccuData)
            CCUData.internalBinaryWrite(message.ccuData, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PanoramaInfo
 */
export const PanoramaInfo = new PanoramaInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CCUData$Type extends MessageType$<CCUData> {
    constructor() {
        super("ProtoMessages.CCUData", [
            { no: 1, name: "saturation", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "hue", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "gamma", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "contrast", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "intensity", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "rx1", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "rx2", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "gx1", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "gx2", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 11, name: "bx1", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "bx2", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<CCUData>): CCUData {
        const message = { saturation: 0, hue: 0, gamma: 0, contrast: 0, intensity: 0, rx1: 0, rx2: 0, gx1: 0, gx2: 0, bx1: 0, bx2: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CCUData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CCUData): CCUData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* float saturation */ 1:
                    message.saturation = reader.float();
                    break;
                case /* float hue */ 3:
                    message.hue = reader.float();
                    break;
                case /* float gamma */ 4:
                    message.gamma = reader.float();
                    break;
                case /* float contrast */ 5:
                    message.contrast = reader.float();
                    break;
                case /* float intensity */ 6:
                    message.intensity = reader.float();
                    break;
                case /* float rx1 */ 7:
                    message.rx1 = reader.float();
                    break;
                case /* float rx2 */ 8:
                    message.rx2 = reader.float();
                    break;
                case /* float gx1 */ 9:
                    message.gx1 = reader.float();
                    break;
                case /* float gx2 */ 10:
                    message.gx2 = reader.float();
                    break;
                case /* float bx1 */ 11:
                    message.bx1 = reader.float();
                    break;
                case /* float bx2 */ 12:
                    message.bx2 = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CCUData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* float saturation = 1; */
        if (message.saturation !== 0)
            writer.tag(1, WireType.Bit32).float(message.saturation);
        /* float hue = 3; */
        if (message.hue !== 0)
            writer.tag(3, WireType.Bit32).float(message.hue);
        /* float gamma = 4; */
        if (message.gamma !== 0)
            writer.tag(4, WireType.Bit32).float(message.gamma);
        /* float contrast = 5; */
        if (message.contrast !== 0)
            writer.tag(5, WireType.Bit32).float(message.contrast);
        /* float intensity = 6; */
        if (message.intensity !== 0)
            writer.tag(6, WireType.Bit32).float(message.intensity);
        /* float rx1 = 7; */
        if (message.rx1 !== 0)
            writer.tag(7, WireType.Bit32).float(message.rx1);
        /* float rx2 = 8; */
        if (message.rx2 !== 0)
            writer.tag(8, WireType.Bit32).float(message.rx2);
        /* float gx1 = 9; */
        if (message.gx1 !== 0)
            writer.tag(9, WireType.Bit32).float(message.gx1);
        /* float gx2 = 10; */
        if (message.gx2 !== 0)
            writer.tag(10, WireType.Bit32).float(message.gx2);
        /* float bx1 = 11; */
        if (message.bx1 !== 0)
            writer.tag(11, WireType.Bit32).float(message.bx1);
        /* float bx2 = 12; */
        if (message.bx2 !== 0)
            writer.tag(12, WireType.Bit32).float(message.bx2);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CCUData
 */
export const CCUData = new CCUData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutoLightControlValues$Type extends MessageType$<AutoLightControlValues> {
    constructor() {
        super("ProtoMessages.AutoLightControlValues", [
            { no: 1, name: "autoLightControlLiveValue", kind: "message", T: () => Int32 },
            { no: 2, name: "autoLightControlHealth", kind: "message", T: () => Int32 },
            { no: 3, name: "autoLightControlDesiredBrightness", kind: "message", T: () => Int32 }
        ]);
    }
    create(value?: PartialMessage<AutoLightControlValues>): AutoLightControlValues {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AutoLightControlValues>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutoLightControlValues): AutoLightControlValues {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Int32 autoLightControlLiveValue */ 1:
                    message.autoLightControlLiveValue = Int32.internalBinaryRead(reader, reader.uint32(), options, message.autoLightControlLiveValue);
                    break;
                case /* ProtoMessages.Int32 autoLightControlHealth */ 2:
                    message.autoLightControlHealth = Int32.internalBinaryRead(reader, reader.uint32(), options, message.autoLightControlHealth);
                    break;
                case /* ProtoMessages.Int32 autoLightControlDesiredBrightness */ 3:
                    message.autoLightControlDesiredBrightness = Int32.internalBinaryRead(reader, reader.uint32(), options, message.autoLightControlDesiredBrightness);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutoLightControlValues, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Int32 autoLightControlLiveValue = 1; */
        if (message.autoLightControlLiveValue)
            Int32.internalBinaryWrite(message.autoLightControlLiveValue, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int32 autoLightControlHealth = 2; */
        if (message.autoLightControlHealth)
            Int32.internalBinaryWrite(message.autoLightControlHealth, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int32 autoLightControlDesiredBrightness = 3; */
        if (message.autoLightControlDesiredBrightness)
            Int32.internalBinaryWrite(message.autoLightControlDesiredBrightness, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AutoLightControlValues
 */
export const AutoLightControlValues = new AutoLightControlValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileTransferMessage$Type extends MessageType$<FileTransferMessage> {
    constructor() {
        super("ProtoMessages.FileTransferMessage", [
            { no: 1, name: "fileName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "fileSize", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "content", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 4, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "fileType", kind: "enum", T: () => ["ProtoMessages.FileTransferMessage.FileType", FileTransferMessage_FileType] },
            { no: 7, name: "transferType", kind: "enum", T: () => ["ProtoMessages.FileTransferMessage.TransferType", FileTransferMessage_TransferType] },
            { no: 8, name: "data", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FileTransferMessage>): FileTransferMessage {
        const message = { fileName: "", fileSize: 0n, content: new Uint8Array(0), offset: 0, count: 0, fileType: 0, transferType: 0, data: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FileTransferMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FileTransferMessage): FileTransferMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string fileName */ 1:
                    message.fileName = reader.string();
                    break;
                case /* uint64 fileSize */ 2:
                    message.fileSize = reader.uint64().toBigInt();
                    break;
                case /* bytes content */ 3:
                    message.content = reader.bytes();
                    break;
                case /* int32 offset */ 4:
                    message.offset = reader.int32();
                    break;
                case /* int32 count */ 5:
                    message.count = reader.int32();
                    break;
                case /* ProtoMessages.FileTransferMessage.FileType fileType */ 6:
                    message.fileType = reader.int32();
                    break;
                case /* ProtoMessages.FileTransferMessage.TransferType transferType */ 7:
                    message.transferType = reader.int32();
                    break;
                case /* string data */ 8:
                    message.data = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FileTransferMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string fileName = 1; */
        if (message.fileName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileName);
        /* uint64 fileSize = 2; */
        if (message.fileSize !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.fileSize);
        /* bytes content = 3; */
        if (message.content.length)
            writer.tag(3, WireType.LengthDelimited).bytes(message.content);
        /* int32 offset = 4; */
        if (message.offset !== 0)
            writer.tag(4, WireType.Varint).int32(message.offset);
        /* int32 count = 5; */
        if (message.count !== 0)
            writer.tag(5, WireType.Varint).int32(message.count);
        /* ProtoMessages.FileTransferMessage.FileType fileType = 6; */
        if (message.fileType !== 0)
            writer.tag(6, WireType.Varint).int32(message.fileType);
        /* ProtoMessages.FileTransferMessage.TransferType transferType = 7; */
        if (message.transferType !== 0)
            writer.tag(7, WireType.Varint).int32(message.transferType);
        /* string data = 8; */
        if (message.data !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.FileTransferMessage
 */
export const FileTransferMessage = new FileTransferMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DriveInformation$Type extends MessageType$<DriveInformation> {
    constructor() {
        super("ProtoMessages.DriveInformation", [
            { no: 1, name: "letter", kind: "message", T: () => String$ },
            { no: 2, name: "totalSpace", kind: "message", T: () => Int64 },
            { no: 3, name: "freeSpace", kind: "message", T: () => Int64 },
            { no: 4, name: "toolTip", kind: "message", T: () => String$ }
        ]);
    }
    create(value?: PartialMessage<DriveInformation>): DriveInformation {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DriveInformation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DriveInformation): DriveInformation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.String letter */ 1:
                    message.letter = String$.internalBinaryRead(reader, reader.uint32(), options, message.letter);
                    break;
                case /* ProtoMessages.Int64 totalSpace */ 2:
                    message.totalSpace = Int64.internalBinaryRead(reader, reader.uint32(), options, message.totalSpace);
                    break;
                case /* ProtoMessages.Int64 freeSpace */ 3:
                    message.freeSpace = Int64.internalBinaryRead(reader, reader.uint32(), options, message.freeSpace);
                    break;
                case /* ProtoMessages.String toolTip */ 4:
                    message.toolTip = String$.internalBinaryRead(reader, reader.uint32(), options, message.toolTip);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DriveInformation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.String letter = 1; */
        if (message.letter)
            String$.internalBinaryWrite(message.letter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int64 totalSpace = 2; */
        if (message.totalSpace)
            Int64.internalBinaryWrite(message.totalSpace, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int64 freeSpace = 3; */
        if (message.freeSpace)
            Int64.internalBinaryWrite(message.freeSpace, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String toolTip = 4; */
        if (message.toolTip)
            String$.internalBinaryWrite(message.toolTip, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.DriveInformation
 */
export const DriveInformation = new DriveInformation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StaticInformationMessage$Type extends MessageType$<StaticInformationMessage> {
    constructor() {
        super("ProtoMessages.StaticInformationMessage", [
            { no: 1, name: "venueId", kind: "message", T: () => String$ },
            { no: 2, name: "venueName", kind: "message", T: () => String$ },
            { no: 3, name: "venueDescription", kind: "message", T: () => String$ },
            { no: 4, name: "systemType", kind: "message", T: () => SystemType },
            { no: 5, name: "totalMemory", kind: "message", T: () => String$ },
            { no: 6, name: "switchInfo", kind: "message", T: () => SwitchInfo },
            { no: 7, name: "licenseInfo", kind: "message", T: () => String$ },
            { no: 8, name: "softwareVersion", kind: "message", T: () => String$ },
            { no: 9, name: "nasInfo", kind: "message", T: () => NasInfo },
            { no: 10, name: "gpuName", kind: "message", T: () => String$ },
            { no: 11, name: "gpuDriverVersion", kind: "message", T: () => String$ },
            { no: 12, name: "cameraFPS", kind: "message", T: () => Float },
            { no: 13, name: "cameraPartNumber", kind: "message", T: () => String$ },
            { no: 14, name: "allowFpsChange", kind: "message", T: () => CameraFPSChangeStatus },
            { no: 15, name: "dongleId", kind: "message", T: () => String$ },
            { no: 16, name: "headType", kind: "message", T: () => String$ },
            { no: 17, name: "licenseInfoValid", kind: "message", T: () => Bool },
            { no: 18, name: "audioVolumeUpdated", kind: "message", T: () => Int64 },
            { no: 19, name: "audioGainUpdated", kind: "message", T: () => Int64 },
            { no: 20, name: "networkInfo", kind: "message", T: () => NetworkInfo },
            { no: 21, name: "cpuName", kind: "message", T: () => String$ },
            { no: 22, name: "vpuMac", kind: "message", T: () => String$ },
            { no: 23, name: "venueEnv", kind: "message", T: () => Environment },
            { no: 24, name: "OemSerialNumber", kind: "message", jsonName: "OemSerialNumber", T: () => String$ },
            { no: 25, name: "cameraHeaterMode", kind: "message", T: () => HeaterMode },
            { no: 26, name: "cameraRevision", kind: "message", T: () => String$ },
            { no: 27, name: "audioEqualizerMode", kind: "message", T: () => AudioEqualizerMode }
        ]);
    }
    create(value?: PartialMessage<StaticInformationMessage>): StaticInformationMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StaticInformationMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StaticInformationMessage): StaticInformationMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.String venueId */ 1:
                    message.venueId = String$.internalBinaryRead(reader, reader.uint32(), options, message.venueId);
                    break;
                case /* ProtoMessages.String venueName */ 2:
                    message.venueName = String$.internalBinaryRead(reader, reader.uint32(), options, message.venueName);
                    break;
                case /* ProtoMessages.String venueDescription */ 3:
                    message.venueDescription = String$.internalBinaryRead(reader, reader.uint32(), options, message.venueDescription);
                    break;
                case /* ProtoMessages.SystemType systemType */ 4:
                    message.systemType = SystemType.internalBinaryRead(reader, reader.uint32(), options, message.systemType);
                    break;
                case /* ProtoMessages.String totalMemory */ 5:
                    message.totalMemory = String$.internalBinaryRead(reader, reader.uint32(), options, message.totalMemory);
                    break;
                case /* ProtoMessages.SwitchInfo switchInfo */ 6:
                    message.switchInfo = SwitchInfo.internalBinaryRead(reader, reader.uint32(), options, message.switchInfo);
                    break;
                case /* ProtoMessages.String licenseInfo */ 7:
                    message.licenseInfo = String$.internalBinaryRead(reader, reader.uint32(), options, message.licenseInfo);
                    break;
                case /* ProtoMessages.String softwareVersion */ 8:
                    message.softwareVersion = String$.internalBinaryRead(reader, reader.uint32(), options, message.softwareVersion);
                    break;
                case /* ProtoMessages.NasInfo nasInfo */ 9:
                    message.nasInfo = NasInfo.internalBinaryRead(reader, reader.uint32(), options, message.nasInfo);
                    break;
                case /* ProtoMessages.String gpuName */ 10:
                    message.gpuName = String$.internalBinaryRead(reader, reader.uint32(), options, message.gpuName);
                    break;
                case /* ProtoMessages.String gpuDriverVersion */ 11:
                    message.gpuDriverVersion = String$.internalBinaryRead(reader, reader.uint32(), options, message.gpuDriverVersion);
                    break;
                case /* ProtoMessages.Float cameraFPS */ 12:
                    message.cameraFPS = Float.internalBinaryRead(reader, reader.uint32(), options, message.cameraFPS);
                    break;
                case /* ProtoMessages.String cameraPartNumber */ 13:
                    message.cameraPartNumber = String$.internalBinaryRead(reader, reader.uint32(), options, message.cameraPartNumber);
                    break;
                case /* ProtoMessages.CameraFPSChangeStatus allowFpsChange */ 14:
                    message.allowFpsChange = CameraFPSChangeStatus.internalBinaryRead(reader, reader.uint32(), options, message.allowFpsChange);
                    break;
                case /* ProtoMessages.String dongleId */ 15:
                    message.dongleId = String$.internalBinaryRead(reader, reader.uint32(), options, message.dongleId);
                    break;
                case /* ProtoMessages.String headType */ 16:
                    message.headType = String$.internalBinaryRead(reader, reader.uint32(), options, message.headType);
                    break;
                case /* ProtoMessages.Bool licenseInfoValid */ 17:
                    message.licenseInfoValid = Bool.internalBinaryRead(reader, reader.uint32(), options, message.licenseInfoValid);
                    break;
                case /* ProtoMessages.Int64 audioVolumeUpdated */ 18:
                    message.audioVolumeUpdated = Int64.internalBinaryRead(reader, reader.uint32(), options, message.audioVolumeUpdated);
                    break;
                case /* ProtoMessages.Int64 audioGainUpdated */ 19:
                    message.audioGainUpdated = Int64.internalBinaryRead(reader, reader.uint32(), options, message.audioGainUpdated);
                    break;
                case /* ProtoMessages.NetworkInfo networkInfo */ 20:
                    message.networkInfo = NetworkInfo.internalBinaryRead(reader, reader.uint32(), options, message.networkInfo);
                    break;
                case /* ProtoMessages.String cpuName */ 21:
                    message.cpuName = String$.internalBinaryRead(reader, reader.uint32(), options, message.cpuName);
                    break;
                case /* ProtoMessages.String vpuMac */ 22:
                    message.vpuMac = String$.internalBinaryRead(reader, reader.uint32(), options, message.vpuMac);
                    break;
                case /* ProtoMessages.Environment venueEnv */ 23:
                    message.venueEnv = Environment.internalBinaryRead(reader, reader.uint32(), options, message.venueEnv);
                    break;
                case /* ProtoMessages.String OemSerialNumber = 24 [json_name = "OemSerialNumber"];*/ 24:
                    message.oemSerialNumber = String$.internalBinaryRead(reader, reader.uint32(), options, message.oemSerialNumber);
                    break;
                case /* ProtoMessages.HeaterMode cameraHeaterMode */ 25:
                    message.cameraHeaterMode = HeaterMode.internalBinaryRead(reader, reader.uint32(), options, message.cameraHeaterMode);
                    break;
                case /* ProtoMessages.String cameraRevision */ 26:
                    message.cameraRevision = String$.internalBinaryRead(reader, reader.uint32(), options, message.cameraRevision);
                    break;
                case /* ProtoMessages.AudioEqualizerMode audioEqualizerMode */ 27:
                    message.audioEqualizerMode = AudioEqualizerMode.internalBinaryRead(reader, reader.uint32(), options, message.audioEqualizerMode);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StaticInformationMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.String venueId = 1; */
        if (message.venueId)
            String$.internalBinaryWrite(message.venueId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String venueName = 2; */
        if (message.venueName)
            String$.internalBinaryWrite(message.venueName, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String venueDescription = 3; */
        if (message.venueDescription)
            String$.internalBinaryWrite(message.venueDescription, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.SystemType systemType = 4; */
        if (message.systemType)
            SystemType.internalBinaryWrite(message.systemType, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String totalMemory = 5; */
        if (message.totalMemory)
            String$.internalBinaryWrite(message.totalMemory, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.SwitchInfo switchInfo = 6; */
        if (message.switchInfo)
            SwitchInfo.internalBinaryWrite(message.switchInfo, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String licenseInfo = 7; */
        if (message.licenseInfo)
            String$.internalBinaryWrite(message.licenseInfo, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String softwareVersion = 8; */
        if (message.softwareVersion)
            String$.internalBinaryWrite(message.softwareVersion, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.NasInfo nasInfo = 9; */
        if (message.nasInfo)
            NasInfo.internalBinaryWrite(message.nasInfo, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String gpuName = 10; */
        if (message.gpuName)
            String$.internalBinaryWrite(message.gpuName, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String gpuDriverVersion = 11; */
        if (message.gpuDriverVersion)
            String$.internalBinaryWrite(message.gpuDriverVersion, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Float cameraFPS = 12; */
        if (message.cameraFPS)
            Float.internalBinaryWrite(message.cameraFPS, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String cameraPartNumber = 13; */
        if (message.cameraPartNumber)
            String$.internalBinaryWrite(message.cameraPartNumber, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.CameraFPSChangeStatus allowFpsChange = 14; */
        if (message.allowFpsChange)
            CameraFPSChangeStatus.internalBinaryWrite(message.allowFpsChange, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String dongleId = 15; */
        if (message.dongleId)
            String$.internalBinaryWrite(message.dongleId, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String headType = 16; */
        if (message.headType)
            String$.internalBinaryWrite(message.headType, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool licenseInfoValid = 17; */
        if (message.licenseInfoValid)
            Bool.internalBinaryWrite(message.licenseInfoValid, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int64 audioVolumeUpdated = 18; */
        if (message.audioVolumeUpdated)
            Int64.internalBinaryWrite(message.audioVolumeUpdated, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Int64 audioGainUpdated = 19; */
        if (message.audioGainUpdated)
            Int64.internalBinaryWrite(message.audioGainUpdated, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.NetworkInfo networkInfo = 20; */
        if (message.networkInfo)
            NetworkInfo.internalBinaryWrite(message.networkInfo, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String cpuName = 21; */
        if (message.cpuName)
            String$.internalBinaryWrite(message.cpuName, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String vpuMac = 22; */
        if (message.vpuMac)
            String$.internalBinaryWrite(message.vpuMac, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Environment venueEnv = 23; */
        if (message.venueEnv)
            Environment.internalBinaryWrite(message.venueEnv, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String OemSerialNumber = 24 [json_name = "OemSerialNumber"]; */
        if (message.oemSerialNumber)
            String$.internalBinaryWrite(message.oemSerialNumber, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.HeaterMode cameraHeaterMode = 25; */
        if (message.cameraHeaterMode)
            HeaterMode.internalBinaryWrite(message.cameraHeaterMode, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String cameraRevision = 26; */
        if (message.cameraRevision)
            String$.internalBinaryWrite(message.cameraRevision, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.AudioEqualizerMode audioEqualizerMode = 27; */
        if (message.audioEqualizerMode)
            AudioEqualizerMode.internalBinaryWrite(message.audioEqualizerMode, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StaticInformationMessage
 */
export const StaticInformationMessage = new StaticInformationMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Environment$Type extends MessageType$<Environment> {
    constructor() {
        super("ProtoMessages.Environment", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.Environment.Env", Environment_Env] }
        ]);
    }
    create(value?: PartialMessage<Environment>): Environment {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Environment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Environment): Environment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Environment.Env value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Environment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Environment.Env value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.Environment
 */
export const Environment = new Environment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventInfo$Type extends MessageType$<EventInfo> {
    constructor() {
        super("ProtoMessages.EventInfo", [
            { no: 1, name: "name", kind: "message", T: () => String$ },
            { no: 2, name: "startTime", kind: "message", T: () => Uint64 },
            { no: 3, name: "endTime", kind: "message", T: () => Uint64 },
            { no: 4, name: "sportType", kind: "message", T: () => SportsType }
        ]);
    }
    create(value?: PartialMessage<EventInfo>): EventInfo {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<EventInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EventInfo): EventInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.String name */ 1:
                    message.name = String$.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* ProtoMessages.Uint64 startTime */ 2:
                    message.startTime = Uint64.internalBinaryRead(reader, reader.uint32(), options, message.startTime);
                    break;
                case /* ProtoMessages.Uint64 endTime */ 3:
                    message.endTime = Uint64.internalBinaryRead(reader, reader.uint32(), options, message.endTime);
                    break;
                case /* ProtoMessages.SportsType sportType */ 4:
                    message.sportType = SportsType.internalBinaryRead(reader, reader.uint32(), options, message.sportType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EventInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.String name = 1; */
        if (message.name)
            String$.internalBinaryWrite(message.name, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Uint64 startTime = 2; */
        if (message.startTime)
            Uint64.internalBinaryWrite(message.startTime, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Uint64 endTime = 3; */
        if (message.endTime)
            Uint64.internalBinaryWrite(message.endTime, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.SportsType sportType = 4; */
        if (message.sportType)
            SportsType.internalBinaryWrite(message.sportType, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.EventInfo
 */
export const EventInfo = new EventInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkingHours$Type extends MessageType$<WorkingHours> {
    constructor() {
        super("ProtoMessages.WorkingHours", [
            { no: 1, name: "from", kind: "message", T: () => String$ },
            { no: 2, name: "to", kind: "message", T: () => String$ }
        ]);
    }
    create(value?: PartialMessage<WorkingHours>): WorkingHours {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<WorkingHours>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkingHours): WorkingHours {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.String from */ 1:
                    message.from = String$.internalBinaryRead(reader, reader.uint32(), options, message.from);
                    break;
                case /* ProtoMessages.String to */ 2:
                    message.to = String$.internalBinaryRead(reader, reader.uint32(), options, message.to);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkingHours, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.String from = 1; */
        if (message.from)
            String$.internalBinaryWrite(message.from, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String to = 2; */
        if (message.to)
            String$.internalBinaryWrite(message.to, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.WorkingHours
 */
export const WorkingHours = new WorkingHours$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamsInfo$Type extends MessageType$<StreamsInfo> {
    constructor() {
        super("ProtoMessages.StreamsInfo", [
            { no: 1, name: "hdEnabled", kind: "message", T: () => Bool },
            { no: 2, name: "hdBandwidth", kind: "message", T: () => Float },
            { no: 3, name: "hdUrl", kind: "message", T: () => String$ },
            { no: 4, name: "panoEnabled", kind: "message", T: () => Bool },
            { no: 5, name: "panoBandwidth", kind: "message", T: () => Float },
            { no: 6, name: "panoUrl", kind: "message", T: () => String$ },
            { no: 7, name: "adaptiveBitrateEnabled", kind: "message", T: () => Bool },
            { no: 8, name: "hdVideoFormat", kind: "message", T: () => String$ },
            { no: 10, name: "cameraEnabled", kind: "message", T: () => Bool },
            { no: 11, name: "cameraBandwidth", kind: "message", T: () => Float },
            { no: 12, name: "cameraUrl", kind: "message", T: () => String$ },
            { no: 13, name: "cameraVideoFormat", kind: "message", T: () => String$ },
            { no: 15, name: "panoGraphicsEnabled", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<StreamsInfo>): StreamsInfo {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StreamsInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamsInfo): StreamsInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool hdEnabled */ 1:
                    message.hdEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.hdEnabled);
                    break;
                case /* ProtoMessages.Float hdBandwidth */ 2:
                    message.hdBandwidth = Float.internalBinaryRead(reader, reader.uint32(), options, message.hdBandwidth);
                    break;
                case /* ProtoMessages.String hdUrl */ 3:
                    message.hdUrl = String$.internalBinaryRead(reader, reader.uint32(), options, message.hdUrl);
                    break;
                case /* ProtoMessages.Bool panoEnabled */ 4:
                    message.panoEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.panoEnabled);
                    break;
                case /* ProtoMessages.Float panoBandwidth */ 5:
                    message.panoBandwidth = Float.internalBinaryRead(reader, reader.uint32(), options, message.panoBandwidth);
                    break;
                case /* ProtoMessages.String panoUrl */ 6:
                    message.panoUrl = String$.internalBinaryRead(reader, reader.uint32(), options, message.panoUrl);
                    break;
                case /* ProtoMessages.Bool adaptiveBitrateEnabled */ 7:
                    message.adaptiveBitrateEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.adaptiveBitrateEnabled);
                    break;
                case /* ProtoMessages.String hdVideoFormat */ 8:
                    message.hdVideoFormat = String$.internalBinaryRead(reader, reader.uint32(), options, message.hdVideoFormat);
                    break;
                case /* ProtoMessages.Bool cameraEnabled */ 10:
                    message.cameraEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.cameraEnabled);
                    break;
                case /* ProtoMessages.Float cameraBandwidth */ 11:
                    message.cameraBandwidth = Float.internalBinaryRead(reader, reader.uint32(), options, message.cameraBandwidth);
                    break;
                case /* ProtoMessages.String cameraUrl */ 12:
                    message.cameraUrl = String$.internalBinaryRead(reader, reader.uint32(), options, message.cameraUrl);
                    break;
                case /* ProtoMessages.String cameraVideoFormat */ 13:
                    message.cameraVideoFormat = String$.internalBinaryRead(reader, reader.uint32(), options, message.cameraVideoFormat);
                    break;
                case /* ProtoMessages.Bool panoGraphicsEnabled */ 15:
                    message.panoGraphicsEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.panoGraphicsEnabled);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamsInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool hdEnabled = 1; */
        if (message.hdEnabled)
            Bool.internalBinaryWrite(message.hdEnabled, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Float hdBandwidth = 2; */
        if (message.hdBandwidth)
            Float.internalBinaryWrite(message.hdBandwidth, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String hdUrl = 3; */
        if (message.hdUrl)
            String$.internalBinaryWrite(message.hdUrl, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool panoEnabled = 4; */
        if (message.panoEnabled)
            Bool.internalBinaryWrite(message.panoEnabled, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Float panoBandwidth = 5; */
        if (message.panoBandwidth)
            Float.internalBinaryWrite(message.panoBandwidth, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String panoUrl = 6; */
        if (message.panoUrl)
            String$.internalBinaryWrite(message.panoUrl, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool adaptiveBitrateEnabled = 7; */
        if (message.adaptiveBitrateEnabled)
            Bool.internalBinaryWrite(message.adaptiveBitrateEnabled, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String hdVideoFormat = 8; */
        if (message.hdVideoFormat)
            String$.internalBinaryWrite(message.hdVideoFormat, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool cameraEnabled = 10; */
        if (message.cameraEnabled)
            Bool.internalBinaryWrite(message.cameraEnabled, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Float cameraBandwidth = 11; */
        if (message.cameraBandwidth)
            Float.internalBinaryWrite(message.cameraBandwidth, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String cameraUrl = 12; */
        if (message.cameraUrl)
            String$.internalBinaryWrite(message.cameraUrl, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String cameraVideoFormat = 13; */
        if (message.cameraVideoFormat)
            String$.internalBinaryWrite(message.cameraVideoFormat, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool panoGraphicsEnabled = 15; */
        if (message.panoGraphicsEnabled)
            Bool.internalBinaryWrite(message.panoGraphicsEnabled, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StreamsInfo
 */
export const StreamsInfo = new StreamsInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SwitchInfo$Type extends MessageType$<SwitchInfo> {
    constructor() {
        super("ProtoMessages.SwitchInfo", [
            { no: 1, name: "ip", kind: "message", T: () => String$ },
            { no: 2, name: "type", kind: "message", T: () => SwitchType }
        ]);
    }
    create(value?: PartialMessage<SwitchInfo>): SwitchInfo {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SwitchInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SwitchInfo): SwitchInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.String ip */ 1:
                    message.ip = String$.internalBinaryRead(reader, reader.uint32(), options, message.ip);
                    break;
                case /* ProtoMessages.SwitchType type */ 2:
                    message.type = SwitchType.internalBinaryRead(reader, reader.uint32(), options, message.type);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SwitchInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.String ip = 1; */
        if (message.ip)
            String$.internalBinaryWrite(message.ip, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.SwitchType type = 2; */
        if (message.type)
            SwitchType.internalBinaryWrite(message.type, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SwitchInfo
 */
export const SwitchInfo = new SwitchInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GraphicEngineInfo$Type extends MessageType$<GraphicEngineInfo> {
    constructor() {
        super("ProtoMessages.GraphicEngineInfo", [
            { no: 1, name: "sbType", kind: "enum", T: () => ["ProtoMessages.GraphicEngineInfo.ScoreboardType", GraphicEngineInfo_ScoreboardType] },
            { no: 2, name: "provider", kind: "enum", T: () => ["ProtoMessages.GraphicEngineInfo.GraphicsDataProvider", GraphicEngineInfo_GraphicsDataProvider] },
            { no: 3, name: "uiType", kind: "enum", T: () => ["ProtoMessages.GraphicEngineInfo.GraphicsUiType", GraphicEngineInfo_GraphicsUiType] },
            { no: 4, name: "ip", kind: "message", T: () => String$ },
            { no: 5, name: "pipUrl", kind: "message", T: () => String$ },
            { no: 6, name: "useOcr", kind: "message", T: () => Bool },
            { no: 7, name: "authentication", kind: "message", T: () => String$ },
            { no: 8, name: "useEnhancedPip", kind: "message", T: () => Bool },
            { no: 9, name: "isOutdoorSports", kind: "message", T: () => Bool },
            { no: 10, name: "multiSportEnabledInVpum", kind: "message", T: () => Bool },
            { no: 11, name: "AlcOcrIsEnabled", kind: "message", jsonName: "AlcOcrIsEnabled", T: () => Bool },
            { no: 12, name: "ocrAiEnabledInVpum", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<GraphicEngineInfo>): GraphicEngineInfo {
        const message = { sbType: 0, provider: 0, uiType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GraphicEngineInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GraphicEngineInfo): GraphicEngineInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.GraphicEngineInfo.ScoreboardType sbType */ 1:
                    message.sbType = reader.int32();
                    break;
                case /* ProtoMessages.GraphicEngineInfo.GraphicsDataProvider provider */ 2:
                    message.provider = reader.int32();
                    break;
                case /* ProtoMessages.GraphicEngineInfo.GraphicsUiType uiType */ 3:
                    message.uiType = reader.int32();
                    break;
                case /* ProtoMessages.String ip */ 4:
                    message.ip = String$.internalBinaryRead(reader, reader.uint32(), options, message.ip);
                    break;
                case /* ProtoMessages.String pipUrl */ 5:
                    message.pipUrl = String$.internalBinaryRead(reader, reader.uint32(), options, message.pipUrl);
                    break;
                case /* ProtoMessages.Bool useOcr */ 6:
                    message.useOcr = Bool.internalBinaryRead(reader, reader.uint32(), options, message.useOcr);
                    break;
                case /* ProtoMessages.String authentication */ 7:
                    message.authentication = String$.internalBinaryRead(reader, reader.uint32(), options, message.authentication);
                    break;
                case /* ProtoMessages.Bool useEnhancedPip */ 8:
                    message.useEnhancedPip = Bool.internalBinaryRead(reader, reader.uint32(), options, message.useEnhancedPip);
                    break;
                case /* ProtoMessages.Bool isOutdoorSports */ 9:
                    message.isOutdoorSports = Bool.internalBinaryRead(reader, reader.uint32(), options, message.isOutdoorSports);
                    break;
                case /* ProtoMessages.Bool multiSportEnabledInVpum */ 10:
                    message.multiSportEnabledInVpum = Bool.internalBinaryRead(reader, reader.uint32(), options, message.multiSportEnabledInVpum);
                    break;
                case /* ProtoMessages.Bool AlcOcrIsEnabled = 11 [json_name = "AlcOcrIsEnabled"];*/ 11:
                    message.alcOcrIsEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.alcOcrIsEnabled);
                    break;
                case /* ProtoMessages.Bool ocrAiEnabledInVpum */ 12:
                    message.ocrAiEnabledInVpum = Bool.internalBinaryRead(reader, reader.uint32(), options, message.ocrAiEnabledInVpum);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GraphicEngineInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.GraphicEngineInfo.ScoreboardType sbType = 1; */
        if (message.sbType !== 0)
            writer.tag(1, WireType.Varint).int32(message.sbType);
        /* ProtoMessages.GraphicEngineInfo.GraphicsDataProvider provider = 2; */
        if (message.provider !== 0)
            writer.tag(2, WireType.Varint).int32(message.provider);
        /* ProtoMessages.GraphicEngineInfo.GraphicsUiType uiType = 3; */
        if (message.uiType !== 0)
            writer.tag(3, WireType.Varint).int32(message.uiType);
        /* ProtoMessages.String ip = 4; */
        if (message.ip)
            String$.internalBinaryWrite(message.ip, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String pipUrl = 5; */
        if (message.pipUrl)
            String$.internalBinaryWrite(message.pipUrl, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool useOcr = 6; */
        if (message.useOcr)
            Bool.internalBinaryWrite(message.useOcr, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String authentication = 7; */
        if (message.authentication)
            String$.internalBinaryWrite(message.authentication, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool useEnhancedPip = 8; */
        if (message.useEnhancedPip)
            Bool.internalBinaryWrite(message.useEnhancedPip, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool isOutdoorSports = 9; */
        if (message.isOutdoorSports)
            Bool.internalBinaryWrite(message.isOutdoorSports, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool multiSportEnabledInVpum = 10; */
        if (message.multiSportEnabledInVpum)
            Bool.internalBinaryWrite(message.multiSportEnabledInVpum, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool AlcOcrIsEnabled = 11 [json_name = "AlcOcrIsEnabled"]; */
        if (message.alcOcrIsEnabled)
            Bool.internalBinaryWrite(message.alcOcrIsEnabled, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool ocrAiEnabledInVpum = 12; */
        if (message.ocrAiEnabledInVpum)
            Bool.internalBinaryWrite(message.ocrAiEnabledInVpum, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.GraphicEngineInfo
 */
export const GraphicEngineInfo = new GraphicEngineInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NetworkSpeedTestRequest$Type extends MessageType$<NetworkSpeedTestRequest> {
    constructor() {
        super("ProtoMessages.NetworkSpeedTestRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<NetworkSpeedTestRequest>): NetworkSpeedTestRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<NetworkSpeedTestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NetworkSpeedTestRequest): NetworkSpeedTestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NetworkSpeedTestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.NetworkSpeedTestRequest
 */
export const NetworkSpeedTestRequest = new NetworkSpeedTestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NetworkSpeedTestResponse$Type extends MessageType$<NetworkSpeedTestResponse> {
    constructor() {
        super("ProtoMessages.NetworkSpeedTestResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "speedTest", kind: "message", T: () => NetworkSpeedTestResult }
        ]);
    }
    create(value?: PartialMessage<NetworkSpeedTestResponse>): NetworkSpeedTestResponse {
        const message = { errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<NetworkSpeedTestResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NetworkSpeedTestResponse): NetworkSpeedTestResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* ProtoMessages.NetworkSpeedTestResult speedTest */ 3:
                    message.speedTest = NetworkSpeedTestResult.internalBinaryRead(reader, reader.uint32(), options, message.speedTest);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NetworkSpeedTestResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* ProtoMessages.NetworkSpeedTestResult speedTest = 3; */
        if (message.speedTest)
            NetworkSpeedTestResult.internalBinaryWrite(message.speedTest, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.NetworkSpeedTestResponse
 */
export const NetworkSpeedTestResponse = new NetworkSpeedTestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NetworkSpeedTestResult$Type extends MessageType$<NetworkSpeedTestResult> {
    constructor() {
        super("ProtoMessages.NetworkSpeedTestResult", [
            { no: 1, name: "downloadMbps", kind: "message", T: () => Double },
            { no: 2, name: "uploadMbps", kind: "message", T: () => Double },
            { no: 3, name: "pingMs", kind: "message", T: () => Double }
        ]);
    }
    create(value?: PartialMessage<NetworkSpeedTestResult>): NetworkSpeedTestResult {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<NetworkSpeedTestResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NetworkSpeedTestResult): NetworkSpeedTestResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Double downloadMbps */ 1:
                    message.downloadMbps = Double.internalBinaryRead(reader, reader.uint32(), options, message.downloadMbps);
                    break;
                case /* ProtoMessages.Double uploadMbps */ 2:
                    message.uploadMbps = Double.internalBinaryRead(reader, reader.uint32(), options, message.uploadMbps);
                    break;
                case /* ProtoMessages.Double pingMs */ 3:
                    message.pingMs = Double.internalBinaryRead(reader, reader.uint32(), options, message.pingMs);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NetworkSpeedTestResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Double downloadMbps = 1; */
        if (message.downloadMbps)
            Double.internalBinaryWrite(message.downloadMbps, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Double uploadMbps = 2; */
        if (message.uploadMbps)
            Double.internalBinaryWrite(message.uploadMbps, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Double pingMs = 3; */
        if (message.pingMs)
            Double.internalBinaryWrite(message.pingMs, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.NetworkSpeedTestResult
 */
export const NetworkSpeedTestResult = new NetworkSpeedTestResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VpuDataResponse$Type extends MessageType$<VpuDataResponse> {
    constructor() {
        super("ProtoMessages.VpuDataResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "vpuSerialNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "vpuPartNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VpuDataResponse>): VpuDataResponse {
        const message = { errorMessage: "", vpuSerialNumber: "", vpuPartNumber: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VpuDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VpuDataResponse): VpuDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* string vpuSerialNumber */ 3:
                    message.vpuSerialNumber = reader.string();
                    break;
                case /* string vpuPartNumber */ 4:
                    message.vpuPartNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VpuDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* string vpuSerialNumber = 3; */
        if (message.vpuSerialNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.vpuSerialNumber);
        /* string vpuPartNumber = 4; */
        if (message.vpuPartNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.vpuPartNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VpuDataResponse
 */
export const VpuDataResponse = new VpuDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VpuDataRequest$Type extends MessageType$<VpuDataRequest> {
    constructor() {
        super("ProtoMessages.VpuDataRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<VpuDataRequest>): VpuDataRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VpuDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VpuDataRequest): VpuDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VpuDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VpuDataRequest
 */
export const VpuDataRequest = new VpuDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VersionMessage$Type extends MessageType$<VersionMessage> {
    constructor() {
        super("ProtoMessages.VersionMessage", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VersionMessage>): VersionMessage {
        const message = { version: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VersionMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VersionMessage): VersionMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string version */ 1:
                    message.version = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VersionMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string version = 1; */
        if (message.version !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.version);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VersionMessage
 */
export const VersionMessage = new VersionMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OperatingSystemMessage$Type extends MessageType$<OperatingSystemMessage> {
    constructor() {
        super("ProtoMessages.OperatingSystemMessage", [
            { no: 1, name: "OsType", kind: "enum", jsonName: "OsType", T: () => ["ProtoMessages.OperatingSystemMessage.Type", OperatingSystemMessage_Type] }
        ]);
    }
    create(value?: PartialMessage<OperatingSystemMessage>): OperatingSystemMessage {
        const message = { osType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OperatingSystemMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OperatingSystemMessage): OperatingSystemMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.OperatingSystemMessage.Type OsType = 1 [json_name = "OsType"];*/ 1:
                    message.osType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OperatingSystemMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.OperatingSystemMessage.Type OsType = 1 [json_name = "OsType"]; */
        if (message.osType !== 0)
            writer.tag(1, WireType.Varint).int32(message.osType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OperatingSystemMessage
 */
export const OperatingSystemMessage = new OperatingSystemMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Token$Type extends MessageType$<Token> {
    constructor() {
        super("ProtoMessages.Token", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Token>): Token {
        const message = { token: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Token>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Token): Token {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Token, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.Token
 */
export const Token = new Token$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToggleSetupMode$Type extends MessageType$<ToggleSetupMode> {
    constructor() {
        super("ProtoMessages.ToggleSetupMode", [
            { no: 1, name: "activate", kind: "message", T: () => Bool },
            { no: 2, name: "vpuStatus", kind: "message", T: () => String$ },
            { no: 3, name: "isPairing", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<ToggleSetupMode>): ToggleSetupMode {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ToggleSetupMode>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToggleSetupMode): ToggleSetupMode {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool activate */ 1:
                    message.activate = Bool.internalBinaryRead(reader, reader.uint32(), options, message.activate);
                    break;
                case /* ProtoMessages.String vpuStatus */ 2:
                    message.vpuStatus = String$.internalBinaryRead(reader, reader.uint32(), options, message.vpuStatus);
                    break;
                case /* ProtoMessages.Bool isPairing */ 3:
                    message.isPairing = Bool.internalBinaryRead(reader, reader.uint32(), options, message.isPairing);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToggleSetupMode, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool activate = 1; */
        if (message.activate)
            Bool.internalBinaryWrite(message.activate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String vpuStatus = 2; */
        if (message.vpuStatus)
            String$.internalBinaryWrite(message.vpuStatus, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool isPairing = 3; */
        if (message.isPairing)
            Bool.internalBinaryWrite(message.isPairing, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ToggleSetupMode
 */
export const ToggleSetupMode = new ToggleSetupMode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraFramesData$Type extends MessageType$<CameraFramesData> {
    constructor() {
        super("ProtoMessages.CameraFramesData", [
            { no: 1, name: "numOfFrames", kind: "message", T: () => Int32 },
            { no: 2, name: "Result", kind: "message", jsonName: "Result", T: () => String$ },
            { no: 3, name: "frames", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => String$ }
        ]);
    }
    create(value?: PartialMessage<CameraFramesData>): CameraFramesData {
        const message = { frames: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraFramesData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraFramesData): CameraFramesData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Int32 numOfFrames */ 1:
                    message.numOfFrames = Int32.internalBinaryRead(reader, reader.uint32(), options, message.numOfFrames);
                    break;
                case /* ProtoMessages.String Result = 2 [json_name = "Result"];*/ 2:
                    message.result = String$.internalBinaryRead(reader, reader.uint32(), options, message.result);
                    break;
                case /* repeated ProtoMessages.String frames */ 3:
                    message.frames.push(String$.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraFramesData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Int32 numOfFrames = 1; */
        if (message.numOfFrames)
            Int32.internalBinaryWrite(message.numOfFrames, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.String Result = 2 [json_name = "Result"]; */
        if (message.result)
            String$.internalBinaryWrite(message.result, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.String frames = 3; */
        for (let i = 0; i < message.frames.length; i++)
            String$.internalBinaryWrite(message.frames[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraFramesData
 */
export const CameraFramesData = new CameraFramesData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestPorts$Type extends MessageType$<TestPorts> {
    constructor() {
        super("ProtoMessages.TestPorts", [
            { no: 1, name: "portNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "index", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "testTCP", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "testUDP", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TestPorts>): TestPorts {
        const message = { portNumber: 0, index: "", testTCP: false, testUDP: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TestPorts>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestPorts): TestPorts {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 portNumber */ 1:
                    message.portNumber = reader.int32();
                    break;
                case /* string index */ 2:
                    message.index = reader.string();
                    break;
                case /* bool testTCP */ 3:
                    message.testTCP = reader.bool();
                    break;
                case /* bool testUDP */ 4:
                    message.testUDP = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestPorts, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 portNumber = 1; */
        if (message.portNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.portNumber);
        /* string index = 2; */
        if (message.index !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.index);
        /* bool testTCP = 3; */
        if (message.testTCP !== false)
            writer.tag(3, WireType.Varint).bool(message.testTCP);
        /* bool testUDP = 4; */
        if (message.testUDP !== false)
            writer.tag(4, WireType.Varint).bool(message.testUDP);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.TestPorts
 */
export const TestPorts = new TestPorts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestPortsResult$Type extends MessageType$<TestPortsResult> {
    constructor() {
        super("ProtoMessages.TestPortsResult", [
            { no: 1, name: "portNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "index", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "testTCPResult", kind: "enum", T: () => ["ProtoMessages.TestPortsResult.Result", TestPortsResult_Result] },
            { no: 4, name: "testUDPResult", kind: "enum", T: () => ["ProtoMessages.TestPortsResult.Result", TestPortsResult_Result] }
        ]);
    }
    create(value?: PartialMessage<TestPortsResult>): TestPortsResult {
        const message = { portNumber: 0, index: "", testTCPResult: 0, testUDPResult: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TestPortsResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestPortsResult): TestPortsResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 portNumber */ 1:
                    message.portNumber = reader.int32();
                    break;
                case /* string index */ 2:
                    message.index = reader.string();
                    break;
                case /* ProtoMessages.TestPortsResult.Result testTCPResult */ 3:
                    message.testTCPResult = reader.int32();
                    break;
                case /* ProtoMessages.TestPortsResult.Result testUDPResult */ 4:
                    message.testUDPResult = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestPortsResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 portNumber = 1; */
        if (message.portNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.portNumber);
        /* string index = 2; */
        if (message.index !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.index);
        /* ProtoMessages.TestPortsResult.Result testTCPResult = 3; */
        if (message.testTCPResult !== 0)
            writer.tag(3, WireType.Varint).int32(message.testTCPResult);
        /* ProtoMessages.TestPortsResult.Result testUDPResult = 4; */
        if (message.testUDPResult !== 0)
            writer.tag(4, WireType.Varint).int32(message.testUDPResult);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.TestPortsResult
 */
export const TestPortsResult = new TestPortsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LigrStatus$Type extends MessageType$<LigrStatus> {
    constructor() {
        super("ProtoMessages.LigrStatus", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<LigrStatus>): LigrStatus {
        const message = { enabled: false, url: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LigrStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LigrStatus): LigrStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LigrStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.LigrStatus
 */
export const LigrStatus = new LigrStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestStatus$Type extends MessageType$<TestStatus> {
    constructor() {
        super("ProtoMessages.TestStatus", [
            { no: 1, name: "type", kind: "enum", T: () => ["ProtoMessages.TestStatus.StatusType", TestStatus_StatusType] },
            { no: 2, name: "index", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TestStatus>): TestStatus {
        const message = { type: 0, index: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TestStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestStatus): TestStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.TestStatus.StatusType type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string index */ 2:
                    message.index = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.TestStatus.StatusType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string index = 2; */
        if (message.index !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.index);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.TestStatus
 */
export const TestStatus = new TestStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestStatusResult$Type extends MessageType$<TestStatusResult> {
    constructor() {
        super("ProtoMessages.TestStatusResult", [
            { no: 1, name: "type", kind: "enum", T: () => ["ProtoMessages.TestStatusResult.StatusType", TestStatusResult_StatusType] },
            { no: 2, name: "index", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "testResult", kind: "enum", T: () => ["ProtoMessages.TestStatusResult.Result", TestStatusResult_Result] }
        ]);
    }
    create(value?: PartialMessage<TestStatusResult>): TestStatusResult {
        const message = { type: 0, index: "", testResult: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TestStatusResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestStatusResult): TestStatusResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.TestStatusResult.StatusType type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string index */ 2:
                    message.index = reader.string();
                    break;
                case /* ProtoMessages.TestStatusResult.Result testResult */ 3:
                    message.testResult = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestStatusResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.TestStatusResult.StatusType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string index = 2; */
        if (message.index !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.index);
        /* ProtoMessages.TestStatusResult.Result testResult = 3; */
        if (message.testResult !== 0)
            writer.tag(3, WireType.Varint).int32(message.testResult);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.TestStatusResult
 */
export const TestStatusResult = new TestStatusResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NetworkTestRequest$Type extends MessageType$<NetworkTestRequest> {
    constructor() {
        super("ProtoMessages.NetworkTestRequest", [
            { no: 1, name: "requestPortTesting", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TestPorts },
            { no: 2, name: "requestStatusTesting", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TestStatus }
        ]);
    }
    create(value?: PartialMessage<NetworkTestRequest>): NetworkTestRequest {
        const message = { requestPortTesting: [], requestStatusTesting: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<NetworkTestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NetworkTestRequest): NetworkTestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.TestPorts requestPortTesting */ 1:
                    message.requestPortTesting.push(TestPorts.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ProtoMessages.TestStatus requestStatusTesting */ 2:
                    message.requestStatusTesting.push(TestStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NetworkTestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.TestPorts requestPortTesting = 1; */
        for (let i = 0; i < message.requestPortTesting.length; i++)
            TestPorts.internalBinaryWrite(message.requestPortTesting[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.TestStatus requestStatusTesting = 2; */
        for (let i = 0; i < message.requestStatusTesting.length; i++)
            TestStatus.internalBinaryWrite(message.requestStatusTesting[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.NetworkTestRequest
 */
export const NetworkTestRequest = new NetworkTestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NetworkTestResult$Type extends MessageType$<NetworkTestResult> {
    constructor() {
        super("ProtoMessages.NetworkTestResult", [
            { no: 1, name: "testPortsResult", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TestPortsResult },
            { no: 2, name: "testStatusResult", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TestStatusResult },
            { no: 3, name: "testPassed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<NetworkTestResult>): NetworkTestResult {
        const message = { testPortsResult: [], testStatusResult: [], testPassed: false, success: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<NetworkTestResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NetworkTestResult): NetworkTestResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.TestPortsResult testPortsResult */ 1:
                    message.testPortsResult.push(TestPortsResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ProtoMessages.TestStatusResult testStatusResult */ 2:
                    message.testStatusResult.push(TestStatusResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool testPassed */ 3:
                    message.testPassed = reader.bool();
                    break;
                case /* bool success */ 4:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NetworkTestResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.TestPortsResult testPortsResult = 1; */
        for (let i = 0; i < message.testPortsResult.length; i++)
            TestPortsResult.internalBinaryWrite(message.testPortsResult[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.TestStatusResult testStatusResult = 2; */
        for (let i = 0; i < message.testStatusResult.length; i++)
            TestStatusResult.internalBinaryWrite(message.testStatusResult[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool testPassed = 3; */
        if (message.testPassed !== false)
            writer.tag(3, WireType.Varint).bool(message.testPassed);
        /* bool success = 4; */
        if (message.success !== false)
            writer.tag(4, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.NetworkTestResult
 */
export const NetworkTestResult = new NetworkTestResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NetworkValidation$Type extends MessageType$<NetworkValidation> {
    constructor() {
        super("ProtoMessages.NetworkValidation", [
            { no: 1, name: "validated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<NetworkValidation>): NetworkValidation {
        const message = { validated: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<NetworkValidation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NetworkValidation): NetworkValidation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool validated */ 1:
                    message.validated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NetworkValidation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool validated = 1; */
        if (message.validated !== false)
            writer.tag(1, WireType.Varint).bool(message.validated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.NetworkValidation
 */
export const NetworkValidation = new NetworkValidation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CCUPreset$Type extends MessageType$<CCUPreset> {
    constructor() {
        super("ProtoMessages.CCUPreset", [
            { no: 1, name: "name", kind: "message", T: () => String$ },
            { no: 2, name: "presetType", kind: "enum", T: () => ["ProtoMessages.CCUPreset.PresetType", CCUPreset_PresetType] },
            { no: 3, name: "ccuValues", kind: "message", T: () => CCUData }
        ]);
    }
    create(value?: PartialMessage<CCUPreset>): CCUPreset {
        const message = { presetType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CCUPreset>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CCUPreset): CCUPreset {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.String name */ 1:
                    message.name = String$.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* ProtoMessages.CCUPreset.PresetType presetType */ 2:
                    message.presetType = reader.int32();
                    break;
                case /* ProtoMessages.CCUData ccuValues */ 3:
                    message.ccuValues = CCUData.internalBinaryRead(reader, reader.uint32(), options, message.ccuValues);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CCUPreset, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.String name = 1; */
        if (message.name)
            String$.internalBinaryWrite(message.name, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.CCUPreset.PresetType presetType = 2; */
        if (message.presetType !== 0)
            writer.tag(2, WireType.Varint).int32(message.presetType);
        /* ProtoMessages.CCUData ccuValues = 3; */
        if (message.ccuValues)
            CCUData.internalBinaryWrite(message.ccuValues, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CCUPreset
 */
export const CCUPreset = new CCUPreset$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BigDataMessage$Type extends MessageType$<BigDataMessage> {
    constructor() {
        super("ProtoMessages.BigDataMessage", [
            { no: 1, name: "messageTypeStr", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "chunkIndex", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "totalChunks", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "totalBytes", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "offset", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "messageContent", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BigDataMessage>): BigDataMessage {
        const message = { messageTypeStr: "", uuid: "", chunkIndex: 0, totalChunks: 0, totalBytes: 0n, offset: 0n, messageContent: new Uint8Array(0) };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BigDataMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BigDataMessage): BigDataMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string messageTypeStr */ 1:
                    message.messageTypeStr = reader.string();
                    break;
                case /* string uuid */ 2:
                    message.uuid = reader.string();
                    break;
                case /* uint32 chunkIndex */ 3:
                    message.chunkIndex = reader.uint32();
                    break;
                case /* uint32 totalChunks */ 4:
                    message.totalChunks = reader.uint32();
                    break;
                case /* uint64 totalBytes */ 5:
                    message.totalBytes = reader.uint64().toBigInt();
                    break;
                case /* uint64 offset */ 6:
                    message.offset = reader.uint64().toBigInt();
                    break;
                case /* bytes messageContent */ 7:
                    message.messageContent = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BigDataMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string messageTypeStr = 1; */
        if (message.messageTypeStr !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.messageTypeStr);
        /* string uuid = 2; */
        if (message.uuid !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.uuid);
        /* uint32 chunkIndex = 3; */
        if (message.chunkIndex !== 0)
            writer.tag(3, WireType.Varint).uint32(message.chunkIndex);
        /* uint32 totalChunks = 4; */
        if (message.totalChunks !== 0)
            writer.tag(4, WireType.Varint).uint32(message.totalChunks);
        /* uint64 totalBytes = 5; */
        if (message.totalBytes !== 0n)
            writer.tag(5, WireType.Varint).uint64(message.totalBytes);
        /* uint64 offset = 6; */
        if (message.offset !== 0n)
            writer.tag(6, WireType.Varint).uint64(message.offset);
        /* bytes messageContent = 7; */
        if (message.messageContent.length)
            writer.tag(7, WireType.LengthDelimited).bytes(message.messageContent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.BigDataMessage
 */
export const BigDataMessage = new BigDataMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileChunkMessage$Type extends MessageType$<FileChunkMessage> {
    constructor() {
        super("ProtoMessages.FileChunkMessage", [
            { no: 1, name: "dataChunk", kind: "message", T: () => DataChunkMessage },
            { no: 2, name: "filename", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FileChunkMessage>): FileChunkMessage {
        const message = { filename: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FileChunkMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FileChunkMessage): FileChunkMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.DataChunkMessage dataChunk */ 1:
                    message.dataChunk = DataChunkMessage.internalBinaryRead(reader, reader.uint32(), options, message.dataChunk);
                    break;
                case /* string filename */ 2:
                    message.filename = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FileChunkMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.DataChunkMessage dataChunk = 1; */
        if (message.dataChunk)
            DataChunkMessage.internalBinaryWrite(message.dataChunk, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string filename = 2; */
        if (message.filename !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.filename);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.FileChunkMessage
 */
export const FileChunkMessage = new FileChunkMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraFramesRequestMessage$Type extends MessageType$<CameraFramesRequestMessage> {
    constructor() {
        super("ProtoMessages.CameraFramesRequestMessage", [
            { no: 1, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "frameType", kind: "enum", T: () => ["ProtoMessages.FrameType", FrameType] },
            { no: 3, name: "replyType", kind: "enum", T: () => ["ProtoMessages.CaptureFramesReplyType", CaptureFramesReplyType] },
            { no: 4, name: "rotateFrames", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "requestSource", kind: "enum", T: () => ["ProtoMessages.CameraFramesRequestMessage.RequestSource", CameraFramesRequestMessage_RequestSource] },
            { no: 6, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CameraFramesRequestMessage>): CameraFramesRequestMessage {
        const message = { requestId: "", frameType: 0, replyType: 0, rotateFrames: false, requestSource: 0, cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraFramesRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraFramesRequestMessage): CameraFramesRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string requestId */ 1:
                    message.requestId = reader.string();
                    break;
                case /* ProtoMessages.FrameType frameType */ 2:
                    message.frameType = reader.int32();
                    break;
                case /* ProtoMessages.CaptureFramesReplyType replyType */ 3:
                    message.replyType = reader.int32();
                    break;
                case /* bool rotateFrames */ 4:
                    message.rotateFrames = reader.bool();
                    break;
                case /* ProtoMessages.CameraFramesRequestMessage.RequestSource requestSource */ 5:
                    message.requestSource = reader.int32();
                    break;
                case /* int32 cameraIndex */ 6:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraFramesRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string requestId = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        /* ProtoMessages.FrameType frameType = 2; */
        if (message.frameType !== 0)
            writer.tag(2, WireType.Varint).int32(message.frameType);
        /* ProtoMessages.CaptureFramesReplyType replyType = 3; */
        if (message.replyType !== 0)
            writer.tag(3, WireType.Varint).int32(message.replyType);
        /* bool rotateFrames = 4; */
        if (message.rotateFrames !== false)
            writer.tag(4, WireType.Varint).bool(message.rotateFrames);
        /* ProtoMessages.CameraFramesRequestMessage.RequestSource requestSource = 5; */
        if (message.requestSource !== 0)
            writer.tag(5, WireType.Varint).int32(message.requestSource);
        /* int32 cameraIndex = 6; */
        if (message.cameraIndex !== 0)
            writer.tag(6, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraFramesRequestMessage
 */
export const CameraFramesRequestMessage = new CameraFramesRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraFramesDirectRequest$Type extends MessageType$<AdditionalCameraFramesDirectRequest> {
    constructor() {
        super("ProtoMessages.AdditionalCameraFramesDirectRequest", [
            { no: 1, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraFramesDirectRequest>): AdditionalCameraFramesDirectRequest {
        const message = { requestId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraFramesDirectRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraFramesDirectRequest): AdditionalCameraFramesDirectRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string requestId */ 1:
                    message.requestId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraFramesDirectRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string requestId = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraFramesDirectRequest
 */
export const AdditionalCameraFramesDirectRequest = new AdditionalCameraFramesDirectRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraFramesLanRequest$Type extends MessageType$<AdditionalCameraFramesLanRequest> {
    constructor() {
        super("ProtoMessages.AdditionalCameraFramesLanRequest", [
            { no: 1, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ipAdresses", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraFramesLanRequest>): AdditionalCameraFramesLanRequest {
        const message = { requestId: "", ipAdresses: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraFramesLanRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraFramesLanRequest): AdditionalCameraFramesLanRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string requestId */ 1:
                    message.requestId = reader.string();
                    break;
                case /* repeated string ipAdresses */ 2:
                    message.ipAdresses.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraFramesLanRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string requestId = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        /* repeated string ipAdresses = 2; */
        for (let i = 0; i < message.ipAdresses.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.ipAdresses[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraFramesLanRequest
 */
export const AdditionalCameraFramesLanRequest = new AdditionalCameraFramesLanRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraFramesDirectResponse$Type extends MessageType$<AdditionalCameraFramesDirectResponse> {
    constructor() {
        super("ProtoMessages.AdditionalCameraFramesDirectResponse", [
            { no: 1, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "errorMsg", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraFramesDirectResponse>): AdditionalCameraFramesDirectResponse {
        const message = { requestId: "", success: false, errorMsg: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraFramesDirectResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraFramesDirectResponse): AdditionalCameraFramesDirectResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string requestId */ 1:
                    message.requestId = reader.string();
                    break;
                case /* bool success */ 2:
                    message.success = reader.bool();
                    break;
                case /* string errorMsg */ 3:
                    message.errorMsg = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraFramesDirectResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string requestId = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        /* bool success = 2; */
        if (message.success !== false)
            writer.tag(2, WireType.Varint).bool(message.success);
        /* string errorMsg = 3; */
        if (message.errorMsg !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMsg);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraFramesDirectResponse
 */
export const AdditionalCameraFramesDirectResponse = new AdditionalCameraFramesDirectResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraPairingRequest$Type extends MessageType$<AdditionalCameraPairingRequest> {
    constructor() {
        super("ProtoMessages.AdditionalCameraPairingRequest", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraType", AdditionalCameraType] },
            { no: 2, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "connectionType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraConnectionType", AdditionalCameraConnectionType] }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraPairingRequest>): AdditionalCameraPairingRequest {
        const message = { cameraType: 0, cameraIndex: 0, connectionType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraPairingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraPairingRequest): AdditionalCameraPairingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AdditionalCameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                case /* int32 cameraIndex */ 2:
                    message.cameraIndex = reader.int32();
                    break;
                case /* ProtoMessages.AdditionalCameraConnectionType connectionType */ 3:
                    message.connectionType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraPairingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AdditionalCameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        /* int32 cameraIndex = 2; */
        if (message.cameraIndex !== 0)
            writer.tag(2, WireType.Varint).int32(message.cameraIndex);
        /* ProtoMessages.AdditionalCameraConnectionType connectionType = 3; */
        if (message.connectionType !== 0)
            writer.tag(3, WireType.Varint).int32(message.connectionType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraPairingRequest
 */
export const AdditionalCameraPairingRequest = new AdditionalCameraPairingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraUnpairingRequest$Type extends MessageType$<AdditionalCameraUnpairingRequest> {
    constructor() {
        super("ProtoMessages.AdditionalCameraUnpairingRequest", [
            { no: 1, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraUnpairingRequest>): AdditionalCameraUnpairingRequest {
        const message = { cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraUnpairingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraUnpairingRequest): AdditionalCameraUnpairingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 cameraIndex */ 1:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraUnpairingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 cameraIndex = 1; */
        if (message.cameraIndex !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraUnpairingRequest
 */
export const AdditionalCameraUnpairingRequest = new AdditionalCameraUnpairingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraUnpairingResponse$Type extends MessageType$<AdditionalCameraUnpairingResponse> {
    constructor() {
        super("ProtoMessages.AdditionalCameraUnpairingResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraUnpairingResponse>): AdditionalCameraUnpairingResponse {
        const message = { errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraUnpairingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraUnpairingResponse): AdditionalCameraUnpairingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraUnpairingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraUnpairingResponse
 */
export const AdditionalCameraUnpairingResponse = new AdditionalCameraUnpairingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraFramesReplyMessage$Type extends MessageType$<CameraFramesReplyMessage> {
    constructor() {
        super("ProtoMessages.CameraFramesReplyMessage", [
            { no: 1, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "frameType", kind: "enum", T: () => ["ProtoMessages.FrameType", FrameType] },
            { no: 3, name: "framesCount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "frameIndex", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "dataMsg", kind: "message", T: () => DataChunkMessage },
            { no: 6, name: "frameRotation", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "cameraIp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "cameraModel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CameraFramesReplyMessage>): CameraFramesReplyMessage {
        const message = { requestId: "", frameType: 0, framesCount: 0, frameIndex: 0, frameRotation: 0, cameraIp: "", cameraModel: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraFramesReplyMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraFramesReplyMessage): CameraFramesReplyMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string requestId */ 1:
                    message.requestId = reader.string();
                    break;
                case /* ProtoMessages.FrameType frameType */ 2:
                    message.frameType = reader.int32();
                    break;
                case /* uint32 framesCount */ 3:
                    message.framesCount = reader.uint32();
                    break;
                case /* uint32 frameIndex */ 4:
                    message.frameIndex = reader.uint32();
                    break;
                case /* CommonUsedMessages.DataChunkMessage dataMsg */ 5:
                    message.dataMsg = DataChunkMessage.internalBinaryRead(reader, reader.uint32(), options, message.dataMsg);
                    break;
                case /* int32 frameRotation */ 6:
                    message.frameRotation = reader.int32();
                    break;
                case /* string cameraIp */ 7:
                    message.cameraIp = reader.string();
                    break;
                case /* string cameraModel */ 8:
                    message.cameraModel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraFramesReplyMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string requestId = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        /* ProtoMessages.FrameType frameType = 2; */
        if (message.frameType !== 0)
            writer.tag(2, WireType.Varint).int32(message.frameType);
        /* uint32 framesCount = 3; */
        if (message.framesCount !== 0)
            writer.tag(3, WireType.Varint).uint32(message.framesCount);
        /* uint32 frameIndex = 4; */
        if (message.frameIndex !== 0)
            writer.tag(4, WireType.Varint).uint32(message.frameIndex);
        /* CommonUsedMessages.DataChunkMessage dataMsg = 5; */
        if (message.dataMsg)
            DataChunkMessage.internalBinaryWrite(message.dataMsg, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int32 frameRotation = 6; */
        if (message.frameRotation !== 0)
            writer.tag(6, WireType.Varint).int32(message.frameRotation);
        /* string cameraIp = 7; */
        if (message.cameraIp !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.cameraIp);
        /* string cameraModel = 8; */
        if (message.cameraModel !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.cameraModel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraFramesReplyMessage
 */
export const CameraFramesReplyMessage = new CameraFramesReplyMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraFramesFailureReplyMessage$Type extends MessageType$<CameraFramesFailureReplyMessage> {
    constructor() {
        super("ProtoMessages.CameraFramesFailureReplyMessage", [
            { no: 1, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "frameType", kind: "enum", T: () => ["ProtoMessages.FrameType", FrameType] },
            { no: 3, name: "failureReason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CameraFramesFailureReplyMessage>): CameraFramesFailureReplyMessage {
        const message = { requestId: "", frameType: 0, failureReason: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraFramesFailureReplyMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraFramesFailureReplyMessage): CameraFramesFailureReplyMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string requestId */ 1:
                    message.requestId = reader.string();
                    break;
                case /* ProtoMessages.FrameType frameType */ 2:
                    message.frameType = reader.int32();
                    break;
                case /* string failureReason */ 3:
                    message.failureReason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraFramesFailureReplyMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string requestId = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        /* ProtoMessages.FrameType frameType = 2; */
        if (message.frameType !== 0)
            writer.tag(2, WireType.Varint).int32(message.frameType);
        /* string failureReason = 3; */
        if (message.failureReason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.failureReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraFramesFailureReplyMessage
 */
export const CameraFramesFailureReplyMessage = new CameraFramesFailureReplyMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GroundPoint$Type extends MessageType$<GroundPoint> {
    constructor() {
        super("ProtoMessages.GroundPoint", [
            { no: 1, name: "framePoint", kind: "message", T: () => Point2D },
            { no: 2, name: "fieldPoint", kind: "message", T: () => Point2D },
            { no: 3, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "skipped", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GroundPoint>): GroundPoint {
        const message = { cameraIndex: 0, skipped: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GroundPoint>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GroundPoint): GroundPoint {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Point2D framePoint */ 1:
                    message.framePoint = Point2D.internalBinaryRead(reader, reader.uint32(), options, message.framePoint);
                    break;
                case /* CommonUsedMessages.Point2D fieldPoint */ 2:
                    message.fieldPoint = Point2D.internalBinaryRead(reader, reader.uint32(), options, message.fieldPoint);
                    break;
                case /* int32 cameraIndex */ 3:
                    message.cameraIndex = reader.int32();
                    break;
                case /* bool skipped */ 4:
                    message.skipped = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GroundPoint, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Point2D framePoint = 1; */
        if (message.framePoint)
            Point2D.internalBinaryWrite(message.framePoint, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* CommonUsedMessages.Point2D fieldPoint = 2; */
        if (message.fieldPoint)
            Point2D.internalBinaryWrite(message.fieldPoint, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 cameraIndex = 3; */
        if (message.cameraIndex !== 0)
            writer.tag(3, WireType.Varint).int32(message.cameraIndex);
        /* bool skipped = 4; */
        if (message.skipped !== false)
            writer.tag(4, WireType.Varint).bool(message.skipped);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.GroundPoint
 */
export const GroundPoint = new GroundPoint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportTypeInfo$Type extends MessageType$<SportTypeInfo> {
    constructor() {
        super("ProtoMessages.SportTypeInfo", [
            { no: 1, name: "displayName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SportTypeInfo>): SportTypeInfo {
        const message = { displayName: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportTypeInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportTypeInfo): SportTypeInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string displayName */ 1:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportTypeInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string displayName = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportTypeInfo
 */
export const SportTypeInfo = new SportTypeInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimplifiedCalibrationGetSportTypesRequestMessage$Type extends MessageType$<SimplifiedCalibrationGetSportTypesRequestMessage> {
    constructor() {
        super("ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage", []);
    }
    create(value?: PartialMessage<SimplifiedCalibrationGetSportTypesRequestMessage>): SimplifiedCalibrationGetSportTypesRequestMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimplifiedCalibrationGetSportTypesRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimplifiedCalibrationGetSportTypesRequestMessage): SimplifiedCalibrationGetSportTypesRequestMessage {
        return target ?? this.create();
    }
    internalBinaryWrite(message: SimplifiedCalibrationGetSportTypesRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SimplifiedCalibrationGetSportTypesRequestMessage
 */
export const SimplifiedCalibrationGetSportTypesRequestMessage = new SimplifiedCalibrationGetSportTypesRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimplifiedCalibrationSportTypesReplyMessage$Type extends MessageType$<SimplifiedCalibrationSportTypesReplyMessage> {
    constructor() {
        super("ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage", [
            { no: 1, name: "autoProductionTypes", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SportTypeInfo },
            { no: 2, name: "fixedFrameTypes", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SportTypeInfo },
            { no: 3, name: "result", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SimplifiedCalibrationSportTypesReplyMessage>): SimplifiedCalibrationSportTypesReplyMessage {
        const message = { autoProductionTypes: [], fixedFrameTypes: [], result: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimplifiedCalibrationSportTypesReplyMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimplifiedCalibrationSportTypesReplyMessage): SimplifiedCalibrationSportTypesReplyMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.SportTypeInfo autoProductionTypes */ 1:
                    message.autoProductionTypes.push(SportTypeInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ProtoMessages.SportTypeInfo fixedFrameTypes */ 2:
                    message.fixedFrameTypes.push(SportTypeInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string result */ 3:
                    message.result = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimplifiedCalibrationSportTypesReplyMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.SportTypeInfo autoProductionTypes = 1; */
        for (let i = 0; i < message.autoProductionTypes.length; i++)
            SportTypeInfo.internalBinaryWrite(message.autoProductionTypes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.SportTypeInfo fixedFrameTypes = 2; */
        for (let i = 0; i < message.fixedFrameTypes.length; i++)
            SportTypeInfo.internalBinaryWrite(message.fixedFrameTypes[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string result = 3; */
        if (message.result !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.result);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SimplifiedCalibrationSportTypesReplyMessage
 */
export const SimplifiedCalibrationSportTypesReplyMessage = new SimplifiedCalibrationSportTypesReplyMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimplifiedCalibrationSetGroundPointsRequestMessage$Type extends MessageType$<SimplifiedCalibrationSetGroundPointsRequestMessage> {
    constructor() {
        super("ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage", [
            { no: 1, name: "groundPoints", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => GroundPoint },
            { no: 2, name: "sportType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "fieldWidth", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "fieldHeight", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SimplifiedCalibrationSetGroundPointsRequestMessage>): SimplifiedCalibrationSetGroundPointsRequestMessage {
        const message = { groundPoints: [], sportType: "", fieldWidth: 0, fieldHeight: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimplifiedCalibrationSetGroundPointsRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimplifiedCalibrationSetGroundPointsRequestMessage): SimplifiedCalibrationSetGroundPointsRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.GroundPoint groundPoints */ 1:
                    message.groundPoints.push(GroundPoint.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string sportType */ 2:
                    message.sportType = reader.string();
                    break;
                case /* int32 fieldWidth */ 3:
                    message.fieldWidth = reader.int32();
                    break;
                case /* int32 fieldHeight */ 4:
                    message.fieldHeight = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimplifiedCalibrationSetGroundPointsRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.GroundPoint groundPoints = 1; */
        for (let i = 0; i < message.groundPoints.length; i++)
            GroundPoint.internalBinaryWrite(message.groundPoints[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string sportType = 2; */
        if (message.sportType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sportType);
        /* int32 fieldWidth = 3; */
        if (message.fieldWidth !== 0)
            writer.tag(3, WireType.Varint).int32(message.fieldWidth);
        /* int32 fieldHeight = 4; */
        if (message.fieldHeight !== 0)
            writer.tag(4, WireType.Varint).int32(message.fieldHeight);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SimplifiedCalibrationSetGroundPointsRequestMessage
 */
export const SimplifiedCalibrationSetGroundPointsRequestMessage = new SimplifiedCalibrationSetGroundPointsRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimplifiedCalibrationSetGroundPointsReplyMessage$Type extends MessageType$<SimplifiedCalibrationSetGroundPointsReplyMessage> {
    constructor() {
        super("ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage", [
            { no: 1, name: "result", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SimplifiedCalibrationSetGroundPointsReplyMessage>): SimplifiedCalibrationSetGroundPointsReplyMessage {
        const message = { result: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimplifiedCalibrationSetGroundPointsReplyMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimplifiedCalibrationSetGroundPointsReplyMessage): SimplifiedCalibrationSetGroundPointsReplyMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string result */ 1:
                    message.result = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimplifiedCalibrationSetGroundPointsReplyMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string result = 1; */
        if (message.result !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.result);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SimplifiedCalibrationSetGroundPointsReplyMessage
 */
export const SimplifiedCalibrationSetGroundPointsReplyMessage = new SimplifiedCalibrationSetGroundPointsReplyMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PipCameraFocusRequest$Type extends MessageType$<PipCameraFocusRequest> {
    constructor() {
        super("ProtoMessages.PipCameraFocusRequest", [
            { no: 1, name: "focus", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PipCameraFocusRequest>): PipCameraFocusRequest {
        const message = { focus: 0, requestId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PipCameraFocusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PipCameraFocusRequest): PipCameraFocusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 focus */ 1:
                    message.focus = reader.int32();
                    break;
                case /* string requestId */ 2:
                    message.requestId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PipCameraFocusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 focus = 1; */
        if (message.focus !== 0)
            writer.tag(1, WireType.Varint).int32(message.focus);
        /* string requestId = 2; */
        if (message.requestId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PipCameraFocusRequest
 */
export const PipCameraFocusRequest = new PipCameraFocusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PipCameraZoomRequest$Type extends MessageType$<PipCameraZoomRequest> {
    constructor() {
        super("ProtoMessages.PipCameraZoomRequest", [
            { no: 1, name: "zoom", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "fine", kind: "message", T: () => Bool },
            { no: 3, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PipCameraZoomRequest>): PipCameraZoomRequest {
        const message = { zoom: 0, requestId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PipCameraZoomRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PipCameraZoomRequest): PipCameraZoomRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 zoom */ 1:
                    message.zoom = reader.int32();
                    break;
                case /* ProtoMessages.Bool fine */ 2:
                    message.fine = Bool.internalBinaryRead(reader, reader.uint32(), options, message.fine);
                    break;
                case /* string requestId */ 3:
                    message.requestId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PipCameraZoomRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 zoom = 1; */
        if (message.zoom !== 0)
            writer.tag(1, WireType.Varint).int32(message.zoom);
        /* ProtoMessages.Bool fine = 2; */
        if (message.fine)
            Bool.internalBinaryWrite(message.fine, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string requestId = 3; */
        if (message.requestId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PipCameraZoomRequest
 */
export const PipCameraZoomRequest = new PipCameraZoomRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PipCameraChangeExposureModeChange$Type extends MessageType$<PipCameraChangeExposureModeChange> {
    constructor() {
        super("ProtoMessages.PipCameraChangeExposureModeChange", [
            { no: 1, name: "newMode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PipCameraChangeExposureModeChange>): PipCameraChangeExposureModeChange {
        const message = { newMode: "", requestId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PipCameraChangeExposureModeChange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PipCameraChangeExposureModeChange): PipCameraChangeExposureModeChange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string newMode */ 1:
                    message.newMode = reader.string();
                    break;
                case /* string requestId */ 2:
                    message.requestId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PipCameraChangeExposureModeChange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string newMode = 1; */
        if (message.newMode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.newMode);
        /* string requestId = 2; */
        if (message.requestId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PipCameraChangeExposureModeChange
 */
export const PipCameraChangeExposureModeChange = new PipCameraChangeExposureModeChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PipCameraFlipRequest$Type extends MessageType$<PipCameraFlipRequest> {
    constructor() {
        super("ProtoMessages.PipCameraFlipRequest", [
            { no: 1, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PipCameraFlipRequest>): PipCameraFlipRequest {
        const message = { requestId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PipCameraFlipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PipCameraFlipRequest): PipCameraFlipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string requestId */ 1:
                    message.requestId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PipCameraFlipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string requestId = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PipCameraFlipRequest
 */
export const PipCameraFlipRequest = new PipCameraFlipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraParams$Type extends MessageType$<AdditionalCameraParams> {
    constructor() {
        super("ProtoMessages.AdditionalCameraParams", [
            { no: 1, name: "gain", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "iris", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "sharpness", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "contrast", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "brightness", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "saturation", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraParams>): AdditionalCameraParams {
        const message = { gain: 0, iris: 0, sharpness: 0, contrast: 0, brightness: 0, saturation: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraParams>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraParams): AdditionalCameraParams {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 gain */ 1:
                    message.gain = reader.int32();
                    break;
                case /* int32 iris */ 2:
                    message.iris = reader.int32();
                    break;
                case /* int32 sharpness */ 3:
                    message.sharpness = reader.int32();
                    break;
                case /* int32 contrast */ 4:
                    message.contrast = reader.int32();
                    break;
                case /* int32 brightness */ 5:
                    message.brightness = reader.int32();
                    break;
                case /* int32 saturation */ 6:
                    message.saturation = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraParams, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 gain = 1; */
        if (message.gain !== 0)
            writer.tag(1, WireType.Varint).int32(message.gain);
        /* int32 iris = 2; */
        if (message.iris !== 0)
            writer.tag(2, WireType.Varint).int32(message.iris);
        /* int32 sharpness = 3; */
        if (message.sharpness !== 0)
            writer.tag(3, WireType.Varint).int32(message.sharpness);
        /* int32 contrast = 4; */
        if (message.contrast !== 0)
            writer.tag(4, WireType.Varint).int32(message.contrast);
        /* int32 brightness = 5; */
        if (message.brightness !== 0)
            writer.tag(5, WireType.Varint).int32(message.brightness);
        /* int32 saturation = 6; */
        if (message.saturation !== 0)
            writer.tag(6, WireType.Varint).int32(message.saturation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraParams
 */
export const AdditionalCameraParams = new AdditionalCameraParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InactivatedScoreboardQuery$Type extends MessageType$<InactivatedScoreboardQuery> {
    constructor() {
        super("ProtoMessages.InactivatedScoreboardQuery", []);
    }
    create(value?: PartialMessage<InactivatedScoreboardQuery>): InactivatedScoreboardQuery {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<InactivatedScoreboardQuery>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InactivatedScoreboardQuery): InactivatedScoreboardQuery {
        return target ?? this.create();
    }
    internalBinaryWrite(message: InactivatedScoreboardQuery, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.InactivatedScoreboardQuery
 */
export const InactivatedScoreboardQuery = new InactivatedScoreboardQuery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InactivatedScoreboardResponse$Type extends MessageType$<InactivatedScoreboardResponse> {
    constructor() {
        super("ProtoMessages.InactivatedScoreboardResponse", [
            { no: 1, name: "inactiveScoreboard", kind: "enum", T: () => ["ProtoMessages.InactivatedScoreboardResponse.Type", InactivatedScoreboardResponse_Type] }
        ]);
    }
    create(value?: PartialMessage<InactivatedScoreboardResponse>): InactivatedScoreboardResponse {
        const message = { inactiveScoreboard: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<InactivatedScoreboardResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InactivatedScoreboardResponse): InactivatedScoreboardResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.InactivatedScoreboardResponse.Type inactiveScoreboard */ 1:
                    message.inactiveScoreboard = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InactivatedScoreboardResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.InactivatedScoreboardResponse.Type inactiveScoreboard = 1; */
        if (message.inactiveScoreboard !== 0)
            writer.tag(1, WireType.Varint).int32(message.inactiveScoreboard);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.InactivatedScoreboardResponse
 */
export const InactivatedScoreboardResponse = new InactivatedScoreboardResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraChangeAfMode$Type extends MessageType$<AdditionalCameraChangeAfMode> {
    constructor() {
        super("ProtoMessages.AdditionalCameraChangeAfMode", [
            { no: 1, name: "switchTo", kind: "enum", T: () => ["ProtoMessages.AFMode", AFMode] },
            { no: 2, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraType", AdditionalCameraType] },
            { no: 3, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraChangeAfMode>): AdditionalCameraChangeAfMode {
        const message = { switchTo: 0, cameraType: 0, cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraChangeAfMode>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraChangeAfMode): AdditionalCameraChangeAfMode {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AFMode switchTo */ 1:
                    message.switchTo = reader.int32();
                    break;
                case /* ProtoMessages.AdditionalCameraType cameraType */ 2:
                    message.cameraType = reader.int32();
                    break;
                case /* int32 cameraIndex */ 3:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraChangeAfMode, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AFMode switchTo = 1; */
        if (message.switchTo !== 0)
            writer.tag(1, WireType.Varint).int32(message.switchTo);
        /* ProtoMessages.AdditionalCameraType cameraType = 2; */
        if (message.cameraType !== 0)
            writer.tag(2, WireType.Varint).int32(message.cameraType);
        /* int32 cameraIndex = 3; */
        if (message.cameraIndex !== 0)
            writer.tag(3, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraChangeAfMode
 */
export const AdditionalCameraChangeAfMode = new AdditionalCameraChangeAfMode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraChangeAFModeReplyMessage$Type extends MessageType$<AdditionalCameraChangeAFModeReplyMessage> {
    constructor() {
        super("ProtoMessages.AdditionalCameraChangeAFModeReplyMessage", [
            { no: 1, name: "mode", kind: "enum", T: () => ["ProtoMessages.AFMode", AFMode] },
            { no: 2, name: "success", kind: "message", T: () => Bool },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraType", AdditionalCameraType] }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraChangeAFModeReplyMessage>): AdditionalCameraChangeAFModeReplyMessage {
        const message = { mode: 0, errorMessage: "", cameraType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraChangeAFModeReplyMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraChangeAFModeReplyMessage): AdditionalCameraChangeAFModeReplyMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AFMode mode */ 1:
                    message.mode = reader.int32();
                    break;
                case /* ProtoMessages.Bool success */ 2:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                case /* ProtoMessages.AdditionalCameraType cameraType */ 4:
                    message.cameraType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraChangeAFModeReplyMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AFMode mode = 1; */
        if (message.mode !== 0)
            writer.tag(1, WireType.Varint).int32(message.mode);
        /* ProtoMessages.Bool success = 2; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        /* ProtoMessages.AdditionalCameraType cameraType = 4; */
        if (message.cameraType !== 0)
            writer.tag(4, WireType.Varint).int32(message.cameraType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraChangeAFModeReplyMessage
 */
export const AdditionalCameraChangeAFModeReplyMessage = new AdditionalCameraChangeAFModeReplyMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PairingStageUpdate$Type extends MessageType$<PairingStageUpdate> {
    constructor() {
        super("ProtoMessages.PairingStageUpdate", [
            { no: 1, name: "stage", kind: "enum", T: () => ["ProtoMessages.PairingStage", PairingStage] },
            { no: 2, name: "stageSuccess", kind: "message", T: () => Bool },
            { no: 3, name: "errorMessege", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "errorCode", kind: "enum", T: () => ["ProtoMessages.PairingStageUpdate.PairingErrorCode", PairingStageUpdate_PairingErrorCode] },
            { no: 5, name: "type", kind: "enum", T: () => ["ProtoMessages.PairingStageUpdate.CameraType", PairingStageUpdate_CameraType] },
            { no: 6, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<PairingStageUpdate>): PairingStageUpdate {
        const message = { stage: 0, errorMessege: "", errorCode: 0, type: 0, cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PairingStageUpdate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PairingStageUpdate): PairingStageUpdate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.PairingStage stage */ 1:
                    message.stage = reader.int32();
                    break;
                case /* ProtoMessages.Bool stageSuccess */ 2:
                    message.stageSuccess = Bool.internalBinaryRead(reader, reader.uint32(), options, message.stageSuccess);
                    break;
                case /* string errorMessege */ 3:
                    message.errorMessege = reader.string();
                    break;
                case /* ProtoMessages.PairingStageUpdate.PairingErrorCode errorCode */ 4:
                    message.errorCode = reader.int32();
                    break;
                case /* ProtoMessages.PairingStageUpdate.CameraType type */ 5:
                    message.type = reader.int32();
                    break;
                case /* int32 cameraIndex */ 6:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PairingStageUpdate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.PairingStage stage = 1; */
        if (message.stage !== 0)
            writer.tag(1, WireType.Varint).int32(message.stage);
        /* ProtoMessages.Bool stageSuccess = 2; */
        if (message.stageSuccess)
            Bool.internalBinaryWrite(message.stageSuccess, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessege = 3; */
        if (message.errorMessege !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessege);
        /* ProtoMessages.PairingStageUpdate.PairingErrorCode errorCode = 4; */
        if (message.errorCode !== 0)
            writer.tag(4, WireType.Varint).int32(message.errorCode);
        /* ProtoMessages.PairingStageUpdate.CameraType type = 5; */
        if (message.type !== 0)
            writer.tag(5, WireType.Varint).int32(message.type);
        /* int32 cameraIndex = 6; */
        if (message.cameraIndex !== 0)
            writer.tag(6, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PairingStageUpdate
 */
export const PairingStageUpdate = new PairingStageUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AACameraZoomRequest$Type extends MessageType$<AACameraZoomRequest> {
    constructor() {
        super("ProtoMessages.AACameraZoomRequest", [
            { no: 1, name: "zoom", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "zoomStep", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AACameraZoomRequest>): AACameraZoomRequest {
        const message = { zoom: 0, zoomStep: 0, requestId: "", cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AACameraZoomRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AACameraZoomRequest): AACameraZoomRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 zoom */ 1:
                    message.zoom = reader.int32();
                    break;
                case /* int32 zoomStep */ 2:
                    message.zoomStep = reader.int32();
                    break;
                case /* string requestId */ 3:
                    message.requestId = reader.string();
                    break;
                case /* int32 cameraIndex */ 4:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AACameraZoomRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 zoom = 1; */
        if (message.zoom !== 0)
            writer.tag(1, WireType.Varint).int32(message.zoom);
        /* int32 zoomStep = 2; */
        if (message.zoomStep !== 0)
            writer.tag(2, WireType.Varint).int32(message.zoomStep);
        /* string requestId = 3; */
        if (message.requestId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestId);
        /* int32 cameraIndex = 4; */
        if (message.cameraIndex !== 0)
            writer.tag(4, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AACameraZoomRequest
 */
export const AACameraZoomRequest = new AACameraZoomRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AACameraFocusRequest$Type extends MessageType$<AACameraFocusRequest> {
    constructor() {
        super("ProtoMessages.AACameraFocusRequest", [
            { no: 1, name: "focus", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AACameraFocusRequest>): AACameraFocusRequest {
        const message = { focus: 0, requestId: "", cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AACameraFocusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AACameraFocusRequest): AACameraFocusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 focus */ 1:
                    message.focus = reader.int32();
                    break;
                case /* string requestId */ 2:
                    message.requestId = reader.string();
                    break;
                case /* int32 cameraIndex */ 3:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AACameraFocusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 focus = 1; */
        if (message.focus !== 0)
            writer.tag(1, WireType.Varint).int32(message.focus);
        /* string requestId = 2; */
        if (message.requestId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestId);
        /* int32 cameraIndex = 3; */
        if (message.cameraIndex !== 0)
            writer.tag(3, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AACameraFocusRequest
 */
export const AACameraFocusRequest = new AACameraFocusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraIrisChangeRequest$Type extends MessageType$<AdditionalCameraIrisChangeRequest> {
    constructor() {
        super("ProtoMessages.AdditionalCameraIrisChangeRequest", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraType", AdditionalCameraType] },
            { no: 2, name: "newIrisValue", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraIrisChangeRequest>): AdditionalCameraIrisChangeRequest {
        const message = { cameraType: 0, newIrisValue: 0, requestId: "", cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraIrisChangeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraIrisChangeRequest): AdditionalCameraIrisChangeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AdditionalCameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                case /* int32 newIrisValue */ 2:
                    message.newIrisValue = reader.int32();
                    break;
                case /* string requestId */ 3:
                    message.requestId = reader.string();
                    break;
                case /* int32 cameraIndex */ 4:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraIrisChangeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AdditionalCameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        /* int32 newIrisValue = 2; */
        if (message.newIrisValue !== 0)
            writer.tag(2, WireType.Varint).int32(message.newIrisValue);
        /* string requestId = 3; */
        if (message.requestId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestId);
        /* int32 cameraIndex = 4; */
        if (message.cameraIndex !== 0)
            writer.tag(4, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraIrisChangeRequest
 */
export const AdditionalCameraIrisChangeRequest = new AdditionalCameraIrisChangeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraGainChangeRequest$Type extends MessageType$<AdditionalCameraGainChangeRequest> {
    constructor() {
        super("ProtoMessages.AdditionalCameraGainChangeRequest", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraType", AdditionalCameraType] },
            { no: 2, name: "newGainValue", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraGainChangeRequest>): AdditionalCameraGainChangeRequest {
        const message = { cameraType: 0, newGainValue: 0, requestId: "", cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraGainChangeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraGainChangeRequest): AdditionalCameraGainChangeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AdditionalCameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                case /* int32 newGainValue */ 2:
                    message.newGainValue = reader.int32();
                    break;
                case /* string requestId */ 3:
                    message.requestId = reader.string();
                    break;
                case /* int32 cameraIndex */ 4:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraGainChangeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AdditionalCameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        /* int32 newGainValue = 2; */
        if (message.newGainValue !== 0)
            writer.tag(2, WireType.Varint).int32(message.newGainValue);
        /* string requestId = 3; */
        if (message.requestId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestId);
        /* int32 cameraIndex = 4; */
        if (message.cameraIndex !== 0)
            writer.tag(4, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraGainChangeRequest
 */
export const AdditionalCameraGainChangeRequest = new AdditionalCameraGainChangeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraSharpnessChangeRequest$Type extends MessageType$<AdditionalCameraSharpnessChangeRequest> {
    constructor() {
        super("ProtoMessages.AdditionalCameraSharpnessChangeRequest", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraType", AdditionalCameraType] },
            { no: 2, name: "newSharpnessValue", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraSharpnessChangeRequest>): AdditionalCameraSharpnessChangeRequest {
        const message = { cameraType: 0, newSharpnessValue: 0, requestId: "", cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraSharpnessChangeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraSharpnessChangeRequest): AdditionalCameraSharpnessChangeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AdditionalCameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                case /* int32 newSharpnessValue */ 2:
                    message.newSharpnessValue = reader.int32();
                    break;
                case /* string requestId */ 3:
                    message.requestId = reader.string();
                    break;
                case /* int32 cameraIndex */ 4:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraSharpnessChangeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AdditionalCameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        /* int32 newSharpnessValue = 2; */
        if (message.newSharpnessValue !== 0)
            writer.tag(2, WireType.Varint).int32(message.newSharpnessValue);
        /* string requestId = 3; */
        if (message.requestId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestId);
        /* int32 cameraIndex = 4; */
        if (message.cameraIndex !== 0)
            writer.tag(4, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraSharpnessChangeRequest
 */
export const AdditionalCameraSharpnessChangeRequest = new AdditionalCameraSharpnessChangeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraContrastChangeRequest$Type extends MessageType$<AdditionalCameraContrastChangeRequest> {
    constructor() {
        super("ProtoMessages.AdditionalCameraContrastChangeRequest", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraType", AdditionalCameraType] },
            { no: 2, name: "newContrastValue", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraContrastChangeRequest>): AdditionalCameraContrastChangeRequest {
        const message = { cameraType: 0, newContrastValue: 0, requestId: "", cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraContrastChangeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraContrastChangeRequest): AdditionalCameraContrastChangeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AdditionalCameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                case /* int32 newContrastValue */ 2:
                    message.newContrastValue = reader.int32();
                    break;
                case /* string requestId */ 3:
                    message.requestId = reader.string();
                    break;
                case /* int32 cameraIndex */ 4:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraContrastChangeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AdditionalCameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        /* int32 newContrastValue = 2; */
        if (message.newContrastValue !== 0)
            writer.tag(2, WireType.Varint).int32(message.newContrastValue);
        /* string requestId = 3; */
        if (message.requestId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestId);
        /* int32 cameraIndex = 4; */
        if (message.cameraIndex !== 0)
            writer.tag(4, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraContrastChangeRequest
 */
export const AdditionalCameraContrastChangeRequest = new AdditionalCameraContrastChangeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraBrightnessChangeRequest$Type extends MessageType$<AdditionalCameraBrightnessChangeRequest> {
    constructor() {
        super("ProtoMessages.AdditionalCameraBrightnessChangeRequest", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraType", AdditionalCameraType] },
            { no: 2, name: "newBrightnessValue", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraBrightnessChangeRequest>): AdditionalCameraBrightnessChangeRequest {
        const message = { cameraType: 0, newBrightnessValue: 0, requestId: "", cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraBrightnessChangeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraBrightnessChangeRequest): AdditionalCameraBrightnessChangeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AdditionalCameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                case /* int32 newBrightnessValue */ 2:
                    message.newBrightnessValue = reader.int32();
                    break;
                case /* string requestId */ 3:
                    message.requestId = reader.string();
                    break;
                case /* int32 cameraIndex */ 4:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraBrightnessChangeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AdditionalCameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        /* int32 newBrightnessValue = 2; */
        if (message.newBrightnessValue !== 0)
            writer.tag(2, WireType.Varint).int32(message.newBrightnessValue);
        /* string requestId = 3; */
        if (message.requestId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestId);
        /* int32 cameraIndex = 4; */
        if (message.cameraIndex !== 0)
            writer.tag(4, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraBrightnessChangeRequest
 */
export const AdditionalCameraBrightnessChangeRequest = new AdditionalCameraBrightnessChangeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraSaturationChangeRequest$Type extends MessageType$<AdditionalCameraSaturationChangeRequest> {
    constructor() {
        super("ProtoMessages.AdditionalCameraSaturationChangeRequest", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraType", AdditionalCameraType] },
            { no: 2, name: "newSaturationValue", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraSaturationChangeRequest>): AdditionalCameraSaturationChangeRequest {
        const message = { cameraType: 0, newSaturationValue: 0, requestId: "", cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraSaturationChangeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraSaturationChangeRequest): AdditionalCameraSaturationChangeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AdditionalCameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                case /* int32 newSaturationValue */ 2:
                    message.newSaturationValue = reader.int32();
                    break;
                case /* string requestId */ 3:
                    message.requestId = reader.string();
                    break;
                case /* int32 cameraIndex */ 4:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraSaturationChangeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AdditionalCameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        /* int32 newSaturationValue = 2; */
        if (message.newSaturationValue !== 0)
            writer.tag(2, WireType.Varint).int32(message.newSaturationValue);
        /* string requestId = 3; */
        if (message.requestId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestId);
        /* int32 cameraIndex = 4; */
        if (message.cameraIndex !== 0)
            writer.tag(4, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraSaturationChangeRequest
 */
export const AdditionalCameraSaturationChangeRequest = new AdditionalCameraSaturationChangeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraRotateRequest$Type extends MessageType$<AdditionalCameraRotateRequest> {
    constructor() {
        super("ProtoMessages.AdditionalCameraRotateRequest", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraType", AdditionalCameraType] },
            { no: 3, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraRotateRequest>): AdditionalCameraRotateRequest {
        const message = { cameraType: 0, requestId: "", cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraRotateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraRotateRequest): AdditionalCameraRotateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AdditionalCameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                case /* string requestId */ 3:
                    message.requestId = reader.string();
                    break;
                case /* int32 cameraIndex */ 4:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraRotateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AdditionalCameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        /* string requestId = 3; */
        if (message.requestId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestId);
        /* int32 cameraIndex = 4; */
        if (message.cameraIndex !== 0)
            writer.tag(4, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraRotateRequest
 */
export const AdditionalCameraRotateRequest = new AdditionalCameraRotateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraParametersRequest$Type extends MessageType$<AdditionalCameraParametersRequest> {
    constructor() {
        super("ProtoMessages.AdditionalCameraParametersRequest", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraType", AdditionalCameraType] },
            { no: 2, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraParametersRequest>): AdditionalCameraParametersRequest {
        const message = { cameraType: 0, cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraParametersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraParametersRequest): AdditionalCameraParametersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AdditionalCameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                case /* int32 cameraIndex */ 2:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraParametersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AdditionalCameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        /* int32 cameraIndex = 2; */
        if (message.cameraIndex !== 0)
            writer.tag(2, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraParametersRequest
 */
export const AdditionalCameraParametersRequest = new AdditionalCameraParametersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalCameraParametersResponse$Type extends MessageType$<AdditionalCameraParametersResponse> {
    constructor() {
        super("ProtoMessages.AdditionalCameraParametersResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraType", AdditionalCameraType] },
            { no: 4, name: "params", kind: "message", T: () => AdditionalCameraParams },
            { no: 5, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AdditionalCameraParametersResponse>): AdditionalCameraParametersResponse {
        const message = { errorMessage: "", cameraType: 0, cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdditionalCameraParametersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalCameraParametersResponse): AdditionalCameraParametersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* ProtoMessages.AdditionalCameraType cameraType */ 3:
                    message.cameraType = reader.int32();
                    break;
                case /* ProtoMessages.AdditionalCameraParams params */ 4:
                    message.params = AdditionalCameraParams.internalBinaryRead(reader, reader.uint32(), options, message.params);
                    break;
                case /* int32 cameraIndex */ 5:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalCameraParametersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* ProtoMessages.AdditionalCameraType cameraType = 3; */
        if (message.cameraType !== 0)
            writer.tag(3, WireType.Varint).int32(message.cameraType);
        /* ProtoMessages.AdditionalCameraParams params = 4; */
        if (message.params)
            AdditionalCameraParams.internalBinaryWrite(message.params, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 cameraIndex = 5; */
        if (message.cameraIndex !== 0)
            writer.tag(5, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdditionalCameraParametersResponse
 */
export const AdditionalCameraParametersResponse = new AdditionalCameraParametersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AACameraAutoFocusRequest$Type extends MessageType$<AACameraAutoFocusRequest> {
    constructor() {
        super("ProtoMessages.AACameraAutoFocusRequest", [
            { no: 1, name: "request", kind: "message", T: () => Bool },
            { no: 2, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AACameraAutoFocusRequest>): AACameraAutoFocusRequest {
        const message = { requestId: "", cameraIndex: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AACameraAutoFocusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AACameraAutoFocusRequest): AACameraAutoFocusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool request */ 1:
                    message.request = Bool.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                case /* string requestId */ 2:
                    message.requestId = reader.string();
                    break;
                case /* int32 cameraIndex */ 3:
                    message.cameraIndex = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AACameraAutoFocusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool request = 1; */
        if (message.request)
            Bool.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string requestId = 2; */
        if (message.requestId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestId);
        /* int32 cameraIndex = 3; */
        if (message.cameraIndex !== 0)
            writer.tag(3, WireType.Varint).int32(message.cameraIndex);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AACameraAutoFocusRequest
 */
export const AACameraAutoFocusRequest = new AACameraAutoFocusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestStatusEnabledAACameras$Type extends MessageType$<RequestStatusEnabledAACameras> {
    constructor() {
        super("ProtoMessages.RequestStatusEnabledAACameras", [
            { no: 1, name: "request", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<RequestStatusEnabledAACameras>): RequestStatusEnabledAACameras {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RequestStatusEnabledAACameras>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestStatusEnabledAACameras): RequestStatusEnabledAACameras {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool request */ 1:
                    message.request = Bool.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestStatusEnabledAACameras, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool request = 1; */
        if (message.request)
            Bool.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.RequestStatusEnabledAACameras
 */
export const RequestStatusEnabledAACameras = new RequestStatusEnabledAACameras$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraStatusPair$Type extends MessageType$<CameraStatusPair> {
    constructor() {
        super("ProtoMessages.CameraStatusPair", [
            { no: 1, name: "index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "status", kind: "enum", T: () => ["ProtoMessages.AACameraStatus", AACameraStatus] },
            { no: 3, name: "type", kind: "enum", T: () => ["ProtoMessages.AACameraType", AACameraType] }
        ]);
    }
    create(value?: PartialMessage<CameraStatusPair>): CameraStatusPair {
        const message = { index: 0, status: 0, type: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraStatusPair>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraStatusPair): CameraStatusPair {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 index */ 1:
                    message.index = reader.int32();
                    break;
                case /* ProtoMessages.AACameraStatus status */ 2:
                    message.status = reader.int32();
                    break;
                case /* ProtoMessages.AACameraType type */ 3:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraStatusPair, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 index = 1; */
        if (message.index !== 0)
            writer.tag(1, WireType.Varint).int32(message.index);
        /* ProtoMessages.AACameraStatus status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* ProtoMessages.AACameraType type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraStatusPair
 */
export const CameraStatusPair = new CameraStatusPair$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StatusEnabledAACameras$Type extends MessageType$<StatusEnabledAACameras> {
    constructor() {
        super("ProtoMessages.StatusEnabledAACameras", [
            { no: 1, name: "status", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CameraStatusPair }
        ]);
    }
    create(value?: PartialMessage<StatusEnabledAACameras>): StatusEnabledAACameras {
        const message = { status: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StatusEnabledAACameras>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StatusEnabledAACameras): StatusEnabledAACameras {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.CameraStatusPair status */ 1:
                    message.status.push(CameraStatusPair.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StatusEnabledAACameras, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.CameraStatusPair status = 1; */
        for (let i = 0; i < message.status.length; i++)
            CameraStatusPair.internalBinaryWrite(message.status[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StatusEnabledAACameras
 */
export const StatusEnabledAACameras = new StatusEnabledAACameras$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChangeStatusAACameras$Type extends MessageType$<ChangeStatusAACameras> {
    constructor() {
        super("ProtoMessages.ChangeStatusAACameras", [
            { no: 1, name: "changes", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CameraStatusPair }
        ]);
    }
    create(value?: PartialMessage<ChangeStatusAACameras>): ChangeStatusAACameras {
        const message = { changes: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChangeStatusAACameras>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChangeStatusAACameras): ChangeStatusAACameras {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.CameraStatusPair changes */ 1:
                    message.changes.push(CameraStatusPair.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChangeStatusAACameras, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.CameraStatusPair changes = 1; */
        for (let i = 0; i < message.changes.length; i++)
            CameraStatusPair.internalBinaryWrite(message.changes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ChangeStatusAACameras
 */
export const ChangeStatusAACameras = new ChangeStatusAACameras$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExistingCalibrationRequest$Type extends MessageType$<ExistingCalibrationRequest> {
    constructor() {
        super("ProtoMessages.ExistingCalibrationRequest", [
            { no: 1, name: "request", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<ExistingCalibrationRequest>): ExistingCalibrationRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ExistingCalibrationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExistingCalibrationRequest): ExistingCalibrationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool request */ 1:
                    message.request = Bool.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExistingCalibrationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool request = 1; */
        if (message.request)
            Bool.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ExistingCalibrationRequest
 */
export const ExistingCalibrationRequest = new ExistingCalibrationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScoreboardCalibrationPoint$Type extends MessageType$<ScoreboardCalibrationPoint> {
    constructor() {
        super("ProtoMessages.ScoreboardCalibrationPoint", [
            { no: 1, name: "x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<ScoreboardCalibrationPoint>): ScoreboardCalibrationPoint {
        const message = { x: 0, y: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ScoreboardCalibrationPoint>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ScoreboardCalibrationPoint): ScoreboardCalibrationPoint {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double x */ 1:
                    message.x = reader.double();
                    break;
                case /* double y */ 2:
                    message.y = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ScoreboardCalibrationPoint, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double x = 1; */
        if (message.x !== 0)
            writer.tag(1, WireType.Bit64).double(message.x);
        /* double y = 2; */
        if (message.y !== 0)
            writer.tag(2, WireType.Bit64).double(message.y);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ScoreboardCalibrationPoint
 */
export const ScoreboardCalibrationPoint = new ScoreboardCalibrationPoint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestScoreboardCalibrationMessage$Type extends MessageType$<RequestScoreboardCalibrationMessage> {
    constructor() {
        super("ProtoMessages.RequestScoreboardCalibrationMessage", []);
    }
    create(value?: PartialMessage<RequestScoreboardCalibrationMessage>): RequestScoreboardCalibrationMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RequestScoreboardCalibrationMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestScoreboardCalibrationMessage): RequestScoreboardCalibrationMessage {
        return target ?? this.create();
    }
    internalBinaryWrite(message: RequestScoreboardCalibrationMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.RequestScoreboardCalibrationMessage
 */
export const RequestScoreboardCalibrationMessage = new RequestScoreboardCalibrationMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScoreboardCalibrationDataMessage$Type extends MessageType$<ScoreboardCalibrationDataMessage> {
    constructor() {
        super("ProtoMessages.ScoreboardCalibrationDataMessage", [
            { no: 1, name: "exists", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "corners", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ScoreboardCalibrationPoint },
            { no: 4, name: "usage", kind: "enum", T: () => ["ProtoMessages.ChuUsage", ChuUsage, "CHU_USAGE_"] }
        ]);
    }
    create(value?: PartialMessage<ScoreboardCalibrationDataMessage>): ScoreboardCalibrationDataMessage {
        const message = { exists: false, cameraIndex: 0, corners: [], usage: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ScoreboardCalibrationDataMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ScoreboardCalibrationDataMessage): ScoreboardCalibrationDataMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool exists */ 1:
                    message.exists = reader.bool();
                    break;
                case /* int32 cameraIndex */ 2:
                    message.cameraIndex = reader.int32();
                    break;
                case /* repeated ProtoMessages.ScoreboardCalibrationPoint corners */ 3:
                    message.corners.push(ScoreboardCalibrationPoint.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ProtoMessages.ChuUsage usage */ 4:
                    message.usage = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ScoreboardCalibrationDataMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool exists = 1; */
        if (message.exists !== false)
            writer.tag(1, WireType.Varint).bool(message.exists);
        /* int32 cameraIndex = 2; */
        if (message.cameraIndex !== 0)
            writer.tag(2, WireType.Varint).int32(message.cameraIndex);
        /* repeated ProtoMessages.ScoreboardCalibrationPoint corners = 3; */
        for (let i = 0; i < message.corners.length; i++)
            ScoreboardCalibrationPoint.internalBinaryWrite(message.corners[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.ChuUsage usage = 4; */
        if (message.usage !== 0)
            writer.tag(4, WireType.Varint).int32(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ScoreboardCalibrationDataMessage
 */
export const ScoreboardCalibrationDataMessage = new ScoreboardCalibrationDataMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApplyScoreboardCalibrationMessage$Type extends MessageType$<ApplyScoreboardCalibrationMessage> {
    constructor() {
        super("ProtoMessages.ApplyScoreboardCalibrationMessage", [
            { no: 1, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "corners", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ScoreboardCalibrationPoint },
            { no: 3, name: "usage", kind: "enum", T: () => ["ProtoMessages.ChuUsage", ChuUsage, "CHU_USAGE_"] }
        ]);
    }
    create(value?: PartialMessage<ApplyScoreboardCalibrationMessage>): ApplyScoreboardCalibrationMessage {
        const message = { cameraIndex: 0, corners: [], usage: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ApplyScoreboardCalibrationMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ApplyScoreboardCalibrationMessage): ApplyScoreboardCalibrationMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 cameraIndex */ 1:
                    message.cameraIndex = reader.int32();
                    break;
                case /* repeated ProtoMessages.ScoreboardCalibrationPoint corners */ 2:
                    message.corners.push(ScoreboardCalibrationPoint.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ProtoMessages.ChuUsage usage */ 3:
                    message.usage = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ApplyScoreboardCalibrationMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 cameraIndex = 1; */
        if (message.cameraIndex !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraIndex);
        /* repeated ProtoMessages.ScoreboardCalibrationPoint corners = 2; */
        for (let i = 0; i < message.corners.length; i++)
            ScoreboardCalibrationPoint.internalBinaryWrite(message.corners[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.ChuUsage usage = 3; */
        if (message.usage !== 0)
            writer.tag(3, WireType.Varint).int32(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ApplyScoreboardCalibrationMessage
 */
export const ApplyScoreboardCalibrationMessage = new ApplyScoreboardCalibrationMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApplyScoreboardCalibrationResponseMessage$Type extends MessageType$<ApplyScoreboardCalibrationResponseMessage> {
    constructor() {
        super("ProtoMessages.ApplyScoreboardCalibrationResponseMessage", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ApplyScoreboardCalibrationResponseMessage>): ApplyScoreboardCalibrationResponseMessage {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ApplyScoreboardCalibrationResponseMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ApplyScoreboardCalibrationResponseMessage): ApplyScoreboardCalibrationResponseMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ApplyScoreboardCalibrationResponseMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ApplyScoreboardCalibrationResponseMessage
 */
export const ApplyScoreboardCalibrationResponseMessage = new ApplyScoreboardCalibrationResponseMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetChuFeedModeMessage$Type extends MessageType$<SetChuFeedModeMessage> {
    constructor() {
        super("ProtoMessages.SetChuFeedModeMessage", [
            { no: 1, name: "usage", kind: "enum", T: () => ["ProtoMessages.ChuUsage", ChuUsage, "CHU_USAGE_"] }
        ]);
    }
    create(value?: PartialMessage<SetChuFeedModeMessage>): SetChuFeedModeMessage {
        const message = { usage: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SetChuFeedModeMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetChuFeedModeMessage): SetChuFeedModeMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.ChuUsage usage */ 1:
                    message.usage = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetChuFeedModeMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.ChuUsage usage = 1; */
        if (message.usage !== 0)
            writer.tag(1, WireType.Varint).int32(message.usage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SetChuFeedModeMessage
 */
export const SetChuFeedModeMessage = new SetChuFeedModeMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestChuOcrFrameMessage$Type extends MessageType$<RequestChuOcrFrameMessage> {
    constructor() {
        super("ProtoMessages.RequestChuOcrFrameMessage", []);
    }
    create(value?: PartialMessage<RequestChuOcrFrameMessage>): RequestChuOcrFrameMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RequestChuOcrFrameMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestChuOcrFrameMessage): RequestChuOcrFrameMessage {
        return target ?? this.create();
    }
    internalBinaryWrite(message: RequestChuOcrFrameMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.RequestChuOcrFrameMessage
 */
export const RequestChuOcrFrameMessage = new RequestChuOcrFrameMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChuOcrFrameMessage$Type extends MessageType$<ChuOcrFrameMessage> {
    constructor() {
        super("ProtoMessages.ChuOcrFrameMessage", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "frame", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "scoreboardData", kind: "message", T: () => OcrDataMessage }
        ]);
    }
    create(value?: PartialMessage<ChuOcrFrameMessage>): ChuOcrFrameMessage {
        const message = { success: false, frame: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChuOcrFrameMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChuOcrFrameMessage): ChuOcrFrameMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string frame */ 2:
                    message.frame = reader.string();
                    break;
                case /* VpuGrpc.OcrDataMessage scoreboardData */ 3:
                    message.scoreboardData = OcrDataMessage.internalBinaryRead(reader, reader.uint32(), options, message.scoreboardData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChuOcrFrameMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string frame = 2; */
        if (message.frame !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.frame);
        /* VpuGrpc.OcrDataMessage scoreboardData = 3; */
        if (message.scoreboardData)
            OcrDataMessage.internalBinaryWrite(message.scoreboardData, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ChuOcrFrameMessage
 */
export const ChuOcrFrameMessage = new ChuOcrFrameMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartChuOcrValidationMessage$Type extends MessageType$<StartChuOcrValidationMessage> {
    constructor() {
        super("ProtoMessages.StartChuOcrValidationMessage", []);
    }
    create(value?: PartialMessage<StartChuOcrValidationMessage>): StartChuOcrValidationMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StartChuOcrValidationMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StartChuOcrValidationMessage): StartChuOcrValidationMessage {
        return target ?? this.create();
    }
    internalBinaryWrite(message: StartChuOcrValidationMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StartChuOcrValidationMessage
 */
export const StartChuOcrValidationMessage = new StartChuOcrValidationMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartChuOcrValidationResponseMessage$Type extends MessageType$<StartChuOcrValidationResponseMessage> {
    constructor() {
        super("ProtoMessages.StartChuOcrValidationResponseMessage", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StartChuOcrValidationResponseMessage>): StartChuOcrValidationResponseMessage {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StartChuOcrValidationResponseMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StartChuOcrValidationResponseMessage): StartChuOcrValidationResponseMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StartChuOcrValidationResponseMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StartChuOcrValidationResponseMessage
 */
export const StartChuOcrValidationResponseMessage = new StartChuOcrValidationResponseMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefreshOcrImageAndPreview$Type extends MessageType$<RefreshOcrImageAndPreview> {
    constructor() {
        super("ProtoMessages.RefreshOcrImageAndPreview", [
            { no: 1, name: "reqId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RefreshOcrImageAndPreview>): RefreshOcrImageAndPreview {
        const message = { reqId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RefreshOcrImageAndPreview>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefreshOcrImageAndPreview): RefreshOcrImageAndPreview {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string reqId */ 1:
                    message.reqId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefreshOcrImageAndPreview, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string reqId = 1; */
        if (message.reqId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.reqId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.RefreshOcrImageAndPreview
 */
export const RefreshOcrImageAndPreview = new RefreshOcrImageAndPreview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingIsBalenaSystemRequest$Type extends MessageType$<OnboardingIsBalenaSystemRequest> {
    constructor() {
        super("ProtoMessages.OnboardingIsBalenaSystemRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<OnboardingIsBalenaSystemRequest>): OnboardingIsBalenaSystemRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingIsBalenaSystemRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingIsBalenaSystemRequest): OnboardingIsBalenaSystemRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingIsBalenaSystemRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingIsBalenaSystemRequest
 */
export const OnboardingIsBalenaSystemRequest = new OnboardingIsBalenaSystemRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingIsBalenaSystemResponse$Type extends MessageType$<OnboardingIsBalenaSystemResponse> {
    constructor() {
        super("ProtoMessages.OnboardingIsBalenaSystemResponse", [
            { no: 1, name: "isBalena", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<OnboardingIsBalenaSystemResponse>): OnboardingIsBalenaSystemResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingIsBalenaSystemResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingIsBalenaSystemResponse): OnboardingIsBalenaSystemResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool isBalena */ 1:
                    message.isBalena = Bool.internalBinaryRead(reader, reader.uint32(), options, message.isBalena);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingIsBalenaSystemResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool isBalena = 1; */
        if (message.isBalena)
            Bool.internalBinaryWrite(message.isBalena, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingIsBalenaSystemResponse
 */
export const OnboardingIsBalenaSystemResponse = new OnboardingIsBalenaSystemResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingGetDiagnosticsResults$Type extends MessageType$<OnboardingGetDiagnosticsResults> {
    constructor() {
        super("ProtoMessages.OnboardingGetDiagnosticsResults", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<OnboardingGetDiagnosticsResults>): OnboardingGetDiagnosticsResults {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingGetDiagnosticsResults>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingGetDiagnosticsResults): OnboardingGetDiagnosticsResults {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingGetDiagnosticsResults, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingGetDiagnosticsResults
 */
export const OnboardingGetDiagnosticsResults = new OnboardingGetDiagnosticsResults$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingDiagnosticsResultsResponse$Type extends MessageType$<OnboardingDiagnosticsResultsResponse> {
    constructor() {
        super("ProtoMessages.OnboardingDiagnosticsResultsResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "hwTestPass", kind: "message", T: () => Bool },
            { no: 3, name: "connectivityTestResult", kind: "message", T: () => ConnectivityTestResult }
        ]);
    }
    create(value?: PartialMessage<OnboardingDiagnosticsResultsResponse>): OnboardingDiagnosticsResultsResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingDiagnosticsResultsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingDiagnosticsResultsResponse): OnboardingDiagnosticsResultsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* ProtoMessages.Bool hwTestPass */ 2:
                    message.hwTestPass = Bool.internalBinaryRead(reader, reader.uint32(), options, message.hwTestPass);
                    break;
                case /* ProtoMessages.ConnectivityTestResult connectivityTestResult */ 3:
                    message.connectivityTestResult = ConnectivityTestResult.internalBinaryRead(reader, reader.uint32(), options, message.connectivityTestResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingDiagnosticsResultsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool hwTestPass = 2; */
        if (message.hwTestPass)
            Bool.internalBinaryWrite(message.hwTestPass, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.ConnectivityTestResult connectivityTestResult = 3; */
        if (message.connectivityTestResult)
            ConnectivityTestResult.internalBinaryWrite(message.connectivityTestResult, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingDiagnosticsResultsResponse
 */
export const OnboardingDiagnosticsResultsResponse = new OnboardingDiagnosticsResultsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingGetFullDiagnosticsResults$Type extends MessageType$<OnboardingGetFullDiagnosticsResults> {
    constructor() {
        super("ProtoMessages.OnboardingGetFullDiagnosticsResults", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<OnboardingGetFullDiagnosticsResults>): OnboardingGetFullDiagnosticsResults {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingGetFullDiagnosticsResults>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingGetFullDiagnosticsResults): OnboardingGetFullDiagnosticsResults {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingGetFullDiagnosticsResults, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingGetFullDiagnosticsResults
 */
export const OnboardingGetFullDiagnosticsResults = new OnboardingGetFullDiagnosticsResults$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingGetFullDiagnosticsResultsResponse$Type extends MessageType$<OnboardingGetFullDiagnosticsResultsResponse> {
    constructor() {
        super("ProtoMessages.OnboardingGetFullDiagnosticsResultsResponse", [
            { no: 1, name: "hwTestResults", kind: "message", T: () => HwTestResults },
            { no: 2, name: "connectivityTestResult", kind: "message", T: () => ConnectivityTestResult },
            { no: 3, name: "cameraConnectionResultList", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SingleCameraConnectionResults },
            { no: 4, name: "poeStatusResultList", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SinglePoeStatusResults }
        ]);
    }
    create(value?: PartialMessage<OnboardingGetFullDiagnosticsResultsResponse>): OnboardingGetFullDiagnosticsResultsResponse {
        const message = { cameraConnectionResultList: [], poeStatusResultList: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingGetFullDiagnosticsResultsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingGetFullDiagnosticsResultsResponse): OnboardingGetFullDiagnosticsResultsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.HwTestResults hwTestResults */ 1:
                    message.hwTestResults = HwTestResults.internalBinaryRead(reader, reader.uint32(), options, message.hwTestResults);
                    break;
                case /* ProtoMessages.ConnectivityTestResult connectivityTestResult */ 2:
                    message.connectivityTestResult = ConnectivityTestResult.internalBinaryRead(reader, reader.uint32(), options, message.connectivityTestResult);
                    break;
                case /* repeated ProtoMessages.SingleCameraConnectionResults cameraConnectionResultList */ 3:
                    message.cameraConnectionResultList.push(SingleCameraConnectionResults.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ProtoMessages.SinglePoeStatusResults poeStatusResultList */ 4:
                    message.poeStatusResultList.push(SinglePoeStatusResults.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingGetFullDiagnosticsResultsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.HwTestResults hwTestResults = 1; */
        if (message.hwTestResults)
            HwTestResults.internalBinaryWrite(message.hwTestResults, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.ConnectivityTestResult connectivityTestResult = 2; */
        if (message.connectivityTestResult)
            ConnectivityTestResult.internalBinaryWrite(message.connectivityTestResult, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.SingleCameraConnectionResults cameraConnectionResultList = 3; */
        for (let i = 0; i < message.cameraConnectionResultList.length; i++)
            SingleCameraConnectionResults.internalBinaryWrite(message.cameraConnectionResultList[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.SinglePoeStatusResults poeStatusResultList = 4; */
        for (let i = 0; i < message.poeStatusResultList.length; i++)
            SinglePoeStatusResults.internalBinaryWrite(message.poeStatusResultList[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingGetFullDiagnosticsResultsResponse
 */
export const OnboardingGetFullDiagnosticsResultsResponse = new OnboardingGetFullDiagnosticsResultsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SingleCameraConnectionResults$Type extends MessageType$<SingleCameraConnectionResults> {
    constructor() {
        super("ProtoMessages.SingleCameraConnectionResults", [
            { no: 1, name: "ip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connected", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<SingleCameraConnectionResults>): SingleCameraConnectionResults {
        const message = { ip: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SingleCameraConnectionResults>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SingleCameraConnectionResults): SingleCameraConnectionResults {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string ip */ 1:
                    message.ip = reader.string();
                    break;
                case /* ProtoMessages.Bool connected */ 2:
                    message.connected = Bool.internalBinaryRead(reader, reader.uint32(), options, message.connected);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SingleCameraConnectionResults, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string ip = 1; */
        if (message.ip !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.ip);
        /* ProtoMessages.Bool connected = 2; */
        if (message.connected)
            Bool.internalBinaryWrite(message.connected, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SingleCameraConnectionResults
 */
export const SingleCameraConnectionResults = new SingleCameraConnectionResults$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SinglePoeStatusResults$Type extends MessageType$<SinglePoeStatusResults> {
    constructor() {
        super("ProtoMessages.SinglePoeStatusResults", [
            { no: 1, name: "connected", kind: "message", T: () => Bool },
            { no: 2, name: "speed", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SinglePoeStatusResults>): SinglePoeStatusResults {
        const message = { speed: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SinglePoeStatusResults>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SinglePoeStatusResults): SinglePoeStatusResults {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool connected */ 1:
                    message.connected = Bool.internalBinaryRead(reader, reader.uint32(), options, message.connected);
                    break;
                case /* int32 speed */ 2:
                    message.speed = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SinglePoeStatusResults, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool connected = 1; */
        if (message.connected)
            Bool.internalBinaryWrite(message.connected, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 speed = 2; */
        if (message.speed !== 0)
            writer.tag(2, WireType.Varint).int32(message.speed);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SinglePoeStatusResults
 */
export const SinglePoeStatusResults = new SinglePoeStatusResults$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HwTestResults$Type extends MessageType$<HwTestResults> {
    constructor() {
        super("ProtoMessages.HwTestResults", [
            { no: 1, name: "gpuPass", kind: "message", T: () => Bool },
            { no: 2, name: "wifiPass", kind: "message", T: () => Bool },
            { no: 3, name: "poePass", kind: "message", T: () => Bool },
            { no: 4, name: "memoryPass", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<HwTestResults>): HwTestResults {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<HwTestResults>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HwTestResults): HwTestResults {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool gpuPass */ 1:
                    message.gpuPass = Bool.internalBinaryRead(reader, reader.uint32(), options, message.gpuPass);
                    break;
                case /* ProtoMessages.Bool wifiPass */ 2:
                    message.wifiPass = Bool.internalBinaryRead(reader, reader.uint32(), options, message.wifiPass);
                    break;
                case /* ProtoMessages.Bool poePass */ 3:
                    message.poePass = Bool.internalBinaryRead(reader, reader.uint32(), options, message.poePass);
                    break;
                case /* ProtoMessages.Bool memoryPass */ 4:
                    message.memoryPass = Bool.internalBinaryRead(reader, reader.uint32(), options, message.memoryPass);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HwTestResults, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool gpuPass = 1; */
        if (message.gpuPass)
            Bool.internalBinaryWrite(message.gpuPass, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool wifiPass = 2; */
        if (message.wifiPass)
            Bool.internalBinaryWrite(message.wifiPass, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool poePass = 3; */
        if (message.poePass)
            Bool.internalBinaryWrite(message.poePass, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool memoryPass = 4; */
        if (message.memoryPass)
            Bool.internalBinaryWrite(message.memoryPass, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.HwTestResults
 */
export const HwTestResults = new HwTestResults$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectivityTestResult$Type extends MessageType$<ConnectivityTestResult> {
    constructor() {
        super("ProtoMessages.ConnectivityTestResult", [
            { no: 1, name: "networkConnectionPass", kind: "message", T: () => Bool },
            { no: 2, name: "ipTestPass", kind: "message", T: () => Bool },
            { no: 3, name: "pixellotCloudConnectionPass", kind: "message", T: () => Bool },
            { no: 4, name: "firewallTestPass", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<ConnectivityTestResult>): ConnectivityTestResult {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ConnectivityTestResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectivityTestResult): ConnectivityTestResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool networkConnectionPass */ 1:
                    message.networkConnectionPass = Bool.internalBinaryRead(reader, reader.uint32(), options, message.networkConnectionPass);
                    break;
                case /* ProtoMessages.Bool ipTestPass */ 2:
                    message.ipTestPass = Bool.internalBinaryRead(reader, reader.uint32(), options, message.ipTestPass);
                    break;
                case /* ProtoMessages.Bool pixellotCloudConnectionPass */ 3:
                    message.pixellotCloudConnectionPass = Bool.internalBinaryRead(reader, reader.uint32(), options, message.pixellotCloudConnectionPass);
                    break;
                case /* ProtoMessages.Bool firewallTestPass */ 4:
                    message.firewallTestPass = Bool.internalBinaryRead(reader, reader.uint32(), options, message.firewallTestPass);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectivityTestResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool networkConnectionPass = 1; */
        if (message.networkConnectionPass)
            Bool.internalBinaryWrite(message.networkConnectionPass, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool ipTestPass = 2; */
        if (message.ipTestPass)
            Bool.internalBinaryWrite(message.ipTestPass, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool pixellotCloudConnectionPass = 3; */
        if (message.pixellotCloudConnectionPass)
            Bool.internalBinaryWrite(message.pixellotCloudConnectionPass, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool firewallTestPass = 4; */
        if (message.firewallTestPass)
            Bool.internalBinaryWrite(message.firewallTestPass, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ConnectivityTestResult
 */
export const ConnectivityTestResult = new ConnectivityTestResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingGetCurrentNetworkRequest$Type extends MessageType$<OnboardingGetCurrentNetworkRequest> {
    constructor() {
        super("ProtoMessages.OnboardingGetCurrentNetworkRequest", [
            { no: 1, name: "request", kind: "message", T: () => Bool },
            { no: 2, name: "fromConnectApp", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<OnboardingGetCurrentNetworkRequest>): OnboardingGetCurrentNetworkRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingGetCurrentNetworkRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingGetCurrentNetworkRequest): OnboardingGetCurrentNetworkRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool request */ 1:
                    message.request = Bool.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                case /* ProtoMessages.Bool fromConnectApp */ 2:
                    message.fromConnectApp = Bool.internalBinaryRead(reader, reader.uint32(), options, message.fromConnectApp);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingGetCurrentNetworkRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool request = 1; */
        if (message.request)
            Bool.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool fromConnectApp = 2; */
        if (message.fromConnectApp)
            Bool.internalBinaryWrite(message.fromConnectApp, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingGetCurrentNetworkRequest
 */
export const OnboardingGetCurrentNetworkRequest = new OnboardingGetCurrentNetworkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingGetCurrentCHUUpdateRequest$Type extends MessageType$<OnboardingGetCurrentCHUUpdateRequest> {
    constructor() {
        super("ProtoMessages.OnboardingGetCurrentCHUUpdateRequest", []);
    }
    create(value?: PartialMessage<OnboardingGetCurrentCHUUpdateRequest>): OnboardingGetCurrentCHUUpdateRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingGetCurrentCHUUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingGetCurrentCHUUpdateRequest): OnboardingGetCurrentCHUUpdateRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: OnboardingGetCurrentCHUUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingGetCurrentCHUUpdateRequest
 */
export const OnboardingGetCurrentCHUUpdateRequest = new OnboardingGetCurrentCHUUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingGetCurrentCHUUpdateResponse$Type extends MessageType$<OnboardingGetCurrentCHUUpdateResponse> {
    constructor() {
        super("ProtoMessages.OnboardingGetCurrentCHUUpdateResponse", [
            { no: 1, name: "step", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "percentage", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<OnboardingGetCurrentCHUUpdateResponse>): OnboardingGetCurrentCHUUpdateResponse {
        const message = { step: "", percentage: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingGetCurrentCHUUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingGetCurrentCHUUpdateResponse): OnboardingGetCurrentCHUUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step */ 1:
                    message.step = reader.string();
                    break;
                case /* int32 percentage */ 2:
                    message.percentage = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingGetCurrentCHUUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step = 1; */
        if (message.step !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.step);
        /* int32 percentage = 2; */
        if (message.percentage !== 0)
            writer.tag(2, WireType.Varint).int32(message.percentage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingGetCurrentCHUUpdateResponse
 */
export const OnboardingGetCurrentCHUUpdateResponse = new OnboardingGetCurrentCHUUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingCurrentNetworkDataResponse$Type extends MessageType$<OnboardingCurrentNetworkDataResponse> {
    constructor() {
        super("ProtoMessages.OnboardingCurrentNetworkDataResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "networkData", kind: "message", T: () => OnboardingNetworkSetupRequest }
        ]);
    }
    create(value?: PartialMessage<OnboardingCurrentNetworkDataResponse>): OnboardingCurrentNetworkDataResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingCurrentNetworkDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingCurrentNetworkDataResponse): OnboardingCurrentNetworkDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* ProtoMessages.OnboardingNetworkSetupRequest networkData */ 2:
                    message.networkData = OnboardingNetworkSetupRequest.internalBinaryRead(reader, reader.uint32(), options, message.networkData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingCurrentNetworkDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.OnboardingNetworkSetupRequest networkData = 2; */
        if (message.networkData)
            OnboardingNetworkSetupRequest.internalBinaryWrite(message.networkData, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingCurrentNetworkDataResponse
 */
export const OnboardingCurrentNetworkDataResponse = new OnboardingCurrentNetworkDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingNetworkSetupRequest$Type extends MessageType$<OnboardingNetworkSetupRequest> {
    constructor() {
        super("ProtoMessages.OnboardingNetworkSetupRequest", [
            { no: 1, name: "manual", kind: "message", T: () => Bool },
            { no: 2, name: "ip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "mask", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "gateway", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "dns1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "dns2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "fromConnectApp", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<OnboardingNetworkSetupRequest>): OnboardingNetworkSetupRequest {
        const message = { ip: "", mask: "", gateway: "", dns1: "", dns2: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingNetworkSetupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingNetworkSetupRequest): OnboardingNetworkSetupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool manual */ 1:
                    message.manual = Bool.internalBinaryRead(reader, reader.uint32(), options, message.manual);
                    break;
                case /* string ip */ 2:
                    message.ip = reader.string();
                    break;
                case /* string mask */ 3:
                    message.mask = reader.string();
                    break;
                case /* string gateway */ 4:
                    message.gateway = reader.string();
                    break;
                case /* string dns1 */ 5:
                    message.dns1 = reader.string();
                    break;
                case /* string dns2 */ 6:
                    message.dns2 = reader.string();
                    break;
                case /* ProtoMessages.Bool fromConnectApp */ 7:
                    message.fromConnectApp = Bool.internalBinaryRead(reader, reader.uint32(), options, message.fromConnectApp);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingNetworkSetupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool manual = 1; */
        if (message.manual)
            Bool.internalBinaryWrite(message.manual, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string ip = 2; */
        if (message.ip !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ip);
        /* string mask = 3; */
        if (message.mask !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.mask);
        /* string gateway = 4; */
        if (message.gateway !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.gateway);
        /* string dns1 = 5; */
        if (message.dns1 !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dns1);
        /* string dns2 = 6; */
        if (message.dns2 !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.dns2);
        /* ProtoMessages.Bool fromConnectApp = 7; */
        if (message.fromConnectApp)
            Bool.internalBinaryWrite(message.fromConnectApp, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingNetworkSetupRequest
 */
export const OnboardingNetworkSetupRequest = new OnboardingNetworkSetupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingNetworkSetupResponseNew$Type extends MessageType$<OnboardingNetworkSetupResponseNew> {
    constructor() {
        super("ProtoMessages.OnboardingNetworkSetupResponseNew", [
            { no: 1, name: "status", kind: "enum", T: () => ["ProtoMessages.OnboardingNetworkSetupResponseNew.NetworkSetupResponseStatus", OnboardingNetworkSetupResponseNew_NetworkSetupResponseStatus] },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OnboardingNetworkSetupResponseNew>): OnboardingNetworkSetupResponseNew {
        const message = { status: 0, description: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingNetworkSetupResponseNew>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingNetworkSetupResponseNew): OnboardingNetworkSetupResponseNew {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.OnboardingNetworkSetupResponseNew.NetworkSetupResponseStatus status */ 1:
                    message.status = reader.int32();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingNetworkSetupResponseNew, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.OnboardingNetworkSetupResponseNew.NetworkSetupResponseStatus status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingNetworkSetupResponseNew
 */
export const OnboardingNetworkSetupResponseNew = new OnboardingNetworkSetupResponseNew$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingNetworkSetupUserFeedback$Type extends MessageType$<OnboardingNetworkSetupUserFeedback> {
    constructor() {
        super("ProtoMessages.OnboardingNetworkSetupUserFeedback", [
            { no: 1, name: "approved", kind: "message", T: () => Bool },
            { no: 2, name: "fromConnectApp", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<OnboardingNetworkSetupUserFeedback>): OnboardingNetworkSetupUserFeedback {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingNetworkSetupUserFeedback>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingNetworkSetupUserFeedback): OnboardingNetworkSetupUserFeedback {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool approved */ 1:
                    message.approved = Bool.internalBinaryRead(reader, reader.uint32(), options, message.approved);
                    break;
                case /* ProtoMessages.Bool fromConnectApp */ 2:
                    message.fromConnectApp = Bool.internalBinaryRead(reader, reader.uint32(), options, message.fromConnectApp);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingNetworkSetupUserFeedback, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool approved = 1; */
        if (message.approved)
            Bool.internalBinaryWrite(message.approved, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool fromConnectApp = 2; */
        if (message.fromConnectApp)
            Bool.internalBinaryWrite(message.fromConnectApp, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingNetworkSetupUserFeedback
 */
export const OnboardingNetworkSetupUserFeedback = new OnboardingNetworkSetupUserFeedback$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingFullNetworkTestRequest$Type extends MessageType$<OnboardingFullNetworkTestRequest> {
    constructor() {
        super("ProtoMessages.OnboardingFullNetworkTestRequest", [
            { no: 1, name: "test", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<OnboardingFullNetworkTestRequest>): OnboardingFullNetworkTestRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingFullNetworkTestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingFullNetworkTestRequest): OnboardingFullNetworkTestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool test */ 1:
                    message.test = Bool.internalBinaryRead(reader, reader.uint32(), options, message.test);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingFullNetworkTestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool test = 1; */
        if (message.test)
            Bool.internalBinaryWrite(message.test, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingFullNetworkTestRequest
 */
export const OnboardingFullNetworkTestRequest = new OnboardingFullNetworkTestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PairingInProgressQuery$Type extends MessageType$<PairingInProgressQuery> {
    constructor() {
        super("ProtoMessages.PairingInProgressQuery", [
            { no: 1, name: "checkForRunningPairing", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<PairingInProgressQuery>): PairingInProgressQuery {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PairingInProgressQuery>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PairingInProgressQuery): PairingInProgressQuery {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool checkForRunningPairing */ 1:
                    message.checkForRunningPairing = Bool.internalBinaryRead(reader, reader.uint32(), options, message.checkForRunningPairing);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PairingInProgressQuery, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool checkForRunningPairing = 1; */
        if (message.checkForRunningPairing)
            Bool.internalBinaryWrite(message.checkForRunningPairing, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PairingInProgressQuery
 */
export const PairingInProgressQuery = new PairingInProgressQuery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PairingInProgressResponse$Type extends MessageType$<PairingInProgressResponse> {
    constructor() {
        super("ProtoMessages.PairingInProgressResponse", [
            { no: 1, name: "pairingAlreadyRunning", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<PairingInProgressResponse>): PairingInProgressResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PairingInProgressResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PairingInProgressResponse): PairingInProgressResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool pairingAlreadyRunning */ 1:
                    message.pairingAlreadyRunning = Bool.internalBinaryRead(reader, reader.uint32(), options, message.pairingAlreadyRunning);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PairingInProgressResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool pairingAlreadyRunning = 1; */
        if (message.pairingAlreadyRunning)
            Bool.internalBinaryWrite(message.pairingAlreadyRunning, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PairingInProgressResponse
 */
export const PairingInProgressResponse = new PairingInProgressResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TokenRequest$Type extends MessageType$<TokenRequest> {
    constructor() {
        super("ProtoMessages.TokenRequest", [
            { no: 1, name: "requestToken", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<TokenRequest>): TokenRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TokenRequest): TokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool requestToken */ 1:
                    message.requestToken = Bool.internalBinaryRead(reader, reader.uint32(), options, message.requestToken);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool requestToken = 1; */
        if (message.requestToken)
            Bool.internalBinaryWrite(message.requestToken, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.TokenRequest
 */
export const TokenRequest = new TokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TokenResponse$Type extends MessageType$<TokenResponse> {
    constructor() {
        super("ProtoMessages.TokenResponse", [
            { no: 1, name: "wsproxyAddress", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "success", kind: "message", T: () => Bool },
            { no: 4, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TokenResponse>): TokenResponse {
        const message = { wsproxyAddress: "", token: "", errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TokenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TokenResponse): TokenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string wsproxyAddress */ 1:
                    message.wsproxyAddress = reader.string();
                    break;
                case /* string token */ 2:
                    message.token = reader.string();
                    break;
                case /* ProtoMessages.Bool success */ 3:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 4:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TokenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string wsproxyAddress = 1; */
        if (message.wsproxyAddress !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.wsproxyAddress);
        /* string token = 2; */
        if (message.token !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.token);
        /* ProtoMessages.Bool success = 3; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 4; */
        if (message.errorMessage !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.TokenResponse
 */
export const TokenResponse = new TokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VenueSelfTestRequest$Type extends MessageType$<VenueSelfTestRequest> {
    constructor() {
        super("ProtoMessages.VenueSelfTestRequest", [
            { no: 1, name: "runTest", kind: "message", T: () => Bool },
            { no: 2, name: "vpumSessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VenueSelfTestRequest>): VenueSelfTestRequest {
        const message = { vpumSessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VenueSelfTestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VenueSelfTestRequest): VenueSelfTestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool runTest */ 1:
                    message.runTest = Bool.internalBinaryRead(reader, reader.uint32(), options, message.runTest);
                    break;
                case /* string vpumSessionId */ 2:
                    message.vpumSessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VenueSelfTestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool runTest = 1; */
        if (message.runTest)
            Bool.internalBinaryWrite(message.runTest, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string vpumSessionId = 2; */
        if (message.vpumSessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.vpumSessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VenueSelfTestRequest
 */
export const VenueSelfTestRequest = new VenueSelfTestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraTestRequest$Type extends MessageType$<CameraTestRequest> {
    constructor() {
        super("ProtoMessages.CameraTestRequest", [
            { no: 1, name: "runTest", kind: "message", T: () => Bool },
            { no: 2, name: "vpumSessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CameraTestRequest>): CameraTestRequest {
        const message = { vpumSessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraTestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraTestRequest): CameraTestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool runTest */ 1:
                    message.runTest = Bool.internalBinaryRead(reader, reader.uint32(), options, message.runTest);
                    break;
                case /* string vpumSessionId */ 2:
                    message.vpumSessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraTestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool runTest = 1; */
        if (message.runTest)
            Bool.internalBinaryWrite(message.runTest, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string vpumSessionId = 2; */
        if (message.vpumSessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.vpumSessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraTestRequest
 */
export const CameraTestRequest = new CameraTestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdvancedCameraTestRequest$Type extends MessageType$<AdvancedCameraTestRequest> {
    constructor() {
        super("ProtoMessages.AdvancedCameraTestRequest", [
            { no: 1, name: "runTest", kind: "message", T: () => Bool },
            { no: 2, name: "vpumSessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AdvancedCameraTestRequest>): AdvancedCameraTestRequest {
        const message = { vpumSessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdvancedCameraTestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdvancedCameraTestRequest): AdvancedCameraTestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool runTest */ 1:
                    message.runTest = Bool.internalBinaryRead(reader, reader.uint32(), options, message.runTest);
                    break;
                case /* string vpumSessionId */ 2:
                    message.vpumSessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdvancedCameraTestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool runTest = 1; */
        if (message.runTest)
            Bool.internalBinaryWrite(message.runTest, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string vpumSessionId = 2; */
        if (message.vpumSessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.vpumSessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdvancedCameraTestRequest
 */
export const AdvancedCameraTestRequest = new AdvancedCameraTestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class POETestRequest$Type extends MessageType$<POETestRequest> {
    constructor() {
        super("ProtoMessages.POETestRequest", [
            { no: 1, name: "runTest", kind: "message", T: () => Bool },
            { no: 2, name: "vpumSessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<POETestRequest>): POETestRequest {
        const message = { vpumSessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<POETestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: POETestRequest): POETestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool runTest */ 1:
                    message.runTest = Bool.internalBinaryRead(reader, reader.uint32(), options, message.runTest);
                    break;
                case /* string vpumSessionId */ 2:
                    message.vpumSessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: POETestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool runTest = 1; */
        if (message.runTest)
            Bool.internalBinaryWrite(message.runTest, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string vpumSessionId = 2; */
        if (message.vpumSessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.vpumSessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.POETestRequest
 */
export const POETestRequest = new POETestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingCameraTestResponse$Type extends MessageType$<OnboardingCameraTestResponse> {
    constructor() {
        super("ProtoMessages.OnboardingCameraTestResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "advancedTestResults", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => IndividualCameraTestResult },
            { no: 4, name: "mainCameraSuccess", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<OnboardingCameraTestResponse>): OnboardingCameraTestResponse {
        const message = { errorMessage: "", advancedTestResults: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingCameraTestResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingCameraTestResponse): OnboardingCameraTestResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* repeated ProtoMessages.IndividualCameraTestResult advancedTestResults */ 3:
                    message.advancedTestResults.push(IndividualCameraTestResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* ProtoMessages.Bool mainCameraSuccess */ 4:
                    message.mainCameraSuccess = Bool.internalBinaryRead(reader, reader.uint32(), options, message.mainCameraSuccess);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingCameraTestResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* repeated ProtoMessages.IndividualCameraTestResult advancedTestResults = 3; */
        for (let i = 0; i < message.advancedTestResults.length; i++)
            IndividualCameraTestResult.internalBinaryWrite(message.advancedTestResults[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool mainCameraSuccess = 4; */
        if (message.mainCameraSuccess)
            Bool.internalBinaryWrite(message.mainCameraSuccess, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingCameraTestResponse
 */
export const OnboardingCameraTestResponse = new OnboardingCameraTestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingGPUTestResponse$Type extends MessageType$<OnboardingGPUTestResponse> {
    constructor() {
        super("ProtoMessages.OnboardingGPUTestResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OnboardingGPUTestResponse>): OnboardingGPUTestResponse {
        const message = { errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingGPUTestResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingGPUTestResponse): OnboardingGPUTestResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingGPUTestResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingGPUTestResponse
 */
export const OnboardingGPUTestResponse = new OnboardingGPUTestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class POETestResponse$Type extends MessageType$<POETestResponse> {
    constructor() {
        super("ProtoMessages.POETestResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "poeErrors", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => POEError }
        ]);
    }
    create(value?: PartialMessage<POETestResponse>): POETestResponse {
        const message = { errorMessage: "", poeErrors: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<POETestResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: POETestResponse): POETestResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* repeated ProtoMessages.POEError poeErrors */ 3:
                    message.poeErrors.push(POEError.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: POETestResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* repeated ProtoMessages.POEError poeErrors = 3; */
        for (let i = 0; i < message.poeErrors.length; i++)
            POEError.internalBinaryWrite(message.poeErrors[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.POETestResponse
 */
export const POETestResponse = new POETestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class POEError$Type extends MessageType$<POEError> {
    constructor() {
        super("ProtoMessages.POEError", [
            { no: 1, name: "errorType", kind: "enum", T: () => ["ProtoMessages.POEErrorType", POEErrorType] },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "temperature", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "powerDetected", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "powerBudget", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<POEError>): POEError {
        const message = { errorType: 0, description: "", temperature: 0, powerDetected: 0, powerBudget: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<POEError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: POEError): POEError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.POEErrorType errorType */ 1:
                    message.errorType = reader.int32();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* double temperature */ 3:
                    message.temperature = reader.double();
                    break;
                case /* double powerDetected */ 4:
                    message.powerDetected = reader.double();
                    break;
                case /* double powerBudget */ 5:
                    message.powerBudget = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: POEError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.POEErrorType errorType = 1; */
        if (message.errorType !== 0)
            writer.tag(1, WireType.Varint).int32(message.errorType);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* double temperature = 3; */
        if (message.temperature !== 0)
            writer.tag(3, WireType.Bit64).double(message.temperature);
        /* double powerDetected = 4; */
        if (message.powerDetected !== 0)
            writer.tag(4, WireType.Bit64).double(message.powerDetected);
        /* double powerBudget = 5; */
        if (message.powerBudget !== 0)
            writer.tag(5, WireType.Bit64).double(message.powerBudget);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.POEError
 */
export const POEError = new POEError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VenueSelfTestResult$Type extends MessageType$<VenueSelfTestResult> {
    constructor() {
        super("ProtoMessages.VenueSelfTestResult", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "manual", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<VenueSelfTestResult>): VenueSelfTestResult {
        const message = { success: false, errorMessage: "", manual: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VenueSelfTestResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VenueSelfTestResult): VenueSelfTestResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* bool manual */ 3:
                    message.manual = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VenueSelfTestResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* bool manual = 3; */
        if (message.manual !== false)
            writer.tag(3, WireType.Varint).bool(message.manual);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VenueSelfTestResult
 */
export const VenueSelfTestResult = new VenueSelfTestResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdvancedCameraTestResult$Type extends MessageType$<AdvancedCameraTestResult> {
    constructor() {
        super("ProtoMessages.AdvancedCameraTestResult", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "testResults", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => IndividualCameraTestResult }
        ]);
    }
    create(value?: PartialMessage<AdvancedCameraTestResult>): AdvancedCameraTestResult {
        const message = { success: false, testResults: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AdvancedCameraTestResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdvancedCameraTestResult): AdvancedCameraTestResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* repeated ProtoMessages.IndividualCameraTestResult testResults */ 2:
                    message.testResults.push(IndividualCameraTestResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdvancedCameraTestResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* repeated ProtoMessages.IndividualCameraTestResult testResults = 2; */
        for (let i = 0; i < message.testResults.length; i++)
            IndividualCameraTestResult.internalBinaryWrite(message.testResults[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AdvancedCameraTestResult
 */
export const AdvancedCameraTestResult = new AdvancedCameraTestResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraTestProcessResult$Type extends MessageType$<CameraTestProcessResult> {
    constructor() {
        super("ProtoMessages.CameraTestProcessResult", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "error_type", kind: "enum", T: () => ["ProtoMessages.CameraErrorType", CameraErrorType] },
            { no: 4, name: "test_results", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => IndividualCameraTestResult }
        ]);
    }
    create(value?: PartialMessage<CameraTestProcessResult>): CameraTestProcessResult {
        const message = { errorMessage: "", errorType: 0, testResults: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraTestProcessResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraTestProcessResult): CameraTestProcessResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string error_message */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* ProtoMessages.CameraErrorType error_type */ 3:
                    message.errorType = reader.int32();
                    break;
                case /* repeated ProtoMessages.IndividualCameraTestResult test_results */ 4:
                    message.testResults.push(IndividualCameraTestResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraTestProcessResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string error_message = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* ProtoMessages.CameraErrorType error_type = 3; */
        if (message.errorType !== 0)
            writer.tag(3, WireType.Varint).int32(message.errorType);
        /* repeated ProtoMessages.IndividualCameraTestResult test_results = 4; */
        for (let i = 0; i < message.testResults.length; i++)
            IndividualCameraTestResult.internalBinaryWrite(message.testResults[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraTestProcessResult
 */
export const CameraTestProcessResult = new CameraTestProcessResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VenueSelfTestResponse$Type extends MessageType$<VenueSelfTestResponse> {
    constructor() {
        super("ProtoMessages.VenueSelfTestResponse", [
            { no: 1, name: "networkTestResponse", kind: "message", T: () => NetworkTestResult },
            { no: 2, name: "cameraTestResponse", kind: "message", T: () => OnboardingCameraTestResponse },
            { no: 3, name: "gpuTestResponse", kind: "message", T: () => OnboardingGPUTestResponse },
            { no: 4, name: "venueSelfTestResult", kind: "message", T: () => VenueSelfTestResult },
            { no: 5, name: "HwTestsResults", kind: "message", jsonName: "HwTestsResults", T: () => SelfTestHwTestResults }
        ]);
    }
    create(value?: PartialMessage<VenueSelfTestResponse>): VenueSelfTestResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VenueSelfTestResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VenueSelfTestResponse): VenueSelfTestResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.NetworkTestResult networkTestResponse */ 1:
                    message.networkTestResponse = NetworkTestResult.internalBinaryRead(reader, reader.uint32(), options, message.networkTestResponse);
                    break;
                case /* ProtoMessages.OnboardingCameraTestResponse cameraTestResponse */ 2:
                    message.cameraTestResponse = OnboardingCameraTestResponse.internalBinaryRead(reader, reader.uint32(), options, message.cameraTestResponse);
                    break;
                case /* ProtoMessages.OnboardingGPUTestResponse gpuTestResponse */ 3:
                    message.gpuTestResponse = OnboardingGPUTestResponse.internalBinaryRead(reader, reader.uint32(), options, message.gpuTestResponse);
                    break;
                case /* ProtoMessages.VenueSelfTestResult venueSelfTestResult */ 4:
                    message.venueSelfTestResult = VenueSelfTestResult.internalBinaryRead(reader, reader.uint32(), options, message.venueSelfTestResult);
                    break;
                case /* ProtoMessages.SelfTestHwTestResults HwTestsResults = 5 [json_name = "HwTestsResults"];*/ 5:
                    message.hwTestsResults = SelfTestHwTestResults.internalBinaryRead(reader, reader.uint32(), options, message.hwTestsResults);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VenueSelfTestResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.NetworkTestResult networkTestResponse = 1; */
        if (message.networkTestResponse)
            NetworkTestResult.internalBinaryWrite(message.networkTestResponse, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.OnboardingCameraTestResponse cameraTestResponse = 2; */
        if (message.cameraTestResponse)
            OnboardingCameraTestResponse.internalBinaryWrite(message.cameraTestResponse, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.OnboardingGPUTestResponse gpuTestResponse = 3; */
        if (message.gpuTestResponse)
            OnboardingGPUTestResponse.internalBinaryWrite(message.gpuTestResponse, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.VenueSelfTestResult venueSelfTestResult = 4; */
        if (message.venueSelfTestResult)
            VenueSelfTestResult.internalBinaryWrite(message.venueSelfTestResult, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.SelfTestHwTestResults HwTestsResults = 5 [json_name = "HwTestsResults"]; */
        if (message.hwTestsResults)
            SelfTestHwTestResults.internalBinaryWrite(message.hwTestsResults, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VenueSelfTestResponse
 */
export const VenueSelfTestResponse = new VenueSelfTestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SelfTestHwTestResults$Type extends MessageType$<SelfTestHwTestResults> {
    constructor() {
        super("ProtoMessages.SelfTestHwTestResults", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "ramMemoryCapacityOk", kind: "message", T: () => Bool },
            { no: 3, name: "poeDetected", kind: "message", T: () => Bool },
            { no: 4, name: "wifiDetected", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<SelfTestHwTestResults>): SelfTestHwTestResults {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SelfTestHwTestResults>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SelfTestHwTestResults): SelfTestHwTestResults {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* ProtoMessages.Bool ramMemoryCapacityOk */ 2:
                    message.ramMemoryCapacityOk = Bool.internalBinaryRead(reader, reader.uint32(), options, message.ramMemoryCapacityOk);
                    break;
                case /* ProtoMessages.Bool poeDetected */ 3:
                    message.poeDetected = Bool.internalBinaryRead(reader, reader.uint32(), options, message.poeDetected);
                    break;
                case /* ProtoMessages.Bool wifiDetected */ 4:
                    message.wifiDetected = Bool.internalBinaryRead(reader, reader.uint32(), options, message.wifiDetected);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SelfTestHwTestResults, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool ramMemoryCapacityOk = 2; */
        if (message.ramMemoryCapacityOk)
            Bool.internalBinaryWrite(message.ramMemoryCapacityOk, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool poeDetected = 3; */
        if (message.poeDetected)
            Bool.internalBinaryWrite(message.poeDetected, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool wifiDetected = 4; */
        if (message.wifiDetected)
            Bool.internalBinaryWrite(message.wifiDetected, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SelfTestHwTestResults
 */
export const SelfTestHwTestResults = new SelfTestHwTestResults$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingHandshakeRequest$Type extends MessageType$<OnboardingHandshakeRequest> {
    constructor() {
        super("ProtoMessages.OnboardingHandshakeRequest", [
            { no: 1, name: "request", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<OnboardingHandshakeRequest>): OnboardingHandshakeRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingHandshakeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingHandshakeRequest): OnboardingHandshakeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool request */ 1:
                    message.request = Bool.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingHandshakeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool request = 1; */
        if (message.request)
            Bool.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingHandshakeRequest
 */
export const OnboardingHandshakeRequest = new OnboardingHandshakeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingHandshakeReply$Type extends MessageType$<OnboardingHandshakeReply> {
    constructor() {
        super("ProtoMessages.OnboardingHandshakeReply", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "venueId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OnboardingHandshakeReply>): OnboardingHandshakeReply {
        const message = { version: "", venueId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingHandshakeReply>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingHandshakeReply): OnboardingHandshakeReply {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string version */ 1:
                    message.version = reader.string();
                    break;
                case /* string venueId */ 2:
                    message.venueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingHandshakeReply, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string version = 1; */
        if (message.version !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.version);
        /* string venueId = 2; */
        if (message.venueId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.venueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingHandshakeReply
 */
export const OnboardingHandshakeReply = new OnboardingHandshakeReply$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingOcrZoomRequest$Type extends MessageType$<OnboardingOcrZoomRequest> {
    constructor() {
        super("ProtoMessages.OnboardingOcrZoomRequest", [
            { no: 1, name: "zoom", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OnboardingOcrZoomRequest>): OnboardingOcrZoomRequest {
        const message = { zoom: 0, requestId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingOcrZoomRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingOcrZoomRequest): OnboardingOcrZoomRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 zoom */ 1:
                    message.zoom = reader.int32();
                    break;
                case /* string requestId */ 2:
                    message.requestId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingOcrZoomRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 zoom = 1; */
        if (message.zoom !== 0)
            writer.tag(1, WireType.Varint).int32(message.zoom);
        /* string requestId = 2; */
        if (message.requestId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingOcrZoomRequest
 */
export const OnboardingOcrZoomRequest = new OnboardingOcrZoomRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingOcrAutoFocusRequest$Type extends MessageType$<OnboardingOcrAutoFocusRequest> {
    constructor() {
        super("ProtoMessages.OnboardingOcrAutoFocusRequest", [
            { no: 1, name: "request", kind: "message", T: () => Bool },
            { no: 2, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OnboardingOcrAutoFocusRequest>): OnboardingOcrAutoFocusRequest {
        const message = { requestId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingOcrAutoFocusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingOcrAutoFocusRequest): OnboardingOcrAutoFocusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool request */ 1:
                    message.request = Bool.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                case /* string requestId */ 2:
                    message.requestId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingOcrAutoFocusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool request = 1; */
        if (message.request)
            Bool.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string requestId = 2; */
        if (message.requestId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.requestId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingOcrAutoFocusRequest
 */
export const OnboardingOcrAutoFocusRequest = new OnboardingOcrAutoFocusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingPipCameraPairingRequest$Type extends MessageType$<OnboardingPipCameraPairingRequest> {
    constructor() {
        super("ProtoMessages.OnboardingPipCameraPairingRequest", [
            { no: 1, name: "request", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<OnboardingPipCameraPairingRequest>): OnboardingPipCameraPairingRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingPipCameraPairingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingPipCameraPairingRequest): OnboardingPipCameraPairingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool request */ 1:
                    message.request = Bool.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingPipCameraPairingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool request = 1; */
        if (message.request)
            Bool.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingPipCameraPairingRequest
 */
export const OnboardingPipCameraPairingRequest = new OnboardingPipCameraPairingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingPipCameraPairingResponse$Type extends MessageType$<OnboardingPipCameraPairingResponse> {
    constructor() {
        super("ProtoMessages.OnboardingPipCameraPairingResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OnboardingPipCameraPairingResponse>): OnboardingPipCameraPairingResponse {
        const message = { errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingPipCameraPairingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingPipCameraPairingResponse): OnboardingPipCameraPairingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingPipCameraPairingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingPipCameraPairingResponse
 */
export const OnboardingPipCameraPairingResponse = new OnboardingPipCameraPairingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingRunPipInSetupModeRequest$Type extends MessageType$<OnboardingRunPipInSetupModeRequest> {
    constructor() {
        super("ProtoMessages.OnboardingRunPipInSetupModeRequest", [
            { no: 1, name: "run", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<OnboardingRunPipInSetupModeRequest>): OnboardingRunPipInSetupModeRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingRunPipInSetupModeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingRunPipInSetupModeRequest): OnboardingRunPipInSetupModeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool run */ 1:
                    message.run = Bool.internalBinaryRead(reader, reader.uint32(), options, message.run);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingRunPipInSetupModeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool run = 1; */
        if (message.run)
            Bool.internalBinaryWrite(message.run, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingRunPipInSetupModeRequest
 */
export const OnboardingRunPipInSetupModeRequest = new OnboardingRunPipInSetupModeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingStopPipInSetupModeRequest$Type extends MessageType$<OnboardingStopPipInSetupModeRequest> {
    constructor() {
        super("ProtoMessages.OnboardingStopPipInSetupModeRequest", [
            { no: 1, name: "stop", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<OnboardingStopPipInSetupModeRequest>): OnboardingStopPipInSetupModeRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingStopPipInSetupModeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingStopPipInSetupModeRequest): OnboardingStopPipInSetupModeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool stop */ 1:
                    message.stop = Bool.internalBinaryRead(reader, reader.uint32(), options, message.stop);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingStopPipInSetupModeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool stop = 1; */
        if (message.stop)
            Bool.internalBinaryWrite(message.stop, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingStopPipInSetupModeRequest
 */
export const OnboardingStopPipInSetupModeRequest = new OnboardingStopPipInSetupModeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestLastPairingDetails$Type extends MessageType$<RequestLastPairingDetails> {
    constructor() {
        super("ProtoMessages.RequestLastPairingDetails", [
            { no: 1, name: "request", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<RequestLastPairingDetails>): RequestLastPairingDetails {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RequestLastPairingDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestLastPairingDetails): RequestLastPairingDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool request */ 1:
                    message.request = Bool.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestLastPairingDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool request = 1; */
        if (message.request)
            Bool.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.RequestLastPairingDetails
 */
export const RequestLastPairingDetails = new RequestLastPairingDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LastPairingDetails$Type extends MessageType$<LastPairingDetails> {
    constructor() {
        super("ProtoMessages.LastPairingDetails", [
            { no: 1, name: "LastPaired", kind: "enum", jsonName: "LastPaired", T: () => ["ProtoMessages.LastPairingDetails.PairingType", LastPairingDetails_PairingType] },
            { no: 2, name: "TimeDateStart", kind: "scalar", jsonName: "TimeDateStart", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "TimeDateEnd", kind: "scalar", jsonName: "TimeDateEnd", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "DataAvailable", kind: "message", jsonName: "DataAvailable", T: () => Bool },
            { no: 5, name: "Successful", kind: "message", jsonName: "Successful", T: () => Bool },
            { no: 6, name: "ErrorMessage", kind: "scalar", jsonName: "ErrorMessage", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<LastPairingDetails>): LastPairingDetails {
        const message = { lastPaired: 0, timeDateStart: "", timeDateEnd: "", errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LastPairingDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LastPairingDetails): LastPairingDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.LastPairingDetails.PairingType LastPaired = 1 [json_name = "LastPaired"];*/ 1:
                    message.lastPaired = reader.int32();
                    break;
                case /* string TimeDateStart = 2 [json_name = "TimeDateStart"];*/ 2:
                    message.timeDateStart = reader.string();
                    break;
                case /* string TimeDateEnd = 3 [json_name = "TimeDateEnd"];*/ 3:
                    message.timeDateEnd = reader.string();
                    break;
                case /* ProtoMessages.Bool DataAvailable = 4 [json_name = "DataAvailable"];*/ 4:
                    message.dataAvailable = Bool.internalBinaryRead(reader, reader.uint32(), options, message.dataAvailable);
                    break;
                case /* ProtoMessages.Bool Successful = 5 [json_name = "Successful"];*/ 5:
                    message.successful = Bool.internalBinaryRead(reader, reader.uint32(), options, message.successful);
                    break;
                case /* string ErrorMessage = 6 [json_name = "ErrorMessage"];*/ 6:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LastPairingDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.LastPairingDetails.PairingType LastPaired = 1 [json_name = "LastPaired"]; */
        if (message.lastPaired !== 0)
            writer.tag(1, WireType.Varint).int32(message.lastPaired);
        /* string TimeDateStart = 2 [json_name = "TimeDateStart"]; */
        if (message.timeDateStart !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.timeDateStart);
        /* string TimeDateEnd = 3 [json_name = "TimeDateEnd"]; */
        if (message.timeDateEnd !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.timeDateEnd);
        /* ProtoMessages.Bool DataAvailable = 4 [json_name = "DataAvailable"]; */
        if (message.dataAvailable)
            Bool.internalBinaryWrite(message.dataAvailable, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool Successful = 5 [json_name = "Successful"]; */
        if (message.successful)
            Bool.internalBinaryWrite(message.successful, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string ErrorMessage = 6 [json_name = "ErrorMessage"]; */
        if (message.errorMessage !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.LastPairingDetails
 */
export const LastPairingDetails = new LastPairingDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LastPairingDetailsRequest$Type extends MessageType$<LastPairingDetailsRequest> {
    constructor() {
        super("ProtoMessages.LastPairingDetailsRequest", [
            { no: 1, name: "request", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<LastPairingDetailsRequest>): LastPairingDetailsRequest {
        const message = { request: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LastPairingDetailsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LastPairingDetailsRequest): LastPairingDetailsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool request */ 1:
                    message.request = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LastPairingDetailsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool request = 1; */
        if (message.request !== false)
            writer.tag(1, WireType.Varint).bool(message.request);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.LastPairingDetailsRequest
 */
export const LastPairingDetailsRequest = new LastPairingDetailsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LastPairingDetailsResponse$Type extends MessageType$<LastPairingDetailsResponse> {
    constructor() {
        super("ProtoMessages.LastPairingDetailsResponse", [
            { no: 1, name: "details", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => LastPairingDetailsResponse_pairingDetails }
        ]);
    }
    create(value?: PartialMessage<LastPairingDetailsResponse>): LastPairingDetailsResponse {
        const message = { details: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LastPairingDetailsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LastPairingDetailsResponse): LastPairingDetailsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.LastPairingDetailsResponse.pairingDetails details */ 1:
                    message.details.push(LastPairingDetailsResponse_pairingDetails.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LastPairingDetailsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.LastPairingDetailsResponse.pairingDetails details = 1; */
        for (let i = 0; i < message.details.length; i++)
            LastPairingDetailsResponse_pairingDetails.internalBinaryWrite(message.details[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.LastPairingDetailsResponse
 */
export const LastPairingDetailsResponse = new LastPairingDetailsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LastPairingDetailsResponse_pairingDetails$Type extends MessageType$<LastPairingDetailsResponse_pairingDetails> {
    constructor() {
        super("ProtoMessages.LastPairingDetailsResponse.pairingDetails", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.LastPairingDetailsResponse.pairingDetails.AditionalCameraType", LastPairingDetailsResponse_pairingDetails_AditionalCameraType] },
            { no: 2, name: "connectionType", kind: "enum", T: () => ["ProtoMessages.AdditionalCameraConnectionType", AdditionalCameraConnectionType] },
            { no: 3, name: "ip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "mac", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "lastTimePairingTimeStampUTC", kind: "message", T: () => Uint64 },
            { no: 6, name: "status", kind: "message", T: () => Bool },
            { no: 7, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "cameraIndex", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<LastPairingDetailsResponse_pairingDetails>): LastPairingDetailsResponse_pairingDetails {
        const message = { cameraType: 0, connectionType: 0, ip: "", mac: "", success: false, cameraIndex: 0, model: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LastPairingDetailsResponse_pairingDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LastPairingDetailsResponse_pairingDetails): LastPairingDetailsResponse_pairingDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.LastPairingDetailsResponse.pairingDetails.AditionalCameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                case /* ProtoMessages.AdditionalCameraConnectionType connectionType */ 2:
                    message.connectionType = reader.int32();
                    break;
                case /* string ip */ 3:
                    message.ip = reader.string();
                    break;
                case /* string mac */ 4:
                    message.mac = reader.string();
                    break;
                case /* ProtoMessages.Uint64 lastTimePairingTimeStampUTC */ 5:
                    message.lastTimePairingTimeStampUTC = Uint64.internalBinaryRead(reader, reader.uint32(), options, message.lastTimePairingTimeStampUTC);
                    break;
                case /* ProtoMessages.Bool status */ 6:
                    message.status = Bool.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* bool success */ 7:
                    message.success = reader.bool();
                    break;
                case /* int32 cameraIndex */ 8:
                    message.cameraIndex = reader.int32();
                    break;
                case /* string model */ 9:
                    message.model = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LastPairingDetailsResponse_pairingDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.LastPairingDetailsResponse.pairingDetails.AditionalCameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        /* ProtoMessages.AdditionalCameraConnectionType connectionType = 2; */
        if (message.connectionType !== 0)
            writer.tag(2, WireType.Varint).int32(message.connectionType);
        /* string ip = 3; */
        if (message.ip !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.ip);
        /* string mac = 4; */
        if (message.mac !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.mac);
        /* ProtoMessages.Uint64 lastTimePairingTimeStampUTC = 5; */
        if (message.lastTimePairingTimeStampUTC)
            Uint64.internalBinaryWrite(message.lastTimePairingTimeStampUTC, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool status = 6; */
        if (message.status)
            Bool.internalBinaryWrite(message.status, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool success = 7; */
        if (message.success !== false)
            writer.tag(7, WireType.Varint).bool(message.success);
        /* int32 cameraIndex = 8; */
        if (message.cameraIndex !== 0)
            writer.tag(8, WireType.Varint).int32(message.cameraIndex);
        /* string model = 9; */
        if (message.model !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.model);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.LastPairingDetailsResponse.pairingDetails
 */
export const LastPairingDetailsResponse_pairingDetails = new LastPairingDetailsResponse_pairingDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChuLastPairingDetailsRequest$Type extends MessageType$<ChuLastPairingDetailsRequest> {
    constructor() {
        super("ProtoMessages.ChuLastPairingDetailsRequest", [
            { no: 1, name: "request", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ChuLastPairingDetailsRequest>): ChuLastPairingDetailsRequest {
        const message = { request: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChuLastPairingDetailsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChuLastPairingDetailsRequest): ChuLastPairingDetailsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool request */ 1:
                    message.request = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChuLastPairingDetailsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool request = 1; */
        if (message.request !== false)
            writer.tag(1, WireType.Varint).bool(message.request);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ChuLastPairingDetailsRequest
 */
export const ChuLastPairingDetailsRequest = new ChuLastPairingDetailsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChuLastPairingDetailsResponse$Type extends MessageType$<ChuLastPairingDetailsResponse> {
    constructor() {
        super("ProtoMessages.ChuLastPairingDetailsResponse", [
            { no: 1, name: "pairingdata", kind: "message", T: () => RunPairingWithData },
            { no: 2, name: "success", kind: "message", T: () => Bool },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ChuLastPairingDetailsResponse>): ChuLastPairingDetailsResponse {
        const message = { errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChuLastPairingDetailsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChuLastPairingDetailsResponse): ChuLastPairingDetailsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.RunPairingWithData pairingdata */ 1:
                    message.pairingdata = RunPairingWithData.internalBinaryRead(reader, reader.uint32(), options, message.pairingdata);
                    break;
                case /* ProtoMessages.Bool success */ 2:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChuLastPairingDetailsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.RunPairingWithData pairingdata = 1; */
        if (message.pairingdata)
            RunPairingWithData.internalBinaryWrite(message.pairingdata, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool success = 2; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ChuLastPairingDetailsResponse
 */
export const ChuLastPairingDetailsResponse = new ChuLastPairingDetailsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestLatestVenueSelfTest$Type extends MessageType$<RequestLatestVenueSelfTest> {
    constructor() {
        super("ProtoMessages.RequestLatestVenueSelfTest", [
            { no: 1, name: "request", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<RequestLatestVenueSelfTest>): RequestLatestVenueSelfTest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RequestLatestVenueSelfTest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestLatestVenueSelfTest): RequestLatestVenueSelfTest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool request */ 1:
                    message.request = Bool.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestLatestVenueSelfTest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool request = 1; */
        if (message.request)
            Bool.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.RequestLatestVenueSelfTest
 */
export const RequestLatestVenueSelfTest = new RequestLatestVenueSelfTest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LatestVenueSelfTestResponse$Type extends MessageType$<LatestVenueSelfTestResponse> {
    constructor() {
        super("ProtoMessages.LatestVenueSelfTestResponse", [
            { no: 1, name: "DataAvailable", kind: "message", jsonName: "DataAvailable", T: () => Bool },
            { no: 2, name: "TimeDateStart", kind: "scalar", jsonName: "TimeDateStart", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "TimeDateEnd", kind: "scalar", jsonName: "TimeDateEnd", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "NetworkTestResponse", kind: "message", jsonName: "NetworkTestResponse", T: () => NetworkTestResult },
            { no: 5, name: "CameraTestResponse", kind: "message", jsonName: "CameraTestResponse", T: () => OnboardingCameraTestResponse },
            { no: 6, name: "GpuTestResponse", kind: "message", jsonName: "GpuTestResponse", T: () => OnboardingGPUTestResponse },
            { no: 7, name: "HwTestsResults", kind: "message", jsonName: "HwTestsResults", T: () => SelfTestHwTestResults }
        ]);
    }
    create(value?: PartialMessage<LatestVenueSelfTestResponse>): LatestVenueSelfTestResponse {
        const message = { timeDateStart: "", timeDateEnd: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LatestVenueSelfTestResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LatestVenueSelfTestResponse): LatestVenueSelfTestResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool DataAvailable = 1 [json_name = "DataAvailable"];*/ 1:
                    message.dataAvailable = Bool.internalBinaryRead(reader, reader.uint32(), options, message.dataAvailable);
                    break;
                case /* string TimeDateStart = 2 [json_name = "TimeDateStart"];*/ 2:
                    message.timeDateStart = reader.string();
                    break;
                case /* string TimeDateEnd = 3 [json_name = "TimeDateEnd"];*/ 3:
                    message.timeDateEnd = reader.string();
                    break;
                case /* ProtoMessages.NetworkTestResult NetworkTestResponse = 4 [json_name = "NetworkTestResponse"];*/ 4:
                    message.networkTestResponse = NetworkTestResult.internalBinaryRead(reader, reader.uint32(), options, message.networkTestResponse);
                    break;
                case /* ProtoMessages.OnboardingCameraTestResponse CameraTestResponse = 5 [json_name = "CameraTestResponse"];*/ 5:
                    message.cameraTestResponse = OnboardingCameraTestResponse.internalBinaryRead(reader, reader.uint32(), options, message.cameraTestResponse);
                    break;
                case /* ProtoMessages.OnboardingGPUTestResponse GpuTestResponse = 6 [json_name = "GpuTestResponse"];*/ 6:
                    message.gpuTestResponse = OnboardingGPUTestResponse.internalBinaryRead(reader, reader.uint32(), options, message.gpuTestResponse);
                    break;
                case /* ProtoMessages.SelfTestHwTestResults HwTestsResults = 7 [json_name = "HwTestsResults"];*/ 7:
                    message.hwTestsResults = SelfTestHwTestResults.internalBinaryRead(reader, reader.uint32(), options, message.hwTestsResults);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LatestVenueSelfTestResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool DataAvailable = 1 [json_name = "DataAvailable"]; */
        if (message.dataAvailable)
            Bool.internalBinaryWrite(message.dataAvailable, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string TimeDateStart = 2 [json_name = "TimeDateStart"]; */
        if (message.timeDateStart !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.timeDateStart);
        /* string TimeDateEnd = 3 [json_name = "TimeDateEnd"]; */
        if (message.timeDateEnd !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.timeDateEnd);
        /* ProtoMessages.NetworkTestResult NetworkTestResponse = 4 [json_name = "NetworkTestResponse"]; */
        if (message.networkTestResponse)
            NetworkTestResult.internalBinaryWrite(message.networkTestResponse, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.OnboardingCameraTestResponse CameraTestResponse = 5 [json_name = "CameraTestResponse"]; */
        if (message.cameraTestResponse)
            OnboardingCameraTestResponse.internalBinaryWrite(message.cameraTestResponse, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.OnboardingGPUTestResponse GpuTestResponse = 6 [json_name = "GpuTestResponse"]; */
        if (message.gpuTestResponse)
            OnboardingGPUTestResponse.internalBinaryWrite(message.gpuTestResponse, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.SelfTestHwTestResults HwTestsResults = 7 [json_name = "HwTestsResults"]; */
        if (message.hwTestsResults)
            SelfTestHwTestResults.internalBinaryWrite(message.hwTestsResults, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.LatestVenueSelfTestResponse
 */
export const LatestVenueSelfTestResponse = new LatestVenueSelfTestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkPipCalibrationAndStopPipRequest$Type extends MessageType$<MarkPipCalibrationAndStopPipRequest> {
    constructor() {
        super("ProtoMessages.MarkPipCalibrationAndStopPipRequest", [
            { no: 1, name: "set", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<MarkPipCalibrationAndStopPipRequest>): MarkPipCalibrationAndStopPipRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<MarkPipCalibrationAndStopPipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MarkPipCalibrationAndStopPipRequest): MarkPipCalibrationAndStopPipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool set */ 1:
                    message.set = Bool.internalBinaryRead(reader, reader.uint32(), options, message.set);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MarkPipCalibrationAndStopPipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool set = 1; */
        if (message.set)
            Bool.internalBinaryWrite(message.set, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.MarkPipCalibrationAndStopPipRequest
 */
export const MarkPipCalibrationAndStopPipRequest = new MarkPipCalibrationAndStopPipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingWiredScoreboardAdded$Type extends MessageType$<OnboardingWiredScoreboardAdded> {
    constructor() {
        super("ProtoMessages.OnboardingWiredScoreboardAdded", [
            { no: 1, name: "set", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<OnboardingWiredScoreboardAdded>): OnboardingWiredScoreboardAdded {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingWiredScoreboardAdded>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingWiredScoreboardAdded): OnboardingWiredScoreboardAdded {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool set */ 1:
                    message.set = Bool.internalBinaryRead(reader, reader.uint32(), options, message.set);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingWiredScoreboardAdded, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool set = 1; */
        if (message.set)
            Bool.internalBinaryWrite(message.set, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingWiredScoreboardAdded
 */
export const OnboardingWiredScoreboardAdded = new OnboardingWiredScoreboardAdded$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingSystemRenameRequest$Type extends MessageType$<OnboardingSystemRenameRequest> {
    constructor() {
        super("ProtoMessages.OnboardingSystemRenameRequest", [
            { no: 1, name: "venueName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pairingType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sn", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "venueType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OnboardingSystemRenameRequest>): OnboardingSystemRenameRequest {
        const message = { venueName: "", pairingType: "", sn: "", venueType: "", tenant: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingSystemRenameRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingSystemRenameRequest): OnboardingSystemRenameRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string venueName */ 1:
                    message.venueName = reader.string();
                    break;
                case /* string pairingType */ 2:
                    message.pairingType = reader.string();
                    break;
                case /* string sn */ 3:
                    message.sn = reader.string();
                    break;
                case /* string venueType */ 4:
                    message.venueType = reader.string();
                    break;
                case /* string tenant */ 5:
                    message.tenant = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingSystemRenameRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string venueName = 1; */
        if (message.venueName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.venueName);
        /* string pairingType = 2; */
        if (message.pairingType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pairingType);
        /* string sn = 3; */
        if (message.sn !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sn);
        /* string venueType = 4; */
        if (message.venueType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.venueType);
        /* string tenant = 5; */
        if (message.tenant !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.tenant);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingSystemRenameRequest
 */
export const OnboardingSystemRenameRequest = new OnboardingSystemRenameRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingSystemRenameRequestRecieved$Type extends MessageType$<OnboardingSystemRenameRequestRecieved> {
    constructor() {
        super("ProtoMessages.OnboardingSystemRenameRequestRecieved", []);
    }
    create(value?: PartialMessage<OnboardingSystemRenameRequestRecieved>): OnboardingSystemRenameRequestRecieved {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingSystemRenameRequestRecieved>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingSystemRenameRequestRecieved): OnboardingSystemRenameRequestRecieved {
        return target ?? this.create();
    }
    internalBinaryWrite(message: OnboardingSystemRenameRequestRecieved, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingSystemRenameRequestRecieved
 */
export const OnboardingSystemRenameRequestRecieved = new OnboardingSystemRenameRequestRecieved$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OnboardingSystemRenameDone$Type extends MessageType$<OnboardingSystemRenameDone> {
    constructor() {
        super("ProtoMessages.OnboardingSystemRenameDone", [
            { no: 1, name: "success", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<OnboardingSystemRenameDone>): OnboardingSystemRenameDone {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OnboardingSystemRenameDone>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OnboardingSystemRenameDone): OnboardingSystemRenameDone {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OnboardingSystemRenameDone, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OnboardingSystemRenameDone
 */
export const OnboardingSystemRenameDone = new OnboardingSystemRenameDone$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TunnelDevice$Type extends MessageType$<TunnelDevice> {
    constructor() {
        super("ProtoMessages.TunnelDevice", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "deviceType", kind: "enum", T: () => ["ProtoMessages.TunnelDevice.DeviceType", TunnelDevice_DeviceType] }
        ]);
    }
    create(value?: PartialMessage<TunnelDevice>): TunnelDevice {
        const message = { id: "", name: "", model: "", deviceType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TunnelDevice>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TunnelDevice): TunnelDevice {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string model */ 3:
                    message.model = reader.string();
                    break;
                case /* ProtoMessages.TunnelDevice.DeviceType deviceType */ 4:
                    message.deviceType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TunnelDevice, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string model = 3; */
        if (message.model !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.model);
        /* ProtoMessages.TunnelDevice.DeviceType deviceType = 4; */
        if (message.deviceType !== 0)
            writer.tag(4, WireType.Varint).int32(message.deviceType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.TunnelDevice
 */
export const TunnelDevice = new TunnelDevice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TunnelDeviceListRequest$Type extends MessageType$<TunnelDeviceListRequest> {
    constructor() {
        super("ProtoMessages.TunnelDeviceListRequest", []);
    }
    create(value?: PartialMessage<TunnelDeviceListRequest>): TunnelDeviceListRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TunnelDeviceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TunnelDeviceListRequest): TunnelDeviceListRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: TunnelDeviceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.TunnelDeviceListRequest
 */
export const TunnelDeviceListRequest = new TunnelDeviceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TunnelDeviceListResponse$Type extends MessageType$<TunnelDeviceListResponse> {
    constructor() {
        super("ProtoMessages.TunnelDeviceListResponse", [
            { no: 1, name: "devices", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => TunnelDevice },
            { no: 2, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TunnelDeviceListResponse>): TunnelDeviceListResponse {
        const message = { devices: [], success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TunnelDeviceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TunnelDeviceListResponse): TunnelDeviceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.TunnelDevice devices */ 1:
                    message.devices.push(TunnelDevice.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool success */ 2:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TunnelDeviceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.TunnelDevice devices = 1; */
        for (let i = 0; i < message.devices.length; i++)
            TunnelDevice.internalBinaryWrite(message.devices[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool success = 2; */
        if (message.success !== false)
            writer.tag(2, WireType.Varint).bool(message.success);
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.TunnelDeviceListResponse
 */
export const TunnelDeviceListResponse = new TunnelDeviceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TunnelControlMessage$Type extends MessageType$<TunnelControlMessage> {
    constructor() {
        super("ProtoMessages.TunnelControlMessage", [
            { no: 1, name: "type", kind: "enum", T: () => ["ProtoMessages.TunnelControlMessage.ControlMessageType", TunnelControlMessage_ControlMessageType] },
            { no: 2, name: "tunnelId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "deviceId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TunnelControlMessage>): TunnelControlMessage {
        const message = { type: 0, tunnelId: "", deviceId: "", errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TunnelControlMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TunnelControlMessage): TunnelControlMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.TunnelControlMessage.ControlMessageType type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string tunnelId */ 2:
                    message.tunnelId = reader.string();
                    break;
                case /* string deviceId */ 3:
                    message.deviceId = reader.string();
                    break;
                case /* string errorMessage */ 4:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TunnelControlMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.TunnelControlMessage.ControlMessageType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string tunnelId = 2; */
        if (message.tunnelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tunnelId);
        /* string deviceId = 3; */
        if (message.deviceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.deviceId);
        /* string errorMessage = 4; */
        if (message.errorMessage !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.TunnelControlMessage
 */
export const TunnelControlMessage = new TunnelControlMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TunnelTcpFrame$Type extends MessageType$<TunnelTcpFrame> {
    constructor() {
        super("ProtoMessages.TunnelTcpFrame", [
            { no: 1, name: "frameType", kind: "enum", T: () => ["ProtoMessages.TunnelTcpFrame.FrameType", TunnelTcpFrame_FrameType] },
            { no: 2, name: "connectionId", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "tunnelId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 5, name: "errorMsg", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TunnelTcpFrame>): TunnelTcpFrame {
        const message = { frameType: 0, connectionId: 0, tunnelId: "", data: new Uint8Array(0), errorMsg: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<TunnelTcpFrame>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TunnelTcpFrame): TunnelTcpFrame {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.TunnelTcpFrame.FrameType frameType */ 1:
                    message.frameType = reader.int32();
                    break;
                case /* uint32 connectionId */ 2:
                    message.connectionId = reader.uint32();
                    break;
                case /* string tunnelId */ 3:
                    message.tunnelId = reader.string();
                    break;
                case /* bytes data */ 4:
                    message.data = reader.bytes();
                    break;
                case /* string errorMsg */ 5:
                    message.errorMsg = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TunnelTcpFrame, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.TunnelTcpFrame.FrameType frameType = 1; */
        if (message.frameType !== 0)
            writer.tag(1, WireType.Varint).int32(message.frameType);
        /* uint32 connectionId = 2; */
        if (message.connectionId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.connectionId);
        /* string tunnelId = 3; */
        if (message.tunnelId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tunnelId);
        /* bytes data = 4; */
        if (message.data.length)
            writer.tag(4, WireType.LengthDelimited).bytes(message.data);
        /* string errorMsg = 5; */
        if (message.errorMsg !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.errorMsg);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.TunnelTcpFrame
 */
export const TunnelTcpFrame = new TunnelTcpFrame$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraInfo$Type extends MessageType$<CameraInfo> {
    constructor() {
        super("ProtoMessages.CameraInfo", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CameraInfo>): CameraInfo {
        const message = { name: "", ip: "", model: "", url: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraInfo): CameraInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string ip */ 2:
                    message.ip = reader.string();
                    break;
                case /* string model */ 3:
                    message.model = reader.string();
                    break;
                case /* string url */ 4:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string ip = 2; */
        if (message.ip !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ip);
        /* string model = 3; */
        if (message.model !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.model);
        /* string url = 4; */
        if (message.url !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraInfo
 */
export const CameraInfo = new CameraInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraControlMessage$Type extends MessageType$<CameraControlMessage> {
    constructor() {
        super("ProtoMessages.CameraControlMessage", [
            { no: 1, name: "type", kind: "enum", T: () => ["ProtoMessages.CameraControlMessage.CameraControlMessageType", CameraControlMessage_CameraControlMessageType] },
            { no: 2, name: "headCameras", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CameraInfo },
            { no: 3, name: "aditionalAnglesCameras", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CameraInfo },
            { no: 4, name: "cameraToConnect", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "input", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "data", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "msg", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CameraControlMessage>): CameraControlMessage {
        const message = { type: 0, headCameras: [], aditionalAnglesCameras: [], cameraToConnect: "", input: "", data: "", msg: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraControlMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraControlMessage): CameraControlMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.CameraControlMessage.CameraControlMessageType type */ 1:
                    message.type = reader.int32();
                    break;
                case /* repeated ProtoMessages.CameraInfo headCameras */ 2:
                    message.headCameras.push(CameraInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ProtoMessages.CameraInfo aditionalAnglesCameras */ 3:
                    message.aditionalAnglesCameras.push(CameraInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string cameraToConnect */ 4:
                    message.cameraToConnect = reader.string();
                    break;
                case /* string input */ 5:
                    message.input = reader.string();
                    break;
                case /* string data */ 6:
                    message.data = reader.string();
                    break;
                case /* string msg */ 7:
                    message.msg = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraControlMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.CameraControlMessage.CameraControlMessageType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* repeated ProtoMessages.CameraInfo headCameras = 2; */
        for (let i = 0; i < message.headCameras.length; i++)
            CameraInfo.internalBinaryWrite(message.headCameras[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProtoMessages.CameraInfo aditionalAnglesCameras = 3; */
        for (let i = 0; i < message.aditionalAnglesCameras.length; i++)
            CameraInfo.internalBinaryWrite(message.aditionalAnglesCameras[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string cameraToConnect = 4; */
        if (message.cameraToConnect !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.cameraToConnect);
        /* string input = 5; */
        if (message.input !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.input);
        /* string data = 6; */
        if (message.data !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.data);
        /* string msg = 7; */
        if (message.msg !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.msg);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CameraControlMessage
 */
export const CameraControlMessage = new CameraControlMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ColorBalanceDataRequest$Type extends MessageType$<ColorBalanceDataRequest> {
    constructor() {
        super("ProtoMessages.ColorBalanceDataRequest", []);
    }
    create(value?: PartialMessage<ColorBalanceDataRequest>): ColorBalanceDataRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ColorBalanceDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ColorBalanceDataRequest): ColorBalanceDataRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: ColorBalanceDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ColorBalanceDataRequest
 */
export const ColorBalanceDataRequest = new ColorBalanceDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalibrationPoints$Type extends MessageType$<CalibrationPoints> {
    constructor() {
        super("ProtoMessages.CalibrationPoints", [
            { no: 1, name: "point2d", kind: "message", jsonName: "point2d", repeat: 1 /*RepeatType.PACKED*/, T: () => Point2D }
        ]);
    }
    create(value?: PartialMessage<CalibrationPoints>): CalibrationPoints {
        const message = { point2D: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CalibrationPoints>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalibrationPoints): CalibrationPoints {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CommonUsedMessages.Point2D point2d = 1 [json_name = "point2d"];*/ 1:
                    message.point2D.push(Point2D.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CalibrationPoints, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated CommonUsedMessages.Point2D point2d = 1 [json_name = "point2d"]; */
        for (let i = 0; i < message.point2D.length; i++)
            Point2D.internalBinaryWrite(message.point2D[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CalibrationPoints
 */
export const CalibrationPoints = new CalibrationPoints$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalibrationPointsReply$Type extends MessageType$<CalibrationPointsReply> {
    constructor() {
        super("ProtoMessages.CalibrationPointsReply", [
            { no: 1, name: "pointsType", kind: "enum", T: () => ["ProtoMessages.CalibrationPointsType", CalibrationPointsType] },
            { no: 2, name: "calibrationPoints", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CalibrationPoints }
        ]);
    }
    create(value?: PartialMessage<CalibrationPointsReply>): CalibrationPointsReply {
        const message = { pointsType: 0, calibrationPoints: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CalibrationPointsReply>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalibrationPointsReply): CalibrationPointsReply {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.CalibrationPointsType pointsType */ 1:
                    message.pointsType = reader.int32();
                    break;
                case /* repeated ProtoMessages.CalibrationPoints calibrationPoints */ 2:
                    message.calibrationPoints.push(CalibrationPoints.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CalibrationPointsReply, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.CalibrationPointsType pointsType = 1; */
        if (message.pointsType !== 0)
            writer.tag(1, WireType.Varint).int32(message.pointsType);
        /* repeated ProtoMessages.CalibrationPoints calibrationPoints = 2; */
        for (let i = 0; i < message.calibrationPoints.length; i++)
            CalibrationPoints.internalBinaryWrite(message.calibrationPoints[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CalibrationPointsReply
 */
export const CalibrationPointsReply = new CalibrationPointsReply$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalibrationPointsRequest$Type extends MessageType$<CalibrationPointsRequest> {
    constructor() {
        super("ProtoMessages.CalibrationPointsRequest", [
            { no: 1, name: "pointsType", kind: "enum", T: () => ["ProtoMessages.CalibrationPointsType", CalibrationPointsType] },
            { no: 2, name: "calibrationPoints", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CalibrationPoints }
        ]);
    }
    create(value?: PartialMessage<CalibrationPointsRequest>): CalibrationPointsRequest {
        const message = { pointsType: 0, calibrationPoints: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CalibrationPointsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalibrationPointsRequest): CalibrationPointsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.CalibrationPointsType pointsType */ 1:
                    message.pointsType = reader.int32();
                    break;
                case /* repeated ProtoMessages.CalibrationPoints calibrationPoints */ 2:
                    message.calibrationPoints.push(CalibrationPoints.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CalibrationPointsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.CalibrationPointsType pointsType = 1; */
        if (message.pointsType !== 0)
            writer.tag(1, WireType.Varint).int32(message.pointsType);
        /* repeated ProtoMessages.CalibrationPoints calibrationPoints = 2; */
        for (let i = 0; i < message.calibrationPoints.length; i++)
            CalibrationPoints.internalBinaryWrite(message.calibrationPoints[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CalibrationPointsRequest
 */
export const CalibrationPointsRequest = new CalibrationPointsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ColorBalanceDataReply$Type extends MessageType$<ColorBalanceDataReply> {
    constructor() {
        super("ProtoMessages.ColorBalanceDataReply", [
            { no: 1, name: "data", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CalibrationPointsReply }
        ]);
    }
    create(value?: PartialMessage<ColorBalanceDataReply>): ColorBalanceDataReply {
        const message = { data: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ColorBalanceDataReply>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ColorBalanceDataReply): ColorBalanceDataReply {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.CalibrationPointsReply data */ 1:
                    message.data.push(CalibrationPointsReply.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ColorBalanceDataReply, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.CalibrationPointsReply data = 1; */
        for (let i = 0; i < message.data.length; i++)
            CalibrationPointsReply.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ColorBalanceDataReply
 */
export const ColorBalanceDataReply = new ColorBalanceDataReply$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePIPStatus$Type extends MessageType$<UpdatePIPStatus> {
    constructor() {
        super("ProtoMessages.UpdatePIPStatus", [
            { no: 1, name: "status", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdatePIPStatus>): UpdatePIPStatus {
        const message = { status: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdatePIPStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdatePIPStatus): UpdatePIPStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool status */ 1:
                    message.status = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdatePIPStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool status = 1; */
        if (message.status !== false)
            writer.tag(1, WireType.Varint).bool(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.UpdatePIPStatus
 */
export const UpdatePIPStatus = new UpdatePIPStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VpumToCoordinatorHeartbeatMessage$Type extends MessageType$<VpumToCoordinatorHeartbeatMessage> {
    constructor() {
        super("ProtoMessages.VpumToCoordinatorHeartbeatMessage", [
            { no: 1, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VpumToCoordinatorHeartbeatMessage>): VpumToCoordinatorHeartbeatMessage {
        const message = { sessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VpumToCoordinatorHeartbeatMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VpumToCoordinatorHeartbeatMessage): VpumToCoordinatorHeartbeatMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sessionId */ 1:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VpumToCoordinatorHeartbeatMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sessionId = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VpumToCoordinatorHeartbeatMessage
 */
export const VpumToCoordinatorHeartbeatMessage = new VpumToCoordinatorHeartbeatMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CoordinatorToVpumHeartbeatAck$Type extends MessageType$<CoordinatorToVpumHeartbeatAck> {
    constructor() {
        super("ProtoMessages.CoordinatorToVpumHeartbeatAck", [
            { no: 1, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CoordinatorToVpumHeartbeatAck>): CoordinatorToVpumHeartbeatAck {
        const message = { sessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CoordinatorToVpumHeartbeatAck>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CoordinatorToVpumHeartbeatAck): CoordinatorToVpumHeartbeatAck {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sessionId */ 1:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CoordinatorToVpumHeartbeatAck, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sessionId = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CoordinatorToVpumHeartbeatAck
 */
export const CoordinatorToVpumHeartbeatAck = new CoordinatorToVpumHeartbeatAck$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SystemTestResultsRequest$Type extends MessageType$<SystemTestResultsRequest> {
    constructor() {
        super("ProtoMessages.SystemTestResultsRequest", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "limit", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<SystemTestResultsRequest>): SystemTestResultsRequest {
        const message = { offset: 0n, limit: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SystemTestResultsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SystemTestResultsRequest): SystemTestResultsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 offset */ 1:
                    message.offset = reader.int64().toBigInt();
                    break;
                case /* int64 limit */ 2:
                    message.limit = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SystemTestResultsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 offset = 1; */
        if (message.offset !== 0n)
            writer.tag(1, WireType.Varint).int64(message.offset);
        /* int64 limit = 2; */
        if (message.limit !== 0n)
            writer.tag(2, WireType.Varint).int64(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SystemTestResultsRequest
 */
export const SystemTestResultsRequest = new SystemTestResultsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IndividualCameraTestResult$Type extends MessageType$<IndividualCameraTestResult> {
    constructor() {
        super("ProtoMessages.IndividualCameraTestResult", [
            { no: 1, name: "testName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "result", kind: "enum", T: () => ["ProtoMessages.SystemTestResult.TestResult", SystemTestResult_TestResult] },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<IndividualCameraTestResult>): IndividualCameraTestResult {
        const message = { testName: "", result: 0, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<IndividualCameraTestResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IndividualCameraTestResult): IndividualCameraTestResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string testName */ 1:
                    message.testName = reader.string();
                    break;
                case /* ProtoMessages.SystemTestResult.TestResult result */ 2:
                    message.result = reader.int32();
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IndividualCameraTestResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string testName = 1; */
        if (message.testName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.testName);
        /* ProtoMessages.SystemTestResult.TestResult result = 2; */
        if (message.result !== 0)
            writer.tag(2, WireType.Varint).int32(message.result);
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.IndividualCameraTestResult
 */
export const IndividualCameraTestResult = new IndividualCameraTestResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SystemTestResult$Type extends MessageType$<SystemTestResult> {
    constructor() {
        super("ProtoMessages.SystemTestResult", [
            { no: 1, name: "timeStamp", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "result", kind: "enum", T: () => ["ProtoMessages.SystemTestResult.TestResult", SystemTestResult_TestResult] },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "runningMode", kind: "enum", T: () => ["ProtoMessages.SystemTestResult.TestRunningMode", SystemTestResult_TestRunningMode] },
            { no: 5, name: "testName", kind: "enum", T: () => ["ProtoMessages.SystemTestResult.TestName", SystemTestResult_TestName] },
            { no: 6, name: "advancedTestResults", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => IndividualCameraTestResult }
        ]);
    }
    create(value?: PartialMessage<SystemTestResult>): SystemTestResult {
        const message = { timeStamp: 0n, result: 0, errorMessage: "", runningMode: 0, testName: 0, advancedTestResults: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SystemTestResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SystemTestResult): SystemTestResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 timeStamp */ 1:
                    message.timeStamp = reader.int64().toBigInt();
                    break;
                case /* ProtoMessages.SystemTestResult.TestResult result */ 2:
                    message.result = reader.int32();
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                case /* ProtoMessages.SystemTestResult.TestRunningMode runningMode */ 4:
                    message.runningMode = reader.int32();
                    break;
                case /* ProtoMessages.SystemTestResult.TestName testName */ 5:
                    message.testName = reader.int32();
                    break;
                case /* repeated ProtoMessages.IndividualCameraTestResult advancedTestResults */ 6:
                    message.advancedTestResults.push(IndividualCameraTestResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SystemTestResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 timeStamp = 1; */
        if (message.timeStamp !== 0n)
            writer.tag(1, WireType.Varint).int64(message.timeStamp);
        /* ProtoMessages.SystemTestResult.TestResult result = 2; */
        if (message.result !== 0)
            writer.tag(2, WireType.Varint).int32(message.result);
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        /* ProtoMessages.SystemTestResult.TestRunningMode runningMode = 4; */
        if (message.runningMode !== 0)
            writer.tag(4, WireType.Varint).int32(message.runningMode);
        /* ProtoMessages.SystemTestResult.TestName testName = 5; */
        if (message.testName !== 0)
            writer.tag(5, WireType.Varint).int32(message.testName);
        /* repeated ProtoMessages.IndividualCameraTestResult advancedTestResults = 6; */
        for (let i = 0; i < message.advancedTestResults.length; i++)
            IndividualCameraTestResult.internalBinaryWrite(message.advancedTestResults[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SystemTestResult
 */
export const SystemTestResult = new SystemTestResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SystemTestResultsResponse$Type extends MessageType$<SystemTestResultsResponse> {
    constructor() {
        super("ProtoMessages.SystemTestResultsResponse", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "total", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "data", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SystemTestResult }
        ]);
    }
    create(value?: PartialMessage<SystemTestResultsResponse>): SystemTestResultsResponse {
        const message = { offset: 0n, total: 0n, data: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SystemTestResultsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SystemTestResultsResponse): SystemTestResultsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 offset */ 1:
                    message.offset = reader.int64().toBigInt();
                    break;
                case /* int64 total */ 2:
                    message.total = reader.int64().toBigInt();
                    break;
                case /* repeated ProtoMessages.SystemTestResult data */ 3:
                    message.data.push(SystemTestResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SystemTestResultsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 offset = 1; */
        if (message.offset !== 0n)
            writer.tag(1, WireType.Varint).int64(message.offset);
        /* int64 total = 2; */
        if (message.total !== 0n)
            writer.tag(2, WireType.Varint).int64(message.total);
        /* repeated ProtoMessages.SystemTestResult data = 3; */
        for (let i = 0; i < message.data.length; i++)
            SystemTestResult.internalBinaryWrite(message.data[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SystemTestResultsResponse
 */
export const SystemTestResultsResponse = new SystemTestResultsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuditInfoRequest$Type extends MessageType$<AuditInfoRequest> {
    constructor() {
        super("ProtoMessages.AuditInfoRequest", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "limit", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "searchKeyword", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AuditInfoRequest>): AuditInfoRequest {
        const message = { offset: 0n, limit: 0n, searchKeyword: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AuditInfoRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuditInfoRequest): AuditInfoRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 offset */ 1:
                    message.offset = reader.int64().toBigInt();
                    break;
                case /* int64 limit */ 2:
                    message.limit = reader.int64().toBigInt();
                    break;
                case /* string searchKeyword */ 3:
                    message.searchKeyword = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuditInfoRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 offset = 1; */
        if (message.offset !== 0n)
            writer.tag(1, WireType.Varint).int64(message.offset);
        /* int64 limit = 2; */
        if (message.limit !== 0n)
            writer.tag(2, WireType.Varint).int64(message.limit);
        /* string searchKeyword = 3; */
        if (message.searchKeyword !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.searchKeyword);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AuditInfoRequest
 */
export const AuditInfoRequest = new AuditInfoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuditInfoResponse$Type extends MessageType$<AuditInfoResponse> {
    constructor() {
        super("ProtoMessages.AuditInfoResponse", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "total", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "data", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AuditInfo },
            { no: 4, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AuditInfoResponse>): AuditInfoResponse {
        const message = { offset: 0n, total: 0n, data: [], success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AuditInfoResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuditInfoResponse): AuditInfoResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 offset */ 1:
                    message.offset = reader.int64().toBigInt();
                    break;
                case /* int64 total */ 2:
                    message.total = reader.int64().toBigInt();
                    break;
                case /* repeated ProtoMessages.AuditInfo data */ 3:
                    message.data.push(AuditInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool success */ 4:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 5:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuditInfoResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 offset = 1; */
        if (message.offset !== 0n)
            writer.tag(1, WireType.Varint).int64(message.offset);
        /* int64 total = 2; */
        if (message.total !== 0n)
            writer.tag(2, WireType.Varint).int64(message.total);
        /* repeated ProtoMessages.AuditInfo data = 3; */
        for (let i = 0; i < message.data.length; i++)
            AuditInfo.internalBinaryWrite(message.data[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool success = 4; */
        if (message.success !== false)
            writer.tag(4, WireType.Varint).bool(message.success);
        /* string errorMessage = 5; */
        if (message.errorMessage !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AuditInfoResponse
 */
export const AuditInfoResponse = new AuditInfoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuditUserData$Type extends MessageType$<AuditUserData> {
    constructor() {
        super("ProtoMessages.AuditUserData", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "role", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AuditUserData>): AuditUserData {
        const message = { name: "", role: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AuditUserData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuditUserData): AuditUserData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string role */ 2:
                    message.role = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuditUserData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string role = 2; */
        if (message.role !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.role);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AuditUserData
 */
export const AuditUserData = new AuditUserData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuditInfo$Type extends MessageType$<AuditInfo> {
    constructor() {
        super("ProtoMessages.AuditInfo", [
            { no: 1, name: "dateTimeStampUTC", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "userData", kind: "message", T: () => AuditUserData }
        ]);
    }
    create(value?: PartialMessage<AuditInfo>): AuditInfo {
        const message = { dateTimeStampUTC: 0n, description: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AuditInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuditInfo): AuditInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 dateTimeStampUTC */ 1:
                    message.dateTimeStampUTC = reader.uint64().toBigInt();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* ProtoMessages.AuditUserData userData */ 3:
                    message.userData = AuditUserData.internalBinaryRead(reader, reader.uint32(), options, message.userData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuditInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint64 dateTimeStampUTC = 1; */
        if (message.dateTimeStampUTC !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.dateTimeStampUTC);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* ProtoMessages.AuditUserData userData = 3; */
        if (message.userData)
            AuditUserData.internalBinaryWrite(message.userData, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AuditInfo
 */
export const AuditInfo = new AuditInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastGetVendorListRequest$Type extends MessageType$<SportzcastGetVendorListRequest> {
    constructor() {
        super("ProtoMessages.SportzcastGetVendorListRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<SportzcastGetVendorListRequest>): SportzcastGetVendorListRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastGetVendorListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastGetVendorListRequest): SportzcastGetVendorListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastGetVendorListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastGetVendorListRequest
 */
export const SportzcastGetVendorListRequest = new SportzcastGetVendorListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastGetVendorSportsListRequest$Type extends MessageType$<SportzcastGetVendorSportsListRequest> {
    constructor() {
        super("ProtoMessages.SportzcastGetVendorSportsListRequest", [
            { no: 1, name: "vendorId", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SportzcastGetVendorSportsListRequest>): SportzcastGetVendorSportsListRequest {
        const message = { vendorId: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastGetVendorSportsListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastGetVendorSportsListRequest): SportzcastGetVendorSportsListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 vendorId */ 1:
                    message.vendorId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastGetVendorSportsListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 vendorId = 1; */
        if (message.vendorId !== 0)
            writer.tag(1, WireType.Varint).int32(message.vendorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastGetVendorSportsListRequest
 */
export const SportzcastGetVendorSportsListRequest = new SportzcastGetVendorSportsListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastGetVendorConfigurationListRequest$Type extends MessageType$<SportzcastGetVendorConfigurationListRequest> {
    constructor() {
        super("ProtoMessages.SportzcastGetVendorConfigurationListRequest", [
            { no: 1, name: "vendorId", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SportzcastGetVendorConfigurationListRequest>): SportzcastGetVendorConfigurationListRequest {
        const message = { vendorId: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastGetVendorConfigurationListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastGetVendorConfigurationListRequest): SportzcastGetVendorConfigurationListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 vendorId */ 1:
                    message.vendorId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastGetVendorConfigurationListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 vendorId = 1; */
        if (message.vendorId !== 0)
            writer.tag(1, WireType.Varint).int32(message.vendorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastGetVendorConfigurationListRequest
 */
export const SportzcastGetVendorConfigurationListRequest = new SportzcastGetVendorConfigurationListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastGetCurrentConfigurationRequest$Type extends MessageType$<SportzcastGetCurrentConfigurationRequest> {
    constructor() {
        super("ProtoMessages.SportzcastGetCurrentConfigurationRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<SportzcastGetCurrentConfigurationRequest>): SportzcastGetCurrentConfigurationRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastGetCurrentConfigurationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastGetCurrentConfigurationRequest): SportzcastGetCurrentConfigurationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastGetCurrentConfigurationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastGetCurrentConfigurationRequest
 */
export const SportzcastGetCurrentConfigurationRequest = new SportzcastGetCurrentConfigurationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastSetConfigurationRequest$Type extends MessageType$<SportzcastSetConfigurationRequest> {
    constructor() {
        super("ProtoMessages.SportzcastSetConfigurationRequest", [
            { no: 1, name: "input", kind: "message", T: () => Configuration },
            { no: 2, name: "vendorName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "vendorSportName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "vendorConfigurationName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SportzcastSetConfigurationRequest>): SportzcastSetConfigurationRequest {
        const message = { vendorName: "", vendorSportName: "", vendorConfigurationName: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastSetConfigurationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastSetConfigurationRequest): SportzcastSetConfigurationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuScoreconnectGrpc.Configuration input */ 1:
                    message.input = Configuration.internalBinaryRead(reader, reader.uint32(), options, message.input);
                    break;
                case /* string vendorName */ 2:
                    message.vendorName = reader.string();
                    break;
                case /* string vendorSportName */ 3:
                    message.vendorSportName = reader.string();
                    break;
                case /* string vendorConfigurationName */ 4:
                    message.vendorConfigurationName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastSetConfigurationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuScoreconnectGrpc.Configuration input = 1; */
        if (message.input)
            Configuration.internalBinaryWrite(message.input, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string vendorName = 2; */
        if (message.vendorName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.vendorName);
        /* string vendorSportName = 3; */
        if (message.vendorSportName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.vendorSportName);
        /* string vendorConfigurationName = 4; */
        if (message.vendorConfigurationName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.vendorConfigurationName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastSetConfigurationRequest
 */
export const SportzcastSetConfigurationRequest = new SportzcastSetConfigurationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastGetLiveDataRequest$Type extends MessageType$<SportzcastGetLiveDataRequest> {
    constructor() {
        super("ProtoMessages.SportzcastGetLiveDataRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<SportzcastGetLiveDataRequest>): SportzcastGetLiveDataRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastGetLiveDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastGetLiveDataRequest): SportzcastGetLiveDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastGetLiveDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastGetLiveDataRequest
 */
export const SportzcastGetLiveDataRequest = new SportzcastGetLiveDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastDiscoverLanScorelinkRequest$Type extends MessageType$<SportzcastDiscoverLanScorelinkRequest> {
    constructor() {
        super("ProtoMessages.SportzcastDiscoverLanScorelinkRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<SportzcastDiscoverLanScorelinkRequest>): SportzcastDiscoverLanScorelinkRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastDiscoverLanScorelinkRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastDiscoverLanScorelinkRequest): SportzcastDiscoverLanScorelinkRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastDiscoverLanScorelinkRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastDiscoverLanScorelinkRequest
 */
export const SportzcastDiscoverLanScorelinkRequest = new SportzcastDiscoverLanScorelinkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CurrentSessionListStartRequest$Type extends MessageType$<CurrentSessionListStartRequest> {
    constructor() {
        super("ProtoMessages.CurrentSessionListStartRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<CurrentSessionListStartRequest>): CurrentSessionListStartRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CurrentSessionListStartRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CurrentSessionListStartRequest): CurrentSessionListStartRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CurrentSessionListStartRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CurrentSessionListStartRequest
 */
export const CurrentSessionListStartRequest = new CurrentSessionListStartRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CurrentSessionListResponse$Type extends MessageType$<CurrentSessionListResponse> {
    constructor() {
        super("ProtoMessages.CurrentSessionListResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "phases", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VpuPhase }
        ]);
    }
    create(value?: PartialMessage<CurrentSessionListResponse>): CurrentSessionListResponse {
        const message = { errorMessage: "", key: "", phases: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CurrentSessionListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CurrentSessionListResponse): CurrentSessionListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* string key */ 3:
                    message.key = reader.string();
                    break;
                case /* repeated ProtoMessages.VpuPhase phases */ 4:
                    message.phases.push(VpuPhase.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CurrentSessionListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* string key = 3; */
        if (message.key !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.key);
        /* repeated ProtoMessages.VpuPhase phases = 4; */
        for (let i = 0; i < message.phases.length; i++)
            VpuPhase.internalBinaryWrite(message.phases[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CurrentSessionListResponse
 */
export const CurrentSessionListResponse = new CurrentSessionListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VpuPhase$Type extends MessageType$<VpuPhase> {
    constructor() {
        super("ProtoMessages.VpuPhase", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "startTime", kind: "message", T: () => Uint64 },
            { no: 3, name: "endTime", kind: "message", T: () => Uint64 }
        ]);
    }
    create(value?: PartialMessage<VpuPhase>): VpuPhase {
        const message = { name: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VpuPhase>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VpuPhase): VpuPhase {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* ProtoMessages.Uint64 startTime */ 2:
                    message.startTime = Uint64.internalBinaryRead(reader, reader.uint32(), options, message.startTime);
                    break;
                case /* ProtoMessages.Uint64 endTime */ 3:
                    message.endTime = Uint64.internalBinaryRead(reader, reader.uint32(), options, message.endTime);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VpuPhase, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* ProtoMessages.Uint64 startTime = 2; */
        if (message.startTime)
            Uint64.internalBinaryWrite(message.startTime, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Uint64 endTime = 3; */
        if (message.endTime)
            Uint64.internalBinaryWrite(message.endTime, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VpuPhase
 */
export const VpuPhase = new VpuPhase$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CurrentSessionListStopRequest$Type extends MessageType$<CurrentSessionListStopRequest> {
    constructor() {
        super("ProtoMessages.CurrentSessionListStopRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<CurrentSessionListStopRequest>): CurrentSessionListStopRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CurrentSessionListStopRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CurrentSessionListStopRequest): CurrentSessionListStopRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CurrentSessionListStopRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CurrentSessionListStopRequest
 */
export const CurrentSessionListStopRequest = new CurrentSessionListStopRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionsEventsAndDatesListRequest$Type extends MessageType$<SessionsEventsAndDatesListRequest> {
    constructor() {
        super("ProtoMessages.SessionsEventsAndDatesListRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<SessionsEventsAndDatesListRequest>): SessionsEventsAndDatesListRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SessionsEventsAndDatesListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionsEventsAndDatesListRequest): SessionsEventsAndDatesListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionsEventsAndDatesListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SessionsEventsAndDatesListRequest
 */
export const SessionsEventsAndDatesListRequest = new SessionsEventsAndDatesListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionsEventsAndDatesListResponse$Type extends MessageType$<SessionsEventsAndDatesListResponse> {
    constructor() {
        super("ProtoMessages.SessionsEventsAndDatesListResponse", [
            { no: 1, name: "eventsAndDates", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SessionsEventsAndDatesListResponse>): SessionsEventsAndDatesListResponse {
        const message = { eventsAndDates: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SessionsEventsAndDatesListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionsEventsAndDatesListResponse): SessionsEventsAndDatesListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string eventsAndDates */ 1:
                    message.eventsAndDates.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionsEventsAndDatesListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string eventsAndDates = 1; */
        for (let i = 0; i < message.eventsAndDates.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.eventsAndDates[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SessionsEventsAndDatesListResponse
 */
export const SessionsEventsAndDatesListResponse = new SessionsEventsAndDatesListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionsHistoryTableByKeyAndCurrentRequest$Type extends MessageType$<SessionsHistoryTableByKeyAndCurrentRequest> {
    constructor() {
        super("ProtoMessages.SessionsHistoryTableByKeyAndCurrentRequest", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SessionsHistoryTableByKeyAndCurrentRequest>): SessionsHistoryTableByKeyAndCurrentRequest {
        const message = { key: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SessionsHistoryTableByKeyAndCurrentRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionsHistoryTableByKeyAndCurrentRequest): SessionsHistoryTableByKeyAndCurrentRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionsHistoryTableByKeyAndCurrentRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SessionsHistoryTableByKeyAndCurrentRequest
 */
export const SessionsHistoryTableByKeyAndCurrentRequest = new SessionsHistoryTableByKeyAndCurrentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionsHistoryTableByKeyAndCurrentResponse$Type extends MessageType$<SessionsHistoryTableByKeyAndCurrentResponse> {
    constructor() {
        super("ProtoMessages.SessionsHistoryTableByKeyAndCurrentResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sessions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VpuSession }
        ]);
    }
    create(value?: PartialMessage<SessionsHistoryTableByKeyAndCurrentResponse>): SessionsHistoryTableByKeyAndCurrentResponse {
        const message = { errorMessage: "", sessions: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SessionsHistoryTableByKeyAndCurrentResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionsHistoryTableByKeyAndCurrentResponse): SessionsHistoryTableByKeyAndCurrentResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* repeated ProtoMessages.VpuSession sessions */ 3:
                    message.sessions.push(VpuSession.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionsHistoryTableByKeyAndCurrentResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* repeated ProtoMessages.VpuSession sessions = 3; */
        for (let i = 0; i < message.sessions.length; i++)
            VpuSession.internalBinaryWrite(message.sessions[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SessionsHistoryTableByKeyAndCurrentResponse
 */
export const SessionsHistoryTableByKeyAndCurrentResponse = new SessionsHistoryTableByKeyAndCurrentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VpuSession$Type extends MessageType$<VpuSession> {
    constructor() {
        super("ProtoMessages.VpuSession", [
            { no: 1, name: "sessionId", kind: "message", T: () => Int32 },
            { no: 2, name: "lastPhaseName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "createdAt", kind: "message", T: () => Uint64 }
        ]);
    }
    create(value?: PartialMessage<VpuSession>): VpuSession {
        const message = { lastPhaseName: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VpuSession>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VpuSession): VpuSession {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Int32 sessionId */ 1:
                    message.sessionId = Int32.internalBinaryRead(reader, reader.uint32(), options, message.sessionId);
                    break;
                case /* string lastPhaseName */ 2:
                    message.lastPhaseName = reader.string();
                    break;
                case /* ProtoMessages.Uint64 createdAt */ 3:
                    message.createdAt = Uint64.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VpuSession, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Int32 sessionId = 1; */
        if (message.sessionId)
            Int32.internalBinaryWrite(message.sessionId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string lastPhaseName = 2; */
        if (message.lastPhaseName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.lastPhaseName);
        /* ProtoMessages.Uint64 createdAt = 3; */
        if (message.createdAt)
            Uint64.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VpuSession
 */
export const VpuSession = new VpuSession$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVpuSnAndPnRequest$Type extends MessageType$<UpdateVpuSnAndPnRequest> {
    constructor() {
        super("ProtoMessages.UpdateVpuSnAndPnRequest", [
            { no: 1, name: "serialNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "partNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "source", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateVpuSnAndPnRequest>): UpdateVpuSnAndPnRequest {
        const message = { serialNumber: "", partNumber: "", source: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdateVpuSnAndPnRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVpuSnAndPnRequest): UpdateVpuSnAndPnRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string serialNumber */ 1:
                    message.serialNumber = reader.string();
                    break;
                case /* string partNumber */ 2:
                    message.partNumber = reader.string();
                    break;
                case /* string source */ 3:
                    message.source = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVpuSnAndPnRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string serialNumber = 1; */
        if (message.serialNumber !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.serialNumber);
        /* string partNumber = 2; */
        if (message.partNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.partNumber);
        /* string source = 3; */
        if (message.source !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.source);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.UpdateVpuSnAndPnRequest
 */
export const UpdateVpuSnAndPnRequest = new UpdateVpuSnAndPnRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVpuSnAndPnResponse$Type extends MessageType$<UpdateVpuSnAndPnResponse> {
    constructor() {
        super("ProtoMessages.UpdateVpuSnAndPnResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<UpdateVpuSnAndPnResponse>): UpdateVpuSnAndPnResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdateVpuSnAndPnResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVpuSnAndPnResponse): UpdateVpuSnAndPnResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVpuSnAndPnResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.UpdateVpuSnAndPnResponse
 */
export const UpdateVpuSnAndPnResponse = new UpdateVpuSnAndPnResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastGetVendorListResponse$Type extends MessageType$<SportzcastGetVendorListResponse> {
    constructor() {
        super("ProtoMessages.SportzcastGetVendorListResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "vendorList", kind: "message", T: () => VendorList }
        ]);
    }
    create(value?: PartialMessage<SportzcastGetVendorListResponse>): SportzcastGetVendorListResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastGetVendorListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastGetVendorListResponse): SportzcastGetVendorListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* VpuScoreconnectGrpc.VendorList vendorList */ 2:
                    message.vendorList = VendorList.internalBinaryRead(reader, reader.uint32(), options, message.vendorList);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastGetVendorListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* VpuScoreconnectGrpc.VendorList vendorList = 2; */
        if (message.vendorList)
            VendorList.internalBinaryWrite(message.vendorList, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastGetVendorListResponse
 */
export const SportzcastGetVendorListResponse = new SportzcastGetVendorListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastGetVendorSportsListResponse$Type extends MessageType$<SportzcastGetVendorSportsListResponse> {
    constructor() {
        super("ProtoMessages.SportzcastGetVendorSportsListResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "vendorSportsList", kind: "message", T: () => VendorSportsList }
        ]);
    }
    create(value?: PartialMessage<SportzcastGetVendorSportsListResponse>): SportzcastGetVendorSportsListResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastGetVendorSportsListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastGetVendorSportsListResponse): SportzcastGetVendorSportsListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* VpuScoreconnectGrpc.VendorSportsList vendorSportsList */ 2:
                    message.vendorSportsList = VendorSportsList.internalBinaryRead(reader, reader.uint32(), options, message.vendorSportsList);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastGetVendorSportsListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* VpuScoreconnectGrpc.VendorSportsList vendorSportsList = 2; */
        if (message.vendorSportsList)
            VendorSportsList.internalBinaryWrite(message.vendorSportsList, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastGetVendorSportsListResponse
 */
export const SportzcastGetVendorSportsListResponse = new SportzcastGetVendorSportsListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastGetVendorConfigurationListResponse$Type extends MessageType$<SportzcastGetVendorConfigurationListResponse> {
    constructor() {
        super("ProtoMessages.SportzcastGetVendorConfigurationListResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "vendorConfigurationList", kind: "message", T: () => VendorConfigurationList }
        ]);
    }
    create(value?: PartialMessage<SportzcastGetVendorConfigurationListResponse>): SportzcastGetVendorConfigurationListResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastGetVendorConfigurationListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastGetVendorConfigurationListResponse): SportzcastGetVendorConfigurationListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* VpuScoreconnectGrpc.VendorConfigurationList vendorConfigurationList */ 2:
                    message.vendorConfigurationList = VendorConfigurationList.internalBinaryRead(reader, reader.uint32(), options, message.vendorConfigurationList);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastGetVendorConfigurationListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* VpuScoreconnectGrpc.VendorConfigurationList vendorConfigurationList = 2; */
        if (message.vendorConfigurationList)
            VendorConfigurationList.internalBinaryWrite(message.vendorConfigurationList, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastGetVendorConfigurationListResponse
 */
export const SportzcastGetVendorConfigurationListResponse = new SportzcastGetVendorConfigurationListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastGetCurrentConfigurationResponse$Type extends MessageType$<SportzcastGetCurrentConfigurationResponse> {
    constructor() {
        super("ProtoMessages.SportzcastGetCurrentConfigurationResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "isConfigured", kind: "message", T: () => Bool },
            { no: 3, name: "configuration", kind: "message", T: () => Configuration }
        ]);
    }
    create(value?: PartialMessage<SportzcastGetCurrentConfigurationResponse>): SportzcastGetCurrentConfigurationResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastGetCurrentConfigurationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastGetCurrentConfigurationResponse): SportzcastGetCurrentConfigurationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* ProtoMessages.Bool isConfigured */ 2:
                    message.isConfigured = Bool.internalBinaryRead(reader, reader.uint32(), options, message.isConfigured);
                    break;
                case /* VpuScoreconnectGrpc.Configuration configuration */ 3:
                    message.configuration = Configuration.internalBinaryRead(reader, reader.uint32(), options, message.configuration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastGetCurrentConfigurationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool isConfigured = 2; */
        if (message.isConfigured)
            Bool.internalBinaryWrite(message.isConfigured, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* VpuScoreconnectGrpc.Configuration configuration = 3; */
        if (message.configuration)
            Configuration.internalBinaryWrite(message.configuration, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastGetCurrentConfigurationResponse
 */
export const SportzcastGetCurrentConfigurationResponse = new SportzcastGetCurrentConfigurationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastSetConfigurationResponse$Type extends MessageType$<SportzcastSetConfigurationResponse> {
    constructor() {
        super("ProtoMessages.SportzcastSetConfigurationResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SportzcastSetConfigurationResponse>): SportzcastSetConfigurationResponse {
        const message = { errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastSetConfigurationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastSetConfigurationResponse): SportzcastSetConfigurationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastSetConfigurationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastSetConfigurationResponse
 */
export const SportzcastSetConfigurationResponse = new SportzcastSetConfigurationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastGetLiveDataResponse$Type extends MessageType$<SportzcastGetLiveDataResponse> {
    constructor() {
        super("ProtoMessages.SportzcastGetLiveDataResponse", [
            { no: 1, name: "botNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "scoreBoardData", kind: "message", T: () => ScoreBoardDataMessage }
        ]);
    }
    create(value?: PartialMessage<SportzcastGetLiveDataResponse>): SportzcastGetLiveDataResponse {
        const message = { botNumber: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastGetLiveDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastGetLiveDataResponse): SportzcastGetLiveDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 botNumber */ 1:
                    message.botNumber = reader.int32();
                    break;
                case /* VpuScoreconnectGrpc.ScoreBoardDataMessage scoreBoardData */ 2:
                    message.scoreBoardData = ScoreBoardDataMessage.internalBinaryRead(reader, reader.uint32(), options, message.scoreBoardData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastGetLiveDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 botNumber = 1; */
        if (message.botNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.botNumber);
        /* VpuScoreconnectGrpc.ScoreBoardDataMessage scoreBoardData = 2; */
        if (message.scoreBoardData)
            ScoreBoardDataMessage.internalBinaryWrite(message.scoreBoardData, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastGetLiveDataResponse
 */
export const SportzcastGetLiveDataResponse = new SportzcastGetLiveDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastDiscoverLanScorelinkResponse$Type extends MessageType$<SportzcastDiscoverLanScorelinkResponse> {
    constructor() {
        super("ProtoMessages.SportzcastDiscoverLanScorelinkResponse", [
            { no: 1, name: "discoverdScoreLinksList", kind: "message", T: () => LanScoreLinkDeviceList }
        ]);
    }
    create(value?: PartialMessage<SportzcastDiscoverLanScorelinkResponse>): SportzcastDiscoverLanScorelinkResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastDiscoverLanScorelinkResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastDiscoverLanScorelinkResponse): SportzcastDiscoverLanScorelinkResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuScoreconnectGrpc.LanScoreLinkDeviceList discoverdScoreLinksList */ 1:
                    message.discoverdScoreLinksList = LanScoreLinkDeviceList.internalBinaryRead(reader, reader.uint32(), options, message.discoverdScoreLinksList);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastDiscoverLanScorelinkResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuScoreconnectGrpc.LanScoreLinkDeviceList discoverdScoreLinksList = 1; */
        if (message.discoverdScoreLinksList)
            LanScoreLinkDeviceList.internalBinaryWrite(message.discoverdScoreLinksList, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastDiscoverLanScorelinkResponse
 */
export const SportzcastDiscoverLanScorelinkResponse = new SportzcastDiscoverLanScorelinkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LiveRtspLinksRequest$Type extends MessageType$<LiveRtspLinksRequest> {
    constructor() {
        super("ProtoMessages.LiveRtspLinksRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<LiveRtspLinksRequest>): LiveRtspLinksRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LiveRtspLinksRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LiveRtspLinksRequest): LiveRtspLinksRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LiveRtspLinksRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.LiveRtspLinksRequest
 */
export const LiveRtspLinksRequest = new LiveRtspLinksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LiveRtspLinksResponse$Type extends MessageType$<LiveRtspLinksResponse> {
    constructor() {
        super("ProtoMessages.LiveRtspLinksResponse", [
            { no: 1, name: "rtspLinks", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => RtspLinkInfo }
        ]);
    }
    create(value?: PartialMessage<LiveRtspLinksResponse>): LiveRtspLinksResponse {
        const message = { rtspLinks: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LiveRtspLinksResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LiveRtspLinksResponse): LiveRtspLinksResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CommonUsedMessages.RtspLinkInfo rtspLinks */ 1:
                    message.rtspLinks.push(RtspLinkInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LiveRtspLinksResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated CommonUsedMessages.RtspLinkInfo rtspLinks = 1; */
        for (let i = 0; i < message.rtspLinks.length; i++)
            RtspLinkInfo.internalBinaryWrite(message.rtspLinks[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.LiveRtspLinksResponse
 */
export const LiveRtspLinksResponse = new LiveRtspLinksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VpumTabsStatusesMessage$Type extends MessageType$<VpumTabsStatusesMessage> {
    constructor() {
        super("ProtoMessages.VpumTabsStatusesMessage", [
            { no: 1, name: "networkCheck", kind: "message", T: () => GeneralStatus },
            { no: 2, name: "systemTest", kind: "message", T: () => GeneralStatus },
            { no: 3, name: "chuPairing", kind: "message", T: () => GeneralStatus },
            { no: 4, name: "chuAdjustment", kind: "message", T: () => GeneralStatus },
            { no: 5, name: "venueCalibration", kind: "message", T: () => GeneralStatus },
            { no: 6, name: "additionalPairing", kind: "message", T: () => GeneralStatus },
            { no: 7, name: "additionalAngle", kind: "message", T: () => GeneralStatus }
        ]);
    }
    create(value?: PartialMessage<VpumTabsStatusesMessage>): VpumTabsStatusesMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VpumTabsStatusesMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VpumTabsStatusesMessage): VpumTabsStatusesMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.GeneralStatus networkCheck */ 1:
                    message.networkCheck = GeneralStatus.internalBinaryRead(reader, reader.uint32(), options, message.networkCheck);
                    break;
                case /* ProtoMessages.GeneralStatus systemTest */ 2:
                    message.systemTest = GeneralStatus.internalBinaryRead(reader, reader.uint32(), options, message.systemTest);
                    break;
                case /* ProtoMessages.GeneralStatus chuPairing */ 3:
                    message.chuPairing = GeneralStatus.internalBinaryRead(reader, reader.uint32(), options, message.chuPairing);
                    break;
                case /* ProtoMessages.GeneralStatus chuAdjustment */ 4:
                    message.chuAdjustment = GeneralStatus.internalBinaryRead(reader, reader.uint32(), options, message.chuAdjustment);
                    break;
                case /* ProtoMessages.GeneralStatus venueCalibration */ 5:
                    message.venueCalibration = GeneralStatus.internalBinaryRead(reader, reader.uint32(), options, message.venueCalibration);
                    break;
                case /* ProtoMessages.GeneralStatus additionalPairing */ 6:
                    message.additionalPairing = GeneralStatus.internalBinaryRead(reader, reader.uint32(), options, message.additionalPairing);
                    break;
                case /* ProtoMessages.GeneralStatus additionalAngle */ 7:
                    message.additionalAngle = GeneralStatus.internalBinaryRead(reader, reader.uint32(), options, message.additionalAngle);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VpumTabsStatusesMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.GeneralStatus networkCheck = 1; */
        if (message.networkCheck)
            GeneralStatus.internalBinaryWrite(message.networkCheck, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.GeneralStatus systemTest = 2; */
        if (message.systemTest)
            GeneralStatus.internalBinaryWrite(message.systemTest, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.GeneralStatus chuPairing = 3; */
        if (message.chuPairing)
            GeneralStatus.internalBinaryWrite(message.chuPairing, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.GeneralStatus chuAdjustment = 4; */
        if (message.chuAdjustment)
            GeneralStatus.internalBinaryWrite(message.chuAdjustment, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.GeneralStatus venueCalibration = 5; */
        if (message.venueCalibration)
            GeneralStatus.internalBinaryWrite(message.venueCalibration, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.GeneralStatus additionalPairing = 6; */
        if (message.additionalPairing)
            GeneralStatus.internalBinaryWrite(message.additionalPairing, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.GeneralStatus additionalAngle = 7; */
        if (message.additionalAngle)
            GeneralStatus.internalBinaryWrite(message.additionalAngle, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VpumTabsStatusesMessage
 */
export const VpumTabsStatusesMessage = new VpumTabsStatusesMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VpumTabStatusUpdate$Type extends MessageType$<VpumTabStatusUpdate> {
    constructor() {
        super("ProtoMessages.VpumTabStatusUpdate", [
            { no: 1, name: "tabName", kind: "enum", T: () => ["ProtoMessages.VpumTabStatusUpdate.TabName", VpumTabStatusUpdate_TabName] },
            { no: 2, name: "status", kind: "message", T: () => GeneralStatus }
        ]);
    }
    create(value?: PartialMessage<VpumTabStatusUpdate>): VpumTabStatusUpdate {
        const message = { tabName: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VpumTabStatusUpdate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VpumTabStatusUpdate): VpumTabStatusUpdate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.VpumTabStatusUpdate.TabName tabName */ 1:
                    message.tabName = reader.int32();
                    break;
                case /* ProtoMessages.GeneralStatus status */ 2:
                    message.status = GeneralStatus.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VpumTabStatusUpdate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.VpumTabStatusUpdate.TabName tabName = 1; */
        if (message.tabName !== 0)
            writer.tag(1, WireType.Varint).int32(message.tabName);
        /* ProtoMessages.GeneralStatus status = 2; */
        if (message.status)
            GeneralStatus.internalBinaryWrite(message.status, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VpumTabStatusUpdate
 */
export const VpumTabStatusUpdate = new VpumTabStatusUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChosenAPDoublePlayCameraRequest$Type extends MessageType$<GetChosenAPDoublePlayCameraRequest> {
    constructor() {
        super("ProtoMessages.GetChosenAPDoublePlayCameraRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<GetChosenAPDoublePlayCameraRequest>): GetChosenAPDoublePlayCameraRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetChosenAPDoublePlayCameraRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetChosenAPDoublePlayCameraRequest): GetChosenAPDoublePlayCameraRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetChosenAPDoublePlayCameraRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.GetChosenAPDoublePlayCameraRequest
 */
export const GetChosenAPDoublePlayCameraRequest = new GetChosenAPDoublePlayCameraRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChosenAPDoublePlayCameraResponse$Type extends MessageType$<GetChosenAPDoublePlayCameraResponse> {
    constructor() {
        super("ProtoMessages.GetChosenAPDoublePlayCameraResponse", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["ProtoMessages.GetChosenAPDoublePlayCameraResponse.CameraType", GetChosenAPDoublePlayCameraResponse_CameraType] },
            { no: 2, name: "success", kind: "message", T: () => Bool },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetChosenAPDoublePlayCameraResponse>): GetChosenAPDoublePlayCameraResponse {
        const message = { cameraType: 0, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetChosenAPDoublePlayCameraResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetChosenAPDoublePlayCameraResponse): GetChosenAPDoublePlayCameraResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.GetChosenAPDoublePlayCameraResponse.CameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                case /* ProtoMessages.Bool success */ 2:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetChosenAPDoublePlayCameraResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.GetChosenAPDoublePlayCameraResponse.CameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        /* ProtoMessages.Bool success = 2; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.GetChosenAPDoublePlayCameraResponse
 */
export const GetChosenAPDoublePlayCameraResponse = new GetChosenAPDoublePlayCameraResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SwitchAPDoublePlayCameraRequest$Type extends MessageType$<SwitchAPDoublePlayCameraRequest> {
    constructor() {
        super("ProtoMessages.SwitchAPDoublePlayCameraRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<SwitchAPDoublePlayCameraRequest>): SwitchAPDoublePlayCameraRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SwitchAPDoublePlayCameraRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SwitchAPDoublePlayCameraRequest): SwitchAPDoublePlayCameraRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SwitchAPDoublePlayCameraRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SwitchAPDoublePlayCameraRequest
 */
export const SwitchAPDoublePlayCameraRequest = new SwitchAPDoublePlayCameraRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SwitchAPDoublePlayCameraResponse$Type extends MessageType$<SwitchAPDoublePlayCameraResponse> {
    constructor() {
        super("ProtoMessages.SwitchAPDoublePlayCameraResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SwitchAPDoublePlayCameraResponse>): SwitchAPDoublePlayCameraResponse {
        const message = { errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SwitchAPDoublePlayCameraResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SwitchAPDoublePlayCameraResponse): SwitchAPDoublePlayCameraResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SwitchAPDoublePlayCameraResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SwitchAPDoublePlayCameraResponse
 */
export const SwitchAPDoublePlayCameraResponse = new SwitchAPDoublePlayCameraResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CamerasConnectionStatusesRequest$Type extends MessageType$<CamerasConnectionStatusesRequest> {
    constructor() {
        super("ProtoMessages.CamerasConnectionStatusesRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<CamerasConnectionStatusesRequest>): CamerasConnectionStatusesRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CamerasConnectionStatusesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CamerasConnectionStatusesRequest): CamerasConnectionStatusesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CamerasConnectionStatusesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CamerasConnectionStatusesRequest
 */
export const CamerasConnectionStatusesRequest = new CamerasConnectionStatusesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CamerasConnectionStatusesResponse$Type extends MessageType$<CamerasConnectionStatusesResponse> {
    constructor() {
        super("ProtoMessages.CamerasConnectionStatusesResponse", [
            { no: 1, name: "adapterStatus", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AdapterStatus },
            { no: 2, name: "cameraStatus", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CameraStatus }
        ]);
    }
    create(value?: PartialMessage<CamerasConnectionStatusesResponse>): CamerasConnectionStatusesResponse {
        const message = { adapterStatus: [], cameraStatus: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CamerasConnectionStatusesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CamerasConnectionStatusesResponse): CamerasConnectionStatusesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CommonUsedMessages.AdapterStatus adapterStatus */ 1:
                    message.adapterStatus.push(AdapterStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated CommonUsedMessages.CameraStatus cameraStatus */ 2:
                    message.cameraStatus.push(CameraStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CamerasConnectionStatusesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated CommonUsedMessages.AdapterStatus adapterStatus = 1; */
        for (let i = 0; i < message.adapterStatus.length; i++)
            AdapterStatus.internalBinaryWrite(message.adapterStatus[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated CommonUsedMessages.CameraStatus cameraStatus = 2; */
        for (let i = 0; i < message.cameraStatus.length; i++)
            CameraStatus.internalBinaryWrite(message.cameraStatus[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.CamerasConnectionStatusesResponse
 */
export const CamerasConnectionStatusesResponse = new CamerasConnectionStatusesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HeaterMode$Type extends MessageType$<HeaterMode> {
    constructor() {
        super("ProtoMessages.HeaterMode", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.HeaterMode.Mode", HeaterMode_Mode] }
        ]);
    }
    create(value?: PartialMessage<HeaterMode>): HeaterMode {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<HeaterMode>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HeaterMode): HeaterMode {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.HeaterMode.Mode value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HeaterMode, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.HeaterMode.Mode value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.HeaterMode
 */
export const HeaterMode = new HeaterMode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioEqualizerMode$Type extends MessageType$<AudioEqualizerMode> {
    constructor() {
        super("ProtoMessages.AudioEqualizerMode", [
            { no: 1, name: "value", kind: "enum", T: () => ["ProtoMessages.AudioEqualizerMode.Mode", AudioEqualizerMode_Mode] }
        ]);
    }
    create(value?: PartialMessage<AudioEqualizerMode>): AudioEqualizerMode {
        const message = { value: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AudioEqualizerMode>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioEqualizerMode): AudioEqualizerMode {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.AudioEqualizerMode.Mode value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioEqualizerMode, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.AudioEqualizerMode.Mode value = 1; */
        if (message.value !== 0)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.AudioEqualizerMode
 */
export const AudioEqualizerMode = new AudioEqualizerMode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VenueSelfTestProgressMessage$Type extends MessageType$<VenueSelfTestProgressMessage> {
    constructor() {
        super("ProtoMessages.VenueSelfTestProgressMessage", [
            { no: 1, name: "running", kind: "message", T: () => Bool },
            { no: 2, name: "initiator", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VenueSelfTestProgressMessage>): VenueSelfTestProgressMessage {
        const message = { initiator: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VenueSelfTestProgressMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VenueSelfTestProgressMessage): VenueSelfTestProgressMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool running */ 1:
                    message.running = Bool.internalBinaryRead(reader, reader.uint32(), options, message.running);
                    break;
                case /* string initiator */ 2:
                    message.initiator = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VenueSelfTestProgressMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool running = 1; */
        if (message.running)
            Bool.internalBinaryWrite(message.running, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string initiator = 2; */
        if (message.initiator !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.initiator);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.VenueSelfTestProgressMessage
 */
export const VenueSelfTestProgressMessage = new VenueSelfTestProgressMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductionManagementParams$Type extends MessageType$<ProductionManagementParams> {
    constructor() {
        super("ProtoMessages.ProductionManagementParams", [
            { no: 1, name: "yellowLineEnabled", kind: "message", T: () => Bool },
            { no: 2, name: "replayEnabled", kind: "message", T: () => Bool },
            { no: 3, name: "replayMinimumPlayTime", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "replayZoom", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "replaySpeed", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ProductionManagementParams>): ProductionManagementParams {
        const message = { replayMinimumPlayTime: 0, replayZoom: 0, replaySpeed: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProductionManagementParams>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductionManagementParams): ProductionManagementParams {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool yellowLineEnabled */ 1:
                    message.yellowLineEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.yellowLineEnabled);
                    break;
                case /* ProtoMessages.Bool replayEnabled */ 2:
                    message.replayEnabled = Bool.internalBinaryRead(reader, reader.uint32(), options, message.replayEnabled);
                    break;
                case /* double replayMinimumPlayTime */ 3:
                    message.replayMinimumPlayTime = reader.double();
                    break;
                case /* int32 replayZoom */ 4:
                    message.replayZoom = reader.int32();
                    break;
                case /* int32 replaySpeed */ 5:
                    message.replaySpeed = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductionManagementParams, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool yellowLineEnabled = 1; */
        if (message.yellowLineEnabled)
            Bool.internalBinaryWrite(message.yellowLineEnabled, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProtoMessages.Bool replayEnabled = 2; */
        if (message.replayEnabled)
            Bool.internalBinaryWrite(message.replayEnabled, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* double replayMinimumPlayTime = 3; */
        if (message.replayMinimumPlayTime !== 0)
            writer.tag(3, WireType.Bit64).double(message.replayMinimumPlayTime);
        /* int32 replayZoom = 4; */
        if (message.replayZoom !== 0)
            writer.tag(4, WireType.Varint).int32(message.replayZoom);
        /* int32 replaySpeed = 5; */
        if (message.replaySpeed !== 0)
            writer.tag(5, WireType.Varint).int32(message.replaySpeed);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ProductionManagementParams
 */
export const ProductionManagementParams = new ProductionManagementParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductionManagementParametersRequest$Type extends MessageType$<ProductionManagementParametersRequest> {
    constructor() {
        super("ProtoMessages.ProductionManagementParametersRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<ProductionManagementParametersRequest>): ProductionManagementParametersRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProductionManagementParametersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductionManagementParametersRequest): ProductionManagementParametersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductionManagementParametersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ProductionManagementParametersRequest
 */
export const ProductionManagementParametersRequest = new ProductionManagementParametersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductionManagementParametersResponse$Type extends MessageType$<ProductionManagementParametersResponse> {
    constructor() {
        super("ProtoMessages.ProductionManagementParametersResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "params", kind: "message", T: () => ProductionManagementParams }
        ]);
    }
    create(value?: PartialMessage<ProductionManagementParametersResponse>): ProductionManagementParametersResponse {
        const message = { errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ProductionManagementParametersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductionManagementParametersResponse): ProductionManagementParametersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* ProtoMessages.ProductionManagementParams params */ 4:
                    message.params = ProductionManagementParams.internalBinaryRead(reader, reader.uint32(), options, message.params);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductionManagementParametersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* ProtoMessages.ProductionManagementParams params = 4; */
        if (message.params)
            ProductionManagementParams.internalBinaryWrite(message.params, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.ProductionManagementParametersResponse
 */
export const ProductionManagementParametersResponse = new ProductionManagementParametersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProductionManagementParametersRequest$Type extends MessageType$<UpdateProductionManagementParametersRequest> {
    constructor() {
        super("ProtoMessages.UpdateProductionManagementParametersRequest", [
            { no: 1, name: "params", kind: "message", T: () => ProductionManagementParams }
        ]);
    }
    create(value?: PartialMessage<UpdateProductionManagementParametersRequest>): UpdateProductionManagementParametersRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdateProductionManagementParametersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateProductionManagementParametersRequest): UpdateProductionManagementParametersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.ProductionManagementParams params */ 1:
                    message.params = ProductionManagementParams.internalBinaryRead(reader, reader.uint32(), options, message.params);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateProductionManagementParametersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.ProductionManagementParams params = 1; */
        if (message.params)
            ProductionManagementParams.internalBinaryWrite(message.params, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.UpdateProductionManagementParametersRequest
 */
export const UpdateProductionManagementParametersRequest = new UpdateProductionManagementParametersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastSwapTeamDataRequest$Type extends MessageType$<SportzcastSwapTeamDataRequest> {
    constructor() {
        super("ProtoMessages.SportzcastSwapTeamDataRequest", [
            { no: 1, name: "empty", kind: "message", T: () => Empty }
        ]);
    }
    create(value?: PartialMessage<SportzcastSwapTeamDataRequest>): SportzcastSwapTeamDataRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastSwapTeamDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastSwapTeamDataRequest): SportzcastSwapTeamDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.Empty empty */ 1:
                    message.empty = Empty.internalBinaryRead(reader, reader.uint32(), options, message.empty);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastSwapTeamDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.Empty empty = 1; */
        if (message.empty)
            Empty.internalBinaryWrite(message.empty, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastSwapTeamDataRequest
 */
export const SportzcastSwapTeamDataRequest = new SportzcastSwapTeamDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SportzcastSwapTeamDataResponse$Type extends MessageType$<SportzcastSwapTeamDataResponse> {
    constructor() {
        super("ProtoMessages.SportzcastSwapTeamDataResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool }
        ]);
    }
    create(value?: PartialMessage<SportzcastSwapTeamDataResponse>): SportzcastSwapTeamDataResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SportzcastSwapTeamDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SportzcastSwapTeamDataResponse): SportzcastSwapTeamDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SportzcastSwapTeamDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.SportzcastSwapTeamDataResponse
 */
export const SportzcastSwapTeamDataResponse = new SportzcastSwapTeamDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartPipFramesStreamRequest$Type extends MessageType$<StartPipFramesStreamRequest> {
    constructor() {
        super("ProtoMessages.StartPipFramesStreamRequest", [
            { no: 1, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StartPipFramesStreamRequest>): StartPipFramesStreamRequest {
        const message = { sessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StartPipFramesStreamRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StartPipFramesStreamRequest): StartPipFramesStreamRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sessionId */ 1:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StartPipFramesStreamRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sessionId = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StartPipFramesStreamRequest
 */
export const StartPipFramesStreamRequest = new StartPipFramesStreamRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartPipFramesStreamResponse$Type extends MessageType$<StartPipFramesStreamResponse> {
    constructor() {
        super("ProtoMessages.StartPipFramesStreamResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StartPipFramesStreamResponse>): StartPipFramesStreamResponse {
        const message = { errorMessage: "", sessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StartPipFramesStreamResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StartPipFramesStreamResponse): StartPipFramesStreamResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* string sessionId */ 3:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StartPipFramesStreamResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* string sessionId = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StartPipFramesStreamResponse
 */
export const StartPipFramesStreamResponse = new StartPipFramesStreamResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopPipFramesStreamRequest$Type extends MessageType$<StopPipFramesStreamRequest> {
    constructor() {
        super("ProtoMessages.StopPipFramesStreamRequest", [
            { no: 1, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StopPipFramesStreamRequest>): StopPipFramesStreamRequest {
        const message = { sessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StopPipFramesStreamRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StopPipFramesStreamRequest): StopPipFramesStreamRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sessionId */ 1:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StopPipFramesStreamRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sessionId = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StopPipFramesStreamRequest
 */
export const StopPipFramesStreamRequest = new StopPipFramesStreamRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopPipFramesStreamResponse$Type extends MessageType$<StopPipFramesStreamResponse> {
    constructor() {
        super("ProtoMessages.StopPipFramesStreamResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StopPipFramesStreamResponse>): StopPipFramesStreamResponse {
        const message = { errorMessage: "", sessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StopPipFramesStreamResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StopPipFramesStreamResponse): StopPipFramesStreamResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* string sessionId */ 3:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StopPipFramesStreamResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* string sessionId = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StopPipFramesStreamResponse
 */
export const StopPipFramesStreamResponse = new StopPipFramesStreamResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PipFrameStreamMessage$Type extends MessageType$<PipFrameStreamMessage> {
    constructor() {
        super("ProtoMessages.PipFrameStreamMessage", [
            { no: 1, name: "frame", kind: "message", T: () => DataChunkMessage },
            { no: 2, name: "frameNumber", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "scoreBoardData", kind: "message", T: () => OcrDataMessage }
        ]);
    }
    create(value?: PartialMessage<PipFrameStreamMessage>): PipFrameStreamMessage {
        const message = { frameNumber: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PipFrameStreamMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PipFrameStreamMessage): PipFrameStreamMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonUsedMessages.DataChunkMessage frame */ 1:
                    message.frame = DataChunkMessage.internalBinaryRead(reader, reader.uint32(), options, message.frame);
                    break;
                case /* uint32 frameNumber */ 2:
                    message.frameNumber = reader.uint32();
                    break;
                case /* VpuGrpc.OcrDataMessage scoreBoardData */ 3:
                    message.scoreBoardData = OcrDataMessage.internalBinaryRead(reader, reader.uint32(), options, message.scoreBoardData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PipFrameStreamMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* CommonUsedMessages.DataChunkMessage frame = 1; */
        if (message.frame)
            DataChunkMessage.internalBinaryWrite(message.frame, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* uint32 frameNumber = 2; */
        if (message.frameNumber !== 0)
            writer.tag(2, WireType.Varint).uint32(message.frameNumber);
        /* VpuGrpc.OcrDataMessage scoreBoardData = 3; */
        if (message.scoreBoardData)
            OcrDataMessage.internalBinaryWrite(message.scoreBoardData, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PipFrameStreamMessage
 */
export const PipFrameStreamMessage = new PipFrameStreamMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PipFrameStreamErrorMessage$Type extends MessageType$<PipFrameStreamErrorMessage> {
    constructor() {
        super("ProtoMessages.PipFrameStreamErrorMessage", [
            { no: 1, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "lastFrameNumber", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<PipFrameStreamErrorMessage>): PipFrameStreamErrorMessage {
        const message = { sessionId: "", errorMessage: "", lastFrameNumber: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PipFrameStreamErrorMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PipFrameStreamErrorMessage): PipFrameStreamErrorMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sessionId */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* uint32 lastFrameNumber */ 3:
                    message.lastFrameNumber = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PipFrameStreamErrorMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sessionId = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* uint32 lastFrameNumber = 3; */
        if (message.lastFrameNumber !== 0)
            writer.tag(3, WireType.Varint).uint32(message.lastFrameNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.PipFrameStreamErrorMessage
 */
export const PipFrameStreamErrorMessage = new PipFrameStreamErrorMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartSendScoreboardDataWithPipFrameStreamRequest$Type extends MessageType$<StartSendScoreboardDataWithPipFrameStreamRequest> {
    constructor() {
        super("ProtoMessages.StartSendScoreboardDataWithPipFrameStreamRequest", [
            { no: 1, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "stopSendAfterMinutes", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<StartSendScoreboardDataWithPipFrameStreamRequest>): StartSendScoreboardDataWithPipFrameStreamRequest {
        const message = { sessionId: "", stopSendAfterMinutes: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StartSendScoreboardDataWithPipFrameStreamRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StartSendScoreboardDataWithPipFrameStreamRequest): StartSendScoreboardDataWithPipFrameStreamRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sessionId */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* int32 stopSendAfterMinutes */ 2:
                    message.stopSendAfterMinutes = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StartSendScoreboardDataWithPipFrameStreamRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sessionId = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* int32 stopSendAfterMinutes = 2; */
        if (message.stopSendAfterMinutes !== 0)
            writer.tag(2, WireType.Varint).int32(message.stopSendAfterMinutes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StartSendScoreboardDataWithPipFrameStreamRequest
 */
export const StartSendScoreboardDataWithPipFrameStreamRequest = new StartSendScoreboardDataWithPipFrameStreamRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartSendScoreboardDataWithPipFrameStreamResponse$Type extends MessageType$<StartSendScoreboardDataWithPipFrameStreamResponse> {
    constructor() {
        super("ProtoMessages.StartSendScoreboardDataWithPipFrameStreamResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StartSendScoreboardDataWithPipFrameStreamResponse>): StartSendScoreboardDataWithPipFrameStreamResponse {
        const message = { sessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StartSendScoreboardDataWithPipFrameStreamResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StartSendScoreboardDataWithPipFrameStreamResponse): StartSendScoreboardDataWithPipFrameStreamResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string sessionId */ 2:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StartSendScoreboardDataWithPipFrameStreamResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string sessionId = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StartSendScoreboardDataWithPipFrameStreamResponse
 */
export const StartSendScoreboardDataWithPipFrameStreamResponse = new StartSendScoreboardDataWithPipFrameStreamResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopSendScoreboardDataWithPipFrameStreamRequest$Type extends MessageType$<StopSendScoreboardDataWithPipFrameStreamRequest> {
    constructor() {
        super("ProtoMessages.StopSendScoreboardDataWithPipFrameStreamRequest", [
            { no: 1, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StopSendScoreboardDataWithPipFrameStreamRequest>): StopSendScoreboardDataWithPipFrameStreamRequest {
        const message = { sessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StopSendScoreboardDataWithPipFrameStreamRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StopSendScoreboardDataWithPipFrameStreamRequest): StopSendScoreboardDataWithPipFrameStreamRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sessionId */ 1:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StopSendScoreboardDataWithPipFrameStreamRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sessionId = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StopSendScoreboardDataWithPipFrameStreamRequest
 */
export const StopSendScoreboardDataWithPipFrameStreamRequest = new StopSendScoreboardDataWithPipFrameStreamRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopSendScoreboardDataWithPipFrameStreamResponse$Type extends MessageType$<StopSendScoreboardDataWithPipFrameStreamResponse> {
    constructor() {
        super("ProtoMessages.StopSendScoreboardDataWithPipFrameStreamResponse", [
            { no: 1, name: "success", kind: "message", T: () => Bool },
            { no: 2, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StopSendScoreboardDataWithPipFrameStreamResponse>): StopSendScoreboardDataWithPipFrameStreamResponse {
        const message = { sessionId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StopSendScoreboardDataWithPipFrameStreamResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StopSendScoreboardDataWithPipFrameStreamResponse): StopSendScoreboardDataWithPipFrameStreamResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProtoMessages.Bool success */ 1:
                    message.success = Bool.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* string sessionId */ 2:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StopSendScoreboardDataWithPipFrameStreamResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* ProtoMessages.Bool success = 1; */
        if (message.success)
            Bool.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string sessionId = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.StopSendScoreboardDataWithPipFrameStreamResponse
 */
export const StopSendScoreboardDataWithPipFrameStreamResponse = new StopSendScoreboardDataWithPipFrameStreamResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FullScoreboardSaveHistoryEntry$Type extends MessageType$<FullScoreboardSaveHistoryEntry> {
    constructor() {
        super("ProtoMessages.FullScoreboardSaveHistoryEntry", [
            { no: 1, name: "user", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<FullScoreboardSaveHistoryEntry>): FullScoreboardSaveHistoryEntry {
        const message = { user: "", timestamp: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FullScoreboardSaveHistoryEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FullScoreboardSaveHistoryEntry): FullScoreboardSaveHistoryEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user */ 1:
                    message.user = reader.string();
                    break;
                case /* uint64 timestamp */ 2:
                    message.timestamp = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FullScoreboardSaveHistoryEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user = 1; */
        if (message.user !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.user);
        /* uint64 timestamp = 2; */
        if (message.timestamp !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.timestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.FullScoreboardSaveHistoryEntry
 */
export const FullScoreboardSaveHistoryEntry = new FullScoreboardSaveHistoryEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FullScoreboardSaveHistoryRequest$Type extends MessageType$<FullScoreboardSaveHistoryRequest> {
    constructor() {
        super("ProtoMessages.FullScoreboardSaveHistoryRequest", [
            { no: 1, name: "numOfRecords", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<FullScoreboardSaveHistoryRequest>): FullScoreboardSaveHistoryRequest {
        const message = { numOfRecords: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FullScoreboardSaveHistoryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FullScoreboardSaveHistoryRequest): FullScoreboardSaveHistoryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 numOfRecords */ 1:
                    message.numOfRecords = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FullScoreboardSaveHistoryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 numOfRecords = 1; */
        if (message.numOfRecords !== 0)
            writer.tag(1, WireType.Varint).int32(message.numOfRecords);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.FullScoreboardSaveHistoryRequest
 */
export const FullScoreboardSaveHistoryRequest = new FullScoreboardSaveHistoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FullScoreboardSaveHistoryResponse$Type extends MessageType$<FullScoreboardSaveHistoryResponse> {
    constructor() {
        super("ProtoMessages.FullScoreboardSaveHistoryResponse", [
            { no: 1, name: "entries", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FullScoreboardSaveHistoryEntry }
        ]);
    }
    create(value?: PartialMessage<FullScoreboardSaveHistoryResponse>): FullScoreboardSaveHistoryResponse {
        const message = { entries: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FullScoreboardSaveHistoryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FullScoreboardSaveHistoryResponse): FullScoreboardSaveHistoryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.FullScoreboardSaveHistoryEntry entries */ 1:
                    message.entries.push(FullScoreboardSaveHistoryEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FullScoreboardSaveHistoryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.FullScoreboardSaveHistoryEntry entries = 1; */
        for (let i = 0; i < message.entries.length; i++)
            FullScoreboardSaveHistoryEntry.internalBinaryWrite(message.entries[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.FullScoreboardSaveHistoryResponse
 */
export const FullScoreboardSaveHistoryResponse = new FullScoreboardSaveHistoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiCalibrateRequest$Type extends MessageType$<OcrAiCalibrateRequest> {
    constructor() {
        super("ProtoMessages.OcrAiCalibrateRequest", [
            { no: 1, name: "sportType", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiCalibrateRequest>): OcrAiCalibrateRequest {
        const message = { sportType: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiCalibrateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiCalibrateRequest): OcrAiCalibrateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sportType */ 1:
                    message.sportType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiCalibrateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sportType = 1; */
        if (message.sportType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sportType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OcrAiCalibrateRequest
 */
export const OcrAiCalibrateRequest = new OcrAiCalibrateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiCalibrateResponse$Type extends MessageType$<OcrAiCalibrateResponse> {
    constructor() {
        super("ProtoMessages.OcrAiCalibrateResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiCalibrateResponse>): OcrAiCalibrateResponse {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiCalibrateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiCalibrateResponse): OcrAiCalibrateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiCalibrateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OcrAiCalibrateResponse
 */
export const OcrAiCalibrateResponse = new OcrAiCalibrateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiSetSportTypeRequest$Type extends MessageType$<OcrAiSetSportTypeRequest> {
    constructor() {
        super("ProtoMessages.OcrAiSetSportTypeRequest", [
            { no: 1, name: "sportType", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiSetSportTypeRequest>): OcrAiSetSportTypeRequest {
        const message = { sportType: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiSetSportTypeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiSetSportTypeRequest): OcrAiSetSportTypeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sportType */ 1:
                    message.sportType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiSetSportTypeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sportType = 1; */
        if (message.sportType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sportType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OcrAiSetSportTypeRequest
 */
export const OcrAiSetSportTypeRequest = new OcrAiSetSportTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiSetSportTypeResponse$Type extends MessageType$<OcrAiSetSportTypeResponse> {
    constructor() {
        super("ProtoMessages.OcrAiSetSportTypeResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiSetSportTypeResponse>): OcrAiSetSportTypeResponse {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiSetSportTypeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiSetSportTypeResponse): OcrAiSetSportTypeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiSetSportTypeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OcrAiSetSportTypeResponse
 */
export const OcrAiSetSportTypeResponse = new OcrAiSetSportTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiSetSwapHomeAwayRequest$Type extends MessageType$<OcrAiSetSwapHomeAwayRequest> {
    constructor() {
        super("ProtoMessages.OcrAiSetSwapHomeAwayRequest", [
            { no: 1, name: "swap", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiSetSwapHomeAwayRequest>): OcrAiSetSwapHomeAwayRequest {
        const message = { swap: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiSetSwapHomeAwayRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiSetSwapHomeAwayRequest): OcrAiSetSwapHomeAwayRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool swap */ 1:
                    message.swap = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiSetSwapHomeAwayRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool swap = 1; */
        if (message.swap !== false)
            writer.tag(1, WireType.Varint).bool(message.swap);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OcrAiSetSwapHomeAwayRequest
 */
export const OcrAiSetSwapHomeAwayRequest = new OcrAiSetSwapHomeAwayRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiSetSwapHomeAwayResponse$Type extends MessageType$<OcrAiSetSwapHomeAwayResponse> {
    constructor() {
        super("ProtoMessages.OcrAiSetSwapHomeAwayResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiSetSwapHomeAwayResponse>): OcrAiSetSwapHomeAwayResponse {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiSetSwapHomeAwayResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiSetSwapHomeAwayResponse): OcrAiSetSwapHomeAwayResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiSetSwapHomeAwayResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OcrAiSetSwapHomeAwayResponse
 */
export const OcrAiSetSwapHomeAwayResponse = new OcrAiSetSwapHomeAwayResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiValidationHistoryRequest$Type extends MessageType$<OcrAiValidationHistoryRequest> {
    constructor() {
        super("ProtoMessages.OcrAiValidationHistoryRequest", []);
    }
    create(value?: PartialMessage<OcrAiValidationHistoryRequest>): OcrAiValidationHistoryRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiValidationHistoryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiValidationHistoryRequest): OcrAiValidationHistoryRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: OcrAiValidationHistoryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OcrAiValidationHistoryRequest
 */
export const OcrAiValidationHistoryRequest = new OcrAiValidationHistoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiValidationHistoryEntry$Type extends MessageType$<OcrAiValidationHistoryEntry> {
    constructor() {
        super("ProtoMessages.OcrAiValidationHistoryEntry", [
            { no: 1, name: "sportType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "lastValidatedTimestamp", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "lastValidationSuccess", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "validatedBy", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiValidationHistoryEntry>): OcrAiValidationHistoryEntry {
        const message = { sportType: "", lastValidatedTimestamp: 0n, lastValidationSuccess: false, validatedBy: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiValidationHistoryEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiValidationHistoryEntry): OcrAiValidationHistoryEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sportType */ 1:
                    message.sportType = reader.string();
                    break;
                case /* uint64 lastValidatedTimestamp */ 2:
                    message.lastValidatedTimestamp = reader.uint64().toBigInt();
                    break;
                case /* bool lastValidationSuccess */ 3:
                    message.lastValidationSuccess = reader.bool();
                    break;
                case /* string validatedBy */ 4:
                    message.validatedBy = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiValidationHistoryEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sportType = 1; */
        if (message.sportType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sportType);
        /* uint64 lastValidatedTimestamp = 2; */
        if (message.lastValidatedTimestamp !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.lastValidatedTimestamp);
        /* bool lastValidationSuccess = 3; */
        if (message.lastValidationSuccess !== false)
            writer.tag(3, WireType.Varint).bool(message.lastValidationSuccess);
        /* string validatedBy = 4; */
        if (message.validatedBy !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.validatedBy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OcrAiValidationHistoryEntry
 */
export const OcrAiValidationHistoryEntry = new OcrAiValidationHistoryEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiValidationHistoryResponse$Type extends MessageType$<OcrAiValidationHistoryResponse> {
    constructor() {
        super("ProtoMessages.OcrAiValidationHistoryResponse", [
            { no: 1, name: "entries", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => OcrAiValidationHistoryEntry }
        ]);
    }
    create(value?: PartialMessage<OcrAiValidationHistoryResponse>): OcrAiValidationHistoryResponse {
        const message = { entries: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiValidationHistoryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiValidationHistoryResponse): OcrAiValidationHistoryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProtoMessages.OcrAiValidationHistoryEntry entries */ 1:
                    message.entries.push(OcrAiValidationHistoryEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiValidationHistoryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated ProtoMessages.OcrAiValidationHistoryEntry entries = 1; */
        for (let i = 0; i < message.entries.length; i++)
            OcrAiValidationHistoryEntry.internalBinaryWrite(message.entries[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProtoMessages.OcrAiValidationHistoryResponse
 */
export const OcrAiValidationHistoryResponse = new OcrAiValidationHistoryResponse$Type();
/**
 * @generated ServiceType for protobuf service ProtoMessages.CoordinatorServiceInterface
 */
export const CoordinatorServiceInterface = new ServiceType("ProtoMessages.CoordinatorServiceInterface", [
    { name: "RunNetworkTest", options: {}, I: NetworkTestRequest, O: NetworkTestResult }
]);
/**
 * @generated ServiceType for protobuf service ProtoMessages.CoordinatorServiceToCameraTesterService
 */
export const CoordinatorServiceToCameraTesterService = new ServiceType("ProtoMessages.CoordinatorServiceToCameraTesterService", [
    { name: "ReportTestResults", options: {}, I: OnboardingCameraTestResponse, O: Empty },
    { name: "ReportPOETestResults", options: {}, I: POETestResponse, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service ProtoMessages.CoordinatorServiceToPIPService
 */
export const CoordinatorServiceToPIPService = new ServiceType("ProtoMessages.CoordinatorServiceToPIPService", [
    { name: "RequestFrame", options: {}, I: Empty, O: DataChunkMessage }
]);
